#
msgid ""
msgstr ""
"Project-Id-Version: oranje-web\n"
"Report-Msgid-Bugs-To: \n"
"POT-Creation-Date: 2026-09-09 12:00-0500\n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Language: en\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Generator: @lingui/cli\n"
"Project-Id-Version: oranje-web\n"
"Report-Msgid-Bugs-To: \n"
"POT-Creation-Date: 2026-09-09 12:00-0500\n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Language: en\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Generator: @lingui/cli\n"

#. placeholder {0}: lastSent.byName
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid " · por {0}"
msgstr " · by {0}"

#. placeholder {0}: entry.lunchDeductionMinutes
#: src/features/timesheet/components/AttendanceView.tsx
msgid "-{0} min lonche"
msgstr "-{0} min lunch"

#: src/features/admin/components/HotelUsersSection.tsx
msgid "; los Supervisores, los Managers de Área y los Managers Generales adicionales se dan de alta aquí. El correo, el hotel y el rol no se editan: cambiar cualquiera es dar de baja y dar de alta."
msgstr "; additional Supervisors, Area Managers and General Managers are created here. The email, the hotel and the role can't be edited: changing any of them means deactivating the account and creating a new one."

#: src/features/worker/pages/PunchPage.tsx
msgid "¡Listo!"
msgstr "Done!"

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "¿A quiénes?"
msgstr "Who?"

#. placeholder {0}: String(latestVersion)
#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "¿Actualizar las tarifas con la v{0}?"
msgstr "Update the rates to v{0}?"

#. placeholder {0}: eligible.length
#: src/features/timesheet/components/BulkApproveButton.tsx
msgid "¿Aprobar {0} semanas de un golpe?"
msgstr "Approve {0} weeks at once?"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "¿Aprobar la semana?"
msgstr "Approve the week?"

#. placeholder {0}: campaign.name
#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "¿Cancelar «{0}»?"
msgstr "Cancel “{0}”?"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "¿Cancelar el envío a firma?"
msgstr "Cancel the signature request?"

#: src/features/worker/pages/PunchPage.tsx
msgid "¿Cómo funciona el ponche?"
msgstr "How does clocking in work?"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "¿Cómo funciona la importación?"
msgstr "How does importing work?"

#: src/features/accounting/pages/AccountingPendingPages.tsx
#: src/features/accounting/pages/AccountingTimesheetPage.tsx
#: src/features/accounting/pages/ConsolidationsPage.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
#: src/features/accounting/pages/InvoicesPage.tsx
#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
#: src/features/accounting/pages/PendingApprovalsPage.tsx
#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/audits/pages/AuditsPage.tsx
#: src/features/contracts/pages/ContractListPage.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "¿Cómo funciona?"
msgstr "How does it work?"

#: src/features/observability/components/CohortsView.tsx
msgid "¿Cómo se calcula?"
msgstr "How is it calculated?"

#: src/features/worker/pages/Phase2Page.tsx
msgid "¿Cómo te trasladas?"
msgstr "How do you get around?"

#: src/features/onboarding/components/CreateProposalPromptDialog.tsx
msgid "¿Creamos la propuesta ahora?"
msgstr "Shall we create the proposal now?"

#: src/features/messaging/components/ContactActions.tsx
msgid "¿Dar de baja a {name}?"
msgstr "Opt out {name}?"

#: src/features/onboarding/components/DeleteHotelAction.tsx
msgid "¿Eliminar {hotelName}?"
msgstr "Delete {hotelName}?"

#: src/features/messaging/components/ContactActions.tsx
msgid "¿Eliminar a {name}?"
msgstr "Delete {name}?"

#. placeholder {0}: tag.name
#: src/features/messaging/components/MessagingTagsList.tsx
msgid "¿Eliminar la etiqueta «{0}»?"
msgstr "Delete the tag “{0}”?"

#: src/features/dashboard/components/InviteHotelAccountCard.tsx
msgid "¿Entró un Supervisor o un gerente nuevo?"
msgstr "Did a new Supervisor or manager join?"

#: src/features/onboarding/components/ConfirmSendProposalDialog.tsx
msgid "¿Enviamos la propuesta?"
msgstr "Shall we send the proposal?"

#. placeholder {0}: campaign.name
#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "¿Enviar «{0}»?"
msgstr "Send “{0}”?"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "¿Enviar la semana a revisión?"
msgstr "Send the week for review?"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "¿Enviar y aprobar la semana?"
msgstr "Send and approve the week?"

#: src/features/auth/pages/LoginPage.tsx
msgid "¿Eres colaborador? <0>Entra por aquí</0>"
msgstr "Are you a Collaborator? <0>Sign in here</0>"

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "¿La olvidaste?"
msgstr "Forgot it?"

#: src/shared/components/ReleaseAssignmentWarningDialog.tsx
msgid "¿Liberar a {workerName}?"
msgstr "Release {workerName}?"

#: src/shared/components/ReleaseAssignmentWarningDialog.tsx
msgid "¿Liberar este lugar?"
msgstr "Release this slot?"

#: src/features/onboarding/components/ConfirmSendProposalDialog.tsx
msgid "¿Marcamos la propuesta como enviada?"
msgstr "Shall we mark the proposal as sent?"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "¿Marcar el contrato como enviado?"
msgstr "Mark the contract as sent?"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "¿Necesitas regresarlo? El semáforo no retrocede: se sale por una rama y se reactiva hacia Azul claro. Desde <0>Rojo</0> reactivan el BD o el BDC; desde <1>Café</1> y <2>Negro</2>, solo el BDC."
msgstr "Need to take it back? The Status Light never goes backwards: you exit through a branch and reactivate into Light Blue. From <0>Red</0> the BD or the BDC reactivate it; from <1>Brown</1> and <2>Black</2>, only the BDC."

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "¿No sabes cómo armarlo?"
msgstr "Not sure how to build it?"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "¿Por qué se elimina? El motivo queda en el journal."
msgstr "Why is it being deleted? The reason stays in the log."

#: src/features/admin/components/PendingHotelUsers.tsx
msgid "¿Por qué se rechaza?"
msgstr "Why reject it?"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "¿Por qué se rechaza? (ilegible, incorrecto…)"
msgstr "Why is it being rejected? (illegible, incorrect…)"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "¿Primera vez aquí?"
msgstr "First time here?"

#: src/features/worker/pages/Phase3Page.tsx
msgid "¿Qué es de ti?"
msgstr "Anything we should know?"

#: src/features/observability/components/CohortSection.tsx
msgid "¿Qué pasó con los que ingresaron?"
msgstr "What happened to those who joined?"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "¿Quién lo pagó?"
msgstr "Who paid for it?"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "¿Quitar el acceso?"
msgstr "Remove access?"

#. placeholder {0}: removing.label
#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "¿Quitar la deducción de {0}?"
msgstr "Remove the {0} deduction?"

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "¿Quitar la función?"
msgstr "Remove the role?"

#: src/features/accounting/components/PayConsolidationButton.tsx
msgid "¿Registrar el pago de {workerName}?"
msgstr "Record the payment for {workerName}?"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "¿Seguro? Toca «Sí, descartar borrador» para confirmar."
msgstr "Are you sure? Tap “Yes, discard draft” to confirm."

#: src/features/auth/pages/LoginPage.tsx
msgid "¿Sin acceso? Pídele el alta al Administrador de tu departamento."
msgstr "No access yet? Ask your department's Administrator to set you up."

#: src/mobile/AppLoginPage.tsx
msgid "¿Sin acceso? Si eres colaborador, tu Reclutadora te da de alta. Si trabajas en un hotel, pide el alta a tu Manager."
msgstr "No access? If you're a Collaborator, your Recruiter sets you up. If you work at a hotel, ask your Manager to set you up."

#: src/features/auth/pages/LoginPage.tsx
msgid "¿Sin acceso? Tu Reclutadora te da de alta y te llega un correo para crear tu contraseña."
msgstr "No access yet? Your Recruiter sets you up and you get an email to create your password."

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "¿Sincronizar colaboradores con Mensajería?"
msgstr "Sync workers with Messaging?"

#: src/features/auth/pages/LoginPage.tsx
msgid "¿Trabajas en Oranje o en un hotel? <0>Entra por aquí</0>"
msgstr "Do you work at Oranje or at a hotel? <0>Sign in here</0>"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid ".xlsx, .csv, .txt o .pdf · hasta 5 MB y 500 hoteles"
msgstr ".xlsx, .csv, .txt or .pdf · up to 5 MB and 500 hotels"

#. placeholder {0}: aggregate.people
#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "· {0} pers."
msgstr "· {0} people"

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "· ajuste a la tarifa de la posición"
msgstr "· adjustment to the position's rate"

#. placeholder {0}: lastSent.version
#. placeholder {1}: lastSent.sentAt ? formatDate(lastSent.sentAt) : '—'
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "· el hotel tiene la v{0} (enviada {1})"
msgstr "· the hotel has v{0} (sent {1})"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "· fuera de geocerca"
msgstr "· outside the geofence"

#. placeholder {0}: row.payConcept.name
#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "· gasto: {0}"
msgstr "· expense: {0}"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "· marca manual"
msgstr "· manual mark"

#. placeholder {0}: i18n._(active.label)
#: src/features/messaging/pages/MessagingPage.tsx
msgid "«{0}» de Mensajería todavía se está construyendo."
msgstr "Messaging «{0}» is still being built."

#. placeholder {0}: template.name
#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "«{0}» quedó desactivada."
msgstr "“{0}” was deactivated."

#. placeholder {0}: campaign.name
#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "«{0}» quedó en pausa."
msgstr "“{0}” is paused."

#. placeholder {0}: campaign.name
#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "«{0}» quedó programada."
msgstr "“{0}” was scheduled."

#. placeholder {0}: campaign.name
#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "«{0}» se canceló."
msgstr "“{0}” was cancelled."

#. placeholder {0}: pending.item.name
#: src/features/admin/pages/CatalogsPage.tsx
msgid "«{0}» se elimina de verdad — no se archiva. Si algo del sistema lo está usando, el propio sistema lo va a impedir y te lo dirá aquí."
msgstr "“{0}” is deleted for real — it isn't archived. If anything in the system is using it, the system itself will stop you and tell you here."

#. placeholder {0}: item.label
#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "«{0}» se elimina de verdad. Si alguna inspección ya lo contestó, el sistema lo va a impedir y te lo dice aquí."
msgstr "“{0}” is deleted for real. If any inspection already answered it, the system will stop you and tell you here."

#. placeholder {0}: campaign.name
#. placeholder {1}: result.queued
#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "«{0}» se está enviando a {1} contactos."
msgstr "“{0}” is being sent to {1} contacts."

#. placeholder {0}: campaign.name
#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "«{0}» se está enviando."
msgstr "“{0}” is sending."

#. placeholder {0}: check?.name ?? input.name
#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "«{0}» se mandó a Meta: queda en revisión."
msgstr "“{0}” was sent to Meta: it's under review."

#. placeholder {0}: template.name
#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "«{0}» se reactivó."
msgstr "“{0}” was reactivated."

#. placeholder {0}: campaign.name
#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "«{0}» se reanudó."
msgstr "“{0}” resumed."

#. placeholder {0}: input.name
#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "«{0}» se reenvió a Meta: queda en revisión."
msgstr "“{0}” was resubmitted to Meta: it's under review."

#. placeholder {0}: campaign.name
#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "«{0}» volvió a borrador."
msgstr "“{0}” is back to draft."

#: src/shared/components/ModulePlaceholder.tsx
msgid "«{title}» ya tiene su lugar en el menú. Lo estamos construyendo y va a estar listo muy pronto."
msgstr "“{title}” already has its place in the menu. We're building it, and it'll be ready very soon."

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "«Aprobada y enviada a Oranje» es del hotel, no tuya"
msgstr "“Approved and sent to Oranje” is the hotel's status, not yours"

#: src/features/observability/components/CohortsView.tsx
msgid "«Ingresó» = su primera semana con ponches en todo su historial. «Trabajó» una semana = ponchó al menos una vez esa semana; no dice cuántos días. Lo que pasó con quien ya no trabaja sale de su estado actual en el Semáforo del Colaborador."
msgstr "\"Joined\" = their first week with punches in their entire history. A week \"worked\" = they punched at least once that week; it doesn't say how many days. What happened to someone who no longer works comes from their current status in the Collaborator Status Light."

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "«Pago estimado» es un cálculo en vivo, no lo que ya se le pagó: parte las 40 h semanales por requisición y paga el resto al multiplicador de horas extra del hotel. Sin contrato ni tarifa interna que resolver, no se inventa un número — queda en «—»."
msgstr "«Estimated pay» is a live calculation, not what was already paid: it splits 40 weekly hours per requisition and pays the rest at the hotel's overtime multiplier. Without a contract or internal rate to resolve, it doesn't invent a number — it shows «—»."

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "«Pago estimado» es un cálculo en vivo, no lo que ya se le pagó: parte las 40 h semanales por requisición y paga el resto al multiplicador de horas extra del hotel. Sin contrato ni tarifa interna que resolver, no se inventa un número — queda en «—». Lo que corrijas aquí es lo que paga la corrida real, no solo esta pantalla."
msgstr "«Estimated pay» is a live calculation, not what was already paid: it splits 40 weekly hours per requisition and pays the rest at the hotel's overtime multiplier. Without a contract or internal rate to resolve, it doesn't invent a number — it shows «—». What you correct here is what the real run pays, not just this screen."

#. placeholder {0}: String(PROSPECT_TEXT_MAX.needDescription)
#: src/features/onboarding/import/mapImportRows.ts
msgid "«Qué necesita» pasa de {0} caracteres"
msgstr "“Needs” is over {0} characters"

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "«Regresar» un prospecto es salir por una rama y reactivarlo. La reentrada es siempre hacia Azul claro, el único punto de retorno: se retoma el contacto, no la propuesta vieja."
msgstr "“Taking back” a Prospect means exiting through a branch and reactivating it. Re-entry is always into Light Blue, the only return point: you pick up the contact again, not the old Proposal."

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "«Stand-by» es una pausa temporal y la compartes con el Manager de Área. «Reportar» abre una incidencia que revisa Inspección. «Ver perfil» te lleva a su expediente."
msgstr "“Stand-by” is a temporary pause and you share it with the Area Manager. “Report” opens an incident that Inspection reviews. “View profile” takes you to their file."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "«Ver bitácora» te dice quién la movió y cuándo. El resto de los botones cambia según dónde esté: cubrirla o eliminarla con motivo."
msgstr "“View log” tells you who moved it and when. The other buttons change with where it stands: cover it, or delete it with a reason."

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
msgid "(devuelta)"
msgstr "(refunded)"

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "(en curso)"
msgstr "(in progress)"

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "(listo)"
msgstr "(done)"

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "(pendiente)"
msgstr "(pending)"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "(sin nombre)"
msgstr "(no name)"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "[Apellido]"
msgstr "[Last name]"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "[Nombre]"
msgstr "[First name]"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "[Teléfono]"
msgstr "[Phone]"

#. placeholder {0}: reasons.length
#: src/features/admin/pages/CatalogsPage.tsx
msgid "{0, plural, =0 {sin motivos} one {# motivo} other {# motivos}}"
msgstr "{0, plural, =0 {no reasons} one {# reason} other {# reasons}}"

#. placeholder {0}: positions.length
#: src/features/admin/pages/CatalogsPage.tsx
msgid "{0, plural, =0 {sin posiciones} one {# posición} other {# posiciones}}"
msgstr "{0, plural, =0 {no positions} one {# position} other {# positions}}"

#. placeholder {0}: group.openCount
#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
msgid "{0, plural, one {# abierta} other {# abiertas}}"
msgstr "{0, plural, one {# open} other {# open}}"

#. placeholder {0}: member.openProspects
#: src/features/team/pages/TeamPage.tsx
msgid "{0, plural, one {# abierto} other {# abiertos}}"
msgstr "{0, plural, one {# open} other {# open}}"

#. placeholder {0}: adjustments.length
#: src/features/timesheet/components/PendingAdjustmentsChip.tsx
msgid "{0, plural, one {# ajuste sin incluir} other {# ajustes sin incluir}}"
msgstr "{0, plural, one {# adjustment not included} other {# adjustments not included}}"

#. placeholder {0}: selected.age
#: src/features/recruitment/components/PoolRoster.tsx
msgid "{0, plural, one {# año} other {# años}}"
msgstr "{0, plural, one {# year} other {# years}}"

#. placeholder {0}: pool.total
#: src/features/recruitment/pages/PoolPage.tsx
msgid "{0, plural, one {# coincide} other {# coinciden}}"
msgstr "{0, plural, one {# match} other {# matches}}"

#. placeholder {0}: manager.activeWorkers
#: src/features/team/pages/HotelTeamPage.tsx
msgid "{0, plural, one {# colaborador activo} other {# colaboradores activos}}"
msgstr "{0, plural, one {# active collaborator} other {# active collaborators}}"

#. placeholder {0}: selected.people.length
#. placeholder {0}: selection.people.length
#: src/features/schedule/pages/SchedulePage.tsx
#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "{0, plural, one {# colaborador} other {# colaboradores}}"
msgstr "{0, plural, one {# collaborator} other {# collaborators}}"

#. placeholder {0}: topPerformer.conversions
#: src/features/dashboard/components/ActivityCards.tsx
msgid "{0, plural, one {# conversión} other {# conversiones}}"
msgstr "{0, plural, one {# conversion} other {# conversions}}"

#. placeholder {0}: selection.total
#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "{0, plural, one {# día elegido} other {# días elegidos}}"
msgstr "{0, plural, one {# day selected} other {# days selected}}"

#. placeholder {0}: candidates.length
#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "{0, plural, one {# hotel con propuesta} other {# hoteles con propuesta}} · cada una se edita desde la ficha del hotel"
msgstr "{0, plural, one {# hotel with a proposal} other {# hotels with a proposal}} · each one is edited from the hotel's own record"

#. placeholder {0}: result.created
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "{0, plural, one {# hotel importado al Pipeline, en Gris.} other {# hoteles importados al Pipeline, en Gris.}}"
msgstr "{0, plural, one {# hotel imported into the Pipeline, in Gray.} other {# hotels imported into the Pipeline, in Gray.}}"

#. placeholder {0}: counts.ready
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "{0, plural, one {# lista} other {# listas}}"
msgstr "{0, plural, one {# ready} other {# ready}}"

#. placeholder {0}: managers.length
#. placeholder {1}: supervisors.length
#: src/features/team/pages/HotelTeamPage.tsx
msgid "{0, plural, one {# Manager de Área} other {# Managers de Área}} y {1, plural, one {# Supervisor} other {# Supervisores}}"
msgstr "{0, plural, one {# Area Manager} other {# Area Managers}} and {1, plural, one {# Supervisor} other {# Supervisors}}"

#. placeholder {0}: result.failed
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "{0, plural, one {# no se importó.} other {# no se importaron.}}"
msgstr "{0, plural, one {# wasn't imported.} other {# weren't imported.}}"

#. placeholder {0}: contract.positionCount
#: src/features/clients/components/ClientCardGrid.tsx
msgid "{0, plural, one {# posición} other {# posiciones}}"
msgstr "{0, plural, one {# position} other {# positions}}"

#. placeholder {0}: candidates.length
#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "{0, plural, one {# prospecto en Rosa esperando aprobación} other {# prospectos en Rosa esperando aprobación}}"
msgstr "{0, plural, one {# Prospect in Pink waiting for approval} other {# Prospects in Pink waiting for approval}}"

#. placeholder {0}: owner.openProspects
#: src/features/territory/components/TerritoryOwnerPicker.tsx
msgid "{0, plural, one {# prospecto} other {# prospectos}}"
msgstr "{0, plural, one {# Prospect} other {# Prospects}}"

#. placeholder {0}: version.rates.length
#. placeholder {1}: formatMoney(cheapest)
#: src/features/onboarding/lib/summarizeRates.ts
msgid "{0, plural, one {# puesto} other {# puestos}} · desde {1} el bill"
msgstr "{0, plural, one {# position} other {# positions}} · bill from {1}"

#. placeholder {0}: member.requisitionsThisMonth ?? 0
#: src/features/team/pages/HotelTeamPage.tsx
msgid "{0, plural, one {# requisición este mes} other {# requisiciones este mes}}"
msgstr "{0, plural, one {# requisition this month} other {# requisitions this month}}"

#. placeholder {0}: hotelItems.length
#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
msgid "{0, plural, one {# requisición} other {# requisiciones}}"
msgstr "{0, plural, one {# requisition} other {# requisitions}}"

#. placeholder {0}: candidate.pendingRequirements
#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "{0, plural, one {# requisito pendiente} other {# requisitos pendientes}}"
msgstr "{0, plural, one {# pending requirement} other {# pending requirements}}"

#. placeholder {0}: board.totalFreeSlots
#. placeholder {1}: board.totalRequisitions
#: src/features/recruitment/pages/SelfPickPage.tsx
msgid "{0, plural, one {# slot libre} other {# slots libres}} en {1, plural, one {# requisición autorizada} other {# requisiciones autorizadas}}"
msgstr "{0, plural, one {# open slot} other {# open slots}} in {1, plural, one {# authorized Requisition} other {# authorized Requisitions}}"

#. placeholder {0}: group.freeSlots
#. placeholder {1}: group.requisitions
#: src/features/recruitment/pages/SelfPickHotelPage.tsx
msgid "{0, plural, one {# slot libre} other {# slots libres}} en {1, plural, one {# requisición} other {# requisiciones}}"
msgstr "{0, plural, one {# open slot} other {# open slots}} in {1, plural, one {# requisition} other {# requisitions}}"

#. placeholder {0}: manager.supervisorsInCharge ?? 0
#: src/features/team/pages/HotelTeamPage.tsx
msgid "{0, plural, one {# supervisor a cargo} other {# supervisores a cargo}}"
msgstr "{0, plural, one {# supervisor in charge} other {# supervisors in charge}}"

#. placeholder {0}: group.urgentCount
#. placeholder {0}: group.urgentRows
#: src/features/recruitment/pages/SelfPickHotelPage.tsx
#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
msgid "{0, plural, one {# urgente} other {# urgentes}}"
msgstr "{0, plural, one {# urgent} other {# urgent}}"

#. placeholder {0}: owner.zoneCount
#: src/features/territory/components/TerritoryOwnerPicker.tsx
msgid "{0, plural, one {# zona} other {# zonas}}"
msgstr "{0, plural, one {# Zone} other {# Zones}}"

#. placeholder {0}: fields.length
#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "{0, plural, one {Agregar contacto} other {Agregar # contactos}}"
msgstr "{0, plural, one {Add contact} other {Add # contacts}}"

#. placeholder {0}: values.drafts.length
#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "{0, plural, one {Contacto agregado} other {# contactos agregados}}"
msgstr "{0, plural, one {Contact added} other {# contacts added}}"

#. placeholder {0}: importable.length
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "{0, plural, one {Elegir el único hotel que se puede importar} other {Elegir los # hoteles que se pueden importar}}"
msgstr "{0, plural, one {Select the only hotel that can be imported} other {Select the # hotels that can be imported}}"

#. placeholder {0}: session.zones.length
#: src/features/audits/pages/AuditsPage.tsx
msgid "{0, plural, one {Inspeccionas los hoteles de tu zona:} other {Inspeccionas los hoteles de tus zonas:}}"
msgstr "{0, plural, one {You inspect the hotels in your zone:} other {You inspect the hotels in your zones:}}"

#. placeholder {0}: session.zones.length
#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "{0, plural, one {Solo ves los hoteles de tu zona:} other {Solo ves los hoteles de tus zonas:}}"
msgstr "{0, plural, one {You only see hotels in your zone:} other {You only see hotels in your zones:}}"

#. placeholder {0}: formatTimeIn(shift.startsAt, shift.hotelTimeZone)
#. placeholder {1}: formatTimeIn(shift.endsAt, shift.hotelTimeZone)
#: src/features/worker/pages/HomePage.tsx
msgid "{0} – {1}"
msgstr "{0} – {1}"

#. placeholder {0}: block.start
#. placeholder {1}: block.end
#. placeholder {2}: block.people.length
#: src/features/schedule/components/ScheduleTimelineGrid.tsx
#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "{0} – {1} · {2} en el turno"
msgstr "{0} – {1} · {2} on the shift"

#. placeholder {0}: role.name
#: src/features/admin/components/UserFormDialog.tsx
msgid "{0} — próximamente"
msgstr "{0} — coming soon"

#. placeholder {0}: scoped.hotelName
#. placeholder {1}: scoped.requisitionNumber
#: src/features/recruitment/pages/SelfPickPage.tsx
msgid "{0} · {1}"
msgstr "{0} · {1}"

#. placeholder {0}: target.worker.fullName
#. placeholder {1}: formatMoney(Number(target.amount))
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "{0} · {1} — el motivo queda registrado y Reclutamiento lo ve."
msgstr "{0} · {1} — the reason is logged and Recruitment sees it."

#. placeholder {0}: detail.hotelName
#. placeholder {1}: detail.department
#. placeholder {2}: detail.createdByName
#. placeholder {3}: formatDateTime(detail.createdAt)
#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "{0} · {1} · creada por {2} el {3}"
msgstr "{0} · {1} · created by {2} on {3}"

#. placeholder {0}: board.requisitionNumber
#. placeholder {1}: board.hotelName
#. placeholder {2}: board.lineNumber
#. placeholder {3}: board.positionName
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "{0} · {1} · renglón {2} · {3}"
msgstr "{0} · {1} · line {2} · {3}"

#. placeholder {0}: member.fullName
#. placeholder {1}: String(member.openProspects)
#. placeholder {2}: formatPercent(member.conversionRate)
#: src/features/dashboard/components/ActivityCards.tsx
msgid "{0} · {1} abiertos · {2}"
msgstr "{0} · {1} open · {2}"

#. placeholder {0}: formatDate(worker.birthDate)
#. placeholder {1}: worker.age
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "{0} · {1} años"
msgstr "{0} · {1} years old"

#. placeholder {0}: contract.hotelName
#. placeholder {1}: formatDate(contract.signedAt)
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "{0} · activado el {1}"
msgstr "{0} · activated on {1}"

#. placeholder {0}: contract.hotelName
#. placeholder {1}: contract.signedByName
#. placeholder {2}: formatDate(contract.signedAt)
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "{0} · activado por {1} el {2}"
msgstr "{0} · activated by {1} on {2}"

#. placeholder {0}: hotel.zone
#. placeholder {1}: workspace.owner.name
#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "{0} · BD: {1}"
msgstr "{0} · BD: {1}"

#. placeholder {0}: version.rates[0]?.positionName ?? ''
#. placeholder {1}: formatMoney(cheapest)
#: src/features/onboarding/lib/summarizeRates.ts
msgid "{0} · bill {1}"
msgstr "{0} · bill {1}"

#. placeholder {0}: contract.hotelName
#. placeholder {1}: formatDate(contract.createdAt)
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "{0} · borrador creado el {1}"
msgstr "{0} · draft created on {1}"

#. placeholder {0}: row.startTime
#. placeholder {1}: row.quantity
#: src/features/schedule/pages/SchedulePage.tsx
msgid "{0} · demanda {1}"
msgstr "{0} · demand {1}"

#. placeholder {0}: shift.position
#. placeholder {1}: formatTimeIn(shift.startsAt, shift.hotelTimeZone)
#: src/features/worker/pages/PunchPage.tsx
msgid "{0} · desde {1}"
msgstr "{0} · from {1}"

#. placeholder {0}: entry.requisitionNumber ?? t`Sin folio`
#: src/features/timesheet/components/TimesheetGrid.tsx
msgid "{0} · días de esta requisición"
msgstr "{0} · days of this requisition"

#. placeholder {0}: contract.hotelName
#. placeholder {1}: formatDate(contract.sentAt)
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "{0} · enviado el {1}"
msgstr "{0} · sent on {1}"

#. placeholder {0}: contract.hotelName
#. placeholder {1}: contract.sentByName
#. placeholder {2}: formatDate(contract.sentAt)
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "{0} · enviado por {1} el {2}"
msgstr "{0} · sent by {1} on {2}"

#. placeholder {0}: hotel.zone
#. placeholder {1}: hotel.geofenceMeters
#. placeholder {2}: hotel.timeZone
#: src/features/territory/components/HotelMapCard.tsx
msgid "{0} · geocerca {1} m · {2}"
msgstr "{0} · {1} m geofence · {2}"

#. placeholder {0}: timeline.hotelName
#. placeholder {1}: formatWeekRange(selectedWeek, addDaysIso(selectedWeek, 6))
#: src/features/schedule/pages/SchedulePage.tsx
msgid "{0} · Semana {1}"
msgstr "{0} · Week {1}"

#. placeholder {0}: shift.position
#. placeholder {1}: formatTimeIn(shift.startsAt, shift.hotelTimeZone)
#. placeholder {2}: formatTimeIn(shift.endsAt, shift.hotelTimeZone)
#: src/features/worker/pages/PunchPage.tsx
msgid "{0} · turno {1} – {2}"
msgstr "{0} · shift {1} – {2}"

#. placeholder {0}: worker.catalogPosition
#. placeholder {1}: worker.zoneName
#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "{0} · Zona {1}"
msgstr "{0} · Zone {1}"

#. placeholder {0}: owner.roleLabel
#. placeholder {1}: scope.periodLabel
#: src/features/dashboard/components/SalesDashboard.tsx
msgid "{0} · zonas {zones} · {1}"
msgstr "{0} · zones {zones} · {1}"

#. placeholder {0}: entry.fromStatus ? ONBOARDING_STATUS_LABEL[entry.fromStatus] : '—'
#. placeholder {1}: ONBOARDING_STATUS_LABEL[entry.toStatus]
#: src/features/onboarding/components/StatusTimeline.tsx
msgid "{0} → {1}"
msgstr "{0} → {1}"

#. placeholder {0}: String(Math.round(months / 12))
#: src/features/clients/pages/ClientPortfolioPage.tsx
msgid "{0} a"
msgstr "{0} yr"

#. placeholder {0}: metrics.openCount
#. placeholder {1}: metrics.urgentCount
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "{0} abiertas · {1} urgentes"
msgstr "{0} open · {1} urgent"

#. placeholder {0}: formatNumber(totals.accepted)
#: src/features/messaging/components/MessagingReportsList.tsx
msgid "{0} aceptados por Meta"
msgstr "{0} accepted by Meta"

#. placeholder {0}: member.fullName
#. placeholder {1}: target.label
#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "{0} ahora reporta a {1}."
msgstr "{0} now reports to {1}."

#. placeholder {0}: row.personal.age
#: src/features/personnel/pages/PersonnelPage.tsx
msgid "{0} años"
msgstr "{0} years old"

#. placeholder {0}: formatHours(row.totalHours + weekLunchMinutes / 60)
#: src/features/timesheet/components/AttendanceView.tsx
msgid "{0} antes del lonche (-{weekLunchMinutes} min)"
msgstr "{0} before lunch (-{weekLunchMinutes} min)"

#. placeholder {0}: formatNumber(totals.optOuts)
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "{0} bajas"
msgstr "{0} opt-outs"

#. placeholder {0}: formatNumber(totals.optOuts)
#: src/features/messaging/components/MessagingReportsList.tsx
msgid "{0} bajas después del envío"
msgstr "{0} opt-outs after sending"

#. placeholder {0}: block.people.length
#. placeholder {0}: rows.length
#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/schedule/components/ScheduleTimelineGrid.tsx
#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "{0} colaboradores"
msgstr "{0} collaborators"

#. placeholder {0}: counts.errors
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "{0} con error"
msgstr "{0} with errors"

#. placeholder {0}: matches.length
#: src/features/accounting/components/ConsolidationPayStatus.tsx
msgid "{0} Consolidados esta semana"
msgstr "{0} Consolidations this week"

#. placeholder {0}: selected.length
#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "{0} contactos elegidos"
msgstr "{0} contacts selected"

#. placeholder {0}: imported.created + imported.updated
#. placeholder {1}: imported.created
#. placeholder {2}: imported.updated
#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "{0} contactos importados: {1} nuevos y {2} actualizados."
msgstr "{0} contacts imported: {1} new and {2} updated."

#. placeholder {0}: member.quarterConversions
#: src/features/team/pages/TeamPage.tsx
msgid "{0} conv."
msgstr "{0} conv."

#. placeholder {0}: prospect.daysWithoutAttempt
#: src/features/dashboard/components/StaleProspectList.tsx
msgid "{0} d sin intento"
msgstr "{0} d without an attempt"

#. placeholder {0}: String(row.filledSlots)
#. placeholder {0}: at1.part
#. placeholder {0}: at12.part
#. placeholder {1}: String(row.totalSlots)
#. placeholder {1}: at1.whole
#. placeholder {1}: at12.whole
#: src/features/observability/components/CohortSection.tsx
#: src/features/observability/components/CohortsView.tsx
#: src/features/observability/components/KpiCard.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "{0} de {1}"
msgstr "{0} of {1}"

#. placeholder {0}: String(withMailbox)
#. placeholder {1}: String(rows.length)
#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "{0} de {1} con buzón"
msgstr "{0} of {1} with a mailbox"

#. placeholder {0}: detail.active
#: src/features/observability/components/CohortSection.tsx
msgid "{0} de {size}"
msgstr "{0} of {size}"

#. placeholder {0}: item.count
#: src/features/observability/components/CohortSection.tsx
msgid "{0} de {total}"
msgstr "{0} of {total}"

#. placeholder {0}: formatHours(row.totalHours)
#: src/features/timesheet/components/WorkerWeekSummary.tsx
msgid "{0} de la meta"
msgstr "{0} of the target"

#. placeholder {0}: formatPercent(rates.delivery)
#. placeholder {0}: formatPercent(rates.failure)
#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "{0} de los destinatarios"
msgstr "{0} of recipients"

#. placeholder {0}: formatPercent(rates.read)
#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "{0} de los entregados"
msgstr "{0} of delivered"

#. placeholder {0}: toRevoke.person.fullName
#. placeholder {1}: roleLabelOf(toRevoke.role.code).title
#: src/features/admin/components/RoleGrantsSection.tsx
msgid "{0} deja de poder trabajar como {1}. Si está trabajando con esa función ahora, vuelve a la de su alta en su siguiente acción."
msgstr "{0} can no longer work as {1}. If they are working in that role right now, they go back to their main role on their next action."

#. placeholder {0}: toRevoke.fullName
#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "{0} deja de ver «{title}». Si solo quieres pausarlo, apágalo con el interruptor: así no hay que volver a darlo."
msgstr "{0} will no longer see “{title}”. If you only want to pause it, turn it off with the switch: that way you don't have to grant it again."

#. placeholder {0}: selected.fullName
#: src/features/recruitment/components/PoolRoster.tsx
msgid "{0} deja de verse en el Pool"
msgstr "{0} is no longer shown in the Pool"

#. placeholder {0}: String(portfolio.total)
#: src/features/clients/pages/ClientPortfolioPage.tsx
msgid "{0} en cartera"
msgstr "{0} in the portfolio"

#. placeholder {0}: pool.total
#: src/features/recruitment/pages/PoolPage.tsx
msgid "{0} en el pool"
msgstr "{0} in the pool"

#. placeholder {0}: preview.blacklistedCount
#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "{0} en lista negra: se importan desactivados y no reciben mensajes."
msgstr "{0} blacklisted: imported as inactive and won't receive messages."

#. placeholder {0}: data.meta.total
#. placeholder {0}: data.pagination.total
#. placeholder {0}: tags.length
#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "{0} en total"
msgstr "{0} in total"

#. placeholder {0}: campaign.deliveredCount
#. placeholder {1}: campaign.readCount
#. placeholder {2}: campaign.failedCount
#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "{0} entregados · {1} leídos · {2} fallidos"
msgstr "{0} delivered · {1} read · {2} failed"

#. placeholder {0}: result.sent
#. placeholder {1}: result.created
#. placeholder {2}: result.updated
#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "{0} enviados a Mensajería: {1} nuevos y {2} actualizados."
msgstr "{0} sent to Messaging: {1} new and {2} updated."

#. placeholder {0}: contract.number
#: src/features/onboarding/components/ContractStepCard.tsx
msgid "{0} está con el hotel, esperando su firma."
msgstr "{0} is with the hotel, waiting for their signature."

#. placeholder {0}: contract.number
#: src/features/onboarding/components/ContractStepCard.tsx
msgid "{0} está en Borrador: termínalo y envíalo desde el contrato."
msgstr "{0} is a Draft: finish it and send it from the contract."

#. placeholder {0}: String(spot.hotels.length)
#: src/features/onboarding/components/HotelGlobeCard.tsx
msgid "{0} hoteles aquí"
msgstr "{0} hotels here"

#. placeholder {0}: String(Math.round(months))
#: src/features/clients/pages/ClientPortfolioPage.tsx
msgid "{0} m"
msgstr "{0} m"

#. placeholder {0}: String(months)
#: src/features/contracts/utils/validity.ts
msgid "{0} meses restantes"
msgstr "{0} months left"

#. placeholder {0}: record.created
#. placeholder {1}: record.updated
#. placeholder {2}: record.skipped
#: src/features/messaging/components/ContactImportsDialog.tsx
msgid "{0} nuevos · {1} actualizados · {2} omitidos"
msgstr "{0} new · {1} updated · {2} skipped"

#. placeholder {0}: counts.incomplete
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "{0} para completar"
msgstr "{0} to complete"

#. placeholder {0}: String(activeCount)
#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "{0} personas con acceso"
msgstr "{0} people with access"

#. placeholder {0}: String(rates.length)
#: src/features/contracts/components/ContractChecklist.tsx
msgid "{0} posiciones cotizadas: cada una con su pay rate y su bill rate."
msgstr "{0} positions quoted: each with its own pay rate and bill rate."

#. placeholder {0}: board?.openCount ?? 0
#. placeholder {1}: board?.zoneCount ?? 0
#: src/features/onboarding/pages/PipelinePage.tsx
msgid "{0} prospectos abiertos · {1} zonas"
msgstr "{0} open Prospects · {1} Zones"

#. placeholder {0}: String(contract.rates.length)
#. placeholder {1}: formatMoney(cheapest)
#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "{0} puestos · desde {1}"
msgstr "{0} positions · from {1}"

#. placeholder {0}: result.blacklisted ?? 0
#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "{0} quedaron desactivados por estar en lista negra."
msgstr "{0} were deactivated for being blacklisted."

#. placeholder {0}: contacts.length
#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "{0} registrados · {pendingLabel}"
msgstr "{0} saved · {pendingLabel}"

#. placeholder {0}: report.exits.total
#. placeholder {1}: report.exits.red
#. placeholder {2}: report.exits.brown
#. placeholder {3}: report.exits.black
#. placeholder {4}: IS_DEV_UI ? ' (RR-V-07)' : ''
#: src/features/reports/pages/ReportsPage.tsx
msgid "{0} salidas · Rojo {1} · Café {2} · Negro {3} — reactivables a Azul claro{4}"
msgstr "{0} exits · Red {1} · Brown {2} · Black {3} — can be reactivated into Light Blue{4}"

#. placeholder {0}: member.staleCount
#: src/features/team/pages/TeamPage.tsx
msgid "{0} sin actividad"
msgstr "{0} with no activity"

#. placeholder {0}: String(quiet)
#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "{0} sin altas ni asignaciones en 7 días o más."
msgstr "{0} with no new collaborators or assignments in 7 days or more."

#. placeholder {0}: String(fields.length)
#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "{0} sin guardar"
msgstr "{0} unsaved"

#. placeholder {0}: selection.withoutRequisition
#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "{0} sin requisición"
msgstr "{0} without a requisition"

#. placeholder {0}: result.synced
#. placeholder {1}: result.created
#. placeholder {2}: result.updated
#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "{0} sincronizadas: {1} nuevas y {2} actualizadas."
msgstr "{0} synced: {1} new and {2} updated."

#. placeholder {0}: metrics.freeSlots
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "{0} slots libres"
msgstr "{0} free slots"

#. placeholder {0}: filters.hotelName
#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "{0} tiene semanas atrasadas sin aprobar:"
msgstr "{0} has overdue weeks without approval:"

#. placeholder {0}: template.variableCount
#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "{0} variables"
msgstr "{0} variables"

#. placeholder {0}: actedHotelName || fallbackProspect
#: src/features/conversion/pages/ConversionPage.tsx
msgid "{0} volvió a renegociación"
msgstr "{0} went back to renegotiation"

#. placeholder {0}: grant.fullName
#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "{0} vuelve a tener «{title}»"
msgstr "{0} has “{title}” again"

#. placeholder {0}: actedHotelName || fallbackHotel
#: src/features/conversion/pages/ConversionPage.tsx
msgid "{0} ya es cliente activo"
msgstr "{0} is now an active client"

#. placeholder {0}: currentPrimary.name
#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "{0} ya es el principal; si marcas este, lo reemplaza"
msgstr "{0} is already the primary one; if you mark this one, it takes over"

#. placeholder {0}: contract.number
#: src/features/onboarding/components/ContractStepCard.tsx
msgid "{0} ya está vigente. Lo que sigue es convertir el hotel en cliente: pasarlo a Naranja."
msgstr "{0} is already active. Next, turn the hotel into a client: move it to Orange."

#. placeholder {0}: target.fullName
#. placeholder {1}: roleLabelOf(role.code).title
#: src/features/admin/components/RoleGrantsSection.tsx
msgid "{0} ya no trabaja como {1}"
msgstr "{0} no longer works as {1}"

#. placeholder {0}: grant.fullName
#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "{0} ya no ve «{title}» hasta que lo prendas"
msgstr "{0} won't see “{title}” until you turn it back on"

#. placeholder {0}: person.fullName
#. placeholder {1}: roleLabelOf(roleCode).title
#: src/features/admin/components/RoleGrantsSection.tsx
msgid "{0} ya puede trabajar como {1}"
msgstr "{0} can now work as {1}"

#. placeholder {0}: person.fullName
#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "{0} ya tiene «{title}»"
msgstr "{0} now has “{title}”"

#. placeholder {0}: weekRangeOf(item.week)
#. placeholder {1}: item.size
#: src/features/observability/components/CohortTimeline.tsx
msgid "{0}: {1} ingresos"
msgstr "{0}: {1} joins"

#. placeholder {0}: missingLaterFields.join(', ')
#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "{0}: eso lo completa el colaborador desde su app."
msgstr "{0}: the collaborator completes that from their app."

#. placeholder {0}: contract.hotelName
#: src/features/contracts/components/ContractPdfButton.tsx
msgid "{0}. Se firma fuera del sistema: el documento sale sin firmas."
msgstr "{0}. It is signed outside the system: the document comes out unsigned."

#. placeholder {0}: requisition.filledSlots
#. placeholder {1}: requisition.totalSlots
#: src/features/dashboard/components/RequisitionMiniList.tsx
msgid "{0}/{1} cubiertos"
msgstr "{0}/{1} covered"

#. placeholder {0}: input.body.text.length
#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "{0}/1024 · Las variables se agregan con el botón de abajo y no pueden ir al inicio ni al final."
msgstr "{0}/1024 · Add variables with the button below; they can't go at the start or the end."

#. placeholder {0}: contract.multipliers.overtime.bill.toFixed(2)
#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "{0}× lo facturado"
msgstr "{0}× the billed rate"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "{anomalies, plural, one {# día con anomalía} other {# días con anomalía}} por revisar: resuélvelos antes de enviar la semana"
msgstr "{anomalies, plural, one {# day with an anomaly} other {# days with anomalies}} to review: resolve them before sending the week"

#: src/features/audits/components/AuditFormDialog.tsx
msgid "{answeredCount} de {totalCount} contestados"
msgstr "{answeredCount} of {totalCount} answered"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "{assignedName} asignado al slot"
msgstr "{assignedName} assigned to the slot"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "{averageDays} d"
msgstr "{averageDays} d"

#: src/features/observability/components/CohortSection.tsx
msgid "{backMonday} de {size}"
msgstr "{backMonday} of {size}"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "{days, plural, one {Última actividad hace # día} other {Última actividad hace # días}}"
msgstr "{days, plural, one {Last activity # day ago} other {Last activity # days ago}}"

#: src/shared/lib/formatters.ts
msgid "{days} d en estado"
msgstr "{days} d in status"

#: src/features/observability/components/KpiCard.tsx
#: src/shared/lib/formatters.ts
msgid "{days} días"
msgstr "{days} days"

#: src/features/accounting/components/ConsolidationPayStatus.tsx
msgid "{daysLate, plural, one {# día de atraso} other {# días de atraso}}"
msgstr "{daysLate, plural, one {# day late} other {# days late}}"

#: src/features/requisitions/components/RequisitionCardList.tsx
msgid "{department} · {positions, plural, one {# posición} other {# posiciones}}"
msgstr "{department} · {positions, plural, one {# position} other {# positions}}"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "{failing, plural, one {# con problema} other {# con problemas}}"
msgstr "{failing, plural, one {# with a problem} other {# with problems}}"

#: src/features/requisitions/components/CoverageBar.tsx
msgid "{filled} de {total} posiciones · {label}"
msgstr "{filled} of {total} positions · {label}"

#: src/features/recruitment/components/SelfPickHotelCardList.tsx
#: src/features/recruitment/components/SelfPickPositionCard.tsx
msgid "{freeSlots, plural, one {# slot libre} other {# slots libres}}"
msgstr "{freeSlots, plural, one {# open slot} other {# open slots}}"

#: src/features/recruitment/components/SelfPickHotelCardList.tsx
msgid "{freeSlots} de {totalFreeSlots} coinciden con los filtros"
msgstr "{freeSlots} of {totalFreeSlots} match the filters"

#: src/features/messaging/components/Pager.tsx
msgid "{from}–{to} de {total}"
msgstr "{from}–{to} of {total}"

#: src/features/recruitment/components/DeleteWorkerDialog.tsx
msgid "{fullName} deja de aparecer en el Pool y en toda búsqueda. Si tiene correo corporativo, también se elimina su buzón."
msgstr "{fullName} will no longer show up in the Pool or in any search. If they have a corporate email, their mailbox is deleted too."

#: src/features/admin/components/PendingHotelUsers.tsx
msgid "{fullName} queda activo y le llega su invitación"
msgstr "{fullName} is now active and their invitation is on its way"

#: src/features/admin/components/PendingHotelUsers.tsx
msgid "{fullName} queda sin aprobar; se avisó a quien la propuso"
msgstr "{fullName} stays unapproved; whoever proposed them was notified"

#: src/features/recruitment/components/DeleteWorkerDialog.tsx
msgid "{fullName} se eliminó del Pool"
msgstr "{fullName} was removed from the Pool"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "{hidden, plural, one {# más: búscala en el Pool de Colaboradores} other {# más: búscalas en el Pool de Colaboradores}}"
msgstr "{hidden, plural, one {# more: find it in the Collaborator Pool} other {# more: find them in the Collaborator Pool}}"

#. placeholder {0}: ONBOARDING_STATUS_LABEL[currentStatus]
#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "{hotelName} · desde {0}. Solo ves los pasos que tu rol puede dar."
msgstr "{hotelName} · from {0}. You only see the steps your role can take."

#. placeholder {0}: version.version
#: src/features/onboarding/components/ContractPreviewDialog.tsx
msgid "{hotelName} · Propuesta v{0}. Las tarifas se toman de esta versión."
msgstr "{hotelName} · Proposal v{0}. The rates come from this version."

#: src/features/onboarding/components/ContractUnlockedDialog.tsx
msgid "{hotelName} pasó a Amarillo: el contrato nace con las tarifas que ya se cotizaron en la propuesta — las revisas, ajustas lo que se haya negociado y lo guardas en Borrador."
msgstr "{hotelName} moved to Yellow: the contract starts with the rates already quoted in the proposal — you review them, adjust what was negotiated, and save it as a Draft."

#: src/features/onboarding/components/CreateProposalPromptDialog.tsx
msgid "{hotelName} ya está en Verde: puedes armar y enviar su propuesta aquí mismo, o hacerlo después desde su ficha."
msgstr "{hotelName} is now in Green: you can put together and send its proposal right here, or do it later from its profile."

#: src/features/recruitment/components/SelfPickHotelCardList.tsx
msgid "{hotelName}: {freeSlots, plural, one {ver su # slot libre} other {ver sus # slots libres}}"
msgstr "{hotelName}: {freeSlots, plural, one {see its # open slot} other {see its # open slots}}"

#: src/features/requisitions/components/HotelRequisitionCardList.tsx
msgid "{hotelName}: {total, plural, one {ver su # requisición} other {ver sus # requisiciones}}"
msgstr "{hotelName}: {total, plural, one {see its # requisition} other {see its # requisitions}}"

#. placeholder {0}: members.length - leadCount
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "{leadCount, plural, one {# Líder} other {# Líderes}} y {0, plural, one {# Reclutadora} other {# Reclutadoras}}"
msgstr "{leadCount, plural, one {# Group Leader} other {# Group Leaders}} and {0, plural, one {# Recruiter} other {# Recruiters}}"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "{memberCount, plural, one {# BD te reporta} other {# BDs te reportan}} · {totalOpen} prospectos abiertos y {totalConversions, plural, one {# conversión} other {# conversiones}} entre todos."
msgstr "{memberCount, plural, one {# BD reports to you} other {# BDs report to you}} · {totalOpen} open prospects and {totalConversions, plural, one {# conversion} other {# conversions}} between them."

#: src/shared/components/RefreshControl.tsx
msgid "{minutos, plural, one {Actualizado hace # minuto} other {Actualizado hace # minutos}}"
msgstr "{minutos, plural, one {Updated # minute ago} other {Updated # minutes ago}}"

#: src/features/schedule/pages/SchedulePage.tsx
msgid "{missing, plural, one {# hueco} other {# huecos}}"
msgstr "{missing, plural, one {# gap} other {# gaps}}"

#: src/features/messaging/components/ContactActions.tsx
msgid "{name} quedó dado de baja."
msgstr "{name} is opted out."

#: src/features/messaging/components/ContactActions.tsx
msgid "{name} se eliminó."
msgstr "{name} was deleted."

#: src/features/requisitions/components/RequisitionCardList.tsx
msgid "{number} · {department} · {positions, plural, one {# posición} other {# posiciones}}"
msgstr "{number} · {department} · {positions, plural, one {# position} other {# positions}}"

#: src/features/timesheet/components/BulkApproveButton.tsx
msgid "{okCount} se aprobaron; {failCount} no — algo cambió mientras tanto. Revísalas una por una."
msgstr "{okCount} were approved; {failCount} weren't — something changed in between. Review them one by one."

#: src/features/timesheet/components/BulkApproveButton.tsx
msgid "{okCount} semanas aprobadas"
msgstr "{okCount} weeks approved"

#: src/features/requisitions/components/HotelRequisitionCardList.tsx
msgid "{openCount, plural, one {# abierta} other {# abiertas}}"
msgstr "{openCount, plural, one {# open} other {# open}}"

#: src/shared/components/CardPagination.tsx
msgid "{page} de {totalPages}"
msgstr "{page} of {totalPages}"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "{pending, plural, one {# pendiente} other {# pendientes}}"
msgstr "{pending, plural, one {# pending} other {# pending}}"

#: src/features/messaging/components/WorkersSyncNotice.tsx
msgid "{pending} colaboradores nuevos sin sincronizar"
msgstr "{pending} new workers not synced"

#: src/features/recruitment/pages/PoolPage.tsx
msgid "{pendingDocsCount} por verificar"
msgstr "{pendingDocsCount} to verify"

#: src/features/dashboard/components/RecruitmentDashboard.tsx
msgid "{pendingValidation} en Blanco, por validar"
msgstr "{pendingValidation} in White, pending validation"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "{positionCount, plural, one {# posición} other {# posiciones}} · {totalSlots, plural, one {# slot} other {# slots}}"
msgstr "{positionCount, plural, one {# position} other {# positions}} · {totalSlots, plural, one {# slot} other {# slots}}"

#: src/features/requisitions/components/HotelRequisitionCardList.tsx
msgid "{positions, plural, one {# posición} other {# posiciones}}"
msgstr "{positions, plural, one {# position} other {# positions}}"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "{previousLifted, plural, one {# levantado} other {# levantados}}"
msgstr "{previousLifted, plural, one {# lifted} other {# lifted}}"

#: src/features/worker/pages/HomePage.tsx
msgid "{punched} de 4"
msgstr "{punched} of 4"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "{quantity, plural, one {# slot libre} other {# slots libres}}"
msgstr "{quantity, plural, one {# free slot} other {# free slots}}"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "{reason}: revisa la fecha de nacimiento."
msgstr "{reason}: check the date of birth."

#: src/features/recruitment/components/SelfPickHotelCardList.tsx
msgid "{requisitions, plural, one {# requisición} other {# requisiciones}}"
msgstr "{requisitions, plural, one {# requisition} other {# requisitions}}"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "{selectedCount, plural, one {Importar # hotel} other {Importar # hoteles}}"
msgstr "{selectedCount, plural, one {Import # hotel} other {Import # hotels}}"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "{sentCount} de {totalRecipients} enviados"
msgstr "{sentCount} of {totalRecipients} sent"

#: src/features/requisitions/components/RequisitionSummaryStrip.tsx
msgid "{slotCount} · {occupiedCount} asignadas"
msgstr "{slotCount} · {occupiedCount} assigned"

#: src/features/requisitions/components/RequisitionSummaryStrip.tsx
msgid "{slotCount} · {occupiedCount} ocupados"
msgstr "{slotCount} · {occupiedCount} taken"

#. placeholder {0}: position.startTime
#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "{slots, plural, one {# slot} other {# slots}} · desde {startDate} · {0}"
msgstr "{slots, plural, one {# slot} other {# slots}} · from {startDate} · {0}"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "{staleCount} sin actividad 7+ días"
msgstr "{staleCount} with no activity for 7+ days"

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "{statusLabel} es un estado final: el ciclo ya no cambia de estado"
msgstr "{statusLabel} is a final status: the cycle doesn't change status any more"

#: src/features/onboarding/components/HotelGlobeCard.tsx
msgid "{title}. Abrir en Mi Territorio"
msgstr "{title}. Open in My Territory"

#: src/features/requisitions/components/HotelRequisitionCardList.tsx
msgid "{total, plural, one {# requisición} other {# requisiciones}}"
msgstr "{total, plural, one {# requisition} other {# requisitions}}"

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
msgid "{total} colaboradores sin teléfono válido"
msgstr "{total} workers without a valid phone"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "{totalConversions, plural, one {# hotel convertido} other {# hoteles convertidos}} por tu equipo · tasa {teamRateLabel}"
msgstr "{totalConversions, plural, one {# hotel converted} other {# hotels converted}} by your team · rate {teamRateLabel}"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "{typedLength} caracteres. Lista para guardar."
msgstr "{typedLength} characters. Ready to save."

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "{unmarked, plural, one {# día sin marca ni estado} other {# días sin marca ni estado}}: marca Descanso, OFF… en cada uno antes de enviar la semana"
msgstr "{unmarked, plural, one {# day without a mark or a status} other {# days without a mark or a status}}: mark Rest, OFF… on each one before sending the week"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "{unresolvedCount, plural, one {# hoja sin tarifa, no incluida} other {# hojas sin tarifa, no incluidas}}"
msgstr "{unresolvedCount, plural, one {# sheet without a rate, not included} other {# sheets without a rate, not included}}"

#: src/features/requisitions/components/HotelRequisitionCardList.tsx
msgid "{urgentCount, plural, one {# urgente} other {# urgentes}}"
msgstr "{urgentCount, plural, one {# urgent} other {# urgent}}"

#: src/features/recruitment/components/SelfPickHotelCardList.tsx
msgid "{urgentRows, plural, one {# urgente} other {# urgentes}}"
msgstr "{urgentRows, plural, one {# urgent} other {# urgent}}"

#: src/features/clients/components/ClientSpotlightCard.tsx
msgid "{value} m"
msgstr "{value} m"

#: src/features/personnel/components/StandByDialog.tsx
msgid "{workerName} quedó en Stand-by"
msgstr "{workerName} is now on Stand-by"

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "{workerName} quedó reportado"
msgstr "{workerName} has been reported"

#: src/features/clients/components/ClientSpotlightCard.tsx
msgid "{years} a"
msgstr "{years} yr"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "% acumulado de destinatarios desde el inicio del envío."
msgstr "Cumulative % of recipients since sending started."

#: src/features/messaging/components/ReportCharts.tsx
msgid "% de destinatarios"
msgstr "% of recipients"

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "← Volver a iniciar sesión"
msgstr "← Back to sign in"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "+ Agregar posición"
msgstr "+ Add position"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "+ Enlace"
msgstr "+ Link"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "+ Llamar"
msgstr "+ Call"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "+ Nueva etiqueta"
msgstr "+ New tag"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "+ Nueva plantilla"
msgstr "+ New template"

#: src/features/messaging/components/ContactActions.tsx
msgid "+ Nuevo contacto"
msgstr "+ New contact"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "+ Respuesta rápida"
msgstr "+ Quick reply"

#: src/features/recruitment/components/SelfPickHotelCardList.tsx
msgid "+{hidden} más"
msgstr "+{hidden} more"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "<0>Casos escalados.</0> Los que te escalan Líderes e Inspectores llegarán con la pantalla de <1>Incidencias</1>."
msgstr "<0>Escalated cases.</0> The ones Group Leaders and Inspectors escalate to you will arrive with the <1>Incidents</1> screen."

#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "<0>El contrato {activeContractNumber} queda vencido.</0> Solo puede haber uno vigente por hotel."
msgstr "<0>Contract {activeContractNumber} becomes expired.</0> Only one can be in force per hotel."

#. placeholder {0}: IS_DEV_UI ? ' (RR-15)' : ''
#: src/features/recruitment/pages/SelfPickPage.tsx
msgid "<0>Gana el primero que confirma{0}.</0> Al tomar un slot se bloquea solo ese slot, no la requisición completa: otra Reclutadora puede seguir tomando los demás de la misma posición."
msgstr "<0>First to confirm wins{0}.</0> Taking a slot locks only that slot, not the whole Requisition: another Recruiter can keep taking the rest of the same position."

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "<0>Indicador de Calidad.</0> Lo mide QA, que todavía no tiene su módulo."
msgstr "<0>Quality Indicator.</0> QA measures it, and QA doesn't have its module yet."

#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "<0>Tarifas y términos quedan bloqueados.</0> Si hace falta corregir algo, se desbloquea con un motivo."
msgstr "<0>Rates and terms get locked.</0> If something needs correcting, unlock it with a reason."

#. placeholder {0}: rate.payRate.toFixed(2)
#. placeholder {1}: rate.billRate.toFixed(2)
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "${0} pay · ${1} bill"
msgstr "${0} pay · ${1} bill"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "1 · La plantilla"
msgstr "1 · The template"

#: src/features/messaging/components/WorkersSyncNotice.tsx
msgid "1 colaborador nuevo sin sincronizar"
msgstr "1 new worker not synced"

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
msgid "1 colaborador sin teléfono válido"
msgstr "1 worker without a valid phone"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "1 contacto elegido"
msgstr "1 contact selected"

#: src/features/contracts/utils/validity.ts
msgid "1 mes restante"
msgstr "1 month left"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "1 persona con acceso"
msgstr "1 person with access"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "1 posición cotizada, con su pay rate y su bill rate."
msgstr "1 position quoted, with its pay rate and its bill rate."

#. placeholder {0}: formatMoney(cheapest)
#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "1 puesto · {0} el bill"
msgstr "1 position · {0} the bill rate"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "1 sin guardar"
msgstr "1 unsaved"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "1 variable"
msgstr "1 variable"

#: src/shared/constants/workerEnums.ts
msgid "1–2 años"
msgstr "1–2 years"

#: src/features/personnel/components/WorkerPerformanceRadar.tsx
msgid "100 = todos sus días salieron bien en esa medida"
msgstr "100 = every day went well on that measure"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "2 · Arrastra el archivo o elígelo"
msgstr "2 · Drag the file here or choose it"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "2 camaristas y 1 houseman"
msgstr "2 housekeepers and 1 houseman"

#: src/shared/constants/workerEnums.ts
msgid "3–5 años"
msgstr "3–5 years"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "a bill rate"
msgstr "at bill rate"

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "A bill rate, no a lo que pagamos"
msgstr "At bill rate, not what we pay"

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "A este correo le llega el contrato para firmar."
msgstr "The contract to sign is sent to this email."

#: src/features/messaging/components/CampaignsTour.tsx
msgid "A estos colaboradores no les llega nada hasta que corrijas su teléfono en su expediente y vuelvas a sincronizar."
msgstr "These workers get nothing until you fix their phone in their file and sync again."

#: src/features/worker/pages/Phase3Page.tsx
msgid "A quién llamamos y qué debemos saber"
msgstr "Who we call and what we should know"

#: src/features/messaging/pages/MessagingPage.tsx
msgid "A quién se le escribe"
msgstr "Who gets the messages"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "A quien tenga al menos una de las etiquetas elegidas."
msgstr "Anyone with at least one of the selected tags."

#: src/shared/constants/workerEnums.ts
msgid "A+"
msgstr "A+"

#: src/shared/constants/workerEnums.ts
msgid "A−"
msgstr "A−"

#: src/shared/constants/workerEnums.ts
msgid "AB+"
msgstr "AB+"

#: src/shared/constants/workerEnums.ts
msgid "AB−"
msgstr "AB−"

#: src/shared/constants/timesheetStatus.ts
msgid "Abierta"
msgstr "Open"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Abiertas"
msgstr "Open"

#: src/features/dashboard/components/StatusFunnel.tsx
msgid "abiertos"
msgstr "open"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Abiertos"
msgstr "Open"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "Abre la hoja lista para descargar como PDF"
msgstr "Opens the sheet ready to download as PDF"

#: src/features/contracts/components/ContractSignatureCard.tsx
#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Abriendo DocuSign…"
msgstr "Opening DocuSign…"

#: src/features/worker/components/CameraCapture.tsx
msgid "Abriendo la cámara…"
msgstr "Opening the camera…"

#: src/app/RequireSession.tsx
msgid "Abriendo tu sesión…"
msgstr "Opening your session…"

#: src/features/onboarding/components/CreateProposalPromptDialog.tsx
#: src/features/onboarding/components/ViewProposalDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Abriendo…"
msgstr "Opening…"

#: src/features/contracts/components/ContractTable.tsx
msgid "Abrir"
msgstr "Open"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Abrir el original en pestaña nueva ↗"
msgstr "Open the original in a new tab ↗"

#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Abrir en el editor"
msgstr "Open in the editor"

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
msgid "Abrir expediente"
msgstr "Open profile"

#: src/features/clients/components/ClientSpotlightCard.tsx
#: src/features/territory/components/HotelMapCard.tsx
msgid "Abrir ficha del hotel"
msgstr "Open the hotel record"

#: src/features/timesheet/components/WorkerWeekSummary.tsx
msgid "Abrir la requisición"
msgstr "Open the requisition"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "Abrir la semana de este día en la vista Días"
msgstr "Open this day's week in the Days view"

#: src/features/onboarding/components/ProposalVersionList.tsx
#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Abrir propuesta"
msgstr "Open Proposal"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Abrir su correo"
msgstr "Open their email"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Abrir versión nueva"
msgstr "Open a new version"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Acceso"
msgstr "Access"

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Acceso creado"
msgstr "Access created"

#. placeholder {0}: grant.fullName
#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Acceso de {0}"
msgstr "Access for {0}"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Acceso y contraseñas"
msgstr "Access and passwords"

#: src/features/admin/pages/FeatureAccessPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Accesos especiales"
msgstr "Special access"

#: src/features/observability/lib/cohorts.ts
#: src/shared/constants/workerStatus.ts
msgid "Accidentado"
msgstr "Injured"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Accidente abierto"
msgstr "Open accident"

#: src/features/observability/lib/cohorts.ts
msgid "Accidente laboral"
msgstr "Work accident"

#: src/layouts/Sidebar.tsx
msgid "Accidentes"
msgstr "Work Accidents"

#: src/features/observability/tabs/InspectionTab.tsx
msgid "Accidentes levantados a tiempo, inspecciones programadas y visitas a hoteles todavía no se pueden medir: el Manager de QA no lee accidentes y el sistema no guarda inspecciones programadas ni visitas."
msgstr "Accidents raised on time, scheduled inspections, and hotel visits can't be measured yet: the QA Manager doesn't read accidents, and the system doesn't store scheduled inspections or visits."

#: src/features/observability/lib/inspectionKpis.ts
msgid "Accidentes que todavía no se cierran, de todos los hoteles."
msgstr "Accidents still open, across all hotels."

#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/contracts/components/ContractTable.tsx
#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Acciones"
msgstr "Actions"

#. placeholder {0}: slot.assigneeName ?? ''
#. placeholder {0}: slot.workerName ?? ''
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/SlotList.tsx
msgid "Acciones de {0}"
msgstr "Actions for {0}"

#: src/features/messaging/components/ReportCharts.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Aceptados por Meta"
msgstr "Accepted by Meta"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Aceptando…"
msgstr "Accepting…"

#: src/features/onboarding/components/HotelLocationMap.tsx
msgid "Acercar"
msgstr "Zoom in"

#: src/features/worker/components/useFaceGuide.ts
msgid "Acércate un poco"
msgstr "Move a little closer"

#: src/features/messaging/components/TemplateDetailDialog.tsx
msgid "Activa"
msgstr "Active"

#: src/features/onboarding/components/HotelDataCard.tsx
msgid "Activado como cliente"
msgstr "Activated as a client"

#: src/features/contracts/components/ActivateContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Activando…"
msgstr "Activating…"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Activar contrato"
msgstr "Activate contract"

#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "Activar el contrato"
msgstr "Activate the contract"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Activar es del BDC"
msgstr "Activating is the BDC's job"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Activar, expirar o cancelar un contrato es del BDC."
msgstr "Activating, expiring or cancelling a contract is the BDC's job."

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Actividad"
msgstr "Activity"

#: src/features/observability/components/PeopleView.tsx
msgid "Actividad en el periodo"
msgstr "Activity in the period"

#: src/features/admin/components/ColaboradorAccountsSection.tsx
#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/worker/pages/PermissionsPage.tsx
#: src/shared/constants/contractStatus.ts
msgid "Activo"
msgstr "Active"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Activo — puede entrar al sistema"
msgstr "Active — can sign in"

#: src/features/admin/components/userListParts.tsx
msgid "Activos"
msgstr "Active"

#: src/features/messaging/components/CampaignsTour.tsx
msgid "Actualiza el estado"
msgstr "Refresh the status"

#: src/features/messaging/components/tours.ts
msgid "Actualiza sin recargar"
msgstr "Refresh without reloading"

#: src/shared/components/RefreshControl.tsx
msgid "Actualizado hace un momento"
msgstr "Updated just now"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Actualizados"
msgstr "Updated"

#: src/features/contracts/components/ProposalSyncNotice.tsx
#: src/features/messaging/components/RefreshButton.tsx
#: src/features/timesheet/components/CorrectPunchDialog.tsx
#: src/features/timesheet/components/ManualPunchDialog.tsx
#: src/shared/components/RefreshControl.tsx
msgid "Actualizando…"
msgstr "Updating…"

#: src/features/messaging/components/RefreshButton.tsx
#: src/shared/components/RefreshControl.tsx
msgid "Actualizar"
msgstr "Refresh"

#: src/shared/components/RefreshControl.tsx
msgid "Actualizar {label}"
msgstr "Refresh {label}"

#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "Actualizar con la v{latestVersion}"
msgstr "Update to v{latestVersion}"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Actualizar estado"
msgstr "Refresh status"

#: src/shared/constants/roles.ts
msgid "Administrador"
msgstr "Administrator"

#: src/shared/constants/roles.ts
msgid "Agente de Customer Service"
msgstr "Customer Service Agent"

#: src/features/onboarding/types/hotelContactsForm.schema.ts
msgid "Agrega al menos un contacto"
msgstr "Add at least one contact"

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "Agrega al menos un puesto con su tarifa"
msgstr "Add at least one position with its rate"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Agrega al menos un puesto con su tarifa: el cuadro es lo que el hotel acepta."
msgstr "Add at least one position with its rate: this table is what the hotel agrees to."

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "Agrega al menos una posición"
msgstr "Add at least one position"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Agrega la tarifa al contrato del hotel y pulsa «Recalcular»: esta factura las va a incluir."
msgstr "Add the rate to the hotel's contract and press «Recalculate»: this invoice will include them."

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Agrega la tarifa en el contrato del hotel, o la tarifa interna del colaborador, y vuelve a cerrar la semana: lo que ya se cerró no se duplica."
msgstr "Add the rate to the hotel's contract, or the collaborator's internal rate, and close the week again: what was already closed won't be duplicated."

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Agregando…"
msgstr "Adding…"

#. placeholder {0}: i18n._(editor.noun)
#. placeholder {0}: i18n._(tab.noun)
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Agregar {0}"
msgstr "Add {0}"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Agregar a Blacklist"
msgstr "Add to Blacklist"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Agregar contacto"
msgstr "Add contact"

#: src/features/admin/components/HotelUsersSection.tsx
msgid "Agregar cuenta del hotel"
msgstr "Add hotel account"

#: src/features/accounting/components/AddDeductionDialog.tsx
#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Agregar deducción"
msgstr "Add deduction"

#. placeholder {0}: consolidation.worker.fullName
#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Agregar deducción a {0}"
msgstr "Add deduction for {0}"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Agregar la entrada que falta"
msgstr "Add the missing clock-in"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Agregar la salida que falta"
msgstr "Add the missing clock-out"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Agregar marca manual"
msgstr "Add manual punch"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Agregar motivo"
msgstr "Add reason"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Agregar otra posición"
msgstr "Add another position"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Agregar otro"
msgstr "Add another"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Agregar otro contacto"
msgstr "Add another contact"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Agregar posición"
msgstr "Add position"

#: src/features/onboarding/components/ProposalRateFields.tsx
msgid "Agregar puesto"
msgstr "Add position"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Agregar reactivo"
msgstr "Add item"

#: src/features/schedule/components/AddShiftDialog.tsx
#: src/features/schedule/pages/SchedulePage.tsx
msgid "Agregar turno"
msgstr "Add shift"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Agregar un gasto extra (p. ej. Uber)"
msgstr "Add an extra expense (e.g. Uber)"

#: src/features/admin/pages/UsersPage.tsx
msgid "Agregar usuario"
msgstr "Add user"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Agregar variable"
msgstr "Add variable"

#: src/features/observability/components/CohortsView.tsx
msgid "Agrupar por"
msgstr "Group by"

#: src/features/observability/components/KpiCard.tsx
#: src/layouts/RoleSwitcher.tsx
msgid "Ahora"
msgstr "Now"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Ahora sigue Reclutamiento"
msgstr "Recruitment is up next"

#. placeholder {0}: roleLabelOf(roleCode).title
#: src/layouts/RoleSwitcher.tsx
msgid "Ahora trabajas como {0}"
msgstr "You are now working as {0}"

#. placeholder {0}: row.workerName
#: src/features/timesheet/components/AttendanceView.tsx
msgid "Ahora viendo a {0}"
msgstr "Now viewing {0}"

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "ajusta la tarifa de su posición"
msgstr "adjusts their position's rate"

#: src/features/contracts/components/EditRateDialog.tsx
msgid "Ajusta lo que ya se cotizó en la propuesta para esta posición."
msgstr "Adjust what was already quoted in the proposal for this position."

#: src/shared/hooks/useResizableSplit.ts
msgid "Ajustar ancho del formulario"
msgstr "Adjust form width"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Ajustar la tarifa de esta posición"
msgstr "Adjust this position's rate"

#: src/features/timesheet/components/PendingAdjustmentsChip.tsx
msgid "Ajuste a la tarifa de la posición"
msgstr "Adjustment to the position's rate"

#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "Ajuste aprobado"
msgstr "Adjustment approved"

#. placeholder {0}: formatMoney(Number(rateRequested))
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Ajuste de {0} pedido: pendiente de aprobación."
msgstr "Adjustment of {0} requested: pending approval."

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "Ajuste de tarifa"
msgstr "Rate adjustment"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Ajuste de tarifa pedido: queda pendiente de que lo apruebe el Manager de QA"
msgstr "Rate adjustment requested: pending the QA Manager's approval"

#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "Ajuste rechazado"
msgstr "Adjustment rejected"

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Ajustes a incluir"
msgstr "Adjustments to include"

#: src/features/admin/pages/MailSettingsPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Ajustes del correo"
msgstr "Email settings"

#. placeholder {0}: formatMoney(Number(payPreview.deductionAmount))
#: src/features/timesheet/components/PayPreviewBadge.tsx
msgid "Ajustes incluidos -{0}"
msgstr "Adjustments included -{0}"

#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
#: src/layouts/Sidebar.tsx
msgid "Ajustes pendientes"
msgstr "Pending Adjustments"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Al 100% (Azul claro)"
msgstr "At 100% (Light blue)"

#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "Al activarlo, este hotel <0>empieza a cobrar</0>: desde la fecha de vigencia, la nómina de su gente y la factura del hotel se calculan con estas tarifas."
msgstr "Once you activate it, this hotel <0>starts billing</0>: from the start date, its people's payroll and the hotel's invoice are calculated with these rates."

#: src/features/conversion/components/ApproveConversionDialog.tsx
msgid "Al convertirlo"
msgstr "When you convert it"

#. placeholder {0}: atCost.map((rate) => rate.positionName).join(', ')
#: src/features/contracts/components/ContractChecklist.tsx
msgid "Al costo, sin margen para Oranje: {0}. Es válido; si no era la intención, corrígelo con «Editar tarifas»."
msgstr "At cost, no margin for Oranje: {0}. That's allowed; if it wasn't intended, fix it with “Edit rates”."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Al crear la cuenta, la persona recibe un correo de invitación y establece su contraseña."
msgstr "When the account is created, the person gets an invitation email and sets their own password."

#. placeholder {0}: currentPrimary.name
#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "al guardar, {0} deja de serlo"
msgstr "on save, {0} stops being the primary one"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Al hotel le llega el PDF para imprimirlo y firmarlo"
msgstr "The hotel gets the PDF to print and sign"

#. placeholder {0}: i18n._(effect.lead)
#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "Al incluirlo, <0>{0}</0>: entra en la próxima corrida de pago de esta semana, la que corres desde el Consolidado."
msgstr "Once included, <0>{0}</0>: it enters the next pay run for this week, the one you run from the Consolidation."

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "Al levantarlo, el colaborador vuelve a <0>Blanco</0> — no a disponible: reingresa por la validación de la Reclutadora."
msgstr "Once lifted, the Collaborator goes back to <0>White</0> — not to available: they re-enter through the Recruiter's validation."

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "Al levantarlo, la persona reingresa por la validación de la Reclutadora, como si empezara."
msgstr "Once lifted, the person re-enters through the Recruiter's validation, as if starting over."

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Al marcar a otro como principal, el anterior deja de serlo en el mismo guardado."
msgstr "Marking another contact as the primary one drops the previous one in the same save."

#: src/features/worker/pages/HomePage.tsx
msgid "Al ponchar se abre la cámara"
msgstr "The camera opens when you punch in"

#: src/features/worker/pages/PunchPage.tsx
msgid "Al tocar el botón se abre la cámara. La foto confirma que eres tú; no se comparte con el hotel."
msgstr "Tapping the button opens the camera. The photo confirms it's you; it isn't shared with the hotel."

#: src/features/onboarding/components/HotelLocationMap.tsx
msgid "Alejar"
msgstr "Zoom out"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Alergias o condiciones médicas"
msgstr "Allergies or medical conditions"

#: src/features/admin/components/PendingHotelUsers.tsx
msgid "Algo en el sistema todavía depende de esta cuenta. Repórtalo para revisarlo."
msgstr "Something in the system still depends on this account. Report it so it can be reviewed."

#: src/app/RouteErrorPage.tsx
msgid "Algo salió mal al abrir esta pantalla. Vuelve a cargarla para intentarlo de nuevo."
msgstr "Something went wrong opening this screen. Reload it to try again."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Alguien más borró un reactivo de esta lista: recarga para ver el orden real."
msgstr "Someone else deleted an item from this list: reload to see the real order."

#. placeholder {0}: String(slotElegido)
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Alguien tomó el lugar {0} mientras llenabas esto. Se asignará el siguiente libre."
msgstr "Someone took slot {0} while you were filling this in. The next free one will be used."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Alta de personal del sistema"
msgstr "New internal staff account"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Alta de una cuenta del hotel"
msgstr "New hotel account"

#. placeholder {0}: formatDayMonth(worker.createdAt)
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Alta del {0}"
msgstr "Created {0}"

#: src/features/worker/pages/ProfilePage.tsx
msgid "Alta en Oranje"
msgstr "Joined Oranje"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Altas · 30 d"
msgstr "New · 30 d"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Altas · 30 días"
msgstr "New collaborators · 30 days"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Altas (30 días)"
msgstr "New collaborators (30 days)"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Altas de tu equipo todavía en Blanco"
msgstr "Collaborators your team created, still in White"

#: src/shared/components/ApprovalTimelinessPanel.tsx
#: src/shared/constants/onboardingStatus.ts
msgid "Amarillo"
msgstr "Yellow"

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "Amarillo · desviación"
msgstr "Yellow · deviation"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/audits/components/AuditHistoryList.tsx
msgid "Ambiente y Recursos"
msgstr "Environment & Resources"

#: src/features/admin/pages/UsersPage.tsx
msgid "Ámbito"
msgstr "Scope"

#: src/shared/constants/workerEnums.ts
msgid "Amistad"
msgstr "Friend"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Análisis con historia; el pulso de hoy vive en el Dashboard"
msgstr "Analysis with history; today's pulse lives in the Dashboard"

#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "Ancho de columna"
msgstr "Column width"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Anomalía sin resolver"
msgstr "Unresolved anomaly"

#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/components/ContactImportsDialog.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/components/Pager.tsx
#: src/features/messaging/components/Tour.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
#: src/shared/components/CardPagination.tsx
msgid "Anterior"
msgstr "Previous"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Antes de activar:"
msgstr "Before activating:"

#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "Antes de actualizar:"
msgstr "Before updating:"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "antes de deducciones"
msgstr "before deductions"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Antes de enviar o activar:"
msgstr "Before sending or activating:"

#: src/features/contracts/components/ContractPdfButton.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Antes de enviar:"
msgstr "Before sending:"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Antes de guardar o enviar:"
msgstr "Before saving or sending:"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Antes de guardar:"
msgstr "Before saving:"

#: src/features/accounting/pages/AccountingPendingPages.tsx
msgid "Antes de pagar, se revisa"
msgstr "Review before paying"

#. placeholder {0}: failing.map((check) => check.title.toLowerCase()).join(' · ')
#: src/features/contracts/components/ContractNextStep.tsx
msgid "Antes hay que resolver: {0}."
msgstr "First you have to resolve: {0}."

#: src/features/observability/lib/hotelKpis.ts
msgid "Anticipación"
msgstr "Lead time"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Apagado"
msgstr "Off"

#: src/features/observability/tabs/SalesTab.tsx
msgid "Aparece quien tiene prospectos o registró intentos. Quien no tiene cartera ni actividad no se puede listar desde aquí. Las conversiones se le cuentan al dueño del prospecto."
msgstr "Shows whoever has prospects or logged attempts. Anyone without a portfolio or activity can't be listed from here. Conversions count toward the prospect's owner."

#: src/features/messaging/components/ContactActions.tsx
msgid "Apellido"
msgstr "Last name"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Apellido del contacto"
msgstr "Contact's last name"

#: src/features/observability/pages/ObservabilityPage.tsx
msgid "Aprobación de ponches"
msgstr "Punch approval"

#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Aprobación oportuna de ponches"
msgstr "Timely punch approval"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
#: src/features/messaging/components/MessagingTemplatesList.tsx
#: src/shared/constants/timesheetStatus.ts
msgid "Aprobada"
msgstr "Approved"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Aprobada y enviada a Oranje"
msgstr "Approved and sent to Oranje"

#: src/features/accounting/types/settlement.constants.ts
msgid "Aprobada, sin enviar"
msgstr "Approved, not sent"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Aprobada. Falta registrar el envío al hotel."
msgstr "Approved. Sending to the hotel still needs to be recorded."

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
msgid "Aprobado no es lo mismo que incluido: aquí ves qué haría cada uno a la próxima corrida y decides, uno por uno, antes de que pese en algo."
msgstr "Approved isn't the same as included: here you see what each one would do to the next run and decide, one by one, before it affects anything."

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "Aprobado por"
msgstr "Approved by"

#. placeholder {0}: row.approvedBy?.fullName ?? '—'
#. placeholder {1}: row.approvedAt && <> · {formatDateTime(row.approvedAt)}</>
#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
msgid "Aprobado por {0}{1}"
msgstr "Approved by {0}{1}"

#: src/features/timesheet/components/PendingAdjustmentsChip.tsx
msgid "Aprobados por el Manager de QA, sin decidir si pesan en esta nómina. Inclúyelos uno por uno."
msgstr "Approved by the QA Manager, not yet decided whether they count in this payroll. Include them one by one."

#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "Aprobados recientemente"
msgstr "Recently approved"

#: src/features/admin/components/PendingHotelUsers.tsx
#: src/features/conversion/pages/ConversionPage.tsx
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
#: src/features/timesheet/components/BulkApproveButton.tsx
#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Aprobando…"
msgstr "Approving…"

#: src/features/admin/components/PendingHotelUsers.tsx
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "Aprobar"
msgstr "Approve"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Aprobar conversión"
msgstr "Approve conversion"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Aprobar factura"
msgstr "Approve invoice"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Aprobar la conversión Rosa → Naranja —o devolverla a Café— es del BDC. Cuando la apruebe, el hotel queda como cliente activo y puede generar requisiciones."
msgstr "Approving the Pink → Orange conversion —or sending it back to Brown— is the BDC's job. Once approved, the hotel becomes an active client and can create Requisitions."

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Aprobar semana"
msgstr "Approve week"

#. placeholder {0}: eligible.length
#: src/features/timesheet/components/BulkApproveButton.tsx
msgid "Aprobar todas ({0})"
msgstr "Approve all ({0})"

#: src/features/observability/components/KpiCard.tsx
msgid "Aproximado"
msgstr "Approximate"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Aprueban la semana:"
msgstr "Who approves the week:"

#: src/features/worker/components/QrScanner.tsx
msgid "Apunta al código impreso en el acceso del hotel. La app también toma tu ubicación."
msgstr "Point at the code printed at the hotel entrance. The app also records your location."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Aquí nace la cuenta de cada persona del equipo Oranje: quién es, qué rol tiene y a quién reporta."
msgstr "This is where every Oranje team member's account starts: who they are, what role they have and who they report to."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Aquí no se captura contraseña: al crear, la persona recibe un correo de invitación y establece la suya. Hasta que entre por primera vez, la cuenta aparece como «Invitación enviada»."
msgstr "No password is captured here: on creation the person gets an invitation email and sets their own. Until they sign in for the first time, the account shows as “Invitation sent”."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Aquí se piden las posiciones que no tienen departamento, las de otras industrias. Las ves completas en la pestaña «Posiciones». General no se renombra ni se elimina."
msgstr "Positions without a department, the ones from other industries, are requested here. You can see all of them in the «Positions» tab. General can't be renamed or deleted."

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "aquí termina el ciclo"
msgstr "the cycle ends here"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Aquí ves lo básico de quien tienes asignado: sus datos de contacto y dónde trabaja. El semáforo, los documentos y el historial completo los lleva Reclutamiento."
msgstr "Here you see the basics of whoever you have assigned: their contact details and where they work. Recruiting handles the status light, documents, and full history."

#: src/features/worker/pages/HomePage.tsx
msgid "Aquí ves tu estado, ponchas tus turnos y recibes los avisos de Reclutamiento y del hotel."
msgstr "Here you see your status, clock your shifts and get notices from Recruitment and the hotel."

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Aquí vive el acuerdo con cada hotel cliente: lo que se le cobra por hora y lo que se le paga a su gente. Antes de esto, el hotel todavía se estaba convenciendo — eso pasa en Propuestas."
msgstr "This is where the agreement with each client hotel lives: what it is charged per hour and what its people are paid. Before this, the hotel was still being won over — that happens in Proposals."

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "Archivando…"
msgstr "Archiving…"

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Archivar ciclo"
msgstr "Archive cycle"

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "Archivar el ciclo"
msgstr "Archive the cycle"

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "Archivar no es marcar Rojo o Negro: esos estados se pueden reactivar. Esto cierra el ciclo para siempre."
msgstr "Archiving isn't the same as marking Red or Black: those statuses can be reactivated. This closes the cycle for good."

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Archivo"
msgstr "File"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Archivo del documento"
msgstr "Document file"

#: src/features/worker/components/TaxDocumentUploader.tsx
msgid "Archivo del SSN o ITIN"
msgstr "SSN or ITIN file"

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Archivo para el vault"
msgstr "File for the vault"

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Archivo subido al vault"
msgstr "File uploaded to the vault"

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Archivos sueltos de este hotel. Se ven igual desde Contrato y desde Propuesta."
msgstr "Loose files for this hotel. They look the same from Contract and from Proposal."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Arizona — Phoenix (sin horario de verano)"
msgstr "Arizona — Phoenix (no daylight saving)"

#: src/shared/constants/onboardingStatus.ts
msgid "Armar y enviar propuesta"
msgstr "Put together and send proposal"

#: src/features/observability/lib/people.ts
msgid "Arrancan en el periodo"
msgstr "Start in the period"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Arrastra el mapa para dejar el pin en la entrada por donde llegan los colaboradores."
msgstr "Drag the map to drop the pin at the entrance the Collaborators walk in through."

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Arrastra la cinta o usa ‹ › para moverte entre semanas, como en el Timesheet del hotel. Cada día es de una persona y una requisición."
msgstr "Drag the ribbon or use ‹ › to move between weeks, just like the hotel's Timesheet. Each day belongs to one person and one requisition."

#: src/features/onboarding/components/HotelLocationMap.tsx
msgid "Arrastra para ajustar la ubicación exacta"
msgstr "Drag to fine-tune the exact location"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/onboarding/components/ProposalRateFields.tsx
msgid "Arrastra para cambiar el orden"
msgstr "Drag to reorder"

#. placeholder {0}: String(index + 1)
#: src/features/onboarding/components/ProposalRateFields.tsx
msgid "Arrastra para cambiar el orden del renglón {0}"
msgstr "Drag to change the order of row {0}"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Así quedó en Borrador, antes de validar y autorizar."
msgstr "This is how it stood in Draft, before validating and authorizing."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Así se leería"
msgstr "How it would read"

#: src/features/messaging/components/TemplateDetailDialog.tsx
msgid "Así se ve en WhatsApp"
msgstr "How it looks in WhatsApp"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Así se verá"
msgstr "Preview"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Así se verá:"
msgstr "It will look like:"

#: src/features/messaging/components/tours.ts
msgid "Así va la mensajería"
msgstr "How messaging is going"

#: src/shared/constants/workerStatus.ts
msgid "Asig. temporal"
msgstr "Temp. assignment"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Asignación de slot"
msgstr "Slot assignment"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Asignaciones · 30 d"
msgstr "Assignments · 30 d"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Asignaciones · 30 días"
msgstr "Assignments · 30 days"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Asignaciones (30 días)"
msgstr "Assignments (30 days)"

#: src/features/worker/pages/HomePage.tsx
msgid "Asignaciones, cambios de turno y recordatorios llegan a Avisos. Revísalos cada día."
msgstr "Assignments, shift changes and reminders arrive in Notices. Check them every day."

#. placeholder {0}: formatDayMonthTime(slot.assignedAt)
#: src/features/requisitions/components/SlotList.tsx
msgid "Asignado {0}"
msgstr "Assigned {0}"

#. placeholder {0}: selected.assignment.hotelName
#. placeholder {1}: selected.assignment.requisitionNumber
#: src/features/recruitment/components/PoolRoster.tsx
msgid "Asignado en {0} · {1}"
msgstr "Assigned at {0} · {1}"

#: src/features/observability/lib/cohorts.ts
msgid "Asignado, pero sin ponches recientes"
msgstr "Assigned, but no recent punches"

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Asignamos a {total, plural, one {la persona que pediste} other {las # personas que pediste}}."
msgstr "We assigned {total, plural, one {the person you requested} other {the # people you requested}}."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Asignando…"
msgstr "Assigning…"

#: src/features/requisitions/components/SlotList.tsx
msgid "Asignar al siguiente slot libre"
msgstr "Assign to the next free slot"

#. placeholder {0}: String(objetivo ?? board.nextFreeOrdinal)
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Asignar al slot {0}"
msgstr "Assign to slot {0}"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Asignar colaborador"
msgstr "Assign Collaborator"

#: src/features/team/components/AssignTerritoryDialog.tsx
#: src/features/team/pages/TeamPage.tsx
msgid "Asignar territorio"
msgstr "Assign territory"

#: src/features/personnel/components/WorkerPerformanceRadar.tsx
#: src/features/timesheet/components/TimesheetViewControls.tsx
msgid "Asistencia"
msgstr "Attendance"

#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/worker/pages/Phase2Page.tsx
#: src/shared/components/GuidedTour.tsx
msgid "Atrás"
msgstr "Back"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Aún no hay cambios de estado."
msgstr "No status changes yet."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Aún no hay clientes activos"
msgstr "No active clients yet"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Aún no hay nadie dado de alta con el rol al que reporta. Da de alta primero a esa persona."
msgstr "Nobody has been created yet with the role this person reports to. Create that person first."

#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "Aún no hay propuestas"
msgstr "No Proposals yet"

#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Aún no hay prospectos abiertos"
msgstr "No open Prospects yet"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "Aún no hay QR generado."
msgstr "No QR generated yet."

#: src/features/requisitions/components/RequisitionCardList.tsx
#: src/features/requisitions/components/RequisitionTable.tsx
msgid "Aún no hay requisiciones"
msgstr "No requisitions yet"

#: src/features/worker/lib/noShiftMessage.ts
msgid "Aún no te validan"
msgstr "You haven't been validated yet"

#: src/features/worker/lib/noShiftMessage.ts
msgid "Aún no tienes asignación"
msgstr "You don't have an assignment yet"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Aún no tienes colaboradores asignados"
msgstr "You don't have any collaborators assigned yet"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "aún sin calcular"
msgstr "not calculated yet"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Aún sin cotizar ningún puesto"
msgstr "No position quoted yet"

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
msgid "aún sin pin"
msgstr "no pin yet"

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Autenticación"
msgstr "Authentication"

#: src/features/observability/lib/cohorts.ts
msgid "Automático"
msgstr "Automatic"

#: src/features/requisitions/api/requisitionsApi.ts
#: src/features/requisitions/components/RequisitionTable.tsx
#: src/shared/constants/requisitionStatus.ts
msgid "Autorizada"
msgstr "Authorized"

#. placeholder {0}: formatDayMonthTime(item.authorizedAt)
#: src/features/requisitions/components/RequisitionCardList.tsx
msgid "Autorizada {0}"
msgstr "Authorized {0}"

#: src/shared/components/UrgencyChip.tsx
msgid "Autorizada {since, plural, one {hace # día} other {hace # días}}"
msgstr "Authorized {since, plural, one {# day ago} other {# days ago}}"

#: src/shared/components/UrgencyChip.tsx
msgid "Autorizada hoy"
msgstr "Authorized today"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Autorizadas hace más de 24 h y nadie las ha tomado; la más vieja primero"
msgstr "Authorized more than 24 h ago and nobody has taken them; oldest first"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Autorizadas hace más de 24 h, sin tomar"
msgstr "Authorized more than 24 h ago, not yet taken"

#: src/features/dashboard/components/HotelDashboard.tsx
#: src/features/dashboard/components/RecruitmentDashboard.tsx
msgid "Autorizadas y en proceso"
msgstr "Authorized and in progress"

#: src/features/dashboard/components/RecruitmentDashboard.tsx
#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Autorizadas, sin tomar (Self-Pick)"
msgstr "Authorized, not yet taken (Self-Pick)"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/types/settlement.constants.ts
#: src/features/observability/lib/inspectionKpis.ts
msgid "Autorizado"
msgstr "Authorized"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Autorizar pago"
msgstr "Authorize payment"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Avance"
msgstr "Progress"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Avance del envío"
msgstr "Sending progress"

#. placeholder {0}: step.movedBy
#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "avanza el {0}"
msgstr "{0} moves it forward"

#: src/shared/constants/catalogs.ts
msgid "Avanzado"
msgstr "Advanced"

#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "Avisamos a la persona y a quien quede como su Líder. Sus requisiciones y colaboradores no cambian."
msgstr "We'll notify the person and their new Group Leader. Their requisitions and collaborators stay the same."

#: src/features/worker/components/MobileShell.tsx
#: src/features/worker/pages/NotificationsPage.tsx
msgid "Avisos"
msgstr "Notices"

#: src/features/worker/components/MobileShell.tsx
msgid "Avisos · {unread}"
msgstr "Notices · {unread}"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Avisos de trabajo: turnos, pagos, documentos. Llega también a EE. UU."
msgstr "Work notices: shifts, payments, documents. Also reaches the US."

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "ayer"
msgstr "yesterday"

#: src/shared/constants/onboardingStatus.ts
msgid "Azul claro"
msgstr "Light blue"

#: src/shared/constants/workerEnums.ts
msgid "B+"
msgstr "B+"

#: src/shared/constants/workerEnums.ts
msgid "B−"
msgstr "B−"

#: src/features/personnel/components/StandByDialog.tsx
msgid "Bajó el ritmo de ocupación esta semana…"
msgstr "Occupancy slowed down this week…"

#: src/shared/constants/catalogs.ts
msgid "Básico"
msgstr "Basic"

#: src/features/reports/pages/ReportsPage.tsx
msgid "BD"
msgstr "BD"

#. placeholder {0}: member.zoneNames.length > 0 ? t`Zonas ${formatList(member.zoneNames)}` : t`sin territorio asignado todavía`
#: src/features/team/pages/TeamPage.tsx
msgid "BD · {0}"
msgstr "BD · {0}"

#: src/features/team/pages/TeamPage.tsx
msgid "BDs a cargo"
msgstr "BDs you manage"

#: src/features/worker/pages/HomePage.tsx
msgid "Bienvenido a Oranje"
msgstr "Welcome to Oranje"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Bienvenido al alta de personal"
msgstr "Welcome to staff sign-up"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
#: src/features/onboarding/components/ProposalRateFields.tsx
msgid "Bill rate"
msgstr "Bill rate"

#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Bill rate por hora"
msgstr "Bill rate per hour"

#: src/features/onboarding/components/ContactAttemptLog.tsx
msgid "Bitácora de intentos de contacto"
msgstr "Contact attempt log"

#: src/features/requisitions/components/RequisitionJournalDialog.tsx
msgid "Bitácora de la requisición"
msgstr "Requisition log"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "BLACK · Blacklist"
msgstr "BLACK · Blacklist"

#: src/features/observability/lib/cohorts.ts
#: src/features/observability/lib/workerKpis.ts
#: src/features/recruitment/pages/BlacklistPage.tsx
#: src/layouts/Sidebar.tsx
#: src/shared/constants/workerStatus.ts
msgid "Blacklist"
msgstr "Blacklist"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Bloqueado"
msgstr "Locked"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Bloqueando…"
msgstr "Locking…"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Bloquear"
msgstr "Lock"

#: src/features/recruitment/pages/SelfPickHotelPage.tsx
#: src/features/recruitment/pages/SelfPickPage.tsx
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Bolsa · Self-Pick"
msgstr "Pool · Self-Pick"

#: src/features/accounting/types/settlement.constants.ts
#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
#: src/features/observability/lib/inspectionKpis.ts
#: src/features/onboarding/components/ProposalVersionHistory.tsx
#: src/shared/constants/contractStatus.ts
msgid "Borrador"
msgstr "Draft"

#: src/features/onboarding/components/ProposalVersionList.tsx
msgid "Borrador · sin enviar"
msgstr "Draft · not sent"

#. placeholder {0}: campaign.name
#. placeholder {1}: campaign.totalRecipients
#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Borrador «{0}» creado: le llegaría a {1} contactos."
msgstr "Draft “{0}” created: it would reach {1} contacts."

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Borrador → la Contadora lo valida contra los Timesheets aprobados → el Manager de Contabilidad autoriza (segunda firma) → se registra el pago."
msgstr "Draft → the Accountant validates it against the approved Timesheets → the Accounting Manager authorizes it (second signature) → the payment is recorded."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Borrador cancelado"
msgstr "Draft cancelled"

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Borrador cancelado: nunca rigió"
msgstr "Draft cancelled: it never took effect"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Borrador descartado"
msgstr "Draft discarded"

#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Borrador guardado"
msgstr "Draft saved"

#. placeholder {0}: formatDateTime(restoredDraftAt)
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Borrador recuperado (guardado el {0})."
msgstr "Draft restored (saved on {0})."

#. placeholder {0}: formatDateTime(restoredDraftAt)
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Borrador recuperado (guardado el {0}). El hotel ya quedó registrado: al crear se completa lo que faltó."
msgstr "Draft restored (saved on {0}). The hotel was already registered: creating will finish what was missing."

#: src/features/onboarding/pages/ProposalListPage.tsx
#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Borrador sin enviar"
msgstr "Unsent draft"

#. placeholder {0}: last.version
#. placeholder {0}: prospect.latestProposalVersion
#: src/features/onboarding/components/ViewProposalDialog.tsx
#: src/features/onboarding/utils/resolveActivityLabel.ts
msgid "Borrador v{0}"
msgstr "Draft v{0}"

#. placeholder {0}: draft.version
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Borrador v{0} · en elaboración"
msgstr "Draft v{0} · in progress"

#. placeholder {0}: String(version)
#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Borrador v{0} abierto"
msgstr "Draft v{0} opened"

#: src/features/onboarding/components/CreateProposalPromptDialog.tsx
msgid "Borrador v1 abierto"
msgstr "Draft v1 opened"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Borrador, sin enviar"
msgstr "Draft, not sent"

#. placeholder {0}: doc.displayName
#. placeholder {0}: documentTypeLabel(doc.documentType)
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Borrar {0}"
msgstr "Delete {0}"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Borrar el documento"
msgstr "Delete the document"

#: src/features/onboarding/components/PlacesSearchField.tsx
msgid "Borrar la búsqueda"
msgstr "Clear the search"

#: src/features/messaging/components/TemplateDetailDialog.tsx
msgid "Botones"
msgstr "Buttons"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Botones (opcional)"
msgstr "Buttons (optional)"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Bruto"
msgstr "Gross"

#. placeholder {0}: formatMoney(totalGross)
#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Bruto {0}"
msgstr "Gross {0}"

#: src/features/messaging/components/tours.ts
msgid "Busca a quien sea"
msgstr "Find anyone"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Busca el hotel en Google"
msgstr "Search the hotel on Google"

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
msgid "Busca el hotel o marca el punto en el mapa"
msgstr "Search the hotel or drop the point on the map"

#: src/shared/components/PhoneInput.tsx
msgid "Busca el país"
msgstr "Search for a country"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Busca por folio o por hotel, o filtra por estado. «Quitar filtros» te devuelve el tablero completo."
msgstr "Search by number or hotel, or filter by status. “Clear filters” brings the whole board back."

#: src/features/messaging/components/tours.ts
msgid "Busca una etiqueta"
msgstr "Find a tag"

#: src/features/onboarding/components/PlacesSearchField.tsx
msgid "Buscador no disponible: marca la ubicación directo en el mapa"
msgstr "Search isn't available: mark the location straight on the map"

#: src/shared/components/SearchField.tsx
msgid "Buscando"
msgstr "Searching"

#. placeholder {0}: term.trim()
#: src/layouts/GlobalSearch.tsx
msgid "Buscando «{0}»…"
msgstr "Searching \"{0}\"…"

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Buscando los cambios disponibles…"
msgstr "Looking for the available changes…"

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Buscando…"
msgstr "Searching…"

#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Buscar"
msgstr "Search"

#: src/features/team/pages/TeamPage.tsx
msgid "Buscar BD"
msgstr "Search BD"

#: src/features/admin/components/ColaboradorAccountsSection.tsx
#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "Buscar colaborador"
msgstr "Search collaborator"

#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Buscar colaboradores"
msgstr "Search collaborators"

#: src/features/messaging/components/CreateCampaignDialog.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
msgid "Buscar contactos"
msgstr "Search contacts"

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Buscar contrato"
msgstr "Search contract"

#: src/features/admin/components/HotelUsersSection.tsx
msgid "Buscar cuenta del hotel"
msgstr "Search hotel account"

#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Buscar destinatarios"
msgstr "Search recipients"

#. placeholder {0}: tab ? i18n._(tab.label) : ''
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Buscar en {0}"
msgstr "Search in {0}"

#: src/features/team/pages/HotelTeamPage.tsx
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Buscar en tu equipo"
msgstr "Search your team"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Buscar en tu plantel"
msgstr "Search your staff"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Buscar etiqueta…"
msgstr "Search tag…"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Buscar etiquetas"
msgstr "Search tags"

#: src/features/clients/components/ClientFilters.tsx
#: src/features/contracts/components/MissingContractsNotice.tsx
#: src/features/onboarding/components/ViewProposalDialog.tsx
#: src/features/onboarding/pages/PipelinePage.tsx
#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "Buscar hotel"
msgstr "Search hotel"

#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "Buscar hotel en la cola"
msgstr "Search hotel in the queue"

#: src/features/territory/pages/TerritoryPage.tsx
msgid "Buscar hotel en mi territorio"
msgstr "Search hotel in my territory"

#: src/layouts/GlobalSearch.tsx
#: src/layouts/Header.tsx
msgid "Buscar hoteles, requisiciones o colaboradores"
msgstr "Search hotels, requisitions or collaborators"

#: src/layouts/Header.tsx
msgid "Buscar hoteles, requisiciones, colaboradores…"
msgstr "Search hotels, requisitions, collaborators…"

#: src/features/onboarding/components/PlacesSearchField.tsx
msgid "Buscar la ubicación del hotel"
msgstr "Search the hotel's location"

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Buscar persona con funciones adicionales"
msgstr "Search people with additional roles"

#: src/features/messaging/components/CreateCampaignDialog.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
msgid "Buscar por nombre, teléfono o email…"
msgstr "Search by name, phone or email…"

#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/components/SyncWorkersButton.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Buscar por nombre…"
msgstr "Search by name…"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Buscar reactivo"
msgstr "Search item"

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Buscar requisición"
msgstr "Search requisitions"

#: src/features/admin/pages/UsersPage.tsx
msgid "Buscar usuario"
msgstr "Search user"

#: src/shared/constants/roles.ts
msgid "Business Developer"
msgstr "Business Developer"

#: src/shared/constants/roles.ts
msgid "Business Developer Coordinator"
msgstr "Business Developer Coordinator"

#: src/features/onboarding/pages/PipelinePage.tsx
#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "búsqueda «{searchTerm}»"
msgstr "search \"{searchTerm}\""

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Buzón"
msgstr "Mailbox"

#: src/features/admin/components/ColaboradorAccountsSection.tsx
msgid "Buzón creado"
msgstr "Mailbox created"

#. placeholder {0}: credential.email
#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Buzón creado: {0}"
msgstr "Mailbox created: {0}"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Buzón eliminado"
msgstr "Mailbox deleted"

#: src/features/admin/components/ColaboradorAccountsSection.tsx
msgid "Buzón sin crear"
msgstr "No mailbox yet"

#. placeholder {0}: hotel.name
#. placeholder {1}: weekRangeOf(hotel.firstWeek)
#: src/features/observability/components/CohortsView.tsx
msgid "Cada barra es una semana y su número, cuántas personas empezaron a ponchar en {0} esa semana (desde {1}). Toca una barra o usa las flechas para moverte; lo sombreado son las 12 semanas que se comparan abajo."
msgstr "Each bar is a week, and its number is how many people started punching at {0} that week (since {1}). Tap a bar or use the arrows to move around; the shaded part is the 12 weeks compared below."

#: src/features/observability/components/CohortsView.tsx
msgid "Cada barra es una semana y su número, cuántas personas empezaron a trabajar esa semana. Toca una barra o usa las flechas para moverte; lo sombreado son las 12 semanas que se comparan abajo."
msgstr "Each bar is a week, and its number is how many people started working that week. Tap a bar or use the arrows to move around; the shaded part is the 12 weeks compared below."

#: src/features/messaging/components/CampaignsTour.tsx
msgid "Cada borrador tiene su botón Enviar, con confirmación. Ahí sí sale por WhatsApp a todos sus destinatarios."
msgstr "Each draft has its Send button, with confirmation. That is when it goes out on WhatsApp to all its recipients."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Cada cambio de estado, con quién lo hizo y cuándo"
msgstr "Every status change, with who made it and when"

#: src/features/onboarding/components/StatusTimeline.tsx
msgid "Cada cambio de estado, con quién lo hizo y por qué"
msgstr "Every status change, with who made it and why"

#: src/features/admin/components/HotelUsersSection.tsx
msgid "Cada cuenta pertenece a un solo hotel. El primer Manager General nace en la Conversión"
msgstr "Each account belongs to a single hotel. The first General Manager is born in the Conversion"

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Cada deducción dice de qué tipo es y, si hace falta, de dónde sale, para que la Contadora pueda cotejarla."
msgstr "Each deduction says what type it is and, when needed, where it comes from, so the Accountant can check it."

#: src/features/onboarding/components/ViewProposalDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Cada envío congela una versión. Renegociar es abrir una nueva, que arranca con las tarifas de la anterior."
msgstr "Every send freezes a version. Renegotiating means opening a new one, which starts with the previous version's rates."

#: src/features/onboarding/components/ProposalVersionHistory.tsx
msgid "Cada envío queda como una versión; ninguna se borra."
msgstr "Every send stays as a version; none of them are deleted."

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "Cada estado avanza solo hacia el siguiente; el semáforo nunca retrocede."
msgstr "Each status only moves on to the next one; the Status Light never goes backwards."

#: src/features/messaging/components/tours.ts
msgid "Cada etiqueta dice cuántos contactos tiene; desde aquí ves a quiénes o la eliminas."
msgstr "Each tag shows how many contacts it has; from here you see who they are or delete it."

#: src/features/messaging/components/ContactImportsDialog.tsx
msgid "Cada Excel importado, con la lista que le puso a sus contactos. Reimportar nunca borra datos."
msgstr "Every imported Excel file, with the list it gave its contacts. Re-importing never deletes data."

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "Cada fila es un hotel y una semana con hojas pendientes, con el Manager de Área responsable de ese departamento."
msgstr "Each row is a hotel and a week with pending sheets, with the Area Manager responsible for that department."

#: src/features/observability/components/CohortsView.tsx
msgid "Cada fila son quienes ingresaron esa semana; cada columna, qué parte trabajó k semanas después. La columna en curso todavía puede subir."
msgstr "Each row is who joined that week; each column, what share worked k weeks later. The current column can still go up."

#: src/features/observability/components/CohortsView.tsx
msgid "Cada fila son quienes ingresaron ese mes; cada columna, qué parte trabajó k meses después. El mes en curso todavía puede subir."
msgstr "Each row is who joined that month; each column, what share worked k months later. The current month can still go up."

#: src/features/audits/pages/AuditsPage.tsx
msgid "Cada inspección queda con su calificación y su fecha. Si te equivocaste en un reactivo, desde aquí la corriges: no se borra, se corrige."
msgstr "Each inspection keeps its score and its date. If you got an item wrong, you correct it from here: it isn't deleted, it's corrected."

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Cada intento cuenta la historia"
msgstr "Every attempt tells the story"

#: src/features/accounting/pages/AccountingPendingPages.tsx
msgid "Cada línea se compara contra el Timesheet aprobado: horas, rate y descuentos."
msgstr "Each line is checked against the approved Timesheet: hours, rate and deductions."

#: src/features/requisitions/components/SlotList.tsx
msgid "Cada lugar es una persona que pediste. Aquí ves quién llega a cada uno."
msgstr "Each spot is one person you requested. Here you can see who is coming to each one."

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Cada persona trae su estado del Semáforo. Búscala por nombre y tócala para ver su detalle del día."
msgstr "Each person carries their Status Light. Search by name and tap to see their detail for the day."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Cada posición con fecha y hora"
msgstr "Each position with a date and time"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Cada puesto con sus lugares. Donde dice «Sin asignar» puedes tocar para llenarlo, y si ya está ocupado te lleva al perfil de quien lo cubre."
msgstr "Each position with its slots. Where it says “Unassigned” you can tap to fill it, and if it's taken it takes you to the profile of whoever covers it."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Cada quien recibe el suyo."
msgstr "Each person gets their own."

#: src/features/audits/pages/AuditsPage.tsx
msgid "Cada reactivo pesa lo suyo"
msgstr "Each checklist item has its own weight"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Cada renglón es un puesto que el hotel pidió: cuántas personas, desde cuándo y con qué modalidad. Cada persona pedida es un <0>slot</0>, y los slots se llenan en orden. <1>Cobertura</1> dice cuántos ya tienen a alguien; <2>Urgencia</2>, cuánto falta para que empiece."
msgstr "Each row is a position the hotel requested: how many people, since when, and with what hiring modality. Each person requested is a <0>slot</0>, and slots fill in order. <1>Coverage</1> says how many already have someone; <2>Urgency</2>, how long until it starts."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Cada renglón es un puesto que pediste: cuántas personas, desde cuándo y con qué modalidad. <0>Cobertura</0> dice a cuántas ya les asignamos a alguien; <1>Urgencia</1>, cuánto falta para que empiecen."
msgstr "Each row is a position you requested: how many people, starting when, and under which modality. <0>Coverage</0> tells you how many already have someone assigned; <1>Urgency</1>, how long until they start."

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Cada semana, el pago al colaborador y el cobro al hotel se calculan con estas tarifas y estos recargos. Si el contrato no está activo, ese hotel no puede facturar."
msgstr "Every week, the Collaborator's pay and the hotel's charge are calculated with these rates and these surcharges. If the contract is not active, that hotel cannot be invoiced."

#: src/features/requisitions/components/SlotList.tsx
msgid "Cada slot es un lugar por cubrir. Un slot libre se puede borrar; uno ocupado no."
msgstr "Each slot is a spot to fill. A free slot can be deleted; a taken one can't."

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Cada tarjeta trae su urgencia y cuánto lleva cubierto. Toca el color y te dice desde cuándo corre y cuándo empieza el puesto."
msgstr "Each card carries its urgency and how much is covered. Tap the color and it tells you since when it's been running and when the position starts."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Cada unidad de Cantidad es un lugar por cubrir"
msgstr "Each unit of Quantity is a spot to fill"

#: src/shared/constants/onboardingStatus.ts
msgid "Cafe"
msgstr "Brown"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Café"
msgstr "Brown"

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Calendario de pago y aprobación"
msgstr "Payment and approval calendar"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Calidad"
msgstr "Quality"

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Calificación preliminar"
msgstr "Preliminary score"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Calle, ciudad y estado"
msgstr "Street, city, and state"

#: src/features/worker/pages/PermissionsPage.tsx
msgid "Cámara"
msgstr "Camera"

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
msgid "Cambia el estado o la búsqueda, o quítalos con «Quitar filtros» para ver todas las de este hotel."
msgstr "Change the status or the search, or clear them with \"Clear filters\" to see all of this hotel's requisitions."

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Cambia el estado o la búsqueda, o quítalos con «Quitar filtros» para volver a ver el tablero completo."
msgstr "Change the status or the search, or clear them with \"Clear filters\" to see the full board again."

#: src/features/contracts/components/ContractRowList.tsx
msgid "Cambia el estado, la zona o la búsqueda. Un hotel gana su contrato al cerrar la negociación."
msgstr "Change the status, the zone or the search. A hotel earns its contract when the negotiation closes."

#: src/shared/components/MascotaPeek.tsx
msgid "Cambia el idioma desde tu tarjeta de perfil, abajo del menú."
msgstr "Switch the language from your profile card, below the menu."

#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Cambia ese filtro o quítalo con «Quitar filtros» para volver a ver el tablero completo."
msgstr "Change that filter or clear it with “Clear filters” to see the whole board again."

#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "Cambia la búsqueda o límpiala para volver a ver todos los prospectos en Rosa."
msgstr "Change the search or clear it to see every Prospect in Pink again."

#: src/features/worker/components/AccessDeadlineBanner.tsx
msgid "Cambia tu contraseña"
msgstr "Change your password"

#: src/features/worker/components/AccessDeadlineBanner.tsx
msgid "Cambia tu contraseña para seguir"
msgstr "Change your password to continue"

#: src/features/recruitment/pages/SelfPickHotelPage.tsx
msgid "Cambia un filtro, o quítalos con «Quitar filtros» para ver todos los slots libres de este hotel."
msgstr "Change a filter, or clear them with “Clear filters” to see all of this hotel's open slots."

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Cambiando…"
msgstr "Changing…"

#: src/features/admin/components/UserFormDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
#: src/features/worker/components/PhotoUploader.tsx
msgid "Cambiar"
msgstr "Change"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Cambiar archivo"
msgstr "Change file"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/worker/components/AccessDeadlineBanner.tsx
#: src/features/worker/components/ChangePasswordForm.tsx
msgid "Cambiar contraseña"
msgstr "Change password"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Cambiar de Líder"
msgstr "Change Group Leader"

#. placeholder {0}: member.fullName
#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "Cambiar de Líder a {0}"
msgstr "Change {0}'s Group Leader"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Cambiar de persona es dar de baja este usuario y dar de alta al nuevo."
msgstr "Switching to another person means deactivating this user and creating the new one."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
#: src/features/onboarding/pages/ProspectDetailPage.tsx
#: src/features/recruitment/components/ChangeStateDialog.tsx
#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Cambiar estado"
msgstr "Change status"

#: src/features/admin/components/PaymentLimitsSection.tsx
#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Cambiar esto es del Administrador."
msgstr "Only the Administrator can change this."

#: src/features/worker/components/PhotoUploader.tsx
msgid "Cambiar foto"
msgstr "Change photo"

#: src/layouts/RoleSwitcher.tsx
msgid "Cambiar función"
msgstr "Switch role"

#: src/layouts/RoleSwitcher.tsx
msgid "Cambiar función. Ahora trabajas como {activeTitle}"
msgstr "Switch role. You are now working as {activeTitle}"

#: src/features/worker/components/PhotoUploader.tsx
msgid "Cambiar mi foto"
msgstr "Change my photo"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Campaña"
msgstr "Campaign"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
#: src/features/messaging/pages/MessagingPage.tsx
msgid "Campañas"
msgstr "Campaigns"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Campañas del periodo"
msgstr "Campaigns in the period"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Campañas enviadas"
msgstr "Campaigns sent"

#: src/features/messaging/components/MessagingOverviewPanel.tsx
msgid "Campañas recientes"
msgstr "Recent campaigns"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Canal y resultado, de la lista"
msgstr "Channel and outcome, from the list"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
msgid "Cancelada"
msgstr "Cancelled"

#: src/shared/constants/contractStatus.ts
msgid "Cancelado"
msgstr "Cancelled"

#: src/features/contracts/components/ContractSignatureCard.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Cancelando…"
msgstr "Cancelling…"

#: src/features/accounting/components/AddDeductionDialog.tsx
#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/accounting/components/PayConsolidationButton.tsx
#: src/features/accounting/components/PayOverrideDialog.tsx
#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/PendingHotelUsers.tsx
#: src/features/admin/components/RoleGrantsSection.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/admin/pages/FeatureAccessPage.tsx
#: src/features/audits/components/AuditFormDialog.tsx
#: src/features/contracts/components/ContractPdfButton.tsx
#: src/features/contracts/components/EditRateDialog.tsx
#: src/features/contracts/components/MultiplierTable.tsx
#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/components/ProposalSyncNotice.tsx
#: src/features/contracts/components/SignAndSendDialog.tsx
#: src/features/contracts/components/UnlockContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/messaging/components/ContactActions.tsx
#: src/features/messaging/components/CreateCampaignDialog.tsx
#: src/features/messaging/components/ImportContactsDialog.tsx
#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/components/TemplateFormDialog.tsx
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
#: src/features/onboarding/components/ArchiveCycleDialog.tsx
#: src/features/onboarding/components/ChangeStatusDialog.tsx
#: src/features/onboarding/components/ConfirmSendProposalDialog.tsx
#: src/features/onboarding/components/DeleteHotelAction.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/onboarding/components/HotelPunchQrCard.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/onboarding/components/RegisterAttemptDialog.tsx
#: src/features/onboarding/import/ImportProspectsDialog.tsx
#: src/features/personnel/components/ReportWorkerDialog.tsx
#: src/features/personnel/components/StandByDialog.tsx
#: src/features/recruitment/components/ChangeStateDialog.tsx
#: src/features/recruitment/components/CreateAccessDialog.tsx
#: src/features/recruitment/components/CreateBlacklistDialog.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/components/DeleteWorkerDialog.tsx
#: src/features/recruitment/components/LiftBlacklistDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/requisitions/components/SlotList.tsx
#: src/features/requisitions/pages/RequisitionDetailPage.tsx
#: src/features/schedule/components/AddShiftDialog.tsx
#: src/features/team/components/AssignTerritoryDialog.tsx
#: src/features/team/components/MoveRecruiterDialog.tsx
#: src/features/timesheet/components/BulkApproveButton.tsx
#: src/features/timesheet/components/CorrectPunchDialog.tsx
#: src/features/timesheet/components/ManualPunchDialog.tsx
#: src/features/timesheet/components/WeekActionBar.tsx
#: src/features/worker/components/CameraCapture.tsx
#: src/shared/components/ReleaseAssignmentWarningDialog.tsx
#: src/shared/components/SendDocumentModal.tsx
msgid "Cancelar"
msgstr "Cancel"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Cancelar borrador"
msgstr "Cancel draft"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Cancelar campaña"
msgstr "Cancel campaign"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Cancelar edición"
msgstr "Cancel editing"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Cancelar edición de datos del documento"
msgstr "Cancel editing document details"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Cancelar edición de multiplicadores"
msgstr "Cancel editing multipliers"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Cancelar edición de vigencia"
msgstr "Cancel editing validity"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Cancelar envío"
msgstr "Cancel request"

#: src/features/observability/lib/people.ts
msgid "Candidatos dados de alta"
msgstr "Candidates registered"

#. placeholder {0}: position.quantity
#: src/features/requisitions/components/SlotList.tsx
msgid "Cant. {0}"
msgstr "Qty. {0}"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Cantidad"
msgstr "Quantity"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Cantidad {ordinal}"
msgstr "Quantity {ordinal}"

#: src/features/observability/lib/inspectionKpis.ts
msgid "Capturado en sitio"
msgstr "Captured on-site"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Capturar una marca que el ponche no registró, con motivo"
msgstr "Record a punch the clock-in didn't capture, with a reason"

#: src/features/worker/components/TaxDeadlineBanner.tsx
msgid "cargado, en verificación"
msgstr "uploaded, pending verification"

#: src/features/worker/pages/ProfilePage.tsx
msgid "Cargado, sin verificar"
msgstr "Uploaded, not verified"

#: src/features/worker/components/WorkerSkeleton.tsx
msgid "Cargando"
msgstr "Loading"

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Cargando archivos…"
msgstr "Loading files…"

#: src/features/requisitions/components/RequisitionJournalDialog.tsx
msgid "Cargando bitácora…"
msgstr "Loading log…"

#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "Cargando la cola…"
msgstr "Loading the queue…"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Cargando los pasos disponibles…"
msgstr "Loading the available steps…"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Cargando motivos…"
msgstr "Loading reasons…"

#: src/features/onboarding/components/ProposalVersionList.tsx
#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "Cargando propuestas…"
msgstr "Loading Proposals…"

#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Cargando prospectos…"
msgstr "Loading Prospects…"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Cargando quién firma…"
msgstr "Loading who signs…"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Cargando requisiciones…"
msgstr "Loading requisitions…"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Cargando…"
msgstr "Loading…"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Catálogo"
msgstr "Catalog"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Catálogo actualizado"
msgstr "Catalog updated"

#: src/features/admin/pages/CatalogsPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Catálogos"
msgstr "Catalogs"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/components/TemplateDetailDialog.tsx
#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Categoría"
msgstr "Category"

#: src/features/worker/components/useFaceGuide.ts
msgid "Centra tu cara en el óvalo"
msgstr "Center your face in the oval"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Central — Chicago, Houston, Dallas"
msgstr "Central — Chicago, Houston, Dallas"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Centro de México — CDMX, Guadalajara, Monterrey"
msgstr "Central Mexico — CDMX, Guadalajara, Monterrey"

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Cerrada"
msgstr "Closed"

#: src/features/observability/lib/inspectionKpis.ts
msgid "Cerrado"
msgstr "Closed"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Cerrando…"
msgstr "Closing…"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/clients/pages/ClientPortfolioPage.tsx
#: src/features/contracts/components/ContractPdfButton.tsx
#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/components/ContactImportsDialog.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/components/TemplateDetailDialog.tsx
#: src/features/onboarding/components/ContractPreviewDialog.tsx
#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
#: src/features/requisitions/components/RequisitionJournalDialog.tsx
#: src/features/timesheet/components/DayStatusTour.tsx
#: src/features/timesheet/components/ReviewDayDialog.tsx
#: src/shared/components/GuidedTour.tsx
#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Cerrar"
msgstr "Close"

#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Cerrar edición de cláusulas"
msgstr "Close clause editing"

#: src/features/worker/components/QrScanner.tsx
msgid "Cerrar el lector"
msgstr "Close the scanner"

#: src/features/territory/components/HotelMapCard.tsx
msgid "Cerrar la ficha del hotel"
msgstr "Close the hotel record"

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Cerrar lista de contratos"
msgstr "Close contract list"

#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "Cerrar lista de propuestas"
msgstr "Close proposal list"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Cerrar semana"
msgstr "Close week"

#: src/features/worker/components/MobileShell.tsx
#: src/layouts/Sidebar.tsx
#: src/mobile/UnsupportedRolePage.tsx
msgid "Cerrar sesión"
msgstr "Sign out"

#. placeholder {0}: formatDate(prospect.cycleStartedAt)
#. placeholder {1}: prospect.daysInStatus
#. placeholder {2}: prospect.owner.name
#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Ciclo abierto desde {0} · {1} días en {statusLabel} · Dueño: {2}"
msgstr "Cycle open since {0} · {1} days in {statusLabel} · Owner: {2}"

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "Ciclo archivado"
msgstr "Cycle archived"

#: src/features/observability/lib/salesKpis.ts
msgid "Ciclo de onboarding"
msgstr "Onboarding cycle"

#: src/features/team/pages/TeamPage.tsx
msgid "Ciclos abiertos por estado"
msgstr "Open cycles by status"

#: src/features/observability/lib/salesKpis.ts
msgid "Ciclos cerrados en Rechazo sobre los ciclos que terminaron en el periodo."
msgstr "Cycles closed as Rejected over cycles that ended in the period."

#. placeholder {0}: formatDayMonth(closingDateOf(mondayOf(day)))
#. placeholder {0}: formatDayMonth(closingDateOf(selectedWeek))
#: src/features/accounting/components/AccountingTimesheetGrid.tsx
msgid "Cierra el {0}"
msgstr "Closes on {0}"

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Cierra el ciclo definitivamente y libera al hotel"
msgstr "Closes the cycle for good and frees up the hotel"

#: src/shared/constants/contactAttempt.ts
msgid "Cita agendada"
msgstr "Meeting scheduled"

#: src/features/observability/lib/people.ts
msgid "Citas"
msgstr "Appointments"

#: src/features/observability/lib/salesKpis.ts
msgid "Citas agendadas"
msgstr "Appointments scheduled"

#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Ciudad y estado"
msgstr "City and state"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Cláusulas del documento"
msgstr "Document clauses"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Cláusulas guardadas"
msgstr "Clauses saved"

#: src/features/contracts/components/clauses/ClausesEditor.tsx
msgid "Clic en una variable para insertarla donde dejaste el cursor"
msgstr "Click a variable to insert it where you left the cursor"

#: src/features/territory/components/TerritoryMapLegend.tsx
msgid "Cliente"
msgstr "Client"

#: src/features/onboarding/components/HotelGlobeCard.tsx
#: src/shared/constants/onboardingStatus.ts
msgid "Cliente activo"
msgstr "Active client"

#: src/features/clients/components/ClientFilters.tsx
msgid "Cliente desde"
msgstr "Client since"

#. placeholder {0}: formatDate(client.activatedAt)
#. placeholder {0}: formatDayMonth(hotel.clientSince)
#: src/features/clients/components/ClientSpotlightCard.tsx
#: src/features/territory/components/TerritoryHotelCard.tsx
msgid "Cliente desde {0}"
msgstr "Client since {0}"

#: src/shared/constants/onboardingStatus.ts
msgid "Cliente pausado o inactivo"
msgstr "Client paused or inactive"

#: src/features/clients/pages/ClientPortfolioPage.tsx
msgid "clientes"
msgstr "clients"

#: src/features/clients/pages/ClientPortfolioPage.tsx
#: src/features/dashboard/components/ActivityCards.tsx
msgid "Clientes activos"
msgstr "Active clients"

#: src/layouts/Sidebar.tsx
msgid "Clientes Activos"
msgstr "Active Clients"

#: src/features/observability/lib/salesKpis.ts
msgid "Clientes sin requisitar"
msgstr "Clients without requisitions"

#: src/features/requisitions/components/RequisitionSummaryStrip.tsx
#: src/features/requisitions/components/RequisitionTable.tsx
msgid "Cobertura"
msgstr "Coverage"

#. placeholder {0}: board.coverage.name
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Cobertura · {0}"
msgstr "Coverage · {0}"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Cobertura parcial"
msgstr "Partial coverage"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Cobertura por hotel"
msgstr "Coverage by hotel"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Cobro registrado"
msgstr "Payment collection recorded"

#: src/features/dashboard/components/RecruitmentDashboard.tsx
msgid "Cola del Self-Pick"
msgstr "Self-Pick queue"

#: src/features/accounting/components/AccountingTimesheetGrid.tsx
#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/accounting/pages/ConsolidationsPage.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
#: src/features/accounting/pages/InvoiceDetailPage.tsx
#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/auth/pages/LoginPage.tsx
#: src/features/observability/components/CohortSection.tsx
#: src/features/observability/pages/ObservabilityPage.tsx
#: src/features/recruitment/components/CreateBlacklistDialog.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/timesheet/components/TimesheetGrid.tsx
#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
#: src/shared/constants/roles.ts
msgid "Colaborador"
msgstr "Collaborator"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "colaborador × requisición"
msgstr "collaborator × requisition"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Colaborador actualizado"
msgstr "Collaborator updated"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Colaborador asignado al slot"
msgstr "Collaborator assigned to the slot"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Colaborador creado — {created}"
msgstr "Collaborator created — {created}"

#: src/features/admin/pages/UsersPage.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/layouts/GlobalSearch.tsx
msgid "Colaboradores"
msgstr "Collaborators"

#: src/features/observability/lib/workerKpis.ts
msgid "Colaboradores con el perfil completo sobre todo el Pool."
msgstr "Collaborators with a complete profile over the whole Pool."

#: src/features/recruitment/pages/PoolPage.tsx
msgid "Colaboradores con su estado en el Semáforo; los Disponibles se pueden asignar a una requisición"
msgstr "Collaborators with their status in the Status Light; the Available ones can be assigned to a Requisition"

#: src/features/observability/lib/recruitmentKpis.ts
msgid "Colaboradores dados de alta en el periodo."
msgstr "Collaborators registered in the period."

#: src/features/observability/lib/workerKpis.ts
msgid "Colaboradores en Blacklist sobre todo el Pool."
msgstr "Collaborators on the Blacklist over the whole Pool."

#: src/features/dashboard/components/RecruitmentDashboard.tsx
msgid "Colaboradores en el Pool"
msgstr "Collaborators in the Pool"

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "Colaboradores evaluados"
msgstr "Collaborators measured"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Colaboradores puestos en un hotel"
msgstr "Collaborators placed in a hotel"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Colaboradores que dio de alta"
msgstr "Collaborators they created"

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Colaboradores sin teléfono válido"
msgstr "Workers without a valid phone"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Color"
msgstr "Color"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Columnas del archivo y cómo llenarlas"
msgstr "File columns and how to fill them"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Columnas: Nombre y Teléfono (obligatorias), Apellido, Email y Etiquetas. Excel, CSV o PDF con texto, hasta 5 MB."
msgstr "Columns: Name and Phone (required), Last name, Email and Tags. Excel, CSV or text PDF, up to 5 MB."

#: src/features/admin/components/UserFormDialog.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Comenzar el alta"
msgstr "Start the sign-up"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Comenzar el contrato"
msgstr "Start the contract"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Comenzar la requisición"
msgstr "Start the requisition"

#: src/features/accounting/types/settlement.constants.ts
#: src/features/contracts/components/MultiplierTable.tsx
msgid "Comida"
msgstr "Meals"

#: src/features/observability/lib/workerKpis.ts
msgid "Comida de más de {LONG_LUNCH_MIN} min"
msgstr "Lunch longer than {LONG_LUNCH_MIN} min"

#: src/features/observability/lib/workerKpis.ts
msgid "Comida de menos de {SHORT_LUNCH_MIN} min"
msgstr "Lunch shorter than {SHORT_LUNCH_MIN} min"

#: src/features/clients/components/ClientSpotlightCard.tsx
msgid "como cliente"
msgstr "as a client"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Cómo combinar las etiquetas"
msgstr "How to combine the tags"

#: src/features/accounting/pages/AccountingPendingPages.tsx
msgid "Cómo funciona"
msgstr "How it works"

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Cómo funciona Contratos"
msgstr "How Contracts works"

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Cómo funciona el Consolidado Semanal"
msgstr "How the Weekly Consolidation works"

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "Cómo funciona el semáforo"
msgstr "How the Status Light works"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Cómo funciona el Timesheet de todos los hoteles"
msgstr "How the Timesheet of all hotels works"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Cómo funciona este Timesheet para Contabilidad"
msgstr "How this Timesheet works for Accounting"

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "Cómo funciona Factura al Hotel"
msgstr "How Hotel Invoice works"

#: src/features/audits/pages/AuditsPage.tsx
msgid "Cómo funciona Inspecciones"
msgstr "How Inspections works"

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "Cómo funciona Semanas sin aprobar"
msgstr "How Weeks awaiting approval works"

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Cómo funcionan las Deducciones"
msgstr "How Deductions work"

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
msgid "Cómo funcionan los ajustes a incluir"
msgstr "How adjustments to include work"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Cómo funcionan los Catálogos"
msgstr "How Catalogs work"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Cómo les fue a las campañas: entregados, leídos y por qué no llegaron."
msgstr "How campaigns did: delivered, read and why they didn't arrive."

#: src/features/messaging/pages/MessagingPage.tsx
msgid "Cómo les fue a los envíos"
msgstr "How sends performed"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Como Líder, también recluta y asigna: sus números son los suyos, no los de su grupo. Las Reclutadoras de su grupo aparecen debajo de ella en la lista."
msgstr "As a Group Leader, they also recruit and assign: these numbers are their own, not their group's. The Recruiters in their group appear below them in the list."

#: src/features/worker/pages/HomePage.tsx
msgid "cómo llegas al trabajo"
msgstr "how you get to work"

#: src/features/worker/pages/Phase2Page.tsx
msgid "Cómo llegas al trabajo"
msgstr "How you get to work"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Como lo conoce el hotel. Si lo llenó Google, puedes corregirlo."
msgstr "The name the hotel goes by. If Google filled it in, you can correct it."

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Cómo poncha tu gente"
msgstr "How your people clock in"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Cómo ponchan aquí"
msgstr "How they clock in here"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Cómo terminó cada mensaje."
msgstr "How each message ended up."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Cómo va esta requisición"
msgstr "How this requisition is going"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Cómo va tu demanda"
msgstr "How your demand is going"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "completa al menos una posición con su pago y su factura"
msgstr "complete at least one position with its pay and its bill"

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Completa el expediente o confirma validarlo a medias"
msgstr "Complete the file or confirm validating it as is"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Completa el gasto: concepto, quién lo pagó, monto y motivo."
msgstr "Fill in the expense: concept, who paid, amount and reason."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Completa la tarifa acordada y su motivo."
msgstr "Fill in the agreed rate and its reason."

#: src/features/worker/components/AccessDeadlineBanner.tsx
msgid "Completa tus datos"
msgstr "Complete your details"

#: src/features/worker/components/AccessDeadlineBanner.tsx
msgid "Completa tus datos para seguir"
msgstr "Complete your details to continue"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
msgid "Completada"
msgstr "Completed"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Completado"
msgstr "Completed"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Completar"
msgstr "Complete"

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Completar datos"
msgstr "Complete details"

#: src/features/worker/components/AccessDeadlineBanner.tsx
#: src/features/worker/pages/HomePage.tsx
msgid "Completar mis datos"
msgstr "Complete my info"

#: src/features/recruitment/components/PoolTable.tsx
msgid "completo"
msgstr "complete"

#: src/features/worker/pages/PermissionsPage.tsx
msgid "Comprobando…"
msgstr "Checking…"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Comprobante de domicilio"
msgstr "Proof of address"

#: src/features/messaging/components/tours.ts
msgid "Con Actualizar traes las cifras y el avance de las campañas al momento."
msgstr "Refresh brings the figures and campaign progress up to date."

#: src/features/messaging/components/CampaignsTour.tsx
msgid "Con Actualizar ves cómo va cada envío (enviados, entregados, leídos) sin recargar la página."
msgstr "Refresh shows how each send is going (sent, delivered, read) without reloading the page."

#: src/features/clients/pages/ClientPortfolioPage.tsx
msgid "con contrato vigente"
msgstr "with an active Contract"

#: src/shared/components/MascotaPeek.tsx
msgid "Con Ctrl/⌘ K abres la búsqueda desde cualquier pantalla."
msgstr "Ctrl/⌘ K opens search from any screen."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Con cualquiera de ellas"
msgstr "With any of them"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Con entrada registrada"
msgstr "Clocked in"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Con error"
msgstr "Error"

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Con este correo entra a la app y revisa su buzón. Las contraseñas las genera el sistema y quedan en su expediente: dáselas en persona, no por correo."
msgstr "With this email they sign in to the app and check their mailbox. The system creates the passwords and keeps them in their profile: give them in person, not by email."

#. placeholder {0}: worker.fullName
#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Con esto {0} entra a su app de ponche y a su correo. Dáselas en mano, no por correo."
msgstr "This is how {0} signs in to the punch app and their email. Give them in person, not by email."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Con estos datos y el SSN/ITIN de Documentos el perfil queda completo; la foto no cuenta"
msgstr "With these fields and the SSN/ITIN in Documents the profile is complete; the photo doesn't count"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "con la tarifa y el multiplicador vigentes"
msgstr "at the current rate and multiplier"

#: src/features/messaging/components/ContactActions.tsx
msgid "Con lada de país (+52…) o elige el país al lado."
msgstr "With the country code (+52…) or pick the country next to it."

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Con las etiquetas se eligen los destinatarios de una campaña."
msgstr "Tags are how you choose a campaign's recipients."

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Con las etiquetas se eligen los destinatarios de una campaña. Las marcadas con «Sincronización» las pone «Sincronizar colaboradores» y no se pueden eliminar."
msgstr "Tags are how you choose a campaign's recipients. Those marked “Sync” are set by “Sync workers” and can't be deleted."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Con los títulos listos, un ejemplo y una hoja de instrucciones con las zonas y los valores válidos."
msgstr "With the titles ready, an example and an instructions sheet with the zones and valid values."

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Con lugares todavía sin llenar"
msgstr "With slots still unfilled"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Con problema"
msgstr "With a problem"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Con su cobertura. Toca una para abrirla y ver puesto por puesto quién la está cubriendo."
msgstr "With their coverage. Tap one to open it and see, position by position, who is covering it."

#: src/features/messaging/components/tours.ts
msgid "Con su nombre, teléfono y etiquetas."
msgstr "With their name, phone and tags."

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "con timesheet esta semana"
msgstr "with a timesheet this week"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Con todas"
msgstr "With all of them"

#: src/features/worker/pages/PunchPage.tsx
msgid "con tu foto"
msgstr "with your photo"

#: src/features/messaging/components/tours.ts
msgid "Con Ver detalle ves cómo llega por WhatsApp. Las rechazadas se corrigen y se reenvían."
msgstr "View details shows how it arrives on WhatsApp. Rejected ones can be fixed and resubmitted."

#: src/features/messaging/components/tours.ts
msgid "Con Ver reporte ves a quién le llegó, quién no y por qué."
msgstr "View report shows who got it, who didn't and why."

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
#: src/features/contracts/components/MultiplierTable.tsx
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Concepto"
msgstr "Item"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "concepto de pago"
msgstr "pay concept"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Concepto del gasto"
msgstr "Expense concept"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Conceptos de pago"
msgstr "Pay Concepts"

#: src/features/worker/pages/PunchPage.tsx
msgid "Confirmando que estás en el hotel"
msgstr "Confirming you're at the hotel"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Confirmar"
msgstr "Confirm"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Confirmar cambio"
msgstr "Confirm change"

#: src/features/admin/components/PendingHotelUsers.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Confirmar rechazo"
msgstr "Confirm rejection"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Confirmar regreso"
msgstr "Confirm send back"

#. placeholder {0}: doc.displayName
#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Confirmar: borrar {0}"
msgstr "Confirm: delete {0}"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "Confirmar: el anterior deja de servir"
msgstr "Confirm: the old one stops working"

#: src/shared/components/MascotaPeek.tsx
msgid "Consejo"
msgstr "Tip"

#: src/features/onboarding/components/ContactAttemptLog.tsx
msgid "Conservar"
msgstr "Keep"

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Consolidado"
msgstr "Consolidation"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Consolidado marcado como revisado"
msgstr "Consolidation marked as reviewed"

#: src/features/accounting/pages/ConsolidationsPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Consolidado Semanal"
msgstr "Weekly Consolidation"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Consta quién firmó por el hotel"
msgstr "There is a record of who signed for the hotel"

#: src/features/observability/pages/ObservabilityPage.tsx
msgid "Contabilidad"
msgstr "Accounting"

#: src/features/team/pages/TeamPage.tsx
msgid "contactado hoy"
msgstr "contacted today"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Contacto actualizado"
msgstr "Contact updated"

#: src/features/messaging/components/ContactActions.tsx
msgid "Contacto actualizado."
msgstr "Contact updated."

#: src/features/messaging/components/ContactActions.tsx
msgid "Contacto creado."
msgstr "Contact created."

#: src/features/personnel/components/ContactQr.tsx
msgid "Contacto de {name} en QR"
msgstr "{name}'s contact as a QR"

#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/lib/profileFields.ts
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/pages/Phase3Page.tsx
msgid "Contacto de emergencia"
msgstr "Emergency contact"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Contacto del hotel"
msgstr "Hotel contact"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Contacto desactivado"
msgstr "Contact deactivated"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Contacto eliminado"
msgstr "Contact deleted"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Contacto nuevo"
msgstr "New contact"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Contacto nuevo · {hotelName}"
msgstr "New contact · {hotelName}"

#: src/features/conversion/api/conversionApi.ts
msgid "Contacto principal registrado"
msgstr "Primary contact saved"

#: src/shared/constants/onboardingStatus.ts
msgid "Contacto y datos"
msgstr "Contact and data"

#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/pages/MessagingPage.tsx
msgid "Contactos"
msgstr "Contacts"

#. placeholder {0}: tag.name
#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Contactos con «{0}»"
msgstr "Contacts with “{0}”"

#: src/features/onboarding/components/HotelContactList.tsx
msgid "Contactos del hotel"
msgstr "Hotel contacts"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Contactos elegidos"
msgstr "Selected contacts"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Contactos específicos"
msgstr "Specific contacts"

#: src/shared/constants/roles.ts
msgid "Contadora"
msgstr "Accountant"

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Contesta todos los reactivos para poder guardar"
msgstr "Answer every checklist item to save"

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "Contexto que le sirva a quien abra el siguiente ciclo…"
msgstr "Context that helps whoever opens the next cycle…"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Continúa al día siguiente"
msgstr "Continues into the next day"

#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/personnel/components/ReportWorkerDialog.tsx
#: src/features/personnel/components/StandByDialog.tsx
#: src/features/recruitment/components/CreateBlacklistDialog.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/components/LiftBlacklistDialog.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/worker/pages/Phase2Page.tsx
#: src/shared/components/OnboardingIntro.tsx
msgid "Continuar"
msgstr "Continue"

#: src/features/onboarding/components/ProspectPhotoCard.tsx
msgid "Continuar borrador →"
msgstr "Continue draft →"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Contraer cláusulas del documento"
msgstr "Collapse document clauses"

#: src/features/contracts/components/MissingContractsNotice.tsx
msgid "Contraer hoteles listos para su contrato"
msgstr "Collapse hotels ready for their contract"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Contraer texto de la propuesta"
msgstr "Collapse proposal text"

#: src/features/admin/components/UserFormDialog.tsx
#: src/features/auth/pages/LoginPage.tsx
#: src/features/worker/components/MobileShell.tsx
#: src/features/worker/pages/PasswordPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Contraseña"
msgstr "Password"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/worker/components/ChangePasswordForm.tsx
msgid "Contraseña cambiada"
msgstr "Password changed"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Contraseña cambiada. Dásela en mano."
msgstr "Password changed. Give it to them in person."

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/recruitment/components/CreateAccessDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Contraseña copiada"
msgstr "Password copied"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "Contraseña de la app (y del web)"
msgstr "App (and web) password"

#: src/features/recruitment/components/CreateAccessDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Contraseña de la app de ponche"
msgstr "Punch app password"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Contraseña del buzón"
msgstr "Mailbox password"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/recruitment/components/CreateAccessDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Contraseña del correo"
msgstr "Email password"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
#: src/features/worker/components/ChangePasswordForm.tsx
msgid "Contraseña nueva"
msgstr "New password"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "Contraseña temporal"
msgstr "Temporary password"

#: src/features/clients/components/ClientFilters.tsx
msgid "Contrato"
msgstr "Contract"

#. placeholder {0}: contract.number
#: src/features/contracts/components/ContractPdfButton.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Contrato {0}"
msgstr "Contract {0}"

#. placeholder {0}: contract?.number ?? ''
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Contrato {0} activado"
msgstr "Contract {0} activated"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Contrato bloqueado"
msgstr "Contract locked"

#: src/features/timesheet/components/PayPreviewBadge.tsx
msgid "Contrato cambió"
msgstr "Contract changed"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Contrato creado — en Borrador"
msgstr "Contract created — in Draft"

#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
msgid "Contrato enviado"
msgstr "Contract sent"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Contrato enviado al hotel"
msgstr "Contract sent to the hotel"

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Contrato expirado: dejó de regir"
msgstr "Contract expired: it no longer applies"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Contrato marcado como enviado: quedó bloqueado"
msgstr "Contract marked as sent: it's now locked"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Contrato marcado como expirado"
msgstr "Contract marked as expired"

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Contrato vigente: no hay nada pendiente"
msgstr "Contract in force: nothing pending"

#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/contracts/pages/ContractListPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Contratos"
msgstr "Contracts"

#: src/shared/constants/catalogs.ts
msgid "Conversacional"
msgstr "Conversational"

#: src/features/conversion/pages/ConversionQueuePage.tsx
#: src/features/observability/lib/salesKpis.ts
#: src/layouts/Sidebar.tsx
msgid "Conversión"
msgstr "Conversion"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Conversión a cliente activo"
msgstr "Conversion to active client"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Conversión aprobada"
msgstr "Conversion approved"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Conversión por BD"
msgstr "Conversion by BD"

#: src/features/dashboard/components/ActivityCards.tsx
#: src/features/observability/lib/people.ts
msgid "Conversiones"
msgstr "Conversions"

#: src/features/team/pages/TeamPage.tsx
msgid "Conversiones (trim.)"
msgstr "Conversions (qtr.)"

#: src/features/team/pages/TeamPage.tsx
msgid "Conversiones del trimestre"
msgstr "Conversions this quarter"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Convertidos"
msgstr "Converted"

#: src/features/conversion/components/ApproveConversionDialog.tsx
msgid "Convertir en cliente"
msgstr "Convert to client"

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Convertir es del BDC"
msgstr "Converting is the BDC's job"

#: src/features/conversion/components/ApproveConversionDialog.tsx
msgid "Convirtiendo…"
msgstr "Converting…"

#: src/shared/constants/workerEnums.ts
msgid "Cónyuge"
msgstr "Spouse"

#: src/shared/constants/roles.ts
msgid "Coordinador de Inspección"
msgstr "Inspection Coordinator"

#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/shared/components/CredentialField.tsx
msgid "Copiar"
msgstr "Copy"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Copiar contraseña"
msgstr "Copy password"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Copiar contraseña de la app"
msgstr "Copy app password"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Copiar contraseña del correo"
msgstr "Copy email password"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Copiar correo"
msgstr "Copy email"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Copiar el teléfono"
msgstr "Copy the phone number"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Copiar usuario"
msgstr "Copy username"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Corre el corte de todos los hoteles con horas aprobadas esa semana. Es idempotente: repetirlo no duplica nada de lo que ya quedó en un Consolidado."
msgstr "Runs the cutoff for every hotel with approved hours that week. It's idempotent: running it again never duplicates anything already in a Consolidation."

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Corrección eliminada — vuelve a lo calculado"
msgstr "Correction removed — back to the calculated value"

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Corrección guardada"
msgstr "Correction saved"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Correcto"
msgstr "Correct"

#: src/features/accounting/components/AccountingTimesheetGrid.tsx
msgid "Corregido"
msgstr "Corrected"

#: src/features/accounting/components/AccountingTimesheetGrid.tsx
#: src/features/audits/components/AuditHistoryList.tsx
msgid "Corregir"
msgstr "Correct"

#: src/features/timesheet/components/AttendanceView.tsx
#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Corregir esta marca"
msgstr "Correct this punch"

#: src/features/onboarding/components/ContactAttemptLog.tsx
msgid "Corregir este intento"
msgstr "Correct this attempt"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Corregir horas extra"
msgstr "Correct overtime"

#. placeholder {0}: row.workerName
#: src/features/timesheet/components/AttendanceView.tsx
msgid "Corregir horas extra de {0}"
msgstr "Correct {0}'s overtime"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Corregir intento de contacto"
msgstr "Correct contact attempt"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Corregir la entrada"
msgstr "Correct the clock-in"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Corregir la salida"
msgstr "Correct the clock-out"

#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "Corregir marca"
msgstr "Correct punch"

#: src/features/worker/pages/Phase2Page.tsx
msgid "Corregir mis datos"
msgstr "Update my info"

#. placeholder {0}: target.workerName
#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Corregir pago de {0}"
msgstr "Correct pay for {0}"

#: src/features/contracts/components/EditRateDialog.tsx
msgid "Corregir tarifa"
msgstr "Correct rate"

#: src/features/contracts/components/RateTable.tsx
msgid "Corregir una tarifa"
msgstr "Fix a rate"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Corregir y reenviar"
msgstr "Fix and resubmit"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Corregir y reenviar a Meta"
msgstr "Fix and resubmit to Meta"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/auth/pages/LoginPage.tsx
#: src/features/observability/lib/people.ts
#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/recruitment/components/CreateAccessDialog.tsx
#: src/features/worker/pages/ProfilePage.tsx
#: src/mobile/AppLoginPage.tsx
#: src/shared/constants/contactAttempt.ts
msgid "Correo"
msgstr "Email"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Correo copiado"
msgstr "Email copied"

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Correo corporativo"
msgstr "Corporate email"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "Correo de acceso"
msgstr "Sign-in email"

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Correo de horas (sábado)"
msgstr "Hours email (Saturday)"

#: src/shared/lib/contractClauses.ts
msgid "Correo de la empresa"
msgstr "Company email"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Correo de Oranje en el documento"
msgstr "Oranje's email in the document"

#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Correo de quien envía"
msgstr "Sender's email"

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Correo de quien firma por el hotel"
msgstr "Email of the hotel's signer"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Correo del contacto no válido: no se guarda"
msgstr "Invalid contact email: not saved"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Correo del hotel"
msgstr "Hotel's email"

#: src/shared/lib/contractClauses.ts
msgid "Correo del proveedor"
msgstr "Provider email"

#: src/features/observability/lib/people.ts
msgid "Correos"
msgstr "Emails"

#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Correos corporativos"
msgstr "Corporate Email"

#: src/features/audits/components/EnvironmentAuditDialog.tsx
msgid "Corrige lo que haga falta de {hotelName}: se guarda con PATCH, sobre la misma inspección."
msgstr "Fix whatever needs it for {hotelName}: it's saved on the same inspection, not as a new one."

#: src/features/audits/components/PersonalPresentationAuditDialog.tsx
msgid "Corrige lo que haga falta: se guarda con PATCH, sobre la misma inspección."
msgstr "Fix whatever needs it: it's saved on the same inspection, not as a new one."

#: src/features/messaging/components/CampaignsTour.tsx
msgid "Corrige los teléfonos"
msgstr "Fix the phones"

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Corte de pago (miércoles)"
msgstr "Payment cut (Wednesday)"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Cotiza al menos un puesto para descargar"
msgstr "Quote at least one position to download"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "cPanel rechazó la operación."
msgstr "cPanel rejected the operation."

#: src/features/messaging/components/CampaignsTour.tsx
msgid "Crea la campaña"
msgstr "Create the campaign"

#: src/features/messaging/components/tours.ts
msgid "Crea una etiqueta"
msgstr "Create a tag"

#: src/features/messaging/components/tours.ts
msgid "Crea una plantilla"
msgstr "Create a template"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
#: src/features/requisitions/api/requisitionsApi.ts
#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Creada"
msgstr "Created"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Creado"
msgstr "Created"

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Créalo desde <0>Correos corporativos</0>."
msgstr "Create it from <0>Corporate emails</0>."

#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/conversion/components/RequirementRow.tsx
#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Creando…"
msgstr "Creating…"

#: src/features/messaging/components/ContactActions.tsx
msgid "Crear"
msgstr "Create"

#: src/features/recruitment/components/CreateAccessDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Crear acceso"
msgstr "Create access"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Crear borrador"
msgstr "Create draft"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Crear buzón"
msgstr "Create mailbox"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/pages/PoolPage.tsx
msgid "Crear colaborador"
msgstr "Create Collaborator"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Crear cuenta"
msgstr "Create account"

#: src/features/conversion/api/conversionApi.ts
msgid "Crear cuenta del hotel"
msgstr "Create hotel account"

#: src/features/onboarding/components/ContractStepCard.tsx
msgid "Crear el contrato"
msgstr "Create the contract"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Crear etiqueta"
msgstr "Create tag"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Crear lista con estos"
msgstr "Create list with these"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Crear o versionar la propuesta es del BD dueño del hotel."
msgstr "Creating or versioning the proposal belongs to the hotel's BD."

#: src/features/onboarding/components/ProspectPhotoCard.tsx
msgid "Crear propuesta →"
msgstr "Create proposal →"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Crear propuesta v1"
msgstr "Create proposal v1"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Crear prospecto"
msgstr "Create Prospect"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Crear requisición"
msgstr "Create requisition"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Crear usuario"
msgstr "Create user"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Crear y gestionar buzones corporativos es una acción del sistema, reservada al Administrador."
msgstr "Creating and managing corporate mailboxes is a system action, reserved for the Administrator."

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "Crédito"
msgstr "Credit"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Crédito aplicado"
msgstr "Credit applied"

#: src/features/observability/lib/people.ts
msgid "Creó la requisición"
msgstr "Created the requisition"

#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/components/SelfPickFilterBar.tsx
msgid "cualquiera"
msgstr "any"

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "Cuando el hotel liquida, Contabilidad marca la factura como pagada — el sistema no cobra solo."
msgstr "When the hotel settles, Accounting marks the invoice as paid — the system doesn't collect on its own."

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Cuando el ponche normal no pudo"
msgstr "When the regular punch couldn't"

#: src/features/audits/components/AuditWorkerList.tsx
msgid "Cuando el Schedule programe a alguien en este hotel, aparecerá aquí para inspeccionarlo."
msgstr "Once the Schedule has someone working at this hotel, they'll show up here to inspect."

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Cuando el Schedule programe turnos de tus requisiciones, aparecerán aquí con su estado y sus marcas del día."
msgstr "When the Schedule programs shifts for your requisitions, they'll show up here with their status and the day's punches."

#: src/features/observability/components/CohortsView.tsx
msgid "Cuando empezó a ponchar"
msgstr "When they started punching"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Cuando esté firmado por las dos partes, actívalo con «Activar contrato»."
msgstr "Once both parties sign it, activate it with “Activate contract”."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Cuando la Reclutadora valida el alta, pasa a Verde fuerte y entra al Pool de Colaboradores."
msgstr "When the Recruiter validates the sign-up, they move to Strong Green and enter the Collaborator Pool."

#: src/features/worker/lib/noShiftMessage.ts
msgid "Cuando la Reclutadora valide tus datos quedarás Disponible para asignación. Con tu primera requisición, tu turno aparece aquí."
msgstr "Once the Recruiter validates your info you'll be Available for assignment. With your first requisition, your shift shows up here."

#: src/features/worker/lib/noShiftMessage.ts
msgid "Cuando Reclutamiento te asigne a una requisición, tu turno del día aparece aquí y podrás ponchar."
msgstr "When Recruitment assigns you to a requisition, today's shift shows up here and you'll be able to clock in."

#: src/shared/components/MascotaPeek.tsx
msgid "Cuando salga una versión nueva te avisamos con un mensaje: recarga y listo."
msgstr "When a new version ships we let you know with a message: reload and you're set."

#: src/features/audits/components/AuditHistoryList.tsx
msgid "Cuando se guarde la primera de Presentación Personal o de Ambiente y Recursos, aparecerá aquí."
msgstr "Once the first Personal Presentation or Environment & Resources inspection is saved, it'll show up here."

#: src/features/requisitions/components/RequisitionCardList.tsx
#: src/features/requisitions/components/RequisitionTable.tsx
msgid "Cuando un hotel pida personal, su requisición aparecerá aquí con su semáforo."
msgstr "When a hotel requests staff, its requisition shows up here with its status light."

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "Cuando una semana cierre con horas sin aprobar, aparecerá aquí con el Manager de Área que debe aprobarla."
msgstr "When a week closes with unapproved hours, it will appear here along with the Area Manager who must approve it."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Cuando valides el alta, pasa a Verde fuerte y queda disponible para asignarse a un hotel."
msgstr "When you validate the sign-up, they move to Strong Green and become available to be assigned to a hotel."

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Cuántas requisiciones tienes trabajándose, cuántas ya se cubrieron y cuántas semanas de horas siguen sin aprobar — esas últimas no se pagan hasta que alguien las apruebe."
msgstr "How many requisitions are being worked, how many are already covered, and how many weeks of hours are still unapproved — those don't get paid until someone approves them."

#: src/features/messaging/components/tours.ts
msgid "Cuántos contactos, plantillas y campañas hay en la plataforma de mensajería."
msgstr "How many contacts, templates and campaigns are on the messaging platform."

#: src/features/messaging/components/tours.ts
msgid "Cuántos se enviaron, entregaron y leyeron, y qué conviene revisar."
msgstr "How many were sent, delivered and read, and what's worth checking."

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Cuántos ya marcaron entrada hoy, cuántos están en pausa y cuántos protegidos por un accidente."
msgstr "How many have clocked in today, how many are paused, and how many are protected by an accident."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Cuatro letras y dos números. Ejemplo: kmrt48"
msgstr "Four letters and two numbers. Example: kmrt48"

#: src/features/worker/pages/PunchPage.tsx
msgid "Cuatro marcas al día"
msgstr "Four punches a day"

#: src/features/requisitions/utils/coverage.ts
msgid "cubierta"
msgstr "covered"

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Cubierta"
msgstr "Filled"

#: src/shared/constants/requisitionStatus.ts
msgid "Cubierta parcialmente"
msgstr "Partially covered"

#: src/shared/constants/requisitionStatus.ts
msgid "Cubierta totalmente"
msgstr "Fully covered"

#: src/features/dashboard/components/HotelDashboard.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Cubiertas"
msgstr "Covered"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Cubiertas parcialmente"
msgstr "Partially covered"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Cubiertas totalmente"
msgstr "Fully covered"

#: src/features/schedule/pages/SchedulePage.tsx
msgid "cubierto"
msgstr "covered"

#: src/features/recruitment/components/SelfPickPositionCard.tsx
msgid "Cubierto"
msgstr "Covered"

#: src/shared/constants/workerStatus.ts
msgid "Cubriendo una asignación temporal, completa o parcial."
msgstr "Covering a temporary assignment, full or partial shift."

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Cubrimos {covered} de {total, plural, one {# lugar} other {# lugares}}. Si todavía necesitas personal, crea una requisición nueva."
msgstr "We filled {covered} of {total, plural, one {# spot} other {# spots}}. If you still need staff, create a new requisition."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Cubrir slots en Self-Pick"
msgstr "Fill slots in Self-Pick"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Cuenta activada"
msgstr "Account activated"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Cuenta actualizada"
msgstr "Account updated"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Cuenta creada"
msgstr "Account created"

#. placeholder {0}: values.email
#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Cuenta creada — invitación enviada a {0}"
msgstr "Account created — invitation sent to {0}"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Cuenta dada de baja"
msgstr "Account deactivated"

#: src/features/worker/components/MobileShell.tsx
msgid "Cuenta de {shortName}"
msgstr "{shortName}'s account"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Cuenta del hotel creada"
msgstr "Hotel account created"

#: src/features/admin/components/PendingHotelUsers.tsx
msgid "Cuentas por aprobar"
msgstr "Accounts to approve"

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Cumple"
msgstr "Meets"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Cumple las reglas de Meta."
msgstr "Meets Meta's rules."

#: src/features/audits/pages/AuditsPage.tsx
msgid "Cumple, No o N/A por reactivo. El score es un promedio ponderado — N/A no cuenta ni pesa, y el peso lo define el Administrador."
msgstr "Meets, Doesn't or N/A per checklist item. The score is a weighted average — N/A doesn't count or weigh, and the Administrator sets the weights."

#: src/shared/constants/workerStatus.ts
msgid "Cumplió una semana: colabora fijo en el hotel."
msgstr "Completed a week: now works fixed at the hotel."

#: src/shared/constants/roles.ts
msgid "Customer Service Manager"
msgstr "Customer Service Manager"

#: src/features/schedule/components/ScheduleMiniCalendar.tsx
msgid "D"
msgstr "S"

#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Da de alta el primero con «Nuevo prospecto»: el ciclo arranca en Gris."
msgstr "Create the first one with “New Prospect”: the cycle starts in Gray."

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Da de alta varios hoteles a la vez desde un Excel, CSV, TXT o PDF. Solo las personas de esta lista ven el botón «Importar hoteles» en el Pipeline."
msgstr "Adds several hotels at once from an Excel, CSV, TXT or PDF file. Only the people on this list see the “Import hotels” button in the Pipeline."

#: src/features/messaging/components/CreateCampaignDialog.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Dado de baja"
msgstr "Opted out"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Dados de alta, todavía en Blanco"
msgstr "Created, still in White"

#: src/features/dashboard/components/InviteHotelAccountCard.tsx
msgid "Dale su acceso al sistema desde aquí: es para quien trabaja en tu hotel con cuenta propia, no para los colaboradores que te asigna Oranje. Si es gerente, Oranje lo confirma antes de que pueda entrar."
msgstr "Give them their access from here: it's for people who work at your hotel with their own account, not for the Collaborators Oranje assigns you. If it's a manager, Oranje confirms them before they can get in."

#: src/features/admin/pages/FeatureAccessPage.tsx
#: src/features/dashboard/components/InviteHotelAccountCard.tsx
#: src/features/worker/pages/PermissionsPage.tsx
msgid "Dar acceso"
msgstr "Allow access"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Dar de alta el hotel abre su ciclo comercial en Gris. Un hotel solo puede tener un ciclo abierto a la vez."
msgstr "Creating the hotel opens its commercial cycle in Gray. A hotel can only have one open cycle at a time."

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/messaging/components/ContactActions.tsx
msgid "Dar de baja"
msgstr "Deactivate"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Dar de baja no borra nada: la persona deja de entrar y su historial queda."
msgstr "Deactivating deletes nothing: the person can no longer sign in and their history stays."

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Dar función"
msgstr "Grant role"

#. placeholder {0}: worker?.fullName ?? ''
#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Dáselas en mano a {0}. Las vuelves a ver en su expediente, con «Acceso y contraseñas»."
msgstr "Give them to {0} in person. You can see them again in their profile, under “Access and passwords”."

#: src/layouts/Sidebar.tsx
msgid "Dashboard"
msgstr "Dashboard"

#: src/features/observability/pages/ObservabilityPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Dashboard de QA"
msgstr "QA Dashboard"

#: src/features/messaging/components/CreateCampaignDialog.tsx
#: src/features/messaging/components/TemplateDetailDialog.tsx
msgid "Datos"
msgstr "Details"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Datos básicos"
msgstr "Basic info"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Datos contables"
msgstr "Accounting data"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Datos de emergencia guardados"
msgstr "Emergency info saved"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Datos del documento"
msgstr "Document details"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Datos del documento guardados"
msgstr "Document details saved"

#: src/features/onboarding/components/HotelDataCard.tsx
msgid "Datos del hotel"
msgstr "Hotel details"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Datos personales"
msgstr "Personal details"

#. placeholder {0}: weekRangeOf(bandFrom)
#. placeholder {1}: weekRangeOf(bandTo)
#: src/features/observability/components/CohortSection.tsx
msgid "De {0} a {1}"
msgstr "From {0} to {1}"

#: src/features/team/pages/TeamPage.tsx
msgid "de abrir el ciclo a convertir"
msgstr "from opening the cycle to converting"

#: src/features/contracts/pages/ContractListPage.tsx
msgid "De aquí salen la nómina y la factura"
msgstr "Payroll and invoicing come from here"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "De baja — ya no puede entrar"
msgstr "Deactivated — can no longer sign in"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "de contrato"
msgstr "contract"

#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "De dónde sale, p. ej. «Dos camisas de uniforme.»"
msgstr "Where it comes from, e.g. “Two uniform shirts.”"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "De Gris a Naranja"
msgstr "From Gray to Orange"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "De los destinatarios a los que leyeron."
msgstr "From recipients to those who read it."

#: src/features/territory/components/TerritoryOwnerPicker.tsx
msgid "De quién es el territorio"
msgstr "Whose territory this is"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "de todos los hoteles, esta semana"
msgstr "across all hotels, this week"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "De un golpe: cuántas tienes abiertas, cuántas van a medias y cuántas empiezan en menos de 3 días."
msgstr "At a glance: how many are open, how many are partly covered, and how many start in under 3 days."

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "De Verde no se sale sin la Propuesta Personalizada enviada."
msgstr "There's no leaving Green until the Custom Proposal has been sent."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Decisiones de Oranje"
msgstr "Oranje's decisions"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Decisiones de Oranje sobre su perfil"
msgstr "Oranje's decisions about their profile"

#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Deducción agregada: {typeLabel}"
msgstr "Deduction added: {typeLabel}"

#. placeholder {0}: target.label
#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Deducción quitada: {0}"
msgstr "Deduction removed: {0}"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/pages/ConsolidationsPage.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Deducciones"
msgstr "Deductions"

#. placeholder {0}: formatMoney(totalDeductions)
#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Deducciones {0}"
msgstr "Deductions {0}"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Deduce comida"
msgstr "Deduct meals"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Define cuántos, desde cuándo y en qué horario. Cada unidad de cantidad es un lugar que Reclutamiento va a cubrir."
msgstr "Set how many, from when and at what time. Each unit of quantity is a spot Recruitment will fill."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Definir contraseña"
msgstr "Set a password"

#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Del periodo"
msgstr "Period"

#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "del Timesheet"
msgstr "of the Timesheet"

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Demanda"
msgstr "Demand"

#: src/features/schedule/pages/SchedulePage.tsx
msgid "Demanda de la semana"
msgstr "This week's demand"

#: src/features/schedule/pages/SchedulePage.tsx
msgid "Demanda y cobertura de la semana"
msgstr "This week's demand and coverage"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "departamento"
msgstr "department"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/requisitions/components/RequisitionTable.tsx
#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Departamento"
msgstr "Department"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Departamento de hotel"
msgstr "Hotel department"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Departamento de la posición"
msgstr "The position's department"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Departamento del hotel"
msgstr "Hotel department"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Departamento o posición, p. ej. Steward…"
msgstr "Department or position, e.g. Steward…"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Departamentos y posiciones"
msgstr "Departments and positions"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Departamentos, posiciones, modalidades e inglés viven aquí — de acá beben las requisiciones y las altas."
msgstr "Departments, positions, hiring modalities and English levels live here — Requisitions and sign-ups all drink from this."

#: src/features/messaging/components/TemplateDetailDialog.tsx
msgid "Desactivada"
msgstr "Deactivated"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Desactivada en la plataforma: no se puede usar en campañas."
msgstr "Deactivated on the platform: it can't be used in campaigns."

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Desactivar"
msgstr "Deactivate"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Desactivar contacto"
msgstr "Deactivate contact"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Desbloqueado"
msgstr "Unlocked"

#: src/features/contracts/components/UnlockContractDialog.tsx
msgid "Desbloqueando…"
msgstr "Unlocking…"

#: src/features/contracts/components/UnlockContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Desbloquear"
msgstr "Unlock"

#: src/features/contracts/components/UnlockContractDialog.tsx
msgid "Desbloquear contrato"
msgstr "Unlock contract"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "desbloquearlo es del BDC."
msgstr "unblocking it is the BDC's job."

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Descanso"
msgstr "Rest"

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "Descárgala como PDF y pégala en el acceso."
msgstr "Download it as a PDF and stick it at the entrance."

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Descargar"
msgstr "Download"

#: src/features/messaging/pages/CampaignReportPage.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Descargar CSV"
msgstr "Download CSV"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Descargar Excel"
msgstr "Download Excel"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Descargar firmado"
msgstr "Download signed copy"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Descargar para firmar en papel"
msgstr "Download to sign on paper"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/contracts/components/ContractPdfButton.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Descargar PDF"
msgstr "Download PDF"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Descargar plantilla"
msgstr "Download template"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "Descargar QR"
msgstr "Download QR"

#: src/features/contracts/components/ContractPdfButton.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Descargar Word"
msgstr "Download Word"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Descartando…"
msgstr "Discarding…"

#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Descartar borrador"
msgstr "Discard draft"

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Descartar cambios"
msgstr "Discard changes"

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "descontado"
msgstr "deducted"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Descripción"
msgstr "Description"

#: src/shared/components/SettlementEffectBadge.tsx
msgid "Descuento: se le resta"
msgstr "Deduction: subtracted from their pay"

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Descuentos con nombre"
msgstr "Named deductions"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Desde"
msgstr "From"

#. placeholder {0}: formatTimeIn(shift.startsAt, shift.hotelTimeZone)
#: src/features/worker/pages/HomePage.tsx
msgid "Desde {0}"
msgstr "From {0}"

#. placeholder {0}: ONBOARDING_STATUS_LABEL[currentStatus]
#. placeholder {1}: i18n._(STATUS_MOVER[currentStatus])
#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Desde {0} tu rol no mueve el prospecto: {1}"
msgstr "From {0} your role can't move the Prospect: {1}"

#. placeholder {0}: i18n._(WORKER_STATUS_MOVER[currentStatus])
#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Desde {currentLabel} tu rol no mueve al colaborador: {0}"
msgstr "From {currentLabel} your role can't move the Collaborator: {0}"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Desde aquí el semáforo solo permite ir a: {targets}."
msgstr "From here the Status Light only allows going to: {targets}."

#: src/features/audits/pages/AuditsPage.tsx
msgid "Desde aquí inspeccionas"
msgstr "This is where you inspect"

#. placeholder {0}: formatDate(value.from)
#: src/shared/components/DateRangeField.tsx
msgid "Desde el {0}"
msgstr "Since {0}"

#: src/features/messaging/components/ReportCharts.tsx
msgid "Desde el inicio"
msgstr "Since start"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Desde el principio"
msgstr "Since the beginning"

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "desde Naranja, por el BDC"
msgstr "from Orange, by the BDC"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Desde un Excel, CSV, TXT o PDF con una tabla de hoteles."
msgstr "From an Excel, CSV, TXT or PDF file with a table of hotels."

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "desde Verde (BD o BDC) o desde Rosa (BDC)"
msgstr "from Green (BD or BDC) or from Pink (BDC)"

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "desde Verde, por el BD"
msgstr "from Green, by the BD"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Desempeño"
msgstr "Performance"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Desempeño del equipo"
msgstr "Team performance"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Deshabilitada"
msgstr "Disabled"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Desprogramar"
msgstr "Unschedule"

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Después"
msgstr "Next"

#: src/features/onboarding/components/ConfirmSendProposalDialog.tsx
msgid "Después de esto la versión queda congelada: no se vuelve a editar. Para cualquier cambio, aunque sea pequeño, se abre una versión nueva."
msgstr "After this the version is frozen: it can't be edited again. For any change, even a small one, a new version is opened."

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Después de revisar, ya no cambian"
msgstr "Once reviewed, they no longer change"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Después se la pones a los contactos al editarlos o al importar un Excel."
msgstr "Then add it to contacts when editing them or importing an Excel file."

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Después: nadie más aprueba. El contrato queda vigente y el hotel puede pedir personal con estas tarifas."
msgstr "Next: nobody else approves. The contract is in force and the hotel can request staff at these rates."

#: src/features/messaging/components/CreateCampaignDialog.tsx
#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/components/ReportCharts.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Destinatarios"
msgstr "Recipients"

#. placeholder {0}: campaign.name
#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "Destinatarios de «{0}»"
msgstr "Recipients of “{0}”"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Detalle de Requisición"
msgstr "Requisition Details"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Detalle del día"
msgstr "Day details"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Devolver a Café"
msgstr "Send back to Brown"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Devolviendo…"
msgstr "Sending back…"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Devuelto a Café"
msgstr "Sent back to Brown"

#: src/features/messaging/components/ReportCharts.tsx
#: src/features/schedule/components/AddShiftDialog.tsx
#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Día"
msgstr "Day"

#: src/shared/constants/workerStatus.ts
msgid "Día 1-2"
msgstr "Day 1-2"

#: src/shared/constants/workerStatus.ts
msgid "Día 3+"
msgstr "Day 3+"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Día de la marca"
msgstr "Day of the punch"

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Día del turno"
msgstr "Shift day"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Día festivo"
msgstr "Holiday"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Día no reconocido: «{weekText}»"
msgstr "Day not recognized: “{weekText}”"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Día revisado"
msgstr "Day reviewed"

#: src/features/timesheet/components/TimesheetViewControls.tsx
msgid "Días"
msgstr "Days"

#: src/features/accounting/pages/PendingApprovalsPage.tsx
#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Días de atraso"
msgstr "Days late"

#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Días de atraso (prom.)"
msgstr "Days late (avg.)"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Días de una misma requisición"
msgstr "Days of the same requisition"

#: src/features/observability/lib/hotelKpis.ts
msgid "Días entre que se crea la requisición y su primer día de trabajo, de las creadas en el periodo."
msgstr "Days between when the requisition is created and its first workday, of those created in the period."

#: src/features/reports/pages/ReportsPage.tsx
msgid "Días prom."
msgstr "Avg. days"

#: src/features/team/pages/TeamPage.tsx
msgid "Días prom. a Naranja"
msgstr "Avg. days to Orange"

#: src/features/team/pages/TeamPage.tsx
msgid "Días promedio a Naranja"
msgstr "Average days to Orange"

#: src/features/reports/pages/ReportsPage.tsx
msgid "días promedio en cada estado · dónde se atora el pipeline"
msgstr "average days in each status · where the pipeline gets stuck"

#: src/features/personnel/components/WorkerPerformanceRadar.tsx
msgid "Días sin anomalía"
msgstr "Days without anomalies"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Días sin ponches"
msgstr "Days without punches"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Dices qué puesto necesitas, cuántas personas y desde cuándo. Nace autorizada: a Reclutamiento le llega en cuanto la guardas."
msgstr "You say which position you need, how many people, and from when. It starts out authorized: Recruitment gets it as soon as you save it."

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "Dinos a quién va dirigida la propuesta"
msgstr "Tell us who the proposal is addressed to"

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "Dinos el nombre de la propiedad en el documento"
msgstr "Tell us the property name in the document"

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "Dinos la ciudad y el estado del hotel"
msgstr "Tell us the hotel's city and state"

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "Dinos la fecha de preparación del documento"
msgstr "Tell us the document's prepared date"

#: src/features/observability/lib/people.ts
msgid "Dio de alta al candidato"
msgstr "Registered the candidate"

#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Dirección"
msgstr "Address"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Dirección de la propiedad"
msgstr "Property address"

#: src/shared/lib/contractClauses.ts
msgid "Dirección del hotel"
msgstr "Hotel address"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Directo contigo"
msgstr "Directly with you"

#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Dirigida a"
msgstr "Addressed to"

#: src/shared/constants/workerStatus.ts
msgid "Disp. voluntario"
msgstr "Voluntary avail."

#: src/features/worker/pages/HomePage.tsx
msgid "Disponibilidad"
msgstr "Availability"

#: src/shared/constants/workerStatus.ts
msgid "Disponible"
msgstr "Available"

#: src/shared/constants/workerStatus.ts
msgid "Disponible para que Reclutamiento lo asigne."
msgstr "Available for Recruiting to assign."

#: src/features/dashboard/components/RecruitmentDashboard.tsx
msgid "Disponibles"
msgstr "Available"

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Doble firma, en orden"
msgstr "Two signatures, in order"

#: src/features/contracts/components/ContractPdfButton.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/components/PoolTable.tsx
msgid "Documento"
msgstr "Document"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Documento agregado"
msgstr "Document added"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Documento borrado"
msgstr "Document deleted"

#: src/features/conversion/api/conversionApi.ts
msgid "Documento de T&C negociado"
msgstr "T&C document negotiated"

#: src/features/recruitment/components/PoolCardBoard.tsx
msgid "documento pendiente"
msgstr "document pending"

#: src/features/recruitment/components/PoolRoster.tsx
msgid "Documento pendiente de verificar"
msgstr "Document pending verification"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Documento rechazado"
msgstr "Document rejected"

#: src/features/worker/components/TaxDocumentUploader.tsx
msgid "Documento recibido. Si te equivocaste de archivo, súbelo de nuevo y reemplaza el anterior."
msgstr "Document received. If you picked the wrong file, upload it again to replace the previous one."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Documento subido"
msgstr "Document uploaded"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Documento verificado"
msgstr "Document verified"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Documentos"
msgstr "Documents"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "DocuSign anula el documento y el hotel ya no podrá firmarlo. El contrato vuelve a ser editable."
msgstr "DocuSign voids the document and the hotel can no longer sign it. The contract becomes editable again."

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "DocuSign no aceptó el envío. Revisa el correo del hotel e inténtalo de nuevo."
msgstr "DocuSign didn't accept the request. Check the hotel's email and try again."

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "DocuSign no aceptó las credenciales de Oranje. Avísale al Administrador."
msgstr "DocuSign didn't accept Oranje's credentials. Let the Administrator know."

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "Dom"
msgstr "Sun"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Domicilio"
msgstr "Address"

#: src/features/audits/pages/AuditsPage.tsx
msgid "Dos caminos: el ambiente del hotel se contesta de una, y la de personal te deja elegir a quién — arriba salen primero los que llevan más tiempo sin inspeccionarse."
msgstr "Two paths: the hotel environment one you answer right away, and the personnel one lets you pick who — whoever has gone longest without an inspection comes first."

#: src/features/audits/pages/AuditsPage.tsx
msgid "Dos inspecciones, un mismo registro"
msgstr "Two inspections, one record"

#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Dueño"
msgstr "Owner"

#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Dueño del prospecto"
msgstr "Prospect owner"

#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Dueño: yo"
msgstr "Owner: me"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Duplicar"
msgstr "Duplicate"

#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/components/PoolTable.tsx
msgid "Edad"
msgstr "Age"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/messaging/components/ContactActions.tsx
#: src/features/onboarding/components/HotelContactList.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Editar"
msgstr "Edit"

#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Editar cláusulas"
msgstr "Edit clauses"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Editar colaborador"
msgstr "Edit Collaborator"

#: src/features/messaging/components/ContactActions.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Editar contacto"
msgstr "Edit contact"

#. placeholder {0}: editingContact.name
#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Editar contacto · {0}"
msgstr "Edit contact · {0}"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Editar cuenta del hotel"
msgstr "Edit hotel account"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Editar datos del documento"
msgstr "Edit document details"

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Editar datos del hotel"
msgstr "Edit hotel details"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Editar expediente"
msgstr "Edit record"

#: src/features/worker/pages/ProfilePage.tsx
msgid "Editar mis datos"
msgstr "Edit my info"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Editar multiplicadores"
msgstr "Edit multipliers"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Editar personal del sistema"
msgstr "Edit internal staff"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Editar prospecto"
msgstr "Edit Prospect"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Editar reactivo"
msgstr "Edit item"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Editar tarifas"
msgstr "Edit rates"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Editar usuario"
msgstr "Edit user"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Editar vigencia"
msgstr "Edit validity"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Ej: Campaña Navidad 2026"
msgstr "E.g. Christmas campaign 2026"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Ej. 10/19/2026"
msgstr "E.g. 10/19/2026"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Ej. Atlanta, GA"
msgstr "E.g. Atlanta, GA"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Ej. Irene Garcia/Business Development Coordinator"
msgstr "E.g. Irene Garcia/Business Development Coordinator"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Ej. Marriott International"
msgstr "E.g. Marriott International"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Ejecutivo"
msgstr "Executive"

#: src/features/messaging/components/TemplateDetailDialog.tsx
msgid "Ejemplo de cada variable"
msgstr "Example for each variable"

#. placeholder {0}: index + 1
#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Ejemplo de la variable {0}"
msgstr "Example for variable {0}"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Ejemplos para Meta"
msgstr "Examples for Meta"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "El \"Dear [nombre],\" de la carta — ya viene del contacto principal del hotel, cámbialo si va dirigida a alguien más"
msgstr "The \"Dear [name],\" of the letter — it already comes from the hotel's primary contact, change it if it's addressed to someone else"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "El \"Prepared [DATE]\" del machote — se prellena con hoy, cámbiala si el documento debe llevar otra fecha"
msgstr "The template's \"Prepared [DATE]\" — prefilled with today, change it if the document should use another date"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "El \"Printed Name / Title\" del lado ORANJE PEOPLE en la firma del documento"
msgstr "The \"Printed Name / Title\" on the ORANJE PEOPLE side of the document's signature"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "El [PROPERTY NAME] del machote — ya viene del hotel, cámbialo si el documento debe usar otro nombre"
msgstr "The template's [PROPERTY NAME] — already comes from the hotel, change it if the document should use another name"

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "El acceso no está configurado en este ambiente. Avisa al Administrador."
msgstr "Sign-in isn't set up in this environment. Let the Administrator know."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "el Administrador"
msgstr "the Administrator"

#: src/features/admin/components/UserFormDialog.tsx
msgid "El Administrador no reporta a nadie."
msgstr "The Administrator doesn't report to anyone."

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
msgid "El ajuste de tarifa o el gasto de una eventual, ya aprobado por el Manager de QA. Mientras no lo incluyas, no pesa en la nómina."
msgstr "The rate adjustment or expense of a temporary assignment, already approved by the QA Manager. Until you include it, it doesn't weigh on payroll."

#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "El ajuste de tarifa o el gasto extra (p. ej. Uber) de una asignación eventual. Mientras esté aquí, no pesa en ningún pago."
msgstr "The rate adjustment or extra expense (e.g. Uber) of a temporary assignment. While it's here, it doesn't count toward any pay."

#: src/features/recruitment/pages/PoolPage.tsx
msgid "El alta es de Reclutamiento: la Reclutadora captura la Fase 1 en la entrevista."
msgstr "Signing up Collaborators is Recruitment's job: the Recruiter captures Phase 1 during the interview."

#: src/features/admin/pages/UsersPage.tsx
msgid "El alta, la edición y la baja del personal interno de Oranje las hace el Administrador; tu rol no tiene este módulo."
msgstr "Creating, editing and deactivating Oranje's internal staff is the Administrator's job; your role doesn't have this module."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "El archivo está vacío."
msgstr "The file is empty."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "El archivo pasa de 15 MB: comprímelo o escanéalo con menos resolución."
msgstr "The file is over 15 MB: compress it or scan it at a lower resolution."

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "El archivo pasa de 5 MB."
msgstr "The file is larger than 5 MB."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "El archivo pasa de 5 MB. Divídelo en varios."
msgstr "The file is over 5 MB. Split it into several files."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "el BD"
msgstr "the BD"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "el BDC"
msgstr "the BDC"

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "El bill rate debe ser mayor que cero"
msgstr "The bill rate must be greater than zero"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "El bill rate es mayor que el pay rate en todas las posiciones: la diferencia es el margen de Oranje."
msgstr "The bill rate is higher than the pay rate in every position: the difference is Oranje's margin."

#. placeholder {0}: badMargin.map((rate) => rate.positionName).join(', ')
#: src/features/contracts/components/ContractChecklist.tsx
msgid "El bill rate no puede quedar por debajo del pay rate: corrige {0} con «Editar tarifas»."
msgstr "The bill rate can't be below the pay rate: fix {0} with “Edit rates”."

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "El bill rate no puede quedar por debajo del pay rate: se pierde en cada hora."
msgstr "The bill rate can't fall below the pay rate: you'd lose money every hour."

#: src/shared/components/MascotaPeek.tsx
msgid "El botón del menú (☰) en el encabezado esconde el panel y te da más espacio."
msgstr "The menu button (☰) in the header hides the panel and gives you more room."

#: src/features/onboarding/components/PlacesSearchField.tsx
msgid "El buscador no está disponible"
msgstr "Search isn't available"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "El buzón de correo quedó con la misma contraseña."
msgstr "The mailbox now has the same password."

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "El buzón de correo quedó listo, con su propia contraseña."
msgstr "The mailbox is ready, with its own password."

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "El buzón real detrás del correo @oranjepeople.com de cada colaborador"
msgstr "The actual mailbox behind each Collaborator's @oranjepeople.com address"

#: src/features/conversion/api/conversionApi.ts
msgid "El cambio queda en el historial del prospecto"
msgstr "The change stays in the Prospect's history"

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "El camino a cliente"
msgstr "The road to becoming a client"

#: src/features/dashboard/components/PipelineFlowCard.tsx
msgid "El camino principal del ciclo; los desvíos abajo"
msgstr "The cycle's main path; detours below"

#: src/features/onboarding/components/ProposalRateFields.tsx
msgid "El catálogo no tiene puestos todavía. Pídele al Administrador que los agregue en Catálogos · Departamentos y posiciones; sin ellos no se puede cotizar."
msgstr "The catalog has no positions yet. Ask the Administrator to add them in Catalogs · Departments and positions; without them there's nothing to quote."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "El ciclo"
msgstr "The cycle"

#: src/features/onboarding/types/prospectForm.schema.ts
msgid "El ciclo abre con un contacto: escribe su nombre"
msgstr "The cycle opens with a contact: write their name"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "El ciclo comercial"
msgstr "The commercial cycle"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "El ciclo comercial de este hotel está cerrado: ya no se cotiza."
msgstr "This hotel's sales cycle is closed: it's no longer quoted."

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "El ciclo comercial del hotel: de prospecto a cliente."
msgstr "The hotel's commercial cycle: from Prospect to client."

#: src/features/conversion/components/ApproveConversionDialog.tsx
msgid "El ciclo comercial se cierra aquí: de Naranja no se regresa. Si más adelante el hotel se pausa, se le marca como inactivo, pero el ciclo no vuelve a abrirse."
msgstr "The sales cycle ends here: there is no way back from Orange. If the hotel is paused later on, it gets marked inactive, but the cycle never reopens."

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "El ciclo de {hotelName} se cierra definitivamente y el hotel queda libre para un ciclo nuevo."
msgstr "{hotelName}'s cycle closes for good and the hotel is free for a new one."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "El ciclo sigue vivo en Café: se retoma desde el Pipeline cuando el hotel se desbloquee."
msgstr "The cycle is still alive in Brown: pick it up from the Pipeline when the hotel unblocks."

#: src/features/observability/lib/cohorts.ts
msgid "El colaborador"
msgstr "The Collaborator"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "El colaborador completa la Fase 2 (transporte y SSN/ITIN) y la Fase 3 (contacto de emergencia y salud) desde su app; si lo validas a medias, tiene 1 día para completarlo."
msgstr "The collaborator completes Phase 2 (transportation and SSN/ITIN) and Phase 3 (emergency contact and health) from the app; if you validate them incomplete, they have 1 day to finish it."

#: src/features/timesheet/api/timesheetApi.ts
msgid "El colaborador no tiene asignación en esta requisición"
msgstr "The collaborator has no assignment on this requisition"

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "El colaborador pasa a Rojo: es una incidencia, no una pausa — Inspección la revisa y decide si vuelve o queda fuera."
msgstr "The Collaborator goes to Red: it's an incident, not a pause — Inspection reviews it and decides whether they come back or are out."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "El colaborador pidió que Oranje lo cubriera: se le resta de su próxima nómina."
msgstr "The collaborator asked Oranje to cover it: it's subtracted from their next payroll."

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "El colaborador ya no tiene asignación en esta requisición."
msgstr "The collaborator no longer has an assignment on this requisition."

#: src/features/worker/pages/HomePage.tsx
msgid "El color de arriba dice en qué punto estás: desde el alta hasta asignado. Lo mueve Oranje; tú solo enciendes tu disponibilidad."
msgstr "The color above says where you are: from sign-up to assigned. Oranje moves it; you only turn on your availability."

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "El color te dice la prisa"
msgstr "The color tells you the rush"

#: src/features/onboarding/import/mapImportRows.ts
msgid "El contacto no tiene teléfono ni correo válidos: agrégalo después"
msgstr "The contact has no valid phone or email: add it later"

#. placeholder {0}: principalContact.name
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "El contacto Principal ({0}) no tiene correo registrado."
msgstr "The Principal contact ({0}) has no email on file."

#. placeholder {0}: principalContact.name
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "El contacto Principal ({0}) no tiene correo registrado. Agrégalo en Contactos del hotel, o escríbelo aquí."
msgstr "The Principal contact ({0}) has no email on file. Add it in Hotel Contacts, or type it here."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "El contrato del hotel no tiene tarifa para este puesto: pídele a Ventas que la agregue."
msgstr "The hotel's contract has no rate for this position: ask Sales to add it."

#: src/features/contracts/pages/ContractListPage.tsx
msgid "El contrato nace en Borrador, se afina y se activa. Solo puede haber uno vigente a la vez: para renovar, se crea el siguiente y se marca el viejo como vencido. Nunca se borra ninguno."
msgstr "The contract starts as a Draft, gets fine-tuned and is activated. Only one can be in force at a time: to renew, you create the next one and mark the old one as expired. None is ever deleted."

#: src/features/timesheet/components/PayPreviewBadge.tsx
msgid "El contrato no tiene tarifa de facturación para esta posición: no se calcula lo que se le cobraría al hotel."
msgstr "The contract has no billing rate for this position: what would be billed to the hotel isn't calculated."

#: src/features/timesheet/components/PayPreviewBadge.tsx
msgid "El contrato se editó DESPUÉS de que esta semana ya se aprobó: lo que ves aquí es el cálculo nuevo, no el que se aprobó."
msgstr "The contract was edited AFTER this week was already approved: what you see here is the new calculation, not what was approved."

#: src/features/onboarding/components/ContractStepCard.tsx
msgid "El contrato ya está en Borrador"
msgstr "The contract is already a Draft"

#: src/features/onboarding/components/ContractStepCard.tsx
msgid "El contrato ya está vigente"
msgstr "The contract is already active"

#: src/features/onboarding/components/ContractStepCard.tsx
msgid "El contrato ya se envió al hotel"
msgstr "The contract was already sent to the hotel"

#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "El contrato ya tenía las tarifas de la última propuesta."
msgstr "The contract already had the latest proposal's rates."

#. placeholder {0}: String(latestVersion)
#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "El contrato ya tiene las tarifas de la v{0}"
msgstr "The contract now has the v{0} rates"

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "El correo de quien envía es obligatorio"
msgstr "The sender's email is required"

#. placeholder {0}: info.message ?? ''
#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "El correo no aceptó el cambio: {0}."
msgstr "The email didn't accept the change: {0}."

#: src/features/admin/pages/UsersPage.tsx
msgid "El correo no se edita: es con el que la persona entra. Para cambiar de persona, da de baja y da de alta. La cuenta queda enlazada la primera vez que entra. Las cuentas de los hoteles tienen su propia pestaña: «Personal de hoteles»."
msgstr "The email can't be edited: it's what the person signs in with. To switch person, deactivate and sign up the new one. The account links up the first time they sign in. Hotel accounts have their own tab: “Hotel staff”."

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "El correo o la contraseña no coinciden. Revísalos e inténtalo de nuevo."
msgstr "The email or password doesn't match. Check them and try again."

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "El correo saldrá por Firebase hasta que lo regreses"
msgstr "Email will go out through Firebase until you switch it back"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "El correo tiene su propia contraseña: el servidor de correo pide una más fuerte que la de la app."
msgstr "The email has its own password: the mail server requires a stronger one than the app's."

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "El correo vuelve a salir por el servidor de Oranje"
msgstr "Email is going out through the Oranje server again"

#. placeholder {0}: ONBOARDING_STATUS_LABEL[report.bottleneck.status]
#. placeholder {1}: String(report.bottleneck.averageDays)
#: src/features/reports/pages/ReportsPage.tsx
msgid "El cuello está en {0}: {1} d promedio antes de salir"
msgstr "The bottleneck is in {0}: {1} d on average before moving on"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "el departamento"
msgstr "the department"

#: src/features/personnel/components/WorkerPerformanceRadar.tsx
msgid "El desempeño se calcula con turnos y marcas reales: cuando acumule días trabajados, aquí aparece su radar."
msgstr "Performance is calculated from real shifts and punches: once they build up worked days, their radar shows up here."

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "El día completo, marca por marca"
msgstr "The whole day, punch by punch"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "El día tiene una anomalía sin resolver: la revisa el Supervisor del hotel."
msgstr "This day has an unresolved anomaly: the hotel's Supervisor reviews it."

#. placeholder {0}: IS_DEV_UI && <code className="text-xs text-ink-4"> · has_anomaly = true</code>
#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "El día tiene una anomalía sin resolver{0}: revisa las marcas y explica la resolución en la nota."
msgstr "This day has an unresolved anomaly{0}: check the punches and explain the resolution in the note."

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "El Documento de T&C ya se negocia. El BDC aprueba la conversión desde <0>Conversión</0> y el hotel pasa a Naranja, listo para pedir personal."
msgstr "The T&C document is already being negotiated. The BDC approves the conversion from <0>Conversion</0> and the hotel turns Orange, ready to request staff."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "El documento quedará sin nombre ni puesto en la firma de ORANJE PEOPLE. Escríbelo aquí si hace falta."
msgstr "The document will be missing a name and title in the ORANJE PEOPLE signature. Type it here if needed."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "El edificio"
msgstr "The building"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
#: src/features/reports/pages/ReportsPage.tsx
msgid "El envío recurrente llega pronto"
msgstr "Recurring delivery is coming soon"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "El envío se rechazó. Corrige lo necesario y vuelve a «Firmar con DocuSign»."
msgstr "The request was declined. Fix what's needed and use “Sign with DocuSign” again."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "El estado del colaborador y la verificación de sus documentos los lleva la Reclutadora o el Líder de Grupo. Aquí consultas su expediente y su historial."
msgstr "The Collaborator's status and the verification of their documents are handled by the Recruiter or the Group Leader. Here you can look up their record and history."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "El expediente se completa por fases"
msgstr "The record is completed in phases"

#: src/features/recruitment/components/SelfPickFilterBar.tsx
msgid "El filtro por zona estará disponible próximamente"
msgstr "Filtering by Zone is coming soon"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "El firmante aún no está registrado: se captura en la ficha del hotel."
msgstr "The signer is not registered yet: it is captured on the hotel's record."

#: src/features/dashboard/components/PipelineFlowCard.tsx
msgid "El flujo del semáforo"
msgstr "The status light flow"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "El folio se asigna al guardar y Reclutamiento la ve en ese momento: la urgencia corre desde ahí."
msgstr "The number is assigned on save and Recruitment sees it right then: urgency runs from that moment."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "El folio se asigna automáticamente al guardar"
msgstr "The number is assigned automatically on save"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "El Gris protege"
msgstr "Gray protects"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "El historial queda"
msgstr "The history stays"

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "el hotel"
msgstr "the hotel"

#: src/features/conversion/pages/ConversionPage.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "El hotel"
msgstr "The hotel"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "El hotel cambió de firmante"
msgstr "The hotel changed its signer"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "El hotel imprime el código en el acceso; la app lo escanea junto con la ubicación."
msgstr "The hotel prints the code at the entrance; the app scans it along with the location."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "El hotel imprime un código en el acceso y la app lo escanea, con la ubicación."
msgstr "The hotel prints a code at the entrance and the app scans it, along with the location."

#: src/features/observability/lib/cohorts.ts
msgid "El hotel lo mandó a descansar (Stand-by)"
msgstr "The hotel sent them to rest (Stand-by)"

#: src/shared/constants/workerStatus.ts
msgid "El hotel lo mandó a descansar (vacaciones, temporada baja)."
msgstr "The hotel sent them on leave (vacation, low season)."

#: src/shared/constants/workerStatus.ts
msgid "El hotel lo reportó. El Inspector está revisando el caso."
msgstr "The hotel reported them. The Inspector is reviewing the case."

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "El hotel no paga el lonche: se resta media hora con 6.5 h o más."
msgstr "The hotel doesn't pay for lunch: half an hour is deducted at 6.5 h or more."

#: src/features/contracts/components/MultiplierTable.tsx
msgid "El hotel no puede pagar menos recargo de festivo que el colaborador."
msgstr "The hotel can't pay less holiday surcharge than the collaborator."

#: src/features/contracts/components/MultiplierTable.tsx
msgid "El hotel no puede pagar menos recargo de overtime que el colaborador."
msgstr "The hotel can't pay less overtime surcharge than the collaborator."

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "El hotel no tiene contrato vigente con tarifa para esas posiciones."
msgstr "The hotel has no active contract with a rate for those positions."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "El hotel no tiene ninguna posición de este departamento en su contrato vigente — por eso el selector de abajo no muestra nada. Agrégala al contrato antes de pedir personal aquí."
msgstr "This hotel has no position from this department in its active contract — that's why the selector below shows nothing. Add it to the contract before requesting staff here."

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "El hotel no tiene QR generado todavía: regenéralo desde su ficha."
msgstr "This hotel doesn't have a QR yet: regenerate it from its profile."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "El hotel no tiene un contacto Principal registrado."
msgstr "The hotel has no Principal contact on file."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "El hotel no tiene un contacto Principal registrado. Agrégalo en Contactos del hotel, o escríbelo aquí."
msgstr "The hotel has no Principal contact on file. Add one in Hotel Contacts, or type the email here."

#: src/features/timesheet/components/HotelPaysLunchToggle.tsx
msgid "El hotel paga el lonche (horas completas)"
msgstr "The hotel pays for lunch (full hours)"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "El hotel paga el lonche: las horas quedan completas."
msgstr "The hotel pays for lunch: the hours stay whole."

#: src/features/contracts/components/UnlockContractDialog.tsx
msgid "El hotel pidió corregir la dirección de la propiedad"
msgstr "The hotel asked to correct the property address"

#: src/features/conversion/api/conversionApi.ts
msgid "El hotel queda activado como cliente desde hoy"
msgstr "The hotel is activated as a client as of today"

#: src/features/worker/lib/noShiftMessage.ts
msgid "El hotel te mandó a descansar. Cuando te reactive, tus turnos vuelven a aparecer aquí."
msgstr "The hotel put you on rest. When it reactivates you, your shifts show up here again."

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "El hotel ya aprobó esta semana"
msgstr "The hotel already approved this week"

#: src/features/contracts/pages/ContractListPage.tsx
msgid "El hotel ya dijo que sí"
msgstr "The hotel already said yes"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "El hotel ya no podrá editar estos días: ni marca manual ni corregir una marca. Si algo cambia después de enviarla, contacta a Oranje."
msgstr "The hotel won't be able to edit these days anymore: no manual punches, no corrections. If something changes after sending it, contact Oranje."

#: src/features/timesheet/components/BulkApproveButton.tsx
msgid "El hotel ya no podrá editar estos días: ni marca manual ni corregir una marca. Si algo cambia después, contacta a Oranje."
msgstr "The hotel won't be able to edit these days anymore: no manual punches, no corrections. If something changes afterward, contact Oranje."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "El hotel ya no tiene un contrato vigente: no se le puede asignar personal hasta que Ventas lo active."
msgstr "The hotel no longer has an active contract: staff can't be assigned until Sales activates it."

#: src/features/conversion/api/conversionApi.ts
msgid "El hotel ya puede generar requisiciones"
msgstr "The hotel can now create Requisitions"

#. placeholder {0}: String(lastSent.version)
#: src/features/onboarding/components/ContractStepCard.tsx
msgid "El hotel ya tiene la propuesta v{0}. El contrato nace con esas mismas tarifas: las revisas, ajustas lo que se haya negociado y lo guardas en Borrador."
msgstr "The hotel already has proposal v{0}. The contract starts with those same rates: you review them, adjust whatever was negotiated and save it as a Draft."

#. placeholder {0}: IS_DEV_UI && ( <code className="text-ink-4"> · pendiente 13 del ADR (duración del turno)</code> )
#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "El Indicador de Cumplimiento del Timesheet lo calcula el sistema comparando el Contrato con el Timesheet, sin intervención humana. Las horas contractuales por colaborador <0>todavía no están disponibles</0>: hasta que lo estén, esas columnas muestran una raya en vez de un dato inventado{0}. Un Colaborador en Gris (accidente) tampoco se evalúa: queda fuera de la medición semanal."
msgstr "The system calculates the Timesheet Compliance Indicator by comparing the Contract with the Timesheet, with no human input. Contract hours per collaborator <0>aren't available yet</0>: until they are, those columns show a dash instead of a made-up number{0}. A Collaborator in Gray (work accident) isn't measured either: they're left out of the weekly measurement."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "El Inspector se asigna solo por la zona del hotel"
msgstr "The Inspector is assigned automatically by the hotel's zone"

#: src/shared/components/ReleaseAssignmentWarningDialog.tsx
msgid "El lugar queda <0>disponible otra vez</0>, pero el puesto no se cubre solo: busca un reemplazo antes de que el hotel se quede sin alguien ahí."
msgstr "The slot becomes <0>available again</0>, but the position doesn't fill itself: find a replacement before the hotel is left short-staffed."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "El machote compartido, o lo que ya se editó para este contrato"
msgstr "The shared template, or whatever's already been edited for this contract"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "El machote de venta, o lo que ya se editó para este ciclo"
msgstr "The sales template, or what's already been edited for this cycle"

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "El Manager de Área aprueba hasta esta hora."
msgstr "The Area Manager approves up to this time."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "El Manager de Área autoriza y aprueba lo de su departamento; no lo de los demás."
msgstr "The Area Manager authorizes and approves what belongs to their department; not the other departments'."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "El Manager de Área reporta al Manager General."
msgstr "The Area Manager reports to the General Manager."

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "El Manager de Contabilidad la aprueba y la envía; la Contadora y el Manager pueden ver el borrador desde que nace."
msgstr "The Accounting Manager approves it and sends it; the Accountant and the Manager can see the draft from the moment it's created."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "El Manager General no lleva departamento: cubre todo el hotel."
msgstr "The General Manager has no department: they cover the whole hotel."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "El Manager General no reporta a nadie."
msgstr "The General Manager doesn't report to anyone."

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "El Manager General ve todos los departamentos"
msgstr "The General Manager sees every department"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "El mismo Timesheet del hotel, de todos a la vez"
msgstr "The same Timesheet as the hotel's, for everyone at once"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "El motivo queda en el historial del prospecto."
msgstr "The reason stays in the Prospect's history."

#: src/features/personnel/components/ReportWorkerDialog.tsx
#: src/features/personnel/components/StandByDialog.tsx
msgid "El motivo queda en su historia"
msgstr "The reason stays in their history"

#: src/features/observability/components/CohortSection.tsx
msgid "El motivo y quién lo originó se leen de las primeras {MAX_HISTORIES} personas que ya no trabajan. Elige una sola semana para verlo de todas."
msgstr "The reason and who originated it are read from the first {MAX_HISTORIES} people who no longer work. Pick a single week to see it for all of them."

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "El multiplicador de horas extra no se corrige aquí — sigue siendo el del hotel. El monto se recalcula solo, con lo que escribas."
msgstr "The overtime multiplier isn't corrected here — it stays the hotel's. The amount recalculates on its own, from what you enter."

#: src/features/accounting/pages/AccountingPendingPages.tsx
msgid "El neto de cada colaborador antes de pagarle: sale del Consolidado con rate interno, deducciones y overtime autorizado."
msgstr "Each collaborator's net pay before it is paid: comes from the Consolidation with the internal rate, deductions and authorized overtime."

#. placeholder {0}: money(netAfter)
#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "El neto queda en <0>{0}</0>."
msgstr "Net pay becomes <0>{0}</0>."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "el nivel de inglés"
msgstr "the English level"

#. placeholder {0}: String(PROSPECT_TEXT_MAX.contactFullName)
#: src/features/onboarding/import/mapImportRows.ts
msgid "El nombre del contacto pasa de {0} caracteres"
msgstr "The contact's name is over {0} characters"

#: src/features/onboarding/types/hotelContactsForm.schema.ts
msgid "El nombre es obligatorio"
msgstr "The name is required"

#. placeholder {0}: String(PROSPECT_TEXT_MAX.hotelName)
#: src/features/onboarding/import/mapImportRows.ts
msgid "El nombre pasa de {0} caracteres"
msgstr "The name is over {0} characters"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "El orden dentro de su categoría se define arrastrando la fila en la lista, después de guardar."
msgstr "The order within its category is set by dragging the row in the list, after saving."

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "El pago en bloque aún no está disponible"
msgstr "Bulk payment isn't available yet"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "El pago estimado es en vivo"
msgstr "The estimated pay is live"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "El pago lo hace Contabilidad cuando la semana está aprobada"
msgstr "Accounting pays once the week is approved"

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "El pay rate debe ser mayor que cero"
msgstr "The pay rate must be greater than zero"

#: src/shared/components/SendDocumentModal.tsx
msgid "El PDF del documento se adjunta solo. Queda registrado en el historial de correos."
msgstr "The document's PDF is attached automatically. It's logged in the email history."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "El PDF tiene más de 50 páginas: no parece una lista de hoteles."
msgstr "The PDF has more than 50 pages: it doesn't look like a hotel list."

#: src/features/admin/pages/UsersPage.tsx
msgid "El personal interno de Oranje: quién es, qué rol tiene y si ya entró."
msgstr "Oranje's internal staff: who they are, what role they have and whether they've signed in."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "El pin exacto y la geocerca validarán los ponches cuando sea cliente: arrástralo a la entrada real del personal."
msgstr "The exact pin and the geofence will validate punches once it's a client: drag it to the real staff entrance."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "El pin se arrastra a propósito."
msgstr "The pin is meant to be dragged."

#: src/features/onboarding/pages/PipelinePage.tsx
msgid "el Pipeline"
msgstr "the Pipeline"

#: src/features/recruitment/pages/PoolPage.tsx
msgid "el Pool de Colaboradores"
msgstr "the Collaborator Pool"

#: src/features/accounting/pages/AccountingPendingPages.tsx
msgid "El Pre-Payroll se arma desde el Consolidado Semanal y las deducciones. Cuando esos datos se conecten a esta pantalla, aparecerán aquí."
msgstr "The Pre-Payroll is built from the Weekly Consolidation and the deductions. Once that data is connected to this screen, it will show up here."

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "el primer contacto"
msgstr "the first contact"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "El primer Manager General de cada hotel nace en la Conversión; aquí se dan de alta los Supervisores, los Managers de Área y los Managers Generales adicionales."
msgstr "Each hotel's first General Manager is born in the Conversion; Supervisors, Area Managers and additional General Managers are signed up here."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "El prospecto"
msgstr "The Prospect"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "El QR anterior deja de servir al instante: hay que cambiar la hoja del acceso"
msgstr "The old QR stops working instantly: the sheet at the entrance has to be replaced"

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "El QR de otro hotel no te corresponde."
msgstr "This QR belongs to another hotel."

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "El QR lo descarga y regenera el BD, el BDC o el personal del hotel."
msgstr "The BD, the BDC, or the hotel's staff can download and regenerate the QR."

#. placeholder {0}: String(GEOFENCE_MAX_M)
#: src/features/onboarding/types/prospectForm.schema.ts
msgid "El radio máximo es de {0} m"
msgstr "The maximum radius is {0} m"

#. placeholder {0}: String(GEOFENCE_MIN_M)
#: src/features/onboarding/types/prospectForm.schema.ts
msgid "El radio mínimo es de {0} m"
msgstr "The minimum radius is {0} m"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "El renglón {line} apunta a un valor que ya no existe en el catálogo."
msgstr "Line {line} points to a value that no longer exists in the catalog."

#. placeholder {0}: i18n._(fieldLabel)
#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "El renglón {line} elige un valor que ya no existe en el catálogo ({0}): vuelve a elegirlo."
msgstr "Line {line} picks a value that no longer exists in the catalog ({0}): pick it again."

#: src/features/recruitment/api/selfPickApi.ts
msgid "El renglón no existe"
msgstr "That line doesn't exist"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "El reporte aparece cuando se envía."
msgstr "The report appears once it's sent."

#: src/features/messaging/components/tours.ts
msgid "El reporte de cada campaña"
msgstr "Each campaign's report"

#: src/features/messaging/components/tours.ts
msgid "El resumen"
msgstr "The summary"

#: src/features/admin/components/UserFormDialog.tsx
msgid "El rol que elijas decide qué módulos verá la persona al entrar. Las cuentas de los hoteles se dan de alta en su propia pestaña."
msgstr "The role you pick decides which modules the person will see when they sign in. Hotel accounts are signed up in their own tab."

#: src/features/schedule/pages/SchedulePage.tsx
msgid "el Schedule"
msgstr "the Schedule"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "El semáforo lo acompaña del primer contacto hasta cliente activo — cada paso queda en su historia."
msgstr "The Status Light goes with it from the first contact all the way to active client — every step stays in its history."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "El semáforo lo mueve Reclutamiento"
msgstr "Recruitment moves the Status Light"

#: src/features/conversion/api/conversionApi.ts
msgid "El semáforo pasa a Naranja"
msgstr "The Status Light moves to Orange"

#: src/features/admin/components/UserFormDialog.tsx
msgid "El servicio de acceso no respondió y el usuario no se creó. Inténtalo de nuevo en un momento."
msgstr "The sign-in service didn't respond and the user wasn't created. Try again in a moment."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "El servidor no aceptó este dato: revísalo."
msgstr "The server didn't accept this value: please check it."

#. placeholder {0}: steps.join(', ')
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "El servidor no aceptó un dato del paso {0}: está marcado en rojo. Corrígelo y vuelve a crear el prospecto."
msgstr "The server didn't accept a value in step {0}: it's marked in red. Fix it and create the prospect again."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "el Sistema"
msgstr "the System"

#: src/shared/constants/workerStatus.ts
msgid "el sistema lo libera al terminar la asignación; el hotel puede mandarlo a Stand-by y el propio colaborador ponerse Disponible voluntario."
msgstr "the system releases them when the assignment ends; the hotel can send them to Stand-by and the Collaborator can set themselves as Voluntarily available."

#. placeholder {0}: IS_DEV_UI ? ' (D-27)' : ''
#: src/features/personnel/pages/PersonnelPage.tsx
msgid "El Stand-by (Rosa) lo compartes con el Manager de Área. Un colaborador en Gris (accidente) está protegido: no se manda a Stand-by, no se veta y sus faltas no cuentan{0}."
msgstr "You share Stand-by (Pink) with the Area Manager. A collaborator in Gray (work accident) is protected: they can't be sent to Stand-by or blacklisted, and their absences don't count{0}."

#: src/features/personnel/components/StandByDialog.tsx
msgid "El Stand-by manda al colaborador a Rosa: sigue siendo tuyo, pero no recibe turnos nuevos hasta reactivarlo."
msgstr "Stand-by sends the collaborator to Pink: they're still yours, but they get no new shifts until you reactivate them."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "El Supervisor reporta a un Manager de Área de su departamento o al Manager General."
msgstr "The Supervisor reports to an Area Manager in their department or to the General Manager."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "El Supervisor revisa el timesheet de su departamento; no verá ni podrá pedir personal de los demás."
msgstr "The Supervisor reviews their department's Timesheet; they won't see or be able to request staff from the others."

#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "El Supervisor revisa; la aprobación de horas es del Manager de Área o del Manager General."
msgstr "The Supervisor reviews; approving hours is up to the Area Manager or the General Manager."

#: src/features/timesheet/components/WorkerWeekSummary.tsx
msgid "El Supervisor ya la envió; ya no se puede editar. Falta que un Manager la apruebe."
msgstr "The Supervisor already sent it; it can't be edited anymore. It's waiting for a Manager to approve it."

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "El Supervisor, el Manager de Área o el Manager General las abren desde su zona. Aquí ves las que llegan, su urgencia y cómo va la cobertura."
msgstr "The Supervisor, the Area Manager or the General Manager open them from their side. Here you see the ones coming in, their urgency and how coverage is going."

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "el tablero de Requisiciones"
msgstr "the Requisitions board"

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "El teléfono de quien envía es obligatorio"
msgstr "The sender's phone is required"

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "El territorio lo reparte el BDC"
msgstr "The BDC hands out the territory"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "El total nuevo quedaría por debajo de las notas de crédito: revísalas antes de recalcular."
msgstr "The new total would fall below the credit notes: review them before recalculating."

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "El trabajo de tu equipo y la cobertura de requisiciones, para descargar"
msgstr "Your team's work and requisition coverage, ready to download"

#: src/features/admin/components/UserFormDialog.tsx
msgid "El usuario quedó guardado, pero el correo de invitación no salió: reenvíala desde su ficha."
msgstr "The user was saved, but the invitation email didn't go out: resend it from their record."

#: src/features/admin/components/UserFormDialog.tsx
msgid "El usuario se guardó, pero sus zonas no: ábrelo de nuevo para reintentar."
msgstr "The user was saved, but their zones weren't: open it again to retry."

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "El veto lo puede quitar únicamente el Administrador; si no eres tú, el sistema va a rechazar la acción."
msgstr "Only the Administrator can lift a ban; if that's not you, the system will reject the action."

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "El veto no se borra: queda en el historial como levantado, con tu motivo"
msgstr "The ban isn't deleted: it stays in the history as lifted, with your reason"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "El veto queda vigente desde ahora; el historial de la persona nunca se borra"
msgstr "The ban takes effect from now on; the person's history is never deleted"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "El veto siempre carga su porqué y su respaldo — sin evidencia no hay veto."
msgstr "A ban always carries its reason and its backup — no evidence, no ban."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Elaborar la propuesta es del BD o del BDC"
msgstr "Drafting the Proposal is the BD's or the BDC's job"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Elegir el archivo"
msgstr "Choose the file"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Elegir el hotel"
msgstr "Choose the hotel"

#: src/features/admin/components/RoleGrantsSection.tsx
#: src/features/admin/pages/FeatureAccessPage.tsx
#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Elige a la persona"
msgstr "Choose the person"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Elige a la persona…"
msgstr "Choose the person…"

#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "Elige a quién"
msgstr "Choose who"

#: src/features/messaging/components/CampaignsTour.tsx
msgid "Elige a quién (todos, por etiquetas o uno por uno) y la plantilla. Para un Excel, primero impórtalo en Contactos. Se guarda como borrador: todavía no se envía nada."
msgstr "Choose who (everyone, by tags or one by one) and the template. For an Excel file, import it in Contacts first. It's saved as a draft: nothing is sent yet."

#: src/features/audits/components/AuditWorkerList.tsx
msgid "Elige a quién inspeccionar. El tiempo sin inspeccionar te dice por dónde empezar."
msgstr "Choose who to inspection. Time since the last inspection tells you where to start."

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Elige a quién se inspecciona antes de guardar."
msgstr "Choose who's being inspected before saving."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Elige a un colaborador Disponible…"
msgstr "Choose an Available Collaborator…"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Elige a un colaborador para asignar"
msgstr "Choose a Collaborator to assign"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Elige a un colaborador."
msgstr "Choose a worker."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Elige al dueño"
msgstr "Choose the owner"

#: src/features/onboarding/types/prospectForm.schema.ts
msgid "Elige al dueño del prospecto"
msgstr "Choose the Prospect's owner"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Elige al menos un contacto."
msgstr "Choose at least one contact."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Elige al menos una etiqueta."
msgstr "Choose at least one tag."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Elige el concepto…"
msgstr "Choose the concept…"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Elige el departamento"
msgstr "Choose the department"

#: src/shared/components/DateField.tsx
msgid "Elige el día"
msgstr "Pick a day"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "elige el hotel"
msgstr "choose the hotel"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Elige el hotel"
msgstr "Choose the hotel"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Elige el hotel y ves en qué va su propuesta: seguirla, abrir una nueva versión o crear la primera."
msgstr "Pick the hotel to see where its proposal stands: continue it, open a new version or create the first one."

#: src/features/onboarding/types/prospectForm.schema.ts
msgid "Elige el hotel ya registrado"
msgstr "Choose the hotel already on file"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Elige el hotel…"
msgstr "Choose the hotel…"

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
#: src/features/onboarding/components/ChangeStatusDialog.tsx
#: src/features/personnel/components/ReportWorkerDialog.tsx
#: src/features/personnel/components/StandByDialog.tsx
msgid "Elige el motivo…"
msgstr "Choose the reason…"

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Elige el nuevo estado"
msgstr "Choose the new status"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Elige el parentesco"
msgstr "Choose the relationship"

#: src/features/messaging/components/tours.ts
msgid "Elige el periodo"
msgstr "Choose the period"

#: src/features/onboarding/components/JobTitleSelect.tsx
#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "Elige el puesto"
msgstr "Choose the position"

#: src/features/onboarding/components/ProposalRateFields.tsx
msgid "Elige el puesto…"
msgstr "Choose the position…"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Elige el resultado del intento"
msgstr "Choose the outcome of the attempt"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Elige el resultado…"
msgstr "Choose the outcome…"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Elige el rol"
msgstr "Choose the role"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Elige el semáforo"
msgstr "Choose the Status Light"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Elige el tipo de intento"
msgstr "Choose the attempt type"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Elige el tipo de sangre"
msgstr "Choose the blood type"

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Elige la función"
msgstr "Choose the role"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Elige la industria"
msgstr "Choose the industry"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Elige la modalidad"
msgstr "Choose the hiring modality"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Elige la posición"
msgstr "Choose the position"

#: src/features/contracts/components/EditRateDialog.tsx
msgid "Elige la posición…"
msgstr "Choose the position…"

#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/onboarding/types/prospectForm.schema.ts
#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Elige la zona"
msgstr "Choose the Zone"

#: src/features/onboarding/types/prospectForm.schema.ts
msgid "Elige la zona horaria"
msgstr "Choose the time zone"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Elige la zona…"
msgstr "Choose the Zone…"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Elige primero el hotel y el rol: los jefes posibles salen de ahí."
msgstr "Choose the hotel and the role first: the possible managers come from those."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Elige quién ocupa el siguiente slot libre"
msgstr "Choose who takes the next open slot"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Elige tu tipo…"
msgstr "Choose your type…"

#: src/features/worker/pages/Phase2Page.tsx
msgid "Elige tu transporte para continuar"
msgstr "Choose your transportation to continue"

#: src/features/worker/pages/Phase2Page.tsx
msgid "Elige tu transporte…"
msgstr "Choose your transportation…"

#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "Elige un bloque para ver a sus colaboradores y revisar sus días."
msgstr "Choose a block to see its collaborators and review their days."

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Elige un hotel de la lista para ver su propuesta."
msgstr "Pick a hotel from the list to see its proposal."

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Elige un hotel para ajustar si paga el lonche"
msgstr "Choose a hotel to adjust whether it pays for lunch"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Elige un hotel para cerrar su semana"
msgstr "Choose a hotel to close its week"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Elige un hotel…"
msgstr "Choose a hotel…"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Elige un motivo…"
msgstr "Choose a reason…"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Elige un resultado para armar la lista."
msgstr "Choose a result to build the list."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Elige un rol"
msgstr "Choose a role"

#: src/features/schedule/pages/SchedulePage.tsx
msgid "Elige un turno para ver a sus colaboradores."
msgstr "Choose a shift to see its collaborators."

#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "Elige una fecha y hora al menos un minuto en el futuro."
msgstr "Choose a date and time at least one minute in the future."

#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "Elige una Líder o «Directo contigo»"
msgstr "Choose a Group Leader or “Directly with you”"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Elige una plantilla aprobada"
msgstr "Choose an approved template"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Elige una plantilla."
msgstr "Choose a template."

#: src/features/worker/pages/PasswordPage.tsx
msgid "Elige una que solo tú sepas; la temporal que te dieron deja de servir."
msgstr "Pick one only you know; the temporary one you were given stops working."

#: src/features/observability/components/CohortSection.tsx
msgid "Elige una semana para verlo."
msgstr "Pick a week to see it."

#: src/shared/constants/requisitionStatus.ts
msgid "Eliminada"
msgstr "Deleted"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/onboarding/components/DeleteHotelAction.tsx
#: src/features/recruitment/components/DeleteWorkerDialog.tsx
#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Eliminando…"
msgstr "Deleting…"

#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/messaging/components/ContactActions.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/recruitment/components/PoolRoster.tsx
msgid "Eliminar"
msgstr "Delete"

#. placeholder {0}: department.name
#. placeholder {0}: i18n._(pending.noun)
#. placeholder {0}: item.label
#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Eliminar {0}"
msgstr "Delete {0}"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Eliminar buzón"
msgstr "Delete mailbox"

#: src/features/recruitment/components/DeleteWorkerDialog.tsx
msgid "Eliminar colaborador"
msgstr "Delete Collaborator"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Eliminar contacto"
msgstr "Delete contact"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Eliminar departamento"
msgstr "Delete department"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Eliminar es de verdad"
msgstr "Deleting is for real"

#: src/features/onboarding/components/ContactAttemptLog.tsx
msgid "Eliminar este intento"
msgstr "Delete this attempt"

#: src/features/onboarding/components/DeleteHotelAction.tsx
msgid "Eliminar hotel"
msgstr "Delete hotel"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Eliminar motivo"
msgstr "Delete reason"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Eliminar posición"
msgstr "Delete position"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Eliminar reactivo"
msgstr "Delete item"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Eliminar requisición"
msgstr "Delete requisition"

#: src/features/messaging/components/ContactActions.tsx
msgid "Email"
msgstr "Email"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Embudo de entrega"
msgstr "Delivery funnel"

#: src/features/worker/pages/ProfilePage.tsx
msgid "Emergencia"
msgstr "Emergency"

#: src/features/accounting/types/settlement.constants.ts
msgid "Emitida"
msgstr "Issued"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Emitida al hotel. Falta registrar el cobro."
msgstr "Issued to the hotel. Collection still needs to be recorded."

#: src/features/worker/pages/HomePage.tsx
msgid "Empezar"
msgstr "Get started"

#. placeholder {0}: formatDate(startDate)
#. placeholder {1}: -ahead
#: src/shared/components/UrgencyChip.tsx
msgid "Empezó el {0} · {1, plural, one {hace # día} other {hace # días}}"
msgstr "Started on {0} · {1, plural, one {# day ago} other {# days ago}}"

#. placeholder {0}: formatDate(startDate)
#: src/shared/components/UrgencyChip.tsx
msgid "Empieza el {0} · {ahead, plural, one {en # día} other {en # días}}"
msgstr "Starts on {0} · {ahead, plural, one {in # day} other {in # days}}"

#: src/shared/constants/requisitionStatus.ts
msgid "empieza en 3 a 5 días"
msgstr "starts in 3 to 5 days"

#: src/shared/constants/requisitionStatus.ts
msgid "empieza en más de 5 días"
msgstr "starts in more than 5 days"

#: src/shared/constants/requisitionStatus.ts
msgid "empieza en menos de 3 días"
msgstr "starts in less than 3 days"

#. placeholder {0}: formatDate(startDate)
#: src/shared/components/UrgencyChip.tsx
msgid "Empieza hoy, {0}"
msgstr "Starts today, {0}"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "empiezan en menos de 3 días"
msgstr "start in less than 3 days"

#. placeholder {0}: String(days)
#: src/features/contracts/components/ContractFilters.tsx
msgid "en {0} días"
msgstr "in {0} days"

#. placeholder {0}: metrics.openHotels
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "en {0} hoteles"
msgstr "across {0} hotels"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "en 7 días"
msgstr "within 7 days"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "En accidente"
msgstr "On work accident"

#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "En Blacklist"
msgstr "On the Blacklist"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
#: src/features/messaging/components/ReportParts.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "En cola"
msgstr "Queued"

#: src/features/territory/components/TerritoryMapLegend.tsx
msgid "En contacto"
msgstr "In contact"

#: src/shared/constants/workerStatus.ts
msgid "En descanso de un hotel y se ofreció disponible para una asignación temporal."
msgstr "On leave from a hotel and offered themselves available for a temporary assignment."

#. placeholder {0}: formatDate(selected.createdAt)
#. placeholder {0}: formatDate(worker.createdAt)
#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "En el Pool desde el {0}"
msgstr "In the Pool since {0}"

#: src/shared/constants/requisitionStatus.ts
msgid "En elaboración"
msgstr "In preparation"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "En ese hotel aún no hay un Manager de Área de ese departamento ni un Manager General activos."
msgstr "That hotel has no active Area Manager for that department and no active General Manager yet."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "En ese hotel aún no hay un Manager General activo."
msgstr "That hotel has no active General Manager yet."

#: src/features/worker/pages/PunchPage.tsx
msgid "En este hotel Entrada y Salida se registran escaneando el QR del acceso."
msgstr "At this hotel, Clock in and Clock out are recorded by scanning the QR at the entrance."

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "En este idioma le llega la invitación y abre la app la primera vez. Después lo cambia desde su cuenta."
msgstr "Their invitation arrives in this language, and so does the app the first time they open it. They can change it later from their account."

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "En firma: falta que firme el hotel. Mientras tanto el contrato no se edita."
msgstr "Out for signature: waiting for the hotel to sign. The contract can't be edited meanwhile."

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "En firma: falta que firme Oranje. Mientras tanto el contrato no se edita."
msgstr "Out for signature: waiting for Oranje to sign. The contract can't be edited meanwhile."

#: src/features/personnel/components/WorkerPerformanceRadar.tsx
msgid "En la geocerca"
msgstr "Inside the geofence"

#: src/features/messaging/components/TemplateDetailDialog.tsx
msgid "En la plataforma"
msgstr "On the platform"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "en los últimos {days} días"
msgstr "in the last {days} days"

#: src/features/observability/components/KpiCard.tsx
msgid "En meta"
msgstr "On target"

#: src/features/dashboard/components/RecruitmentDashboard.tsx
#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
#: src/shared/constants/requisitionStatus.ts
msgid "En proceso"
msgstr "In progress"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "En revisión"
msgstr "In review"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "En Stand-by"
msgstr "On Stand-by"

#: src/features/messaging/components/ReportCharts.tsx
msgid "En total"
msgstr "In total"

#: src/shared/components/MascotaPeek.tsx
msgid "En una vista de detalle, la flecha ← te regresa a donde estabas."
msgstr "In a detail view, the ← arrow takes you back to where you were."

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Encabezado (opcional)"
msgstr "Header (optional)"

#: src/features/worker/pages/HomePage.tsx
msgid "Enciende Amarillo cuando quieras que te consideren para más turnos."
msgstr "Turn on Yellow when you want to be considered for more shifts."

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Enlace"
msgstr "Link"

#: src/features/accounting/pages/AccountingPendingPages.tsx
#: src/features/accounting/pages/AccountingTimesheetPage.tsx
#: src/features/accounting/pages/ConsolidationsPage.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
#: src/features/accounting/pages/InvoicesPage.tsx
#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
#: src/features/accounting/pages/PendingApprovalsPage.tsx
#: src/features/messaging/components/Tour.tsx
#: src/features/timesheet/components/DayStatusTour.tsx
#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Entendido"
msgstr "Got it"

#. placeholder {0}: i18n._(branch.enteredFrom)
#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "entra {0}"
msgstr "{0} steps in"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Entra a cada una para ver el detalle, los motivos y los destinatarios."
msgstr "Open each one to see the details, reasons and recipients."

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Entra a Oranje"
msgstr "Sign in to Oranje"

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Entra al Pool hoy. Lo suyo tiene 1 día para completarlo desde su app; si no lo hace, su acceso se bloquea hasta que lo complete. Lo de Fase 1 no le bloquea nada: eso queda en tus manos."
msgstr "They join the Pool today. They have 1 day to complete their part from the app; if they don't, their access locks until they do. What's missing from Phase 1 doesn't block them — that's on you."

#: src/features/schedule/components/AddShiftDialog.tsx
#: src/features/timesheet/components/AttendanceView.tsx
#: src/features/timesheet/components/CorrectPunchDialog.tsx
#: src/features/timesheet/components/ManualPunchDialog.tsx
#: src/features/timesheet/components/ReviewDayDialog.tsx
#: src/features/worker/api/punchApi.ts
#: src/features/worker/pages/PunchPage.tsx
msgid "Entrada"
msgstr "Clock in"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Entrada – Salida"
msgstr "Clock in – Clock out"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Entrada de hoy"
msgstr "Today's clock-in"

#: src/features/worker/pages/PunchPage.tsx
msgid "Entrada y Salida llevan tu foto"
msgstr "Clock in and Clock out take your photo"

#: src/features/worker/pages/PunchPage.tsx
msgid "Entrada y Salida necesitan tu foto: tómala y vuelve a intentar."
msgstr "Clock in and Clock out need your photo: take it and try again."

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Entrada, lunch y salida con su geocerca y sus dos relojes. Un día sin salida no puede irse a revisión."
msgstr "Clock in, lunch and clock out, each with its geofence and its two clocks. A day without a clock-out can't go to review."

#: src/features/worker/pages/PunchPage.tsx
msgid "Entrada, salida al lunch, regreso y salida. El botón siempre sabe cuál toca: solo tócalo cuando llegue el momento."
msgstr "Clock in, out to lunch, back from lunch and clock out. The button always knows which one is next: just tap it when the time comes."

#: src/features/observability/lib/workerKpis.ts
msgid "Entradas a la hora o antes, de las que tenían un turno programado."
msgstr "Clock-ins on time or earlier, of those with a scheduled shift."

#. placeholder {0}: role.title
#: src/mobile/UnsupportedRolePage.tsx
msgid "Entraste como {0}. Tu trabajo en Oranje está en el web, desde la computadora."
msgstr "You signed in as {0}. Your work at Oranje is on the web, from a computer."

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/components/ReportCharts.tsx
#: src/features/messaging/components/ReportParts.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Entregados"
msgstr "Delivered"

#: src/features/messaging/components/ReportCharts.tsx
msgid "Entregados sin leer"
msgstr "Delivered, unread"

#. placeholder {0}: timeOf(row.clockInAt, timeZone)
#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Entró {0}"
msgstr "Clocked in {0}"

#: src/features/onboarding/components/ProposalVersionHistory.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Enviada"
msgstr "Sent"

#. placeholder {0}: formatDate(candidate.latestSentAt)
#. placeholder {0}: formatDate(version.sentAt)
#: src/features/onboarding/components/ProposalVersionHistory.tsx
#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "Enviada {0}"
msgstr "Sent {0}"

#. placeholder {0}: formatDate(selected.sentAt)
#. placeholder {0}: formatDate(version.sentAt)
#. placeholder {1}: selected.byName
#. placeholder {1}: version.byName
#: src/features/onboarding/components/ProposalVersionList.tsx
#: src/features/onboarding/components/ViewProposalDialog.tsx
#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Enviada {0} · {1}"
msgstr "Sent {0} · {1}"

#. placeholder {0}: formatDate(version.sentAt)
#. placeholder {1}: version.byName
#: src/features/onboarding/components/ProposalVersionHistory.tsx
msgid "Enviada {0} por {1}"
msgstr "Sent {0} by {1}"

#: src/shared/constants/timesheetStatus.ts
msgid "Enviada a aprobación"
msgstr "Sent for approval"

#: src/features/admin/pages/MailSettingsPage.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Enviado"
msgstr "Sent"

#: src/features/worker/pages/Phase2Page.tsx
msgid "Enviado, en revisión"
msgstr "Sent, under review"

#: src/features/messaging/components/ReportParts.tsx
msgid "Enviados sin confirmar"
msgstr "Sent, unconfirmed"

#: src/features/messaging/components/CampaignsTour.tsx
msgid "Envíala desde aquí"
msgstr "Send it from here"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
msgid "Enviando"
msgstr "Sending"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Enviando y aprobando…"
msgstr "Submitting and approving…"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/onboarding/components/ConfirmSendProposalDialog.tsx
#: src/features/timesheet/components/WeekActionBar.tsx
#: src/shared/components/SendDocumentModal.tsx
msgid "Enviando…"
msgstr "Sending…"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Enviar"
msgstr "Send"

#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "Enviar a {total} contactos"
msgstr "Send to {total} contacts"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Enviar a revisión"
msgstr "Send for review"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Enviar contrato"
msgstr "Send contract"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Enviar contrato por correo"
msgstr "Send contract by email"

#: src/shared/components/SendDocumentModal.tsx
msgid "Enviar correo"
msgstr "Send email"

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Enviar enlace"
msgstr "Send link"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Enviar invitación por correo"
msgstr "Send an invitation by email"

#: src/features/onboarding/components/ContractPreviewDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Enviar por correo"
msgstr "Send by email"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Enviar por correo para firmar en papel"
msgstr "Email it to sign on paper"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Enviar propuesta"
msgstr "Send Proposal"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Enviar propuesta por correo"
msgstr "Send proposal by email"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Enviar y aprobar"
msgstr "Submit and approve"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Envío cancelado: el contrato se puede editar otra vez"
msgstr "Request canceled: the contract can be edited again"

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Envío de emergencia (jueves)"
msgstr "Emergency send (Thursday)"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Envío registrado"
msgstr "Sending recorded"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/pages/MessagingPage.tsx
msgid "Envíos masivos por WhatsApp"
msgstr "Bulk WhatsApp sends"

#: src/features/onboarding/components/JobTitleSelect.tsx
msgid "Equipo Oranje"
msgstr "Oranje team"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Es el contacto principal"
msgstr "This is the primary contact"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "es el principal de este hotel"
msgstr "is this hotel's primary contact"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Es el punto que usa el ponche para medir la distancia. Arrástralo a la entrada real del hotel para tener mejor precisión: unos metros de más rechazan ponches legítimos."
msgstr "It's the point the punch uses to measure distance. Drag it to the hotel's real entrance for better accuracy: a few extra meters reject legitimate punches."

#: src/features/worker/components/ChangePasswordForm.tsx
msgid "Es la contraseña con la que entras a esta app. La de tu correo corporativo se cambia desde el correo."
msgstr "This is the password you use to sign in to this app. Your corporate email password is changed from the email itself."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Es menor de edad"
msgstr "They're under 18"

#: src/features/personnel/components/ReportWorkerDialog.tsx
#: src/features/personnel/components/StandByDialog.tsx
msgid "Es obligatorio decir por qué: el motivo acompaña la transición en el historial del colaborador."
msgstr "You have to say why: the reason goes with the transition in the collaborator's history."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Es su contraseña de uso: puede cambiarla cuando quiera con «¿Olvidaste tu contraseña?». No se envía por correo."
msgstr "This is the password they'll use: they can change it whenever they want with “Forgot your password?”. It isn't sent by email."

#. placeholder {0}: formatDate(access.dueAt)
#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Es temporal y se le venció el {0}: su app solo le deja cambiarla."
msgstr "It's temporary and expired on {0}: their app only lets them change it."

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "Es temporal: el colaborador la cambia desde su app en los próximos 30 días. La verás una sola vez: dásela en persona, no por correo."
msgstr "It is temporary: the worker changes it from their app within the next 30 days. You will see it only once: hand it over in person, not by email."

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Es temporal: tiene 30 días para cambiarla desde su app; si no, su acceso se bloquea hasta que lo haga."
msgstr "It's temporary: they have 30 days to change it from their app; otherwise their access is locked until they do."

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "Es temporal: tiene 30 días para cambiarla desde su app."
msgstr "It is temporary: they have 30 days to change it from their app."

#. placeholder {0}: formatDate(access.dueAt)
#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Es temporal: tiene hasta el {0} para cambiarla desde su app."
msgstr "It's temporary: they have until {0} to change it from their app."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Es un borrador en elaboración: los valores pueden cambiar hasta que el BD o el BDC la envíen. Cuando la envíen, aquí verás la versión final."
msgstr "This is a draft in progress: the values can change until the BD or the BDC sends it. Once they do, you'll see the final version here."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Es un Excel antiguo (.xls): ábrelo y guárdalo como .xlsx."
msgstr "It's an old Excel file (.xls): open it and save it as .xlsx."

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Esa asignación es de otro hotel."
msgstr "That assignment belongs to another hotel."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Esa cuenta ya no existe en ese hotel. Recarga la página."
msgstr "That account no longer exists in that hotel. Reload the page."

#: src/features/worker/pages/PunchPage.tsx
msgid "Esa foto no se pudo procesar: toma otra desde la cámara."
msgstr "That photo couldn't be processed: take another one with the camera."

#. placeholder {0}: formatDayMonth(workDate)
#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Esa marca ya quedó registrada el {0}."
msgstr "That punch was already recorded on {0}."

#: src/features/worker/pages/PunchPage.tsx
msgid "Esa marca ya quedó registrada hoy."
msgstr "That punch was already recorded today."

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Esa persona ya no tiene una asignación activa aquí."
msgstr "That person no longer has an active assignment here."

#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "Esa Reclutadora ya no está en tu equipo. Recarga la página para ver tu equipo actual."
msgstr "That Recruiter is no longer on your team. Reload the page to see your current team."

#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Esa versión de la propuesta no existe. Vuelve a Propuestas y elige otra."
msgstr "That Proposal version doesn't exist. Go back to Proposals and choose another one."

#: src/features/worker/components/QrScanner.tsx
msgid "Escanea el QR del acceso"
msgstr "Scan the QR at the entrance"

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "Escanéalo con la cámara de tu celular al llegar y al salir: te lleva directo a ponchar. También toma tu ubicación."
msgstr "Scan it with your phone's camera when you arrive and leave: it takes you straight to punching in. It also takes your location."

#: src/features/personnel/components/ContactQr.tsx
msgid "Escanéalo con tu celular para llamarle o guardar su contacto"
msgstr "Scan it with your phone to call them or save their contact"

#: src/features/worker/pages/PunchPage.tsx
msgid "escaneando el QR del acceso"
msgstr "by scanning the QR at the entrance"

#: src/layouts/GlobalSearch.tsx
msgid "Escribe al menos 2 letras. Navega con ↑ ↓ y abre con Enter."
msgstr "Type at least 2 letters. Move with ↑ ↓ and open with Enter."

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Escribe al menos 4 caracteres para poder guardar."
msgstr "Write at least 4 characters to be able to save."

#: src/features/onboarding/types/prospectForm.schema.ts
msgid "Escribe al menos un teléfono o un correo del contacto"
msgstr "Enter at least one phone number or email for the contact"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Escribe el motivo (al menos 4 letras) para poder eliminarla"
msgstr "Write the reason (at least 4 characters) to delete it"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Escribe el motivo: queda en el journal."
msgstr "Write the reason: it stays in the log."

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Escribe el nombre completo"
msgstr "Write the full name"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Escribe el nombre de la etiqueta."
msgstr "Write the tag name."

#: src/features/onboarding/types/prospectForm.schema.ts
msgid "Escribe el nombre del hotel"
msgstr "Write the hotel's name"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Escribe el teléfono con su código de país: +1 para EE. UU., +52 para México."
msgstr "Write the phone with its country code: +1 for the US, +52 for Mexico."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Escribe el texto de cada variable fija."
msgstr "Enter the text for each fixed variable."

#: src/features/onboarding/import/mapImportRows.ts
msgid "Escribe Sí o No en horas extra, no «{overtimeText}»"
msgstr "Write Yes or No for overtime, not “{overtimeText}”"

#: src/features/auth/types/login.schema.ts
#: src/mobile/AppLoginPage.tsx
msgid "Escribe tu contraseña"
msgstr "Write your password"

#: src/features/auth/types/login.schema.ts
#: src/mobile/AppLoginPage.tsx
msgid "Escribe tu correo"
msgstr "Write your email"

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Escribe tu correo y te mandamos el enlace."
msgstr "Write your email and we'll send you the link."

#: src/features/onboarding/types/hotelContactsForm.schema.ts
#: src/shared/components/SendDocumentModal.tsx
msgid "Escribe un correo válido"
msgstr "Write a valid email"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Escribe un correo válido, como ana@hotel.com"
msgstr "Write a valid email, like ana@hotel.com"

#: src/features/auth/types/login.schema.ts
#: src/mobile/AppLoginPage.tsx
msgid "Escribe un correo válido, como ana@oranje.mx"
msgstr "Write a valid email, like ana@oranje.mx"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Escribe un correo válido, como ana@oranjepeople.com"
msgstr "Write a valid email, like ana@oranjepeople.com"

#: src/features/onboarding/types/prospectForm.schema.ts
msgid "Escribe un correo válido, como marta@hotel.mx"
msgstr "Write a valid email, like marta@hotel.mx"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "Escribir una contraseña"
msgstr "Type a password"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Escribirla yo"
msgstr "I'll type it"

#: src/features/worker/components/TaxDocumentUploader.tsx
msgid "Ese archivo no se pudo leer: sube una foto clara o un PDF."
msgstr "That file couldn't be read: upload a clear photo or a PDF."

#: src/features/worker/pages/PunchPage.tsx
msgid "Ese código no es el QR vigente del hotel: busca la hoja actual, o pídele al Supervisor un ponche manual."
msgstr "That code isn't the hotel's current QR: find the current sheet, or ask the Supervisor for a manual punch."

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Ese colaborador ya no tiene asignación activa en este hotel."
msgstr "That collaborator no longer has an active assignment at this hotel."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Ese colaborador ya tiene una asignación activa."
msgstr "That Collaborator already has an active assignment."

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "Ese correo no es válido"
msgstr "That email isn't valid"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Ese correo ya está dado de alta en Oranje."
msgstr "That email is already signed up at Oranje."

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Ese correo ya está en uso: prueba otro."
msgstr "That email is already in use: try another one."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Ese correo ya tiene cuenta de acceso. Da el alta sin contraseña (invitación) o que la persona use «¿Olvidaste tu contraseña?»."
msgstr "That email already has a sign-in account. Sign them up without a password (invitation) or have the person use “Forgot your password?”."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Ese documento ya está verificado: no se puede borrar, deja rastro de quién lo revisó."
msgstr "That document is already verified: it can't be deleted, it keeps a record of who reviewed it."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Ese documento ya estaba verificado: no se puede rechazar."
msgstr "That document was already verified: it can't be rejected."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Ese documento ya estaba verificado."
msgstr "That document was already verified."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Ese formato no se pudo abrir: usa una foto JPG, PNG o WebP."
msgstr "That format couldn't be opened: use a JPG, PNG or WebP photo."

#: src/features/worker/components/PhotoUploader.tsx
msgid "Ese formato no se pudo leer: usa JPG, PNG o WebP."
msgstr "That format couldn't be read: use JPG, PNG or WebP."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Ese formato no se puede procesar (los HEIC del iPhone no entran): usa JPG, PNG o WebP."
msgstr "That format can't be processed (iPhone HEIC files don't work): use JPG, PNG or WebP."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Ese formato no se puede procesar (los HEIC del iPhone no entran): usa JPG, PNG, WebP o PDF."
msgstr "That format can't be processed (iPhone HEIC files don't work): use JPG, PNG, WebP or PDF."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Ese hotel no está en ninguna de tus zonas."
msgstr "That hotel isn't in any of your zones."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Ese hotel ya no existe. Recarga la página y vuelve a elegirlo."
msgstr "That hotel no longer exists. Reload the page and pick it again."

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "Ese motivo ya no está disponible: elige otro de la lista."
msgstr "That reason is no longer available: choose another one from the list."

#: src/features/worker/pages/Phase3Page.tsx
msgid "Ese número de emergencia no es válido para el país elegido. Revisa los dígitos o cambia el país."
msgstr "That emergency number isn't valid for the selected country. Check the digits or change the country."

#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/onboarding/types/hotelContactsForm.schema.ts
#: src/features/onboarding/types/prospectForm.schema.ts
#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Ese número no es válido para el país elegido. Revisa los dígitos o cambia el país."
msgstr "That number isn't valid for the selected country. Check the digits or change the country."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Ese paso existe, pero lo ejecuta {rolesLabel}: pídeselo — tu rol no lo tiene asignado."
msgstr "That step exists, but {rolesLabel} takes it: ask them — your role doesn't have it."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Ese paso no existe en el Semáforo: elige otro estado."
msgstr "That step doesn't exist in the Status Light: choose another status."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Ese rol no se da de alta aquí: las cuentas de los hoteles van en «Personal de hoteles»."
msgstr "That role isn't signed up here: hotel accounts go in “Hotel staff”."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Ese rol ya no existe. Recarga la página y vuelve a elegirlo."
msgstr "That role no longer exists. Reload the page and pick it again."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Ese semáforo no existe."
msgstr "That Status Light doesn't exist."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Ese tipo de archivo no se puede importar. Usa .xlsx, .csv, .txt o .pdf."
msgstr "That file type can't be imported. Use .xlsx, .csv, .txt or .pdf."

#: src/features/worker/pages/PunchPage.tsx
msgid "Ese turno no es tuyo. Recarga la pantalla e inténtalo de nuevo."
msgstr "That shift isn't yours. Reload the screen and try again."

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "esperando al Manager"
msgstr "waiting on the Manager"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Esperando aprobación"
msgstr "Awaiting approval"

#: src/mobile/UnsupportedRolePage.tsx
msgid "Esta app es para colaboradores y hoteles"
msgstr "This app is for collaborators and hotels"

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "Esta asignación paga esto en vez de la tarifa del contrato, desde ahora."
msgstr "From now on, this assignment pays this instead of the contract's rate."

#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "Está bloqueado: desbloquéalo primero."
msgstr "It's locked: unlock it first."

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Esta campaña todavía no sale"
msgstr "This campaign hasn't been sent yet"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Está dada de baja: el acceso no cuenta."
msgstr "This account is deactivated: the access doesn't count."

#: src/features/contracts/components/UnlockContractDialog.tsx
msgid "Está en firma: primero cancela el envío."
msgstr "It's out for signature: cancel the request first."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Está en firma: se activa sola cuando firme el hotel"
msgstr "It's out for signature: it activates on its own once the hotel signs"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Está en Gris por un accidente laboral: no se puede vetar hasta que su caso se resuelva."
msgstr "They're in Gray because of a work accident: they can't be banned until their case is resolved."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Está en uso: hay requisiciones, posiciones o colaboradores colgando de esta fila. Elimina o reasigna eso primero."
msgstr "It's in use: there are Requisitions, positions or Collaborators hanging off this row. Delete or reassign those first."

#: src/features/onboarding/components/ProposalVersionHistory.tsx
msgid "Esta es la versión que tiene el hotel"
msgstr "This is the version the hotel has"

#: src/features/onboarding/components/ProposalVersionHistory.tsx
msgid "Esta es la versión que tiene el hotel: la última que se le envió."
msgstr "This is the version the hotel has: the last one sent to them."

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Esta factura ya se aprobó y no se recalcula: agrega la tarifa al contrato para las siguientes y cobra estas horas aparte."
msgstr "This invoice is already approved and can't be recalculated: add the rate to the contract for the next ones and bill these hours separately."

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Esta inspección no es de tu hotel."
msgstr "This inspection isn't from your hotel."

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Está llenando"
msgstr "Filling"

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "Esta pantalla dice a quién avisar"
msgstr "This screen says who to notify"

#: src/features/accounting/pages/AccountingPendingPages.tsx
msgid "Esta pantalla existe para que el módulo tenga su lugar; sus reglas siguen en el vault."
msgstr "This screen exists so the module has its place; its rules still live in the vault."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Esta plantilla no tiene variables: le llega igual a todos."
msgstr "This template has no variables: everyone gets the same message."

#: src/shared/components/UrgencyChip.tsx
msgid "Esta posición ya está cubierta: no importa cuánto falte para que inicie."
msgstr "This position is already covered: how soon it starts no longer matters."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Esta requisición la elimina quien la creó, el Manager de Área de su departamento, el Manager General o el Inspector de su zona."
msgstr "This requisition can be deleted by whoever created it, its department's Area Manager, the General Manager, or its zone's Inspector."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Esta requisición no es tuya: solo puedes eliminar las que tú creaste."
msgstr "This requisition isn't yours: you can only delete the ones you created."

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Esta requisición se eliminó"
msgstr "This requisition was deleted"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Esta requisición tiene posiciones de otro departamento: la elimina el Manager General."
msgstr "This requisition has positions from another department: only the General Manager can delete it."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/SlotList.tsx
msgid "Esta requisición ya cerró: el slot no vuelve a abrirse."
msgstr "This Requisition is already closed: the slot won't open again."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Esta requisición ya estaba eliminada."
msgstr "This requisition was already deleted."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Esta requisición ya no está autorizada o en proceso: no se puede unir."
msgstr "This requisition is no longer authorized or in progress: you can't join it."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Esta requisición ya no está en proceso: revisa su estado antes de asignar."
msgstr "This Requisition is no longer in progress: check its status before assigning."

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "esta semana"
msgstr "this week"

#: src/features/observability/lib/period.ts
msgid "Esta semana"
msgstr "This week"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Esta semana es de otro departamento: no te toca aprobarla."
msgstr "This week belongs to another department: it isn't yours to approve."

#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "Esta semana no hay jornadas con horas. La vista Días también enseña ausencias y pendientes."
msgstr "There are no workdays with hours this week. The Days view also shows absences and pending days."

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Esta semana ya está cerrada."
msgstr "This week is already closed."

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Esta semana ya se envió a aprobación: no admite más cambios."
msgstr "This week was already sent for approval: no more changes allowed."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Esta transición exige un motivo: elígelo de la lista."
msgstr "This transition needs a reason: choose one from the list."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Esta versión ya se envió: lo enviado no se descarta."
msgstr "This version was already sent: what's been sent can't be discarded."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Esta versión ya se envió: lo enviado no se edita — abre una versión nueva."
msgstr "This version was already sent: what's been sent can't be edited — open a new version."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "estado"
msgstr "status"

#: src/features/accounting/pages/ConsolidationsPage.tsx
#: src/features/accounting/pages/InvoicesPage.tsx
#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/contracts/components/ContractFilters.tsx
#: src/features/contracts/components/ContractTable.tsx
#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingFilters.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/components/TemplateDetailDialog.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
#: src/features/recruitment/components/CreateBlacklistDialog.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/components/PoolTable.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
#: src/features/requisitions/components/RequisitionTable.tsx
#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "Estado"
msgstr "Status"

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "estado actual"
msgstr "current status"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Estado actual"
msgstr "Current status"

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Estado actual: {currentLabel}. Puedes pasarlo a cualquier estado y regresarlo al anterior; Blacklist va por su propio flujo y Asignación temporal se pone sola al asignar."
msgstr "Current status: {currentLabel}. You can move them to any status and back to the previous one; Blacklist has its own flow, and Temporary assignment is set automatically when assigning."

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Estado actual: {currentLabel}. Solo puedes elegir los cambios permitidos para tu rol."
msgstr "Current status: {currentLabel}. You can only choose the changes allowed for your role."

#. placeholder {0}: ONBOARDING_STATUS_LABEL[selectedStatus]
#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Estado cambiado a {0}"
msgstr "Status changed to {0}"

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Estado cambiado a {label}"
msgstr "Status changed to {label}"

#. placeholder {0}: template.name
#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Estado de «{0}» actualizado con Meta."
msgstr "Status of “{0}” refreshed from Meta."

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Estado de la semana"
msgstr "Week status"

#: src/features/timesheet/components/WorkerWeekSummary.tsx
msgid "Estado de la semana."
msgstr "Week status."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Estado inicial"
msgstr "Initial status"

#. placeholder {0}: WORKER_STATUS_LABEL[status]
#: src/features/worker/pages/HomePage.tsx
msgid "Estado: {0}"
msgstr "Status: {0}"

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Estado: {statusLabel}"
msgstr "Status: {statusLabel}"

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Estamos trabajando en tu requisición"
msgstr "We're working on your requisition"

#: src/features/observability/lib/people.ts
msgid "Estancados"
msgstr "Stalled"

#: src/features/worker/pages/HomePage.tsx
msgid "Estás <0>disponible por voluntad propia</0>: Reclutamiento puede asignarte en cuanto haya una requisición."
msgstr "You're <0>available by choice</0>: Recruitment can assign you as soon as there's a requisition."

#: src/features/worker/lib/noShiftMessage.ts
msgid "Estás en incapacidad"
msgstr "You're on medical leave"

#: src/features/timesheet/components/TimesheetViewControls.tsx
msgid "Estás en la semana actual"
msgstr "You're on the current week"

#: src/features/worker/lib/noShiftMessage.ts
msgid "Estás en Stand-by"
msgstr "You're on Stand-by"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Estas filas no se importan:"
msgstr "These rows will not be imported:"

#: src/features/worker/pages/PunchPage.tsx
msgid "Estás fuera del hotel: la marca no se guarda. Pídele al Supervisor un ponche manual."
msgstr "You're outside the hotel: the punch isn't saved. Ask the Supervisor for a manual punch."

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Estas horas del periodo no se cobraron porque el contrato no tiene tarifa para su puesto:"
msgstr "These hours in the period weren't billed because the contract has no rate for their position:"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Estas horas no entraron porque no tienen tarifa:"
msgstr "These hours weren't included because they have no rate:"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Este — Atlanta, Miami, Nueva York"
msgstr "Eastern — Atlanta, Miami, New York"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Este ambiente no está conectado a la plataforma de mensajería"
msgstr "This environment is not connected to the messaging platform"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Este ambiente no manda correo propio"
msgstr "This environment doesn't send its own email"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Este borrador lo activa el BDC cuando la verificación de «Qué sigue» esté en verde: al activarlo, el contrato pasa a regir la nómina y la factura del hotel."
msgstr "The BDC activates this draft once the «What's next» check is green: activating it makes the contract govern the hotel's payroll and invoice."

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Este cambio necesita un motivo"
msgstr "This change needs a reason"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Este catálogo está vacío. Agrega su primera fila con el botón de arriba."
msgstr "This catalog is empty. Add its first row with the button above."

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "Este ciclo ya estaba cerrado."
msgstr "This cycle was already closed."

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Este colaborador no tiene un correo @oranjepeople.com asignado todavía."
msgstr "This Collaborator doesn't have an @oranjepeople.com address yet."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Este colaborador todavía no tiene acceso. Créalo primero."
msgstr "This worker doesn't have access yet. Create it first."

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Este colaborador ya tiene acceso."
msgstr "This collaborator already has access."

#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Este consolidado ya tiene una deducción de {typeLabel}. Agrégala solo si corresponde otra."
msgstr "This consolidation already has a {typeLabel} deduction. Add it only if another one applies."

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Este contacto aparece en la bitácora de intentos, así que no se puede borrar. Desactívalo y dejará de mostrarse."
msgstr "This contact shows up in the attempt log, so it can't be deleted. Deactivate it and it will stop showing."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Este contrato no existe o fue borrado. Vuelve a la lista y elige otro."
msgstr "This contract does not exist or was deleted. Go back to the list and pick another one."

#: src/features/contracts/components/RateTable.tsx
msgid "Este contrato no trae ninguna posición cotizada."
msgstr "This contract has no quoted positions."

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Este contrato se canceló en borrador: nunca rigió y no admite cambios."
msgstr "This contract was cancelled while still a draft: it never applied and admits no changes."

#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "Este contrato tiene las tarifas de la propuesta v{currentVersion}, pero la última enviada es la v{latestVersion}."
msgstr "This contract has the rates from proposal v{currentVersion}, but the latest one sent is v{latestVersion}."

#: src/features/contracts/components/EditRateDialog.tsx
msgid "Este contrato ya está cerrado: las tarifas quedaron congeladas."
msgstr "This contract is already closed: the rates stayed frozen."

#: src/features/contracts/components/MultiplierTable.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Este contrato ya está cerrado: no admite más cambios."
msgstr "This contract is already closed: it admits no further changes."

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Este contrato ya está en firma."
msgstr "This contract is already out for signature."

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Este contrato ya estaba marcado como enviado."
msgstr "This contract was already marked as sent."

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Este contrato ya expiró: dejó de regir y no admite cambios. Para renovar, se crea uno nuevo para el hotel."
msgstr "This contract already expired: it no longer applies and admits no changes. To renew, a new one is created for the hotel."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Este cuadro es el que firma el hotel: al crear el Documento de T&C se copia tal cual, sin volver a capturarlo."
msgstr "This table is what the hotel signs: when the T&C document is created it's copied exactly as is, with nothing to fill in again."

#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "Este día no tiene jornadas con horas. El punto naranja marca los días que sí."
msgstr "This day has no workdays with hours. The orange dot marks the days that do."

#: src/features/contracts/components/clauses/ClausesEditWarningDialog.tsx
msgid "Este es el <0>texto de venta</0> de esta propuesta: lo que cambies aquí queda solo para este ciclo, sin afectar al Contrato ni a otras propuestas."
msgstr "This is this proposal's <0>sales text</0>: what you change here applies only to this cycle, without affecting the Contract or other proposals."

#: src/features/audits/components/AuditWorkerList.tsx
msgid "Este hotel no tiene colaboradores asignados"
msgstr "This hotel has no collaborators assigned"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "este hotel no tiene principal todavía"
msgstr "this hotel has no primary contact yet"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Este hotel no tiene propuesta o el enlace ya no sirve. Vuelve al Pipeline y ábrela desde su ficha."
msgstr "This hotel has no Proposal, or the link no longer works. Go back to the Pipeline and open it from its record."

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
msgid "Este hotel no tiene requisiciones en tu tablero"
msgstr "This hotel has no requisitions on your board"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Este hotel no tiene requisiciones todavía."
msgstr "This hotel has no requisitions yet."

#: src/features/schedule/components/ScheduleMiniCalendar.tsx
msgid "Este hotel no tiene schedule ese día"
msgstr "This hotel has no schedule that day"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Este hotel no tiene sus datos contables capturados (cierre de semana y pago de horas extra): complétalos en su ficha antes de crear el contrato."
msgstr "This hotel doesn't have its accounting data captured yet (payroll week cutoff and overtime pay): complete it in its profile before creating the contract."

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Este hotel no tiene un BDC que firme por Oranje"
msgstr "This hotel has no BDC to sign for Oranje"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Este hotel no tiene un contrato vigente con tarifas: no se puede pedir personal todavía."
msgstr "This hotel has no active contract with rates yet: staff can't be requested here yet."

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "Este hotel poncha con selfie: cambia el método antes."
msgstr "This hotel clocks in with a selfie: change the punch method first."

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "Este hotel poncha con selfie: no tiene QR que imprimir."
msgstr "This hotel clocks in with a selfie: there's no QR to print."

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Este hotel todavía no tiene propuesta."
msgstr "This hotel doesn't have a proposal yet."

#: src/features/schedule/pages/SchedulePage.tsx
msgid "Este hotel todavía no tiene Schedule. En cuanto se programe una semana, aparece aquí."
msgstr "This hotel doesn't have a Schedule yet. As soon as a week is programmed, it shows up here."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Este hotel todavía no tiene un contrato activo con tarifas, así que no se le puede pedir personal. Cuando Ventas lo active, aquí aparecen sus posiciones."
msgstr "This hotel doesn't have an active contract with rates yet, so staff can't be requested for it. Once Sales activates it, its positions will show up here."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Este hotel todavía no tiene un contrato activo con tarifas."
msgstr "This hotel doesn't have an active contract with rates yet."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Este hotel ya es cliente activo"
msgstr "This hotel is already an active client"

#: src/features/recruitment/pages/SelfPickHotelPage.tsx
msgid "Este hotel ya no tiene slots libres en la Bolsa"
msgstr "This hotel has no open slots left in the Self-Pick pool"

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Este hotel ya tiene el contrato {activeContractNumber} vigente. Cuando firmen los dos, este no se va a activar solo: primero cancela el vigente o espera a que venza."
msgstr "This hotel already has contract {activeContractNumber} in force. Once both sign, this one won't activate on its own: first cancel the current one or wait for it to expire."

#. placeholder {0}: outgoingManager.fullName
#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Este hotel ya tiene gerente: {0}. Si dejó el hotel, dale de baja su cuenta desde «Personal de hoteles» — mientras siga activa puede entrar y aprobar horas."
msgstr "This hotel already has a manager: {0}. If they left, deactivate their account under “Hotel staff” — while it stays active they can sign in and approve hours."

#: src/features/onboarding/components/DeleteHotelAction.tsx
msgid "Este hotel ya tiene operación y no se puede eliminar: archiva su ciclo."
msgstr "This hotel already has operations and can't be deleted: archive its cycle instead."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Este hotel ya tiene un ciclo comercial abierto: ciérralo o elige otro hotel."
msgstr "This hotel already has an open commercial cycle: close it or choose another hotel."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Este hotel ya tiene un contrato vigente: primero hay que expirarlo."
msgstr "This hotel already has a contract in force: you have to expire it first."

#: src/features/observability/lib/period.ts
msgid "Este mes"
msgstr "This month"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "Este mes no tiene jornadas registradas. Navega con ‹ › a una semana con datos."
msgstr "This month has no recorded workdays. Use ‹ › to move to a week with data."

#: src/features/worker/pages/PunchPage.tsx
msgid "Este navegador no da la ubicación: usa el navegador del teléfono."
msgstr "This browser doesn't share location: use your phone's browser."

#: src/features/worker/components/CameraCapture.tsx
#: src/features/worker/components/QrScanner.tsx
msgid "Este navegador no puede abrir la cámara."
msgstr "This browser can't open the camera."

#. placeholder {0}: ONBOARDING_STATUS_LABEL[state]
#: src/features/conversion/pages/ConversionPage.tsx
msgid "Este prospecto está en <0>{0}</0> — la conversión sale de Rosa"
msgstr "This Prospect is in <0>{0}</0> — the conversion starts from Pink"

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Este prospecto no existe o ya no está disponible. Vuelve al Pipeline y elige otro."
msgstr "This Prospect doesn't exist or is no longer available. Go back to the Pipeline and choose another one."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Este prospecto ya no está en Rosa: alguien más lo movió."
msgstr "This prospect is no longer in Pink: someone else moved it."

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "Este puesto ya tiene su tarifa más arriba"
msgstr "This position already has its rate above"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Este reporte aún no se define"
msgstr "This report isn't defined yet"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Este rol normalmente reporta a alguien: sin jefe no aparecerá en ningún «Mi Equipo»."
msgstr "This role usually reports to someone: with no manager they won't show up in anyone's “My Team”."

#: src/features/contracts/components/clauses/ClausesEditWarningDialog.tsx
msgid "Este texto parte del <0>machote compartido</0> con todos los hoteles. Lo que cambies aquí queda solo para este documento, pero es un <1>documento legal</1>: edítalo con cuidado, porque es lo que el hotel firma."
msgstr "This text comes from the <0>shared template</0> used by every hotel. What you change here only applies to this document, but it's a <1>legal document</1>: edit it with care, because it's what the hotel signs."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Este usuario ya no existe."
msgstr "This user no longer exists."

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Este veto es <0>manual</0>; los vetos por ausencias o disputa los genera el sistema. Al vetar, la persona pasa a <1>Negro</1> y sale del Pool de Colaboradores."
msgstr "This ban is <0>manual</0>; bans for absences or disputes are generated by the system. Once banned, the person moves to <1>Black</1> and leaves the Collaborator Pool."

#. placeholder {0}: deleteTarget?.email ?? ''
#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Esto borra de verdad el buzón de {0} en cPanel — no se puede deshacer."
msgstr "This really deletes {0}'s mailbox in cPanel — it can't be undone."

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Esto es del Administrador"
msgstr "This is the Administrator's job"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Esto es lo que ves desde el Hotel"
msgstr "This is what you see from the Hotel"

#: src/features/worker/pages/HomePage.tsx
msgid "Esto no cambia tu turno de hoy: es solo para que te consideren para más."
msgstr "This doesn't change today's shift — it just means you're considered for more."

#: src/features/recruitment/components/DeleteWorkerDialog.tsx
msgid "Esto no se deshace desde aquí. Si sigue trabajando en algún hotel, su asignación se libera al eliminarlo. El expediente y su historial se conservan por dentro, pero nadie vuelve a verlo en el Pool."
msgstr "This can't be undone from here. If they're still working at a hotel, their assignment is released when you delete them. Their file and history are kept internally, but nobody sees them in the Pool again."

#: src/features/messaging/components/ReportCharts.tsx
msgid "Etapa"
msgstr "Stage"

#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Etiqueta"
msgstr "Tag"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Etiqueta para todos los del archivo (opcional)"
msgstr "Tag for everyone in the file (optional)"

#: src/features/messaging/components/ContactActions.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/pages/MessagingPage.tsx
msgid "Etiquetas"
msgstr "Tags"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Etiquetas aplicadas:"
msgstr "Tags applied:"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Etiquetas en el archivo:"
msgstr "Tags in the file:"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Evidencia"
msgstr "Evidence"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Evidencia <0>(obligatoria en un veto manual)</0>"
msgstr "Evidence <0>(required for a manual ban)</0>"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "evidencia-turnos.pdf"
msgstr "shift-evidence.pdf"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Expandir cláusulas del documento"
msgstr "Expand document clauses"

#: src/features/contracts/components/MissingContractsNotice.tsx
msgid "Expandir hoteles listos para su contrato"
msgstr "Expand hotels ready for their contract"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Expandir texto de la propuesta"
msgstr "Expand proposal text"

#: src/features/observability/lib/workerKpis.ts
msgid "Expedientes completos"
msgstr "Complete profiles"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/lib/profileFields.ts
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Experiencia"
msgstr "Experience"

#: src/shared/constants/contractStatus.ts
msgid "Expirado"
msgstr "Expired"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "extra"
msgstr "overtime"

#. placeholder {0}: String(index + 1)
#: src/features/contracts/components/NewContractDialog.tsx
msgid "Factura {0}"
msgstr "Bill {0}"

#: src/features/accounting/pages/InvoicesPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Factura al Hotel"
msgstr "Hotel Invoice"

#. placeholder {0}: formatMoney(Number(payPreview.billSubtotal))
#: src/features/timesheet/components/PayPreviewBadge.tsx
msgid "Factura al hotel {0}"
msgstr "Hotel invoice {0}"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Factura aprobada"
msgstr "Invoice approved"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Factura por hora"
msgstr "Bill per hour"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Factura recalculada con las tarifas y horas de hoy"
msgstr "Invoice recalculated with today's rates and hours"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
msgid "Falló"
msgstr "Failed"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Falta"
msgstr "Absence"

#. placeholder {0}: formatList(faltantes)
#: src/features/worker/pages/HomePage.tsx
msgid "Falta {0}. Con eso Reclutamiento puede validarte y empiezas a recibir turnos. Tu foto no hace falta para esto."
msgstr "Missing {0}. With that, Recruitment can validate you and you start getting shifts. Your photo isn't needed for this."

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Falta aprobar antes de cerrar:"
msgstr "Still needs approval before closing:"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Falta decir quién pagó el gasto."
msgstr "Missing who paid for the expense."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Falta el bill rate de un puesto"
msgstr "A position is missing its bill rate"

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "Falta el departamento"
msgstr "The department is missing"

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "Falta el departamento del hotel"
msgstr "The hotel department is missing"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Falta el día de inicio de semana"
msgstr "The week start day is missing"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Falta el domicilio"
msgstr "The address is missing"

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "Falta el hotel"
msgstr "The hotel is missing"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Falta el nombre"
msgstr "The name is missing"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Falta el nombre completo"
msgstr "The full name is missing"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Falta el nombre del contacto de emergencia"
msgstr "The emergency contact's name is missing"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Falta el nombre del hotel"
msgstr "The hotel name is missing"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Falta el pay rate de un puesto"
msgstr "A position is missing its pay rate"

#: src/features/conversion/api/conversionApi.ts
msgid "Falta el Usuario del Hotel: sin él no se puede aprobar"
msgstr "The Hotel User is missing: without one it can't be approved"

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "Falta grave en el hotel"
msgstr "Serious misconduct at the hotel"

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "Falta la fecha de inicio"
msgstr "The start date is missing"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Falta la fecha de nacimiento"
msgstr "The date of birth is missing"

#: src/features/onboarding/types/registerContactAttempt.schema.ts
msgid "Falta la fecha y hora del intento"
msgstr "The date and time of the attempt are missing"

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "Falta la hora"
msgstr "The time is missing"

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "Falta la modalidad"
msgstr "The hiring modality is missing"

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "Falta la posición"
msgstr "The position is missing"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Falta la zona"
msgstr "The zone is missing"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Falta si paga horas extra (Sí o No)"
msgstr "Whether it pays overtime is missing (Yes or No)"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Falta su firma"
msgstr "Signature pending"

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Faltan datos de este hotel"
msgstr "This hotel is missing details"

#: src/features/worker/pages/HomePage.tsx
msgid "Faltan datos tuyos"
msgstr "Some of your info is missing"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Faltan las variables MESSAGING_API_* en el API. Cuando se configuren, aquí aparecen las campañas."
msgstr "The MESSAGING_API_* variables are missing in the API. Once they are set, campaigns show up here."

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Faltan las variables MESSAGING_API_* en el API. Cuando se configuren, aquí aparecen las etiquetas."
msgstr "The MESSAGING_API_* variables are missing in the API. Once set, the tags show up here."

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Faltan las variables MESSAGING_API_* en el API. Cuando se configuren, aquí aparecen las plantillas."
msgstr "The API is missing the MESSAGING_API_* variables. Once they are set, templates show up here."

#: src/features/messaging/components/MessagingOverviewPanel.tsx
msgid "Faltan las variables MESSAGING_API_* en el API. Cuando se configuren, aquí aparecen los contactos, las plantillas y las campañas."
msgstr "The API is missing the MESSAGING_API_* variables. Once they are set, contacts, templates and campaigns show up here."

#: src/features/messaging/components/MessagingContactsList.tsx
msgid "Faltan las variables MESSAGING_API_* en el API. Cuando se configuren, aquí aparecen los contactos."
msgstr "The API is missing the MESSAGING_API_* variables. Once they are set, contacts show up here."

#: src/features/worker/components/NativePunchGate.tsx
msgid "Faltan permisos para ponchar"
msgstr "Missing permissions to punch"

#: src/features/observability/lib/cohorts.ts
msgid "Faltó sin justificación"
msgstr "Missed without justification"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Fase 1 · Entrevista"
msgstr "Phase 1 · Interview"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
#: src/features/timesheet/components/AttendanceView.tsx
msgid "Fecha"
msgstr "Date"

#: src/features/admin/components/HotelUsersSection.tsx
#: src/features/admin/pages/UsersPage.tsx
msgid "Fecha de alta"
msgstr "Signed up on"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/shared/lib/contractClauses.ts
msgid "Fecha de fin"
msgstr "End date"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/shared/lib/contractClauses.ts
msgid "Fecha de inicio"
msgstr "Start date"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Fecha de la firma de Oranje"
msgstr "Date of Oranje's signature"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Fecha de nacimiento"
msgstr "Date of birth"

#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Fecha de preparación"
msgstr "Prepared date"

#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Fecha y hora"
msgstr "Date and time"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/shared/constants/workerEnums.ts
msgid "Femenino"
msgstr "Female"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/recruitment/types/selfPick.types.ts
#: src/shared/constants/workerStatus.ts
msgid "Fijo"
msgstr "Fixed"

#. placeholder {0}: String(row.rowNumber)
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "fila {0}"
msgstr "row {0}"

#. placeholder {0}: item.rowNumber
#. placeholder {0}: row.rowNumber
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Fila {0}"
msgstr "Row {0}"

#. placeholder {0}: row.rowNumber
#. placeholder {1}: row.errors.join(', ')
#. placeholder {1}: row.warnings.join(', ')
#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Fila {0}: {1}"
msgstr "Row {0}: {1}"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Filas"
msgstr "Rows"

#: src/features/observability/lib/recruitmentKpis.ts
msgid "Fill rate"
msgstr "Fill rate"

#: src/features/messaging/components/tours.ts
msgid "Filtra por etiqueta"
msgstr "Filter by tag"

#: src/features/contracts/pages/ContractListPage.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "Filtrar"
msgstr "Filter"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Fin (obligatoria)"
msgstr "End (required)"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Fin (opcional)"
msgstr "End (optional)"

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Finalizar inspección"
msgstr "Finish inspection"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Firebase (respaldo)"
msgstr "Firebase (backup)"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Firebase no pudo mandar el correo. Inténtalo de nuevo."
msgstr "Firebase couldn't send the email. Try again."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Firma de Oranje en el documento"
msgstr "Oranje's signature on the document"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Firma electrónica"
msgstr "Electronic signature"

#. placeholder {0}: signature.signer.name
#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Firma por Oranje {0}, el BDC que lleva el hotel"
msgstr "{0}, the BDC who handles the hotel, signs for Oranje"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Firmado por las dos partes, pero no se activó solo: el hotel ya tiene el contrato {activeContractNumber} vigente. Cancélalo o espera a que venza, y luego activa este."
msgstr "Signed by both parties, but it didn't activate on its own: the hotel already has contract {activeContractNumber} in force. Cancel it or wait for it to expire, then activate this one."

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Firmado por las dos partes, pero no se pudo activar solo: revisa «Activar contrato»."
msgstr "Signed by both parties, but it couldn't activate on its own: check “Activate contract”."

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Firmado por las dos partes. El contrato quedó activo."
msgstr "Signed by both parties. The contract is now active."

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Firmar ahora"
msgstr "Sign now"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Firmar con DocuSign"
msgstr "Sign with DocuSign"

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Firmar en DocuSign"
msgstr "Sign in DocuSign"

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Firmar y enviar el contrato"
msgstr "Sign and send the contract"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Firmas en DocuSign y al hotel le llega por correo para firmar"
msgstr "You sign in DocuSign and the hotel gets it by email to sign"

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Firmas por Oranje en DocuSign. Al terminar, DocuSign le manda el contrato a quien firma por el hotel. Cuando firmen los dos, el contrato se activa solo."
msgstr "You sign for Oranje in DocuSign. When you finish, DocuSign sends the contract to the hotel's signer. Once both sign, the contract activates on its own."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Firmaste por Oranje. DocuSign ya le mandó el contrato a {email}."
msgstr "You signed for Oranje. DocuSign already sent the contract to {email}."

#. placeholder {0}: formatDateTime(signature.hotelSignedAt)
#. placeholder {0}: formatDateTime(signature.oranjeSignedAt)
#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Firmó el {0}"
msgstr "Signed on {0}"

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "Folio"
msgstr "Folio"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Folio o hotel, p. ej. Xcaret…"
msgstr "Number or hotel, e.g. Xcaret…"

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
msgid "Folio, p. ej. 202608…"
msgstr "Number, e.g. 202608…"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/worker/components/PhotoUploader.tsx
msgid "Foto"
msgstr "Photo"

#. placeholder {0}: prospect.hotelName
#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Foto de {0} según Google"
msgstr "Photo of {0} from Google"

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Foto de {hotelDisplayName} según Google"
msgstr "Photo of {hotelDisplayName} from Google"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Foto del colaborador"
msgstr "Collaborator photo"

#: src/features/worker/components/PhotoUploader.tsx
msgid "Foto guardada"
msgstr "Photo saved"

#: src/features/admin/components/UserFormDialog.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Foto subida"
msgstr "Photo uploaded"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Fuera de la geocerca"
msgstr "Outside the geofence"

#: src/features/observability/components/KpiCard.tsx
msgid "Fuera de meta"
msgstr "Off target"

#: src/features/worker/pages/PunchPage.tsx
msgid "Fuera del hotel"
msgstr "Outside the hotel"

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Función que se le da"
msgstr "Role to grant"

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Funciones adicionales"
msgstr "Additional roles"

#. placeholder {0}: item.fullName
#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Funciones adicionales de {0}"
msgstr "Additional roles of {0}"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Funciones que se dan por persona y no por rol. Solo quien esté en la lista las ve, y las puedes prender, apagar o quitar cuando quieras."
msgstr "Features granted per person, not per role. Only the people on the list see them, and you can turn them on, off or remove them at any time."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Gana la primera que confirma: si alguien se adelanta, el tablero se actualiza al momento."
msgstr "First to confirm wins: if someone gets there first, the board updates right away."

#. placeholder {0}: formatMoney(Number(expenseRequested))
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Gasto de {0} pedido: pendiente de aprobación."
msgstr "Expense of {0} requested: pending approval."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Gasto de la empresa: no se le descuenta ni se le suma nada al colaborador."
msgstr "Company expense: nothing is added to or subtracted from the collaborator's pay."

#: src/shared/components/SettlementEffectBadge.tsx
msgid "Gasto de Oranje"
msgstr "Oranje's expense"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Gasto pedido: queda pendiente de que lo apruebe el Manager de QA"
msgstr "Expense requested: pending the QA Manager's approval"

#. placeholder {0}: adjustment.payConcept.name
#: src/features/timesheet/components/PendingAdjustmentsChip.tsx
msgid "Gasto: {0}"
msgstr "Expense: {0}"

#: src/features/timesheet/components/PayPreviewBadge.tsx
msgid "Gastos/descuentos que Contabilidad ya decidió incluir en esta nómina — de toda la semana, no de un día en particular (el ajuste no tiene fecha propia). Ya están restados del Total de abajo."
msgstr "Expenses/deductions Accounting already decided to include in this payroll — for the whole week, not a specific day (the adjustment has no date of its own). They're already subtracted from the Total below."

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "Generando el código…"
msgstr "Generating the code…"

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "Generando…"
msgstr "Generating…"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Generar Consolidado es tu botón"
msgstr "Generate Consolidation is your button"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "Generar una contraseña segura"
msgstr "Generate a secure password"

#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Género"
msgstr "Gender"

#: src/features/clients/components/ClientSpotlightCard.tsx
msgid "geocerca"
msgstr "geofence"

#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/onboarding/components/PlacesAutofillSummary.tsx
msgid "Geocerca"
msgstr "Geofence"

#. placeholder {0}: client.geofenceRadiusM
#: src/features/clients/components/ClientCardGrid.tsx
msgid "geocerca {0} m"
msgstr "{0} m geofence"

#. placeholder {0}: String(GEOFENCE_MIN_M)
#. placeholder {1}: String(GEOFENCE_MAX_M)
#. placeholder {2}: String(DEFAULT_GEOFENCE_M)
#: src/features/onboarding/import/mapImportRows.ts
msgid "Geocerca fuera de rango ({0}–{1} m): se usa {2} m"
msgstr "Geofence out of range ({0}–{1} m): using {2} m"

#: src/shared/components/SendDocumentModal.tsx
msgid "gerencia@hotel.com"
msgstr "gerencia@hotel.com"

#: src/features/admin/components/ColaboradorAccountsSection.tsx
msgid "Gestionar buzón"
msgstr "Manage mailbox"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Google mandó un identificador del lugar que el servidor no aceptó. Vuelve a buscar el hotel en el paso 1 o marca la ubicación a mano en el mapa."
msgstr "Google sent a place ID the server didn't accept. Search for the hotel again in step 1 or drop the pin on the map by hand."

#: src/shared/constants/onboardingStatus.ts
msgid "Gris"
msgstr "Gray"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "Gris → Naranja"
msgstr "Gray → Orange"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Grupo de {name}"
msgstr "{name}'s group"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Guardamos tu avance como borrador. Lo retomas en «Nuevo prospecto»."
msgstr "We saved your progress as a draft. Pick it up again from “New prospect”."

#: src/features/timesheet/components/HotelPaysLunchToggle.tsx
msgid "Guardando"
msgstr "Saving"

#: src/features/worker/pages/PunchPage.tsx
msgid "Guardando tu ubicación"
msgstr "Saving your location"

#: src/features/worker/pages/PunchPage.tsx
msgid "Guardando tu ubicación y tu foto"
msgstr "Saving your location and your photo"

#: src/features/accounting/components/AddDeductionDialog.tsx
#: src/features/accounting/components/PayOverrideDialog.tsx
#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/audits/components/AuditFormDialog.tsx
#: src/features/contracts/components/EditRateDialog.tsx
#: src/features/contracts/components/MultiplierTable.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/components/ChangeStatusDialog.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/onboarding/components/RegisterAttemptDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/team/components/AssignTerritoryDialog.tsx
#: src/features/timesheet/components/CorrectPunchDialog.tsx
#: src/features/timesheet/components/ReviewDayDialog.tsx
#: src/features/worker/components/ChangePasswordForm.tsx
#: src/features/worker/pages/Phase2Page.tsx
#: src/features/worker/pages/Phase3Page.tsx
msgid "Guardando…"
msgstr "Saving…"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/messaging/components/ContactActions.tsx
#: src/features/worker/pages/Phase3Page.tsx
msgid "Guardar"
msgstr "Save"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Guardar borrador"
msgstr "Save draft"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/contracts/components/MultiplierTable.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Guardar cambios"
msgstr "Save changes"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Guardar contraseña"
msgstr "Save password"

#: src/features/accounting/components/PayOverrideDialog.tsx
#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Guardar corrección"
msgstr "Save correction"

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Guardar límites"
msgstr "Save limits"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Guardar requisición"
msgstr "Save requisition"

#: src/features/contracts/components/EditRateDialog.tsx
msgid "Guardar tarifa"
msgstr "Save rate"

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "Guardar territorio"
msgstr "Save territory"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "Habilitados para requisiciones"
msgstr "Enabled for requisitions"

#. placeholder {0}: String(cycle.daysSinceAttempt)
#: src/features/team/pages/TeamPage.tsx
msgid "hace {0} d"
msgstr "{0} d ago"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "hace {days} días"
msgstr "{days} days ago"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Hasta"
msgstr "Until"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Hasta 60 caracteres"
msgstr "Up to 60 characters"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Hasta 60 caracteres, sin variables."
msgstr "Up to 60 characters, no variables."

#. placeholder {0}: formatDate(value.to)
#: src/shared/components/DateRangeField.tsx
msgid "Hasta el {0}"
msgstr "Until {0}"

#. placeholder {0}: matches.data.length
#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Hay {total} coincidencias y aquí salen {0}: afina la búsqueda para ver a los demás."
msgstr "There are {total} matches and {0} are shown here: refine the search to see the rest."

#. placeholder {0}: results.length
#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Hay {total} coincidencias y aquí salen {0}: busca para encontrar a los demás."
msgstr "There are {total} matches and {0} are shown here: search to find the rest."

#: src/features/admin/components/PendingHotelUsers.tsx
msgid "Hay cuentas que tienen a esta persona como jefe. Cámbiales el jefe y vuelve a intentarlo."
msgstr "Some accounts have this person as their manager. Change their manager and try again."

#: src/features/onboarding/import/mapImportRows.ts
msgid "Hay datos de contacto pero falta su nombre: no se crea el contacto"
msgstr "There are contact details but no name: the contact isn't created"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Hay dos renglones para el mismo puesto: deja uno solo."
msgstr "There are two lines for the same position: keep only one."

#: src/features/timesheet/components/TimesheetDayCell.tsx
msgid "Hay entrada sin salida (o al revés), en un día que ya pasó. Así la semana no puede irse a aprobación."
msgstr "There's a clock-in without a clock-out (or the other way around), on a day that's already past. The week can't go to approval like this."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Hay inspecciones con respuestas a este reactivo: no se puede eliminar."
msgstr "There are inspections with answers to this item: it can't be deleted."

#: src/features/observability/components/TabParts.tsx
msgid "Hay más registros de los que esta pantalla puede traer: algunos números se calcularon sobre una parte."
msgstr "There are more records than this screen can fetch: some numbers were calculated over a partial set."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Hay un puesto donde el bill rate queda por debajo del pay rate: se pierde en cada hora."
msgstr "There's a position where the bill rate falls below the pay rate: you'd lose money every hour."

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Hay una tarifa cotizada por debajo del costo: lo que se factura no puede ser menor a lo que se paga."
msgstr "There is a rate quoted below cost: what is billed cannot be less than what is paid."

#: src/app/RouteErrorPage.tsx
msgid "Hay una versión nueva de Oranje. Actualizando…"
msgstr "There's a new version of Oranje. Updating…"

#: src/shared/constants/workerEnums.ts
msgid "Hermano/a"
msgstr "Sibling"

#: src/shared/constants/workerEnums.ts
msgid "Hijo/a"
msgstr "Child"

#: src/features/requisitions/components/StatusHistoryCard.tsx
msgid "Historia de estado"
msgstr "Status history"

#: src/features/audits/pages/AuditsPage.tsx
msgid "Historial"
msgstr "History"

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "historial completo"
msgstr "full history"

#: src/features/messaging/components/ContactImportsDialog.tsx
msgid "Historial de importaciones"
msgstr "Import history"

#: src/features/onboarding/components/ProposalVersionHistory.tsx
msgid "Historial de versiones"
msgstr "Version history"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Historial del semáforo"
msgstr "Status Light history"

#: src/features/dashboard/api/dashboardApi.ts
msgid "histórico"
msgstr "all time"

#: src/features/observability/components/KpiCard.tsx
msgid "Histórico"
msgstr "All-time"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Hojas esta semana"
msgstr "Sheets this week"

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "Hojas pendientes"
msgstr "Pending sheets"

#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Hojas sin aprobar"
msgstr "Unapproved sheets"

#: src/features/worker/pages/HomePage.tsx
msgid "Hola, {firstName}"
msgstr "Hi, {firstName}"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Hora"
msgstr "Time"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Hora {ordinal}"
msgstr "Time {ordinal}"

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Hora de entrada"
msgstr "Start time"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Hora de la marca"
msgstr "Time of the punch"

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Hora de salida"
msgstr "End time"

#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "Hora real"
msgstr "Actual time"

#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "Hora real de la marca"
msgstr "Actual time of the punch"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/pages/InvoiceDetailPage.tsx
#: src/features/timesheet/components/TimesheetViewControls.tsx
#: src/features/worker/pages/PunchPage.tsx
msgid "Horas"
msgstr "Hours"

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "Horas de semanas ya cerradas que el Manager de Área no ha aprobado. Lo que no se aprueba no entra al Consolidado ni se paga."
msgstr "Hours from closed weeks that the Area Manager has not approved. What is not approved does not go into the Consolidation and is not paid."

#: src/features/accounting/components/PayOverrideDialog.tsx
#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Horas extra"
msgstr "Overtime"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Horas extra esta semana"
msgstr "Overtime this week"

#: src/features/timesheet/components/AttendanceView.tsx
#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Horas netas"
msgstr "Net hours"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Horas por semana"
msgstr "Hours per week"

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Horas regulares"
msgstr "Regular hours"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/pages/ConsolidationsPage.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
#: src/features/accounting/pages/InvoicesPage.tsx
#: src/features/accounting/pages/PendingApprovalsPage.tsx
#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/HotelUsersSection.tsx
#: src/features/contracts/components/ContractSignatureCard.tsx
#: src/features/contracts/components/ContractTable.tsx
#: src/features/messaging/components/MessagingFilters.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
#: src/features/observability/components/CohortsView.tsx
#: src/features/observability/pages/ObservabilityPage.tsx
#: src/features/onboarding/components/JobTitleSelect.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/requisitions/components/RequisitionTable.tsx
#: src/features/timesheet/components/TimesheetToolbar.tsx
#: src/features/timesheet/pages/TimesheetPage.tsx
#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Hotel"
msgstr "Hotel"

#: src/features/observability/lib/cohorts.ts
msgid "Hotel (gerente o supervisor)"
msgstr "Hotel (manager or supervisor)"

#: src/features/observability/components/CohortSection.tsx
msgid "Hotel al ingresar"
msgstr "Hotel on joining"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Hotel cliente"
msgstr "Client hotel"

#: src/features/observability/lib/people.ts
msgid "Hotel convertido en cliente"
msgstr "Hotel converted to client"

#: src/features/onboarding/components/DeleteHotelAction.tsx
msgid "Hotel eliminado: {hotelName}"
msgstr "Hotel deleted: {hotelName}"

#: src/shared/constants/onboardingStatus.ts
msgid "Hotel identificado"
msgstr "Hotel identified"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Hotel nuevo"
msgstr "New hotel"

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Hotel o número de contrato, p. ej. Puerto Real…"
msgstr "Hotel or contract number, e.g. Puerto Real…"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Hotel Puerto Real"
msgstr "Hotel Puerto Real"

#: src/features/onboarding/components/PlacesSearchField.tsx
msgid "Hotel Puerto Real, Cancún"
msgstr "Hotel Puerto Real, Cancún"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Hotel registrado"
msgstr "Hotel registered"

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
msgid "Hotel sin nombre"
msgstr "Unnamed hotel"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Hotel ya registrado"
msgstr "Hotel already registered"

#: src/layouts/GlobalSearch.tsx
msgid "Hotel, folio de requisición o colaborador, p. ej. Xcaret…"
msgstr "Hotel, requisition number or collaborator, e.g. Xcaret…"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Hoteles"
msgstr "Hotels"

#: src/features/clients/pages/ClientPortfolioPage.tsx
msgid "Hoteles activados como clientes, listos para generar requisiciones"
msgstr "Hotels activated as clients, ready to open requisitions"

#: src/features/observability/lib/salesKpis.ts
msgid "Hoteles cliente sin ninguna requisición creada en los últimos {NO_REQUISITION_DAYS} días."
msgstr "Client hotels with no requisition created in the last {NO_REQUISITION_DAYS} days."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Hoteles del archivo"
msgstr "Hotels in the file"

#: src/features/contracts/components/MissingContractsNotice.tsx
msgid "Hoteles listos para su contrato"
msgstr "Hotels ready for their contract"

#: src/features/observability/lib/salesKpis.ts
msgid "Hoteles que pasaron a cliente sobre los ciclos que terminaron en el periodo."
msgstr "Hotels that became clients over the cycles that ended in the period."

#: src/layouts/GlobalSearch.tsx
msgid "Hoteles y prospectos"
msgstr "Hotels and prospects"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "hoy"
msgstr "today"

#: src/features/worker/lib/noShiftMessage.ts
msgid "Hoy descansas"
msgstr "Today is your day off"

#: src/features/worker/pages/PunchPage.tsx
msgid "Hoy descansas. No tienes turno programado hoy."
msgstr "You're resting today. You have no shift scheduled today."

#: src/features/observability/components/TabParts.tsx
msgid "Hoy en el sistema"
msgstr "Today in the system"

#: src/features/worker/pages/PunchPage.tsx
msgid "Hoy no ponchas."
msgstr "You're not clocking in today."

#: src/features/worker/lib/noShiftMessage.ts
msgid "Hoy no tienes turno"
msgstr "No shift today"

#: src/features/worker/pages/PunchPage.tsx
msgid "Hoy no tienes turno: no hay nada que ponchar."
msgstr "You have no shift today: there's nothing to clock."

#: src/features/worker/pages/HomePage.tsx
msgid "Hoy no tienes turno. Cuando te asignen, aquí aparece el hotel y el horario."
msgstr "No shift today. When you're assigned, the hotel and schedule show up here."

#. placeholder {0}: member.reportsTo.fullName
#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "Hoy reporta a {0}."
msgstr "Currently reports to {0}."

#: src/features/worker/pages/PunchPage.tsx
msgid "Hoy tienes más de un turno: pídele al Supervisor que registre la marca."
msgstr "You have more than one shift today: ask the Supervisor to record the punch."

#: src/features/timesheet/components/TimesheetDayCell.tsx
msgid "Hoy, con entrada marcada y la jornada todavía sin terminar. No es un problema: solo falta que salga."
msgstr "Today, clocked in and the shift isn't over yet. Not a problem — they just haven't clocked out."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Identidad"
msgstr "Identity"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Identificación oficial"
msgstr "Government-issued ID"

#: src/features/territory/components/TerritoryMapLegend.tsx
msgid "Identificado"
msgstr "Identified"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/messaging/components/TemplateDetailDialog.tsx
#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Idioma"
msgstr "Language"

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Imagen de referencia"
msgstr "Reference image"

#. placeholder {0}: prospect.hotelName
#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Imagen de referencia: {0} todavía no tiene foto"
msgstr "Reference image: {0} has no photo yet"

#: src/features/messaging/components/tours.ts
msgid "Importa un Excel"
msgstr "Import an Excel file"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Importación completada"
msgstr "Import complete"

#: src/features/messaging/components/ContactImportsDialog.tsx
msgid "Importaciones"
msgstr "Imports"

#: src/features/messaging/components/ImportContactsDialog.tsx
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Importando…"
msgstr "Importing…"

#. placeholder {0}: row.hotelName || t`fila ${String(row.rowNumber)}`
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Importar {0}"
msgstr "Import {0}"

#. placeholder {0}: preview.validCount
#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Importar {0} contactos"
msgstr "Import {0} contacts"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Importar contactos"
msgstr "Import contacts"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Importar hoteles"
msgstr "Import hotels"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Importar hoteles al Pipeline"
msgstr "Import hotels into the Pipeline"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Importar hoteles no está en tu rol."
msgstr "Importing hotels isn't part of your role."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Importar otro archivo"
msgstr "Import another file"

#: src/features/contracts/components/ContractPdfButton.tsx
#: src/features/onboarding/components/ContractPreviewDialog.tsx
msgid "Imprimir o guardar como PDF"
msgstr "Print or save as PDF"

#: src/features/admin/components/ColaboradorAccountsSection.tsx
#: src/features/admin/components/userListParts.tsx
msgid "Inactivo"
msgstr "Inactive"

#: src/features/admin/components/userListParts.tsx
msgid "Inactivos"
msgstr "Inactive"

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "Inasistencias"
msgstr "Absences"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Incidencia (Rojo); Inspección la revisa"
msgstr "Incident (Red); Inspection reviews it"

#: src/layouts/Sidebar.tsx
msgid "Incidencias"
msgstr "Incidents"

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
#: src/features/timesheet/components/PendingAdjustmentsChip.tsx
msgid "Incluido en la nómina"
msgstr "Included in payroll"

#: src/features/timesheet/components/PendingAdjustmentsChip.tsx
msgid "Incluir"
msgstr "Include"

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
msgid "Incluir en la nómina"
msgstr "Include in payroll"

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "Incluyendo…"
msgstr "Including…"

#: src/features/recruitment/components/PoolTable.tsx
msgid "incompleto"
msgstr "incomplete"

#: src/features/contracts/utils/validity.ts
msgid "indefinido"
msgstr "open-ended"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Indefinido"
msgstr "Open-ended"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Indica cuándo ocurrió el intento"
msgstr "Says when the attempt happened"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "industria"
msgstr "industry"

#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/onboarding/components/ProposalRateFields.tsx
msgid "Industria"
msgstr "Industry"

#. placeholder {0}: String(index + 1)
#: src/features/contracts/components/NewContractDialog.tsx
msgid "Industria {0}"
msgstr "Industry {0}"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Industria de la posición"
msgstr "Position's industry"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/onboarding/components/ProposalRateFields.tsx
msgid "Industria…"
msgstr "Industry…"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Industrias"
msgstr "Industries"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Información general"
msgstr "General information"

#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/components/PoolTable.tsx
#: src/features/recruitment/components/SelfPickFilterBar.tsx
#: src/features/recruitment/lib/profileFields.ts
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Inglés"
msgstr "English"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Inglés {ordinal}"
msgstr "English {ordinal}"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Inglés y experiencia"
msgstr "English and experience"

#: src/features/observability/components/CohortSection.tsx
msgid "Ingresaron"
msgstr "Joined"

#: src/features/observability/components/CohortsView.tsx
msgid "Ingreso"
msgstr "Join"

#: src/features/observability/lib/recruitmentKpis.ts
msgid "Ingreso al Pool"
msgstr "Joined the Pool"

#: src/features/observability/components/TabParts.tsx
msgid "Ingresos"
msgstr "Joins"

#: src/features/observability/components/CohortsView.tsx
msgid "Ingresos de las 12 semanas sombreadas"
msgstr "Joins in the 12 shaded weeks"

#: src/features/auth/pages/LoginPage.tsx
msgid "Inicia sesión"
msgstr "Sign in"

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Iniciando sesión…"
msgstr "Signing in…"

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Iniciar sesión"
msgstr "Sign in"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/worker/components/MobileShell.tsx
msgid "Inicio"
msgstr "Home"

#. placeholder {0}: formatDayMonth(position.startDate)
#: src/features/requisitions/components/SlotList.tsx
msgid "Inicio {0}"
msgstr "Start {0}"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Inicio {ordinal}"
msgstr "Start {ordinal}"

#: src/features/observability/components/CohortsView.tsx
msgid "Inicio del historial"
msgstr "Start of the history"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Inicio y fin definidos: la nómina toma lo que regía cada día."
msgstr "Start and end defined: payroll takes whatever applied on each day."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/observability/lib/cohorts.ts
#: src/features/observability/pages/ObservabilityPage.tsx
msgid "Inspección"
msgstr "Inspection"

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Inspección corregida"
msgstr "Inspection corrected"

#: src/features/audits/components/AuditHotelCard.tsx
#: src/features/audits/components/AuditWorkerList.tsx
msgid "Inspección de personal"
msgstr "Staff inspection"

#: src/features/audits/components/PersonalPresentationAuditDialog.tsx
msgid "Inspección de Presentación Personal"
msgstr "Personal Presentation Inspection"

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Inspección guardada"
msgstr "Inspection saved"

#: src/features/audits/components/AuditWorkerList.tsx
msgid "Inspeccionado ayer"
msgstr "Inspected yesterday"

#: src/features/audits/components/AuditWorkerList.tsx
msgid "Inspeccionado hace {days} días"
msgstr "Inspected {days} days ago"

#: src/features/audits/components/AuditWorkerList.tsx
msgid "Inspeccionado hoy"
msgstr "Inspected today"

#. placeholder {0}: worker.fullName
#: src/features/audits/components/AuditFormDialog.tsx
msgid "Inspeccionando a <0>{0}</0>"
msgstr "Inspecting <0>{0}</0>"

#: src/features/audits/components/AuditHotelCard.tsx
msgid "Inspeccionar"
msgstr "Inspect"

#: src/features/audits/components/AuditHotelCard.tsx
msgid "Inspeccionar por ambiente"
msgstr "Inspect the environment"

#: src/features/audits/pages/AuditsPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Inspecciones"
msgstr "Inspections"

#: src/features/requisitions/components/RequisitionTable.tsx
#: src/shared/constants/roles.ts
msgid "Inspector"
msgstr "Inspector"

#: src/features/requisitions/components/RequisitionSummaryStrip.tsx
msgid "Inspector de zona"
msgstr "Zone Inspector"

#: src/features/audits/components/EnvironmentAuditDialog.tsx
msgid "Insumos, relaciones, carga laboral y entorno de {hotelName}."
msgstr "Supplies, relationships, workload and surroundings at {hotelName}."

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Intento corregido"
msgstr "Attempt corrected"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Intento registrado"
msgstr "Attempt logged"

#: src/features/observability/lib/people.ts
msgid "Intentos"
msgstr "Attempts"

#: src/features/observability/lib/salesKpis.ts
msgid "Intentos de contacto con resultado «cita agendada». No existe una entidad de cita: es una aproximación."
msgstr "Contact attempts with the outcome \"appointment scheduled.\" There's no appointment entity: this is an approximation."

#: src/features/reports/pages/ReportsPage.tsx
msgid "Intentos por canal × resultado"
msgstr "Attempts by channel × outcome"

#: src/shared/constants/contactAttempt.ts
msgid "Interesado"
msgstr "Interested"

#: src/shared/constants/catalogs.ts
msgid "Intermedio"
msgstr "Intermediate"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "interna"
msgstr "internal"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Inválidas"
msgstr "Invalid"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Invitación"
msgstr "Invitation"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/admin/components/userListParts.tsx
msgid "Invitación enviada"
msgstr "Invitation sent"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Invitación enviada a:"
msgstr "Invitation sent to:"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Invitación reenviada: la persona tiene un correo nuevo para establecer su contraseña."
msgstr "Invitation resent: they have a new email to set their password."

#: src/features/team/pages/HotelTeamPage.tsx
msgid "Invítalos desde tu Dashboard, en «¿Entró un Supervisor o un gerente nuevo?»."
msgstr "Invite them from your Dashboard, under “Did a new Supervisor or manager join?”."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Ir a Catálogos"
msgstr "Go to Catalogs"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Ir a Inicio"
msgstr "Go to Home"

#: src/features/audits/pages/AuditsPage.tsx
msgid "Ir a Inspecciones"
msgstr "Go to Inspections"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Ir a la propuesta"
msgstr "Go to the proposal"

#: src/features/timesheet/components/TimesheetViewControls.tsx
msgid "Ir a la semana actual"
msgstr "Go to the current week"

#: src/features/schedule/components/ScheduleMiniCalendar.tsx
msgid "Ir a la semana de este día"
msgstr "Go to this day's week"

#: src/features/worker/pages/PunchPage.tsx
msgid "Ir a Permisos"
msgstr "Go to Permissions"

#: src/features/worker/pages/PunchPage.tsx
msgid "Ir a ponchar"
msgstr "Go clock in"

#: src/features/onboarding/components/ContractUnlockedDialog.tsx
msgid "Ir al contrato"
msgstr "Go to the contract"

#: src/features/recruitment/components/PoolTable.tsx
msgid "ITIN"
msgstr "ITIN"

#: src/features/schedule/components/ScheduleMiniCalendar.tsx
msgid "J"
msgstr "T"

#: src/features/worker/pages/PunchPage.tsx
msgid "Jornada completa"
msgstr "Full day done"

#: src/features/observability/lib/workerKpis.ts
#: src/features/personnel/components/WorkerPerformanceRadar.tsx
msgid "Jornadas completas"
msgstr "Complete workdays"

#: src/features/observability/lib/workerKpis.ts
msgid "Jornadas completas de menos de {SHORT_SHIFT_HOURS} horas entre entrada y salida."
msgstr "Complete shifts of less than {SHORT_SHIFT_HOURS} hours between clock-in and clock-out."

#: src/features/observability/lib/workerKpis.ts
msgid "Jornadas con dos marcas seguidas en menos de un minuto."
msgstr "Shifts with two punches within less than a minute of each other."

#: src/features/observability/lib/workerKpis.ts
msgid "Jornadas con entrada, salida y regreso de cada comida, sin contar las de hoy."
msgstr "Shifts with clock-in, clock-out, and a return from each lunch, not counting today's."

#: src/features/observability/lib/workerKpis.ts
msgid "Jornadas cuya comida duró más de {LONG_LUNCH_MIN} minutos."
msgstr "Shifts whose lunch lasted more than {LONG_LUNCH_MIN} minutes."

#: src/features/observability/lib/workerKpis.ts
msgid "Jornadas cuya comida duró menos de {SHORT_LUNCH_MIN} minutos."
msgstr "Shifts whose lunch lasted less than {SHORT_LUNCH_MIN} minutes."

#: src/features/observability/lib/workerKpis.ts
msgid "Jornadas de menos de {SHORT_SHIFT_HOURS} h"
msgstr "Shifts under {SHORT_SHIFT_HOURS} h"

#: src/features/observability/lib/workerKpis.ts
msgid "Jornadas en curso"
msgstr "Shifts in progress"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "Jue"
msgstr "Thu"

#: src/features/observability/components/TabParts.tsx
msgid "KPIs"
msgstr "KPIs"

#: src/features/schedule/components/ScheduleMiniCalendar.tsx
msgid "L"
msgstr "M"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "La app toma la foto en el momento de ponchar. Para cambiarlo, edita el hotel."
msgstr "The app takes the photo at the moment of punching. To change this, edit the hotel."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "La app toma la foto en el momento. Es el método por defecto."
msgstr "The app takes the photo on the spot. It's the default method."

#. placeholder {0}: credential.mailbox.reason
#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "La app ya tiene la contraseña nueva, pero el buzón de correo no cambió: {0}."
msgstr "The app already has the new password, but the mailbox did not change: {0}."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "La aprobación es del BDC"
msgstr "Approval is the BDC's"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "La aprobación es del Manager"
msgstr "Approval is up to the Manager"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "La aprueba el Manager de Contabilidad, validando bill rate y horas autorizadas."
msgstr "The Accounting Manager approves it, checking the bill rate and authorized hours."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "La asignación quedó hecha, pero el ajuste/gasto no se pudo pedir. Vuelve a intentarlo."
msgstr "The assignment went through, but the adjustment/expense couldn't be requested. Try again."

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "La asignación se canceló: las horas registradas se conservan, pero ya no se capturan marcas"
msgstr "The assignment was cancelled: recorded hours are kept, but no more punches can be recorded"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "La asignación terminó el {endsOn}: las horas se aprueban y pagan, pero ya no se capturan marcas"
msgstr "The assignment ended on {endsOn}: hours get approved and paid, but no more punches can be recorded"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "La asignación terminó: las horas se aprueban y pagan, pero ya no se capturan marcas"
msgstr "The assignment ended: hours get approved and paid, but no more punches can be recorded"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "La bitácora del prospecto vive de estos registros: quién buscó al hotel, cuándo y por qué canal."
msgstr "The prospect's log lives on these entries: who reached out to the hotel, when, and through which channel."

#. placeholder {0}: worker?.workerName ?? ''
#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "La contraseña con la que {0} entra a la app y a su correo."
msgstr "The password {0} uses to sign in to the app and to their email."

#: src/features/admin/components/UserFormDialog.tsx
msgid "La contraseña necesita al menos 8 caracteres"
msgstr "The password needs at least 8 characters"

#. placeholder {0}: worker?.workerName ?? ''
#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "La contraseña se muestra una sola vez. Dásela en mano a {0}."
msgstr "The password is shown only once. Hand it to {0} in person."

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "La conversión a cliente es exclusiva del BDC y exige el Usuario del Hotel creado."
msgstr "Converting to client is the BDC's alone, and the Hotel User must already exist."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "la conversión a Naranja la aprueba el BDC desde Conversión."
msgstr "the BDC approves the move to Orange from Conversion."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "La conversión Rosa → Naranja quedó aprobada: el hotel puede generar requisiciones y el BD queda como su referente comercial."
msgstr "The Pink → Orange conversion is approved: the hotel can open requisitions and the BD stays as its commercial contact."

#. placeholder {0}: primaryContact.fullName
#. placeholder {1}: primaryContact.email
#: src/features/conversion/api/conversionApi.ts
msgid "La cuenta con la que el hotel opera Oranje: pedir requisiciones, administrar su Schedule y aprobar horas. Se crea para el contacto principal — {0} · {1} — y sin ella la conversión se bloquea"
msgstr "The account the hotel uses to run Oranje: request requisitions, manage its Schedule and approve hours. It's created for the main contact — {0} · {1} — and without it the conversion is blocked"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "La cuenta de este colaborador está desactivada."
msgstr "This worker's account is deactivated."

#. placeholder {0}: credential.mailbox.reason
#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "La cuenta de Oranje ya existe, pero el buzón de correo no se pudo crear: {0}."
msgstr "The Oranje account already exists, but the mailbox could not be created: {0}."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "La cuenta quedó guardada, pero el correo de invitación no salió: reenvíala desde su ficha."
msgstr "The account was saved, but the invitation email didn't go out: resend it from their record."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "La cuenta quedó guardada, pero el correo de invitación no salió. Reenvíala desde su ficha en unos minutos."
msgstr "The account was saved, but the invitation email didn't go out. Resend it from their record in a few minutes."

#: src/features/admin/components/PendingHotelUsers.tsx
msgid "La cuenta se borra: el hotel tendría que proponerla de nuevo."
msgstr "The account gets deleted: the hotel would have to propose it again."

#. placeholder {0}: extra.grantedBy
#. placeholder {1}: formatDate(extra.grantedAt)
#: src/features/admin/components/RoleGrantsSection.tsx
msgid "La dio {0} el {1}"
msgstr "Granted by {0} on {1}"

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "la dirección"
msgstr "the address"

#. placeholder {0}: String(PROSPECT_TEXT_MAX.address)
#: src/features/onboarding/import/mapImportRows.ts
msgid "La dirección pasa de {0} caracteres"
msgstr "The address is over {0} characters"

#: src/shared/constants/workerStatus.ts
msgid "La disputa se resolvió a favor del hotel: tiene el acceso bloqueado."
msgstr "The dispute was resolved in the hotel's favor: their access is blocked."

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
msgid "la eliges tú — Google no la conoce"
msgstr "you pick it — Google doesn't know it"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "La entrevista es la Fase 1"
msgstr "The interview is Phase 1"

#. placeholder {0}: tag.name
#: src/features/messaging/components/MessagingTagsList.tsx
msgid "La etiqueta «{0}» se creó."
msgstr "The tag “{0}” was created."

#. placeholder {0}: tag.name
#: src/features/messaging/components/MessagingTagsList.tsx
msgid "La etiqueta «{0}» se eliminó."
msgstr "The tag “{0}” was deleted."

#: src/features/contracts/components/ContractChecklist.tsx
msgid "La fecha de fin es anterior al inicio: corrige el rango."
msgstr "The end date is earlier than the start: fix the range."

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "La fecha de fin tiene que ser posterior al inicio."
msgstr "The end date has to be later than the start."

#: src/features/contracts/components/ContractChecklist.tsx
msgid "La fecha de fin ya pasó: este contrato debe marcarse expirado."
msgstr "The end date has already passed: this contract should be marked expired."

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "La fecha debe ser un día real (AAAA-MM-DD)"
msgstr "The date must be a real day (YYYY-MM-DD)"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "La fila no se borra: se marca levantada con tu motivo, y el pasado sigue consultable."
msgstr "The row isn't deleted: it's marked as lifted with your reason, and the history stays available."

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "La firma electrónica todavía no está configurada."
msgstr "Electronic signature isn't set up yet."

#: src/features/worker/pages/HomePage.tsx
msgid "La foto confirma que eres tú; no se comparte con el hotel. Al continuar, tu teléfono te va a pedir permiso de cámara."
msgstr "The photo confirms it's you; it's never shared with the hotel. When you continue, your phone will ask for camera permission."

#: src/features/admin/components/UserFormDialog.tsx
msgid "La foto pesa demasiado: el máximo es 15 MB."
msgstr "The photo is too heavy: 15 MB is the limit."

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "La geocerca rechazó la marca, se acabó la pila o no hubo señal: para eso existe la marca manual."
msgstr "The geofence rejected the punch, the battery died or there was no signal: that's what the manual punch is for."

#: src/features/onboarding/types/prospectForm.schema.ts
msgid "La geocerca se mide en metros enteros"
msgstr "The geofence is measured in whole meters"

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "La hora debe ser HH:MM (00:00–23:59)"
msgstr "The time must be HH:MM (00:00–23:59)"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "La hora extra se paga 1.5 veces la hora normal."
msgstr "Overtime is paid 1.5 times the regular hour."

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "La hora que pongas manda"
msgstr "The time you enter is what counts"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "La imagen no cargó o está dañada — ábrela en pestaña nueva para revisarla."
msgstr "The image didn't load or is damaged — open it in a new tab to review it."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "La imagen pasa de 15 MB: toma la foto con menos resolución o comprímela."
msgstr "The image is over 15 MB: take it at a lower resolution or compress it."

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "La lista reemplaza, no suma"
msgstr "The list replaces, it doesn't add"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "La marca carga tu motivo y se distingue de las normales en la revisión del día — nada se disfraza."
msgstr "The punch carries your reason and stands apart from regular ones in the day's review — nothing is disguised."

#: src/features/worker/pages/PunchPage.tsx
msgid "La marca no quedó registrada"
msgstr "The punch wasn't recorded"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "la modalidad"
msgstr "the hiring type"

#: src/features/auth/pages/LoginPage.tsx
msgid "La operación de tu hotel, en un solo lugar."
msgstr "Your hotel's operation, all in one place."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "La persona a la que reporta no es de ese hotel o está de baja."
msgstr "The person they report to isn't from that hotel or is deactivated."

#: src/features/admin/components/UserFormDialog.tsx
msgid "La persona a la que reporta no existe o está de baja."
msgstr "The person they report to doesn't exist or is deactivated."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "La persona del hotel con quien hablas: la gerente, el de compras, quien te atendió. No son tus datos: a esta persona le llegará la propuesta."
msgstr "The person at the hotel you talk to: the manager, someone in purchasing, whoever helped you. These aren't your details: the proposal goes to this person."

#: src/features/timesheet/components/TimesheetDayCell.tsx
msgid "La persona marcó su entrada y su salida. Revisar el día es aparte: lo dice el chip."
msgstr "They clocked in and clocked out. Reviewing the day is separate: the chip says so."

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "La persona recibirá un correo para establecer su contraseña. Hasta que entre por primera vez, su cuenta aparece como «Invitación enviada»."
msgstr "They'll get an email to set their password. Until they sign in for the first time, their account shows as “Invitation sent”."

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "La plantilla de Firebase, que no se puede editar. Solo para salir del paso."
msgstr "Firebase's template, which can't be edited. Only to get by."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "La plataforma deja fuera a quien se dio de baja, está inactivo o en lista negra."
msgstr "The platform leaves out anyone who unsubscribed, is inactive or is blacklisted."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "la posición"
msgstr "the position"

#: src/features/schedule/pages/SchedulePage.tsx
msgid "La posición y la requisición del turno se enseñan en la fila de Demanda: el contrato aún no liga el turno con una posición."
msgstr "The shift's position and requisition are shown in the Demand row: the contract doesn't link the shift to a position yet."

#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "La propuesta cambió después de este contrato"
msgstr "The proposal changed after this contract"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "La propuesta quedó enviada — el correo no salió, mándalo aparte."
msgstr "The proposal was sent — the email didn't go out, send it separately."

#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "La propuesta se abre cuando un prospecto llega a Verde. Búscalo con «Ver propuesta» o ábrela desde la ficha del prospecto."
msgstr "The proposal opens when a prospect reaches Green. Find it with “See proposal” or open it from the prospect's page."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "La propuesta se trabaja con el hotel en Verde o Café — este está en {statusLabel}."
msgstr "The proposal is worked with the hotel in Green or Brown — this one is in {statusLabel}."

#. placeholder {0}: ONBOARDING_STATUS_LABEL[workspace.prospectStatus]
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "La propuesta se trabaja con el hotel en Verde o Café: este está en {0}"
msgstr "The proposal is worked with the hotel in Green or Brown: this one is in {0}"

#: src/features/onboarding/components/ViewProposalDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "La propuesta vive en Verde"
msgstr "The proposal lives in Green"

#. placeholder {0}: formatDate(password.dueAt)
#. placeholder {1}: password.day ?? 1
#: src/features/worker/components/AccessDeadlineBanner.tsx
msgid "La que te dieron es temporal. Tienes hasta el <0>{0}</0> (día {1} de 30); después tu acceso se bloquea hasta que la cambies."
msgstr "The one you were given is temporary. You have until <0>{0}</0> (day {1} of 30); after that your access is blocked until you change it."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "La que tiene ahora deja de servir en cuanto la cambies."
msgstr "Their current password stops working as soon as you change it."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "La requisición es el pedido formal de colaboradores: qué posiciones necesitas y cuántas personas en cada una."
msgstr "A requisition is the formal request for collaborators: which positions you need and how many people in each."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "La requisición ya está en la Bolsa del Self-Pick: las Reclutadoras van cubriendo los slots y aquí verás la cobertura al día."
msgstr "The requisition is already in the Self-Pick pool: Recruiters are filling the slots and you'll see up-to-date coverage here."

#: src/features/timesheet/components/AttendanceView.tsx
msgid "La salida no es después de la entrada"
msgstr "Clock-out isn't after clock-in"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "La semana de nómina la fija el contrato"
msgstr "The contract sets the payroll week"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "La semana del hotel empieza en"
msgstr "The hotel's week starts on"

#: src/features/onboarding/components/HotelDataCard.tsx
msgid "La semana empieza en"
msgstr "The week starts on"

#: src/features/personnel/components/WorkerPerformanceRadar.tsx
msgid "La semana en cinco medidas"
msgstr "The week in five measures"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "La semana no puede empezar y terminar el mismo día"
msgstr "The week can't start and end on the same day"

#: src/features/observability/components/CohortSection.tsx
msgid "La semana siguiente todavía no empieza."
msgstr "The following week hasn't started yet."

#: src/features/worker/pages/PunchPage.tsx
msgid "La semana ya se cerró: esta marca la captura el Supervisor."
msgstr "The week is already closed: the Supervisor records this punch."

#: src/features/timesheet/components/CorrectPunchDialog.tsx
#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "La semana ya se envió a aprobación: no admite más cambios. Si algo quedó mal, comunícate con Oranje."
msgstr "This week was already sent for approval: it no longer accepts changes. If something's wrong, contact Oranje."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "La sesión de firma caducó. «Firmar ahora» abre una nueva."
msgstr "The signing session expired. “Sign now” opens a new one."

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "la ubicación en el mapa"
msgstr "the location on the map"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "La ubicación importa"
msgstr "Location matters"

#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "La ven Reclutamiento y el Manager de QA, que son quienes sincronizan."
msgstr "Recruitment and the QA Manager see it, since they are the ones who sync."

#: src/features/contracts/components/ContractChecklist.tsx
msgid "La vigencia está bien definida"
msgstr "The validity is properly defined"

#: src/features/onboarding/import/mapImportRows.ts
msgid "La zona «{zoneText}» no existe en Oranje"
msgstr "The zone “{zoneText}” doesn't exist in Oranje"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "La zona ya no existe en Oranje"
msgstr "The zone no longer exists in Oranje"

#. placeholder {0}: band.length
#: src/features/observability/components/CohortSection.tsx
msgid "Las {0} semanas alrededor"
msgstr "The {0} weeks around it"

#. placeholder {0}: worker?.workerName ?? ''
#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "Las contraseñas se muestran una sola vez. Dáselas en mano a {0}."
msgstr "The passwords are shown only once. Hand them to {0} in person."

#: src/features/admin/pages/UsersPage.tsx
msgid "Las cuentas de cada hotel: Supervisores, Managers de Área y Managers Generales."
msgstr "Each hotel's accounts: Supervisors, Area Managers and General Managers."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Las defines tú en la entrevista; el candidato no las declara."
msgstr "You set these in the interview; the candidate doesn't declare them."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Las dos"
msgstr "Both"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/worker/components/ChangePasswordForm.tsx
msgid "Las dos contraseñas no coinciden"
msgstr "The two passwords don't match"

#: src/features/messaging/components/tours.ts
msgid "Las entregas y lecturas siguen llegando después del envío: actualiza para verlas."
msgstr "Deliveries and reads keep arriving after sending: refresh to see them."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Las enviadas no se editan: para renegociar se abre una versión nueva, que arranca con el título y las tarifas de la anterior."
msgstr "Sent proposals can't be edited: to renegotiate, open a new version, which starts with the previous one's title and rates."

#: src/features/messaging/components/tours.ts
msgid "Las etiquetas agrupan contactos: con ellas eliges a quién va una campaña."
msgstr "Tags group contacts: use them to choose who a campaign goes to."

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Las fechas de vigencia que definas aquí mandan después en la nómina y en la factura. El corte semanal y el recargo de overtime ya los trae el hotel de sus datos contables."
msgstr "The validity dates you set here later drive payroll and billing. The weekly cutoff and the overtime premium already come from the hotel's accounting data."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Las filas «para completar» se importan y lo que falta se termina en la ficha de cada prospecto. Las filas con error no se pueden elegir: corrígelas en el archivo y vuelve a subirlo."
msgstr "Rows “to complete” are imported and what's missing is finished on each prospect's page. Rows with errors can't be selected: fix them in the file and upload it again."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Las horas que pasan de 40 a la semana no se le pagan al colaborador en este hotel."
msgstr "Hours beyond 40 in the week aren't paid to the collaborator at this hotel."

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Las horas son de la zona horaria de cada hotel. Los días son fijos: el plazo y el corte son miércoles, el envío de emergencia es jueves y el correo de horas sale el sábado."
msgstr "Hours follow each hotel’s time zone. The days are fixed: the deadline and the cut fall on Wednesday, the emergency send on Thursday, and the hours email goes out on Saturday."

#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "Las horas ya están aprobadas y no se modifican."
msgstr "The hours are already approved and can't be changed."

#: src/features/audits/components/AuditHotelCard.tsx
msgid "Las inspecciones las hace el Supervisor del hotel; tú puedes ver el historial."
msgstr "Inspections are done by the hotel's Supervisor; you can view the history."

#: src/features/audits/pages/AuditsPage.tsx
msgid "Las inspecciones las ve el equipo del hotel. Si crees que deberías tener acceso, pídeselo a tu Manager General."
msgstr "Inspections are visible to the hotel team. If you think you should have access, ask your General Manager."

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Las Líderes y Reclutadoras se asignan en Usuarios: cuando alguien tenga «Reporta a» con tu nombre, aparecerá aquí."
msgstr "Group Leaders and Recruiters are assigned in Users: once someone has your name in “Reports to”, they'll show up here."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Las listas de las que bebe todo el sistema: requisiciones, altas y contratos."
msgstr "The lists the whole system draws from: requisitions, intake and contracts."

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Las marcas del día"
msgstr "The day's punches"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Las más recientes, con su cobertura"
msgstr "The most recent, with their coverage"

#: src/features/observability/pages/ObservabilityPage.tsx
msgid "Las metas son de ejemplo, tomadas del tablero maquetado: todavía nadie las aprobó."
msgstr "The targets are examples, taken from the mocked-up dashboard: nobody has approved them yet."

#: src/features/team/pages/TeamPage.tsx
msgid "Las notas al BD llegan pronto"
msgstr "Notes to the BD are coming soon"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Las posiciones"
msgstr "The positions"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Las propuestas las elabora el BD dueño de cada hotel: pídele que la abra."
msgstr "Proposals are prepared by each hotel's BD: ask them to open it."

#: src/features/onboarding/components/CreateProposalPromptDialog.tsx
msgid "Las propuestas las elabora el BD dueño de cada prospecto: pídele que la abra."
msgstr "The BD who owns each prospect writes the proposal: ask them to open it."

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "Las ramas: salir y volver"
msgstr "The branches: leaving and coming back"

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
msgid "las requisiciones de {hotelName}"
msgstr "{hotelName}'s requisitions"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Las requisiciones de otro departamento las crea su Manager de Área o el Manager General."
msgstr "Requisitions for another department are created by its Area Manager or the General Manager."

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Las requisiciones las crea el hotel"
msgstr "Requisitions are created by the hotel"

#. placeholder {0}: data.range.tz
#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Las respuestas y bajas cuentan para una campaña si llegan en los 7 días siguientes al envío. Horarios en {0}."
msgstr "Replies and opt-outs count toward a campaign if they arrive within 7 days of sending. Times in {0}."

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Las semanas enviadas las aprueba el Manager de Área de su departamento o el Manager General. Hasta entonces las horas no se pagan ni se facturan."
msgstr "Sent weeks are approved by the Area Manager of their department or by the General Manager. Until then, hours aren't paid or billed."

#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "Las semanas ya aprobadas <0>no se recalculan</0>: cada consolidado guarda lo que regía ese día."
msgstr "Weeks already approved <0>are not recalculated</0>: each consolidation keeps whatever applied that day."

#. placeholder {0}: String(latestVersion)
#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "Las tarifas del contrato se reemplazan por las de la v{0}. Los datos del documento, la vigencia y los multiplicadores no cambian."
msgstr "The contract's rates are replaced with the v{0} rates. Document details, term and multipliers stay the same."

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Las tarifas solo se editan en borrador"
msgstr "Rates are only edited while in draft"

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Las tarifas ya están completas. Al activarlo, la nómina y la factura del hotel empiezan a usarlo y queda bloqueado — se desbloquea con un motivo si hace falta corregir algo."
msgstr "The rates are complete. Once activated, payroll and the hotel's invoice start using it and it gets locked — unlock it with a reason if something needs correcting."

#: src/features/messaging/components/tours.ts
msgid "Las últimas campañas"
msgstr "The latest campaigns"

#: src/features/accounting/pages/AccountingPendingPages.tsx
msgid "Las vacaciones aún no tienen reglas ni registro en el sistema. Esta pantalla se llenará cuando existan."
msgstr "Vacations do not yet have rules or a record in the system. This screen will fill up once they exist."

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "Las zonas del BD las asigna su coordinador (o el Administrador): son donde abre y trabaja sus prospectos."
msgstr "A BD's zones are assigned by their coordinator (or the Administrator): they're where they open and work their prospects."

#. placeholder {0}: member.fullName
#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "Las zonas donde {0} abre y trabaja sus prospectos."
msgstr "The zones where {0} opens and works their prospects."

#: src/features/team/pages/TeamPage.tsx
msgid "Las zonas donde este BD trabaja sus prospectos"
msgstr "The zones where this BD works their prospects"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Latitud o longitud no válidas: marca el pin en la ficha del prospecto"
msgstr "Invalid latitude or longitude: set the pin on the prospect's page"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Laura Méndez"
msgstr "Laura Méndez"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Le faltan columnas obligatorias. Agrégalas con estos títulos o usa la plantilla:"
msgstr "Required columns are missing. Add them with these titles or use the template:"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Le llega cuando firme Oranje"
msgstr "Sent once Oranje signs"

#. placeholder {0}: preview.totalRecipients
#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "Le llegaría a <0>{0}</0> contactos"
msgstr "It would reach <0>{0}</0> contacts"

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/components/ReportCharts.tsx
#: src/features/messaging/components/ReportParts.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Leídos"
msgstr "Read"

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Levantada"
msgstr "Lifted"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "Levantando…"
msgstr "Lifting…"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "Levantar de Blacklist"
msgstr "Lift from Blacklist"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "Levantar el veto"
msgstr "Lift the ban"

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Levantar un veto es del Administrador"
msgstr "Lifting a ban is the Administrator's"

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Levantar veto"
msgstr "Lift ban"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Leyendo el archivo…"
msgstr "Reading the file…"

#. placeholder {0}: formatPercent(share(totals.read, totals.delivered))
#: src/features/messaging/components/ReportCharts.tsx
msgid "Leyeron el {0} de los que lo recibieron."
msgstr "{0} of those who received it read it."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/SlotList.tsx
msgid "Liberando…"
msgstr "Releasing…"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/SlotList.tsx
msgid "Liberar"
msgstr "Release"

#: src/shared/components/ReleaseAssignmentWarningDialog.tsx
msgid "Liberar a {workerName}"
msgstr "Release {workerName}"

#: src/features/recruitment/components/PoolRoster.tsx
msgid "Liberar asignación temporal"
msgstr "Release temporary assignment"

#: src/features/requisitions/components/SlotList.tsx
msgid "Libre"
msgstr "Free"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "libre · elegir"
msgstr "free · pick"

#: src/shared/constants/roles.ts
msgid "Líder de Grupo de Reclutadoras"
msgstr "Recruiters Group Leader"

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Límites guardados"
msgstr "Limits saved"

#: src/shared/components/SearchField.tsx
msgid "Limpiar"
msgstr "Clear"

#: src/shared/components/SearchField.tsx
msgid "Limpiar la búsqueda"
msgstr "Clear the search"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Líneas facturadas"
msgstr "Invoiced lines"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Líneas trabajadas"
msgstr "Worked lines"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Lista"
msgstr "Ready"

#. placeholder {0}: result.list.name
#. placeholder {1}: result.contacts
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Lista «{0}» lista con {1} contactos: elígela en una campaña nueva."
msgstr "List “{0}” ready with {1} contacts: pick it in a new campaign."

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Lista de verificación"
msgstr "Checklist"

#. placeholder {0}: result.deactivated
#. placeholder {1}: result.reactivated
#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Lista negra: {0} dejan de recibir y {1} vuelven a recibir."
msgstr "Blacklist: {0} stop receiving and {1} receive again."

#: src/features/messaging/components/ImportContactsDialog.tsx
#: src/features/onboarding/import/ImportProspectsDialog.tsx
#: src/features/recruitment/components/CreateAccessDialog.tsx
#: src/shared/components/GuidedTour.tsx
msgid "Listo"
msgstr "Done"

#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "Listo para aprobar"
msgstr "Ready to approve"

#: src/features/recruitment/components/ProfileProgressAvatar.tsx
msgid "Listo para asignar"
msgstr "Ready to assign"

#: src/features/observability/lib/people.ts
#: src/shared/constants/contactAttempt.ts
msgid "Llamada"
msgstr "Call"

#: src/features/observability/lib/people.ts
msgid "Llamadas"
msgstr "Calls"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Llenando"
msgstr "Filling"

#. placeholder {0}: member.activeRequisitions
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Llenando {0}"
msgstr "Filling {0}"

#. placeholder {0}: String(slot.ordinal)
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Llenar el slot {0} en vez de este"
msgstr "Fill slot {0} instead of this one"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Llenar un slot es de Reclutamiento: la Reclutadora, su Líder de Grupo o el Manager de Reclutamiento."
msgstr "Filling a slot is Recruitment's job: the Recruiter, their Group Leader, or the Recruitment Manager."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Llevas {typedLength} de {minLength} caracteres."
msgstr "{typedLength} of {minLength} characters."

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Lo aprobado hasta aquí se paga ese día."
msgstr "What is approved up to here is paid that day."

#: src/shared/constants/workerStatus.ts
msgid "lo asigna Reclutamiento (la Reclutadora, su Líder de Grupo o el Manager); el propio colaborador puede ponerse Disponible voluntario."
msgstr "Recruitment sets it (the Recruiter, their Group Leader or the Manager); the collaborator can also mark themselves Voluntarily available."

#: src/shared/constants/workerStatus.ts
msgid "lo asigna Reclutamiento temporalmente (la Reclutadora, su Líder de Grupo o el Manager)."
msgstr "Recruitment assigns it temporarily (the Recruiter, their Group Leader or the Manager)."

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Lo autoriza el Manager de Contabilidad: segunda firma."
msgstr "The Accounting Manager authorizes it: second signature."

#: src/shared/constants/workerStatus.ts
msgid "lo avanza el sistema con los ponches (el Inspector verifica su llegada)."
msgstr "the system moves it forward with the punches (the Inspector confirms they arrived)."

#: src/shared/constants/workerStatus.ts
msgid "lo avanza el sistema con los ponches; al completar la semana queda Fijo."
msgstr "the system moves it forward with the punches; once the week is complete they become Permanent."

#: src/features/worker/pages/PermissionsPage.tsx
msgid "Lo bloqueaste antes: el navegador ya no vuelve a preguntar. Actívalo desde los Ajustes de tu teléfono, en los permisos de este sitio, y vuelve aquí a confirmar."
msgstr "You blocked it before: the browser won't ask again. Turn it on from your phone's Settings, in this site's permissions, and come back here to confirm."

#: src/shared/constants/workerStatus.ts
msgid "lo cierra el Inspector con el alta médica."
msgstr "the Inspector closes it with the medical release."

#. placeholder {0}: missingPhase1Fields.join(', ')
#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Lo de Fase 1 ({0}) lo defines tú con «Editar»."
msgstr "Phase 1 ({0}) is yours to define with \"Edit\"."

#. placeholder {0}: grant.grantedBy
#. placeholder {1}: formatDate(grant.grantedAt)
#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Lo dio {0} el {1}"
msgstr "Granted by {0} on {1}"

#. placeholder {0}: workspace.owner.name
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Lo elabora <0>{0}</0> — el BD dueño del ciclo — o el BDC."
msgstr "Written by <0>{0}</0> — the BD who owns the cycle — or the BDC."

#: src/features/onboarding/components/ViewProposalDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Lo enviado no se edita"
msgstr "What's sent can't be edited"

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Lo haces tú, desde este mismo lugar (Ventas)."
msgstr "You do it, right here (Sales)."

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Lo imprimes, lo firman a mano y después lo activas"
msgstr "You print it, it gets signed by hand, then you activate it"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "lo mueve el BD o el BDC."
msgstr "the BD or the BDC moves it."

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "Lo pagó de su bolsillo: el monto se suma a lo que recibe esta semana, junto a sus horas."
msgstr "They paid out of pocket: the amount is added to what they receive this week, along with their hours."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Lo pagó el colaborador"
msgstr "The collaborator paid for it"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Lo pagó Oranje"
msgstr "Oranje paid for it"

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "Lo pagó Oranje directo: queda registrado, pero no cambia lo que recibe esta semana."
msgstr "Oranje paid directly: it gets recorded, but it does not change what they receive this week."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Lo pagó Oranje, descontárselo"
msgstr "Oranje paid for it, deduct it from them"

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "Lo que cada hotel nos paga por semana, al precio que cobramos (bill rate)."
msgstr "What each hotel pays us per week, at the price we charge (bill rate)."

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Lo que cada hotel nos paga y lo que le pagamos a su gente. Un contrato vigente por hotel."
msgstr "What each hotel pays us and what we pay its people. One contract in force per hotel."

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Lo que corrijas, se paga"
msgstr "What you correct gets paid"

#: src/features/worker/pages/ProfilePage.tsx
msgid "Lo que decide Oranje"
msgstr "What Oranje decides"

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "Lo que dejes marcado ES el territorio completo del BD — desmarcar una zona se la quita en el mismo guardado."
msgstr "What you leave checked IS the BD's whole territory — unchecking a zone takes it away in that same save."

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "Lo que el hotel nos paga por semana, al precio que le cobramos — nunca el pago interno al colaborador."
msgstr "What the hotel pays us per week, at the rate we charge — never the collaborator's internal pay."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Lo que el machote necesita y hoy no venía de ningún lado"
msgstr "What the template needs that nothing else provided yet"

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
msgid "Lo que Google llenó por ti"
msgstr "What Google filled in for you"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "lo que marca el contrato"
msgstr "what the contract states"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Lo que no llegue aprobado al cierre semanal queda en espera: sin pago y sin factura hasta que alguien apruebe."
msgstr "Whatever isn't approved by the weekly close stays on hold: no pay and no invoice until someone approves it."

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "Lo que no se aprueba, no se paga"
msgstr "What isn't approved doesn't get paid"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Lo que puedes hacer"
msgstr "What you can do"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Lo que puedes hacer con cada uno"
msgstr "What you can do with each one"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "lo que recibe"
msgstr "what they receive"

#: src/features/contracts/components/EditRateDialog.tsx
msgid "Lo que se factura no puede ser menor a lo que se paga a la persona."
msgstr "What is billed cannot be less than what is paid to the person."

#: src/features/contracts/components/EditRateDialog.tsx
#: src/features/contracts/components/NewContractDialog.tsx
msgid "Lo que se factura no puede ser menor a lo que se paga."
msgstr "What is billed cannot be less than what is paid."

#. placeholder {0}: formatMoney(Number(payPreview.billRate))
#: src/features/timesheet/components/PayPreviewBadge.tsx
msgid "Lo que se le cobra al HOTEL por esta hoja, a {0} la hora (bill rate del contrato) — no lo que recibe el colaborador."
msgstr "What's billed to the HOTEL for this sheet, at {0} an hour (the contract's bill rate) — not what the collaborator receives."

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Lo que se le paga a cada colaborador por semana. Se revisa, se autoriza y se paga en ese orden."
msgstr "What each collaborator is paid per week. It is reviewed, authorized and paid in that order."

#: src/features/worker/pages/PermissionsPage.tsx
msgid "Lo que tu teléfono le permite a Oranje para que puedas ponchar."
msgstr "What your phone allows Oranje to do so you can punch in."

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Lo que viste y que vale la pena dejar por escrito…"
msgstr "What you saw that's worth putting in writing…"

#: src/features/audits/pages/AuditsPage.tsx
msgid "Lo que ya inspeccionaste"
msgstr "What you've already inspected"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Lo registra Contabilidad al pagar."
msgstr "Accounting records it when paying."

#: src/shared/constants/workerStatus.ts
msgid "lo regresa el hotel (Supervisor, Manager de Área o Manager General); el propio colaborador puede ponerse Disponible voluntario."
msgstr "the hotel sends them back (Supervisor, Area Manager or General Manager); the collaborator can also mark themselves Voluntarily available."

#: src/shared/constants/workerStatus.ts
msgid "lo resuelve el Inspector: a Disponible o a Blacklist."
msgstr "the Inspector resolves it: to Available or to Blacklist."

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Lo revisa la Contadora contra los Timesheets aprobados."
msgstr "The Accountant reviews it against the approved Timesheets."

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Lo usan Contabilidad y el hotel cada semana, sin que tengas que hacer nada."
msgstr "Accounting and the hotel use it every week, without you having to do anything."

#: src/shared/constants/workerStatus.ts
msgid "lo valida Reclutamiento (la Reclutadora, su Líder de Grupo o el Manager) cuando el expediente está completo."
msgstr "Recruitment validates it (the Recruiter, their Group Leader or the Manager) once the file is complete."

#: src/features/messaging/components/MessagingWorkersList.tsx
msgid "Lo ven Reclutamiento, el Manager de QA, Contabilidad y los roles del hotel (solo su personal)."
msgstr "Recruitment, the QA Manager, Accounting and hotel roles (their own staff only) can see it."

#. placeholder {0}: board.slots.length
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Los {0} slots están ocupados: la cobertura del renglón quedó completa."
msgstr "All {0} slots are taken: this line is fully covered."

#: src/features/worker/pages/HomePage.tsx
msgid "Los avisos importan"
msgstr "Notices matter"

#: src/features/team/pages/TeamPage.tsx
msgid "Los BDs de tu equipo se asignan en el alta de personal: cuando alguien tenga «Reporta a» con tu nombre, aparecerá aquí."
msgstr "BDs join your team at staff intake: when someone has “Reports to” with your name, they'll show up here."

#: src/features/team/pages/TeamPage.tsx
msgid "Los BDs que te reportan y cómo va su ciclo comercial"
msgstr "The BDs who report to you and how their commercial cycle is going"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Los catálogos alimentan toda la plataforma"
msgstr "Catalogs feed the whole platform"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Los catálogos los administra el Administrador del sistema."
msgstr "Catalogs are managed by the system Administrator."

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Los colaboradores asignados a tus requisiciones, con su estado en el Semáforo. El Stand-by (Rosa) lo compartes con el Manager de Área."
msgstr "The collaborators assigned to your requisitions, with their status light. You share Stand-by (Pink) with the Area Manager."

#: src/features/admin/pages/UsersPage.tsx
msgid "Los colaboradores con correo corporativo, y si su buzón real ya existe."
msgstr "Collaborators with a company email, and whether their real mailbox exists yet."

#: src/features/admin/components/ColaboradorAccountsSection.tsx
msgid "Los colaboradores que ya tienen correo @oranjepeople.com. El alta es de Reclutamiento."
msgstr "Collaborators who already have an @oranjepeople.com address. Intake belongs to Recruitment."

#: src/features/accounting/pages/AccountingPendingPages.tsx
msgid "Los días de vacaciones de los colaboradores y cómo se pagan."
msgstr "Collaborators' vacation days and how they are paid."

#. placeholder {0}: session.hotel.name
#: src/features/team/pages/HotelTeamPage.tsx
msgid "Los gerentes y supervisores de {0}"
msgstr "The managers and supervisors of {0}"

#. placeholder {0}: hotels && ` ${String(hotels.length)} con coordenada.`
#: src/features/onboarding/components/HotelGlobeCard.tsx
msgid "Los hoteles de tus zonas, del prospecto al cliente activo.{0} Cada pin abre Mi Territorio."
msgstr "The hotels in your zones, from prospect to active client.{0} Each pin opens My Territory."

#: src/features/observability/pages/ObservabilityPage.tsx
msgid "Los indicadores de cada departamento, calculados con lo que el sistema ya registra — todo de solo lectura."
msgstr "Each department's indicators, calculated from what the system already records — all read-only."

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Los mensajes que aún no salieron ya no se envían. No se puede deshacer."
msgstr "Messages that have not gone out yet will not be sent. This cannot be undone."

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Los que no tengan teléfono válido se saltan."
msgstr "Those without a valid phone are skipped."

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Los que ya existen se actualizan con los datos del archivo; no se duplican."
msgstr "Existing contacts are updated with the file data; they are not duplicated."

#: src/features/messaging/components/tours.ts
msgid "Los reportes cuentan las campañas que salieron en esas fechas."
msgstr "Reports count the campaigns sent in those dates."

#: src/features/team/pages/TeamPage.tsx
msgid "Los reportes por BD llegan con la pantalla de Reportes"
msgstr "Per-BD reports come with the Reports screen"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Los reportes que te envían tus Líderes llegarán con su pantalla «Mi Grupo», que todavía no existe."
msgstr "Reports from your Group Leaders will arrive with their “My Group” screen, which doesn't exist yet."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Los títulos de la tabla"
msgstr "The table titles"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Los títulos pueden estar en español, inglés o portugués. Las marcadas como obligatorias tienen que existir; si una celda queda vacía, ese dato se completa después."
msgstr "Titles can be in Spanish, English or Portuguese. The required ones must exist; if a cell is empty, that detail is completed later."

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Lugares cubiertos"
msgstr "Slots filled"

#: src/features/observability/lib/recruitmentKpis.ts
msgid "Lugares cubiertos sobre lugares pedidos, de las requisiciones que empiezan en el periodo."
msgstr "Spots covered over spots requested, of requisitions starting in the period."

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Lugares pedidos"
msgstr "Slots requested"

#: src/features/observability/lib/people.ts
msgid "Lugares por cubrir en las suyas"
msgstr "Spots to cover in theirs"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "Lun"
msgstr "Mon"

#. placeholder {0}: timeOf(marks.LUNCH_OUT, shiftTimeZone)
#. placeholder {1}: marks.LUNCH_IN ? timeOf(marks.LUNCH_IN, shiftTimeZone) : '--:--'
#: src/features/worker/pages/PunchPage.tsx
msgid "Lunch {0} – {1}"
msgstr "Lunch {0} – {1}"

#: src/features/schedule/components/ScheduleMiniCalendar.tsx
msgid "M"
msgstr "T"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "MA"
msgstr "AM"

#: src/shared/constants/workerEnums.ts
msgid "Madre"
msgstr "Mother"

#: src/features/admin/types/admin.types.ts
#: src/shared/components/ApprovalTimelinessPanel.tsx
#: src/shared/constants/roles.ts
msgid "Manager de Área"
msgstr "Area Manager"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Manager de Área (su departamento)"
msgstr "Area Manager (their department)"

#: src/shared/constants/roles.ts
msgid "Manager de Contabilidad"
msgstr "Accounting Manager"

#: src/features/onboarding/pages/PipelinePage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
#: src/features/requisitions/pages/RequisitionDetailPage.tsx
#: src/shared/constants/roles.ts
msgid "Manager de QA"
msgstr "QA Manager"

#: src/shared/constants/roles.ts
msgid "Manager de Reclutamiento"
msgstr "Recruitment Manager"

#: src/features/admin/types/admin.types.ts
#: src/shared/constants/roles.ts
msgid "Manager General"
msgstr "General Manager"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Manager General (cualquier departamento)"
msgstr "General Manager (any department)"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Manda la invitación por correo y cada quien establece la suya. Si lo necesitas, también puedes definirla tú."
msgstr "Send the invitation by email and each person sets their own. If you need to, you can also set it yourself."

#: src/features/onboarding/components/ContractStepCard.tsx
msgid "Manda primero la propuesta: el contrato se arma con las tarifas que el hotel aceptó."
msgstr "Send the proposal first: the contract is built with the rates the hotel accepted."

#: src/features/personnel/components/StandByDialog.tsx
msgid "Mandando…"
msgstr "Sending…"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Mandar a aprobación"
msgstr "Submit for approval"

#: src/features/personnel/components/StandByDialog.tsx
#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Mandar a Stand-by"
msgstr "Send to Stand-by"

#: src/features/personnel/components/StandByDialog.tsx
msgid "Mandar a Stand-by a {workerName}"
msgstr "Send {workerName} to Stand-by"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Mandar la semana a aprobación del Manager"
msgstr "Send the week to the Manager for approval"

#: src/features/recruitment/types/blacklist.types.ts
msgid "Manual"
msgstr "Manual"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Manual · {manualReason}"
msgstr "Manual · {manualReason}"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "Mar"
msgstr "Tue"

#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Marca / Administradora"
msgstr "Brand / Management company"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Marca a quiénes enviarle:"
msgstr "Check who to send it to:"

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Marca a quiénes sincronizar:"
msgstr "Check who to sync:"

#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "Marca corregida"
msgstr "Punch corrected"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Marca el documento como revisado. No afecta la retención del 16% del SSN/ITIN."
msgstr "Marks the document as reviewed. It doesn't affect the 16% SSN/ITIN withholding."

#: src/features/onboarding/types/prospectForm.schema.ts
msgid "Marca la ubicación en el mapa"
msgstr "Mark the location on the map"

#: src/features/timesheet/components/DayStatusTour.tsx
msgid "Marca los días sin ponches"
msgstr "Mark the days without punches"

#: src/features/timesheet/components/ManualPunchDialog.tsx
#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Marca manual"
msgstr "Manual punch"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Marca manual registrada"
msgstr "Manual punch recorded"

#: src/features/contracts/components/ContractPdfButton.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Marcando…"
msgstr "Marking…"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Marcar como enviada"
msgstr "Mark as sent"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Marcar como enviado"
msgstr "Mark as sent"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Marcar como principal"
msgstr "Set as main contact"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Marcar como revisado"
msgstr "Mark as reviewed"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Marcar el día"
msgstr "Mark the day"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Marcar expirado"
msgstr "Mark expired"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Marcar revisado"
msgstr "Mark as reviewed"

#: src/features/messaging/components/CreateCampaignDialog.tsx
#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Marcar todos"
msgstr "Select all"

#: src/features/worker/pages/HomePage.tsx
msgid "Marcarme disponible"
msgstr "Mark me available"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Marcas"
msgstr "Clocked hours"

#: src/features/observability/lib/workerKpis.ts
msgid "Marcas en el mismo minuto"
msgstr "Punches in the same minute"

#: src/features/contracts/components/MultiplierTable.tsx
#: src/features/contracts/components/RateTable.tsx
msgid "Margen"
msgstr "Margin"

#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Margen bruto por hora"
msgstr "Gross margin per hour"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "María Sandoval Ruiz"
msgstr "María Sandoval Ruiz"

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/components/MessagingTemplatesList.tsx
#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Marketing"
msgstr "Marketing"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Marta Solís"
msgstr "Marta Solís"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "marta.solis@puertoreal.mx"
msgstr "marta.solis@puertoreal.mx"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Más acciones"
msgstr "More actions"

#: src/features/clients/types/client.types.ts
msgid "más antiguo"
msgstr "oldest"

#: src/shared/constants/workerEnums.ts
msgid "Más de 5 años"
msgstr "More than 5 years"

#: src/features/clients/types/client.types.ts
msgid "más reciente"
msgstr "newest"

#: src/features/onboarding/components/ContractUnlockedDialog.tsx
#: src/features/onboarding/components/CreateProposalPromptDialog.tsx
msgid "Más tarde"
msgstr "Later"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/shared/constants/workerEnums.ts
msgid "Masculino"
msgstr "Male"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Máximo 160 caracteres"
msgstr "160 characters max"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Máximo 255 caracteres"
msgstr "255 characters max"

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "Máximo 999 personas por posición"
msgstr "Up to 999 people per position"

#. placeholder {0}: formatDuration(report.latency.deliveredP90Seconds)
#. placeholder {0}: formatDuration(report.latency.readP90Seconds)
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "mediana · 90 % en {0}"
msgstr "median · 90% within {0}"

#: src/shared/constants/requisitionStatus.ts
msgid "Medio"
msgstr "Medium"

#: src/shared/constants/catalogs.ts
msgid "Medio tiempo"
msgstr "Part-time"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Mensaje"
msgstr "Message"

#: src/features/messaging/pages/ExcludedWorkersPage.tsx
#: src/features/messaging/pages/MessagingPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Mensajería"
msgstr "Messaging"

#: src/features/messaging/components/ReportCharts.tsx
msgid "Mensajes"
msgstr "Messages"

#: src/features/messaging/pages/MessagingPage.tsx
msgid "Mensajes aprobados por Meta"
msgstr "Messages approved by Meta"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Mensajes aprobados por Meta, disponibles para usar en campañas."
msgstr "Messages approved by Meta, ready to use in campaigns."

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Mensajes por día"
msgstr "Messages per day"

#: src/features/messaging/components/ReportCharts.tsx
msgid "Mensajes por día y resultado. Usa las flechas para recorrer los días; «Ver tabla» tiene todos los valores."
msgstr "Messages per day and outcome. Use the arrow keys to move through days; \"View table\" has all the values."

#: src/features/messaging/pages/MessagingPage.tsx
msgid "Mensajes por WhatsApp a colaboradores, con plantillas y campañas."
msgstr "WhatsApp messages to collaborators, with templates and campaigns."

#: src/features/observability/components/CohortsView.tsx
msgid "Mensual"
msgstr "Monthly"

#: src/features/timesheet/components/TimesheetViewControls.tsx
msgid "Mes"
msgstr "Month"

#: src/features/observability/components/CohortsView.tsx
msgid "Mes {k}"
msgstr "Month {k}"

#. placeholder {0}: formatNumber(report.billable)
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Meta cobra las plantillas entregadas ({0} en esta campaña); las no entregadas no se cobran. Respuestas y bajas: 7 días siguientes al envío."
msgstr "Meta charges for delivered templates ({0} in this campaign); undelivered ones aren't charged. Replies and opt-outs: 7 days after sending."

#: src/features/observability/components/KpiCard.tsx
msgid "meta de ejemplo"
msgstr "example target"

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "Meta del ciclo: el hotel ya es cliente."
msgstr "The cycle's goal: the hotel is now a client."

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Meta la revisa antes de poder usarla en campañas; suele tardar minutos, a veces horas."
msgstr "Meta reviews it before it can be used in campaigns; it usually takes minutes, sometimes hours."

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Meta los usa para revisar la plantilla; no se envían a nadie."
msgstr "Meta uses them to review the template; they're not sent to anyone."

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Meta no entrega Marketing a números de EE. UU."
msgstr "Meta doesn't deliver Marketing to US numbers."

#: src/features/onboarding/import/mapImportRows.ts
msgid "Método de ponche no reconocido: se usa Selfie"
msgstr "Punch method not recognized: using Selfie"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "MG"
msgstr "GM"

#: src/features/worker/components/MobileShell.tsx
msgid "Mi correo"
msgstr "My email"

#: src/features/team/pages/HotelTeamPage.tsx
#: src/features/team/pages/RecruitmentTeamPage.tsx
#: src/features/team/pages/TeamPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Mi Equipo"
msgstr "My Team"

#: src/features/team/pages/HotelTeamPage.tsx
msgid "Mi Equipo del Hotel es del Manager General"
msgstr "My Hotel Team belongs to the General Manager"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Mi Equipo es de la Manager de Reclutamiento"
msgstr "My Team belongs to the Recruitment Manager"

#: src/features/team/pages/TeamPage.tsx
msgid "Mi Equipo solo la ve el BDC"
msgstr "Only the BDC sees My Team"

#: src/features/worker/components/MobileShell.tsx
msgid "Mi Perfil"
msgstr "My Profile"

#: src/features/personnel/pages/PersonnelPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Mi Personal"
msgstr "My Staff"

#: src/features/territory/components/TerritoryOwnerPicker.tsx
msgid "Mi territorio"
msgstr "My Territory"

#: src/features/territory/pages/TerritoryPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Mi Territorio"
msgstr "My Territory"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "Mié"
msgstr "Wed"

#: src/features/worker/lib/noShiftMessage.ts
msgid "Mientras dure tu incapacidad no hay turnos que ponchar. Tu Inspector lleva el seguimiento."
msgstr "While you're on medical leave there are no shifts to clock. Your Inspector is following up."

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/worker/components/ChangePasswordForm.tsx
msgid "Mínimo {MIN_LENGTH} caracteres"
msgstr "At least {MIN_LENGTH} characters"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Mínimo {minLength} caracteres."
msgstr "At least {minLength} characters."

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Minúsculas y guion bajo, p. ej. aviso_turno"
msgstr "Lowercase and underscores, e.g. shift_notice"

#: src/features/messaging/components/tours.ts
msgid "Mira el detalle"
msgstr "See the details"

#: src/features/worker/components/MobileShell.tsx
msgid "Mis datos"
msgstr "My info"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "modalidad"
msgstr "hiring modality"

#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/components/PoolTable.tsx
#: src/features/recruitment/components/SelfPickFilterBar.tsx
#: src/features/recruitment/lib/profileFields.ts
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Modalidad"
msgstr "Hiring modality"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Modalidad {ordinal}"
msgstr "Hiring modality {ordinal}"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Modalidades"
msgstr "Hiring modalities"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Montaña — Denver, Salt Lake City"
msgstr "Mountain — Denver, Salt Lake City"

#: src/features/accounting/components/AddDeductionDialog.tsx
#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Monto"
msgstr "Amount"

#. placeholder {0}: money(consolidation.grossAmount)
#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Monto (16% del bruto de {0})"
msgstr "Amount (16% of the {0} gross)"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Monto de comida por día laborado"
msgstr "Meal deduction amount per day worked"

#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Monto de la deducción"
msgstr "Deduction amount"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Monto del gasto, en dólares"
msgstr "Expense amount, in dollars"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Monto por día laborado (USD)"
msgstr "Amount per day worked (USD)"

#: src/features/observability/components/CohortSection.tsx
msgid "Mostrar"
msgstr "Show"

#: src/features/auth/pages/LoginPage.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Mostrar contraseña"
msgstr "Show password"

#: src/layouts/Header.tsx
msgid "Mostrar u ocultar el menú"
msgstr "Show or hide the menu"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "motivo"
msgstr "reason"

#: src/features/contracts/components/ContractSignatureCard.tsx
#: src/features/contracts/components/UnlockContractDialog.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
#: src/features/onboarding/components/ChangeStatusDialog.tsx
#: src/features/personnel/components/ReportWorkerDialog.tsx
#: src/features/personnel/components/StandByDialog.tsx
#: src/features/recruitment/components/ChangeStateDialog.tsx
#: src/features/recruitment/components/LiftBlacklistDialog.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Motivo"
msgstr "Reason"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Motivo (obligatorio)"
msgstr "Reason (required)"

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Motivo (opcional)"
msgstr "Reason (optional)"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/SlotList.tsx
msgid "Motivo (queda en el journal, obligatorio)"
msgstr "Reason (goes to the log, required)"

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Motivo <0>(obligatorio, mínimo 4 caracteres)</0>"
msgstr "Reason <0>(required, minimum 4 characters)</0>"

#. placeholder {0}: signature.closedReason
#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Motivo de la cancelación: «{0}»"
msgstr "Cancellation reason: “{0}”"

#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "Motivo de la corrección"
msgstr "Reason for the correction"

#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "Motivo de la corrección (obligatorio)"
msgstr "Reason for the correction (required)"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Motivo de la marca manual"
msgstr "Reason for the manual punch"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Motivo del ajuste de tarifa"
msgstr "Rate adjustment reason"

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "Motivo del cierre"
msgstr "Reason for closing"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Motivo del gasto"
msgstr "Expense reason"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "Motivo del levantamiento <0>(obligatorio)</0>"
msgstr "Reason for lifting <0>(required)</0>"

#: src/features/admin/components/PendingHotelUsers.tsx
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Motivo del rechazo"
msgstr "Rejection reason"

#. placeholder {0}: signature.closedReason
#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Motivo del rechazo: «{0}»"
msgstr "Decline reason: “{0}”"

#. placeholder {0}: template.rejectionReason
#: src/features/messaging/components/MessagingTemplatesList.tsx
#: src/features/messaging/components/TemplateDetailDialog.tsx
msgid "Motivo del rechazo: {0}"
msgstr "Rejection reason: {0}"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Motivo del regreso (obligatorio):"
msgstr "Reason for sending it back (required):"

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "Motivo del reporte"
msgstr "Reason for the report"

#: src/features/personnel/components/StandByDialog.tsx
msgid "Motivo del Stand-by"
msgstr "Reason for Stand-by"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Motivo del veto <0>(obligatorio)</0>"
msgstr "Reason for the ban <0>(required)</0>"

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "motivo obligatorio"
msgstr "reason required"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/SlotList.tsx
msgid "Motivo para liberar el slot"
msgstr "Reason for releasing the slot"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Motivo y evidencia, obligatorios"
msgstr "Reason and evidence, both required"

#. placeholder {0}: filters.errorKey
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Motivo: {0}"
msgstr "Reason: {0}"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Motivos"
msgstr "Reasons"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Motivos de salida a Rojo · Café · Negro"
msgstr "Exit reasons to Red · Brown · Black"

#. placeholder {0}: target.label
#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "Mover con {0}"
msgstr "Move to {0}"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Multiplicador de festivo facturado"
msgstr "Billed holiday multiplier"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Multiplicador de festivo pagado"
msgstr "Paid holiday multiplier"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Multiplicador de overtime facturado"
msgstr "Billed overtime multiplier"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Multiplicadores"
msgstr "Multipliers"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Multiplicadores actualizados"
msgstr "Multipliers updated"

#: src/features/messaging/pages/MessagingPage.tsx
#: src/shared/components/ModulePlaceholder.tsx
msgid "Muy pronto estará aquí"
msgstr "Coming very soon"

#: src/features/audits/components/AuditFormDialog.tsx
msgid "N/A"
msgstr "N/A"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Nace autorizada"
msgstr "Starts out authorized"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Nace autorizada: Reclutamiento la ve en cuanto la guardas, y la urgencia corre desde ese momento."
msgstr "It starts out authorized: Recruitment sees it as soon as you save it, and urgency runs from that moment."

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Nace de la corrida de pago"
msgstr "It's born from the payment run"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Nace en Blanco al guardar"
msgstr "Starts in White once saved"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Nace en Blanco: el colaborador termina las fases 2 y 3 en su app — si lo validas con algo pendiente, tiene 1 día para completarlo."
msgstr "Born in White: the collaborator finishes phases 2 and 3 in the app — if you validate them with something still pending, they have 1 day to complete it."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Nace en Blanco: el expediente se completa por fases."
msgstr "Starts in White: the file is completed in phases."

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Nace en Borrador"
msgstr "It starts as a Draft"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Nace en Borrador con las tarifas del contrato vigente: ajusta lo que haya cambiado y actívalo cuando esté listo — el anterior sigue rigiendo hasta entonces."
msgstr "Starts as a Draft with the current contract's rates: adjust whatever changed and activate it when ready — the previous one keeps governing until then."

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Nace en Borrador: las tarifas se afinan ahí y activarlo es el paso final."
msgstr "It starts as a Draft: the rates are fine-tuned there and activating it is the final step."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Nacimiento"
msgstr "Date of birth"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Nacimiento y género"
msgstr "Date of birth and gender"

#. placeholder {0}: term.trim()
#: src/layouts/GlobalSearch.tsx
msgid "Nada coincide con «{0}». Prueba con el nombre del hotel, el folio de la requisición o el nombre del colaborador."
msgstr "Nothing matches \"{0}\". Try the hotel name, the requisition number or the collaborator's name."

#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "Nada por convertir"
msgstr "Nothing to convert"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Nada que cerrar: ya estaba pagado o aún no llega su corte."
msgstr "Nothing to close: it was already paid, or its cutoff hasn't arrived yet."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Nadie — la punta de la jerarquía"
msgstr "No one — the top of the hierarchy"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Nadie — la punta de la jerarquía del hotel"
msgstr "No one — the top of the hotel's hierarchy"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Nadie (sin jefe por ahora)"
msgstr "No one (no manager for now)"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/components/MessagingTemplatesList.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Nadie coincide"
msgstr "No matches"

#: src/shared/components/SearchableSelect.tsx
msgid "Nadie coincide con «{query}»."
msgstr "No one matches “{query}”."

#: src/features/admin/components/ColaboradorAccountsSection.tsx
msgid "Nadie coincide con «{search}»."
msgstr "No one matches “{search}”."

#: src/features/recruitment/components/PoolRoster.tsx
msgid "Nadie coincide con esa búsqueda o esos filtros. Cambia el nombre, la posición, la zona o el estado, o quítalos con «Quitar filtros»."
msgstr "No one matches that search or those filters. Change the name, position, zone or status, or clear them with “Clear filters”."

#: src/features/admin/pages/UsersPage.tsx
msgid "Nadie coincide con esa búsqueda. Prueba otro nombre, correo o rol, o quita los filtros."
msgstr "No one matches that search. Try another name, email or role, or clear the filters."

#: src/features/admin/components/HotelUsersSection.tsx
msgid "Nadie coincide con esa búsqueda. Prueba otro nombre, correo, hotel o rol, o quita los filtros."
msgstr "No one matches that search. Try another name, email, hotel or role, or clear the filters."

#: src/features/timesheet/components/TimesheetGrid.tsx
msgid "Nadie coincide con esos filtros esta semana. Cambia la requisición, el estado o el hotel."
msgstr "No one matches those filters this week. Change the requisition, the status or the hotel."

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Nadie coincide con esos filtros."
msgstr "No one matches those filters."

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "Nadie coincide con esos filtros. Cambia el nombre, la requisición, el estado, el hotel o el periodo."
msgstr "Nobody matches those filters. Change the name, requisition, status, hotel, or period."

#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Nadie coincide."
msgstr "No one matches."

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Nadie con funciones adicionales coincide con la búsqueda."
msgstr "No one with additional roles matches the search."

#: src/features/observability/components/PeopleView.tsx
msgid "Nadie de este departamento tiene actividad registrada que se pueda ver."
msgstr "Nobody in this department has recorded activity that can be viewed."

#. placeholder {0}: search.trim()
#: src/features/team/pages/HotelTeamPage.tsx
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Nadie de tu equipo se llama «{0}». Cambia la búsqueda o límpiala para ver a todos."
msgstr "No one on your team is named “{0}”. Change the search or clear it to see everyone."

#: src/features/observability/components/CohortSection.tsx
msgid "Nadie empezó a trabajar esa semana."
msgstr "Nobody started working that week."

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Nadie en la lista se llama «{search}»."
msgstr "No one on the list is named “{search}”."

#. placeholder {0}: search.trim()
#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Nadie en tu plantel se llama «{0}». Cambia la búsqueda o límpiala para ver a todos."
msgstr "No one on your staff is named \"{0}\". Change the search or clear it to see everyone."

#: src/features/admin/pages/UsersPage.tsx
msgid "Nadie está de baja. Las personas que des de baja aparecerán aquí."
msgstr "No one is deactivated. People you deactivate will show up here."

#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Nadie falta"
msgstr "Nobody is missing"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Nadie la está trabajando todavía."
msgstr "Nobody is working on it yet."

#: src/features/schedule/components/ScheduleTimelineGrid.tsx
msgid "Nadie programado todavía: los turnos aparecen conforme se cubren los slots."
msgstr "No one scheduled yet: shifts show up as slots get covered."

#: src/features/team/pages/RecruitmentTeamPage.tsx
#: src/features/team/pages/TeamPage.tsx
msgid "Nadie te reporta todavía"
msgstr "No one reports to you yet"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Nadie te reporta todavía. Asigna tu equipo en Usuarios con «Reporta a»."
msgstr "No one reports to you yet. Assign your team in Users with “Reports to”."

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Nadie tiene asignación activa en la demanda de este hotel todavía"
msgstr "Nobody has an active assignment on this hotel's demand yet"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Nadie tiene correo corporativo asignado todavía."
msgstr "No one has a company email yet."

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Nadie tiene este acceso: nadie ve la función. Dáselo a alguien abajo."
msgstr "Nobody has this access: nobody sees the feature. Grant it to someone below."

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Nadie tiene funciones adicionales: cada persona trabaja con el rol de su alta."
msgstr "No one has additional roles: everyone works with the role they were created with."

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Nadie tiene que hacer nada con este documento."
msgstr "Nobody has to do anything with this document."

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "Nadie tiene Timesheet esta semana. Las filas aparecen cuando los Supervisores registran horas."
msgstr "No one has a Timesheet this week. Rows show up once Supervisors record hours."

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Nadie tiene una asignación activa en una requisición autorizada de este hotel."
msgstr "Nobody has an active assignment on an authorized requisition for this hotel."

#: src/features/conversion/pages/ConversionPage.tsx
#: src/shared/constants/onboardingStatus.ts
msgid "Naranja"
msgstr "Orange"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "Naranja / ciclos cerrados"
msgstr "Orange / closed cycles"

#: src/shared/constants/onboardingStatus.ts
msgid "Negociación de términos"
msgstr "Negotiating terms"

#: src/shared/constants/onboardingStatus.ts
msgid "Negro"
msgstr "Black"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Neto"
msgstr "Net"

#. placeholder {0}: formatMoney(totalNet)
#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Neto {0}"
msgstr "Net {0}"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Neto a pagar"
msgstr "Net to pay"

#. placeholder {0}: search.trim()
#: src/features/team/pages/TeamPage.tsx
msgid "Ningún BD de tu equipo se llama «{0}». Cambia la búsqueda o límpiala para ver a todos."
msgstr "No BD on your team is named “{0}”. Change the search or clear it to see everyone."

#: src/features/messaging/components/MessagingWorkersList.tsx
msgid "Ningún colaborador coincide con «{search}»."
msgstr "No collaborator matches «{search}»."

#: src/features/recruitment/components/PoolCardBoard.tsx
#: src/features/recruitment/components/PoolTable.tsx
msgid "Ningún colaborador coincide con estos filtros. Cambia o quita un filtro para ver más."
msgstr "No collaborator matches these filters. Change or drop a filter to see more."

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Ningún colaborador coincide: no se sincronizaría a nadie."
msgstr "No worker matches: no one would be synced."

#: src/features/messaging/components/MessagingWorkersList.tsx
msgid "Ningún colaborador está en ese estado."
msgstr "No collaborator is in that state."

#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Ningún colaborador sin teléfono válido coincide con esos filtros."
msgstr "No worker without a valid phone matches those filters."

#: src/features/messaging/components/MessagingContactsList.tsx
msgid "Ningún contacto coincide con «{search}»."
msgstr "No contact matches «{search}»."

#: src/features/messaging/components/MessagingContactsList.tsx
msgid "Ningún contacto tiene esa etiqueta."
msgstr "No contact has that tag."

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Ningún contacto tiene esta etiqueta."
msgstr "No contact has this tag."

#: src/features/contracts/components/ContractRowList.tsx
msgid "Ningún contrato coincide"
msgstr "No contract matches"

#: src/features/contracts/components/ContractTable.tsx
msgid "Ningún contrato coincide con esos filtros. Cambia el estado, la zona o la búsqueda."
msgstr "No contract matches those filters. Change the status, the zone or the search."

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Ningún contrato con estos filtros. Prueba a quitar uno."
msgstr "No contract with these filters. Try removing one."

#. placeholder {0}: search.trim()
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Ningún departamento ni posición coincide con «{0}». Cambia la búsqueda o agrégala."
msgstr "No department or position matches “{0}”. Change the search or add it."

#: src/features/clients/pages/ClientPortfolioPage.tsx
msgid "Ningún hotel coincide con estos filtros. Cambia la búsqueda o quita un filtro."
msgstr "No hotel matches these filters. Change the search or drop a filter."

#: src/features/contracts/components/MissingContractsNotice.tsx
msgid "Ningún hotel coincide con la búsqueda."
msgstr "No hotel matches the search."

#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "Ningún hotel con ese nombre"
msgstr "No hotel with that name"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Ningún hotel con ese nombre. Prueba con otra parte del nombre."
msgstr "No hotel with that name. Try another part of the name."

#. placeholder {0}: search.trim()
#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "Ningún hotel de la cola se llama «{0}»"
msgstr "No hotel in the queue is named “{0}”"

#: src/features/territory/pages/TerritoryPage.tsx
msgid "Ningún hotel de tu territorio coincide con estos filtros. Cambia la búsqueda o elige otra zona."
msgstr "No hotel in your territory matches these filters. Change the search or pick another zone."

#: src/features/messaging/components/ReportParts.tsx
msgid "Ningún mensaje falló."
msgstr "No message failed."

#. placeholder {0}: statusLight.name
#. placeholder {1}: search.trim()
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Ningún motivo de {0} coincide con «{1}»."
msgstr "No {0} reason matches “{1}”."

#: src/shared/components/PhoneInput.tsx
msgid "Ningún país se llama así"
msgstr "No country by that name"

#. placeholder {0}: activeFilterLabels.join(' · ')
#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Ningún prospecto coincide con {0}"
msgstr "No prospect matches {0}"

#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "Ningún prospecto llegó a Rosa todavía. Un hotel entra aquí cuando su Documento de T&C se negocia y el BD lo mueve a Rosa en el Pipeline; entonces el BDC aprueba la conversión."
msgstr "No prospect has reached Pink yet. A hotel lands here when its T&C Document is being negotiated and the BD moves it to Pink in the Pipeline; then the BDC approves the conversion."

#: src/features/dashboard/components/StaleProspectList.tsx
msgid "Ningún prospecto lleva más de 7 días sin un intento de contacto."
msgstr "No prospect has gone more than 7 days without a contact attempt."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Ningún reactivo coincide con lo que buscas. Cambia el filtro o la búsqueda."
msgstr "No checklist item matches what you're looking for. Change the filter or the search."

#: src/features/recruitment/pages/SelfPickHotelPage.tsx
msgid "Ningún renglón de este hotel coincide con los filtros"
msgstr "No line at this hotel matches the filters"

#. placeholder {0}: search.trim()
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Ningún semáforo ni motivo coincide con «{0}». Cambia la búsqueda o agrégalo."
msgstr "No Status Light or reason matches “{0}”. Change the search or add it."

#. placeholder {0}: search.trim()
#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Ningún veto es de alguien llamado «{0}». Prueba otro nombre o quita la búsqueda."
msgstr "No ban belongs to anyone named “{0}”. Try another name or clear the search."

#: src/features/worker/pages/Phase3Page.tsx
msgid "Ninguna"
msgstr "None"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Ninguna campaña está en ese estado."
msgstr "No campaign is in that status."

#. placeholder {0}: periodLabel[period].toLowerCase()
#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Ninguna campaña salió en {0}."
msgstr "No campaign went out in {0}."

#: src/features/admin/components/HotelUsersSection.tsx
msgid "Ninguna cuenta de hotel está de baja. Las que des de baja aparecerán aquí."
msgstr "No hotel account is deactivated. The ones you deactivate will show up here."

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Ninguna de sus altas sigue en Blanco."
msgstr "None of the collaborators they created is still in White."

#. placeholder {0}: search.trim()
#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Ninguna etiqueta coincide con «{0}»."
msgstr "No tag matches “{0}”."

#. placeholder {0}: search.trim()
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Ninguna fila coincide con «{0}». Cambia la búsqueda o agrégala."
msgstr "No row matches “{0}”. Change the search or add it."

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Ninguna plantilla está en ese estado."
msgstr "No template is in that state."

#. placeholder {0}: department.name
#. placeholder {1}: search.trim()
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Ninguna posición de {0} coincide con «{1}»."
msgstr "No {0} position matches “{1}”."

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Ninguna posición se factura por debajo de lo que se paga"
msgstr "No position is billed below what is paid"

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Ninguna requisición coincide con {activeFiltersText}"
msgstr "No requisition matches {activeFiltersText}"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Ninguna requisición lleva más de 24 h esperando."
msgstr "No requisition has been waiting more than 24 h."

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "Ninguna semana espera aprobación"
msgstr "No week is waiting for approval"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Ninguno"
msgstr "None"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Ninguno — cubre todo el hotel"
msgstr "None — covers the whole hotel"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Ninguno — fuera de Hospitality"
msgstr "None — outside Hospitality"

#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Nivel"
msgstr "Level"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "nivel de inglés"
msgstr "English level"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Nivel de inglés"
msgstr "English level"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Niveles de inglés"
msgstr "English levels"

#: src/features/recruitment/components/PoolTable.tsx
msgid "no"
msgstr "no"

#: src/features/audits/components/AuditFormDialog.tsx
#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "No"
msgstr "Doesn't"

#: src/shared/constants/contactAttempt.ts
msgid "No contestó"
msgstr "No answer"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "No dio de alta a nadie en los últimos 30 días."
msgstr "They haven't created anyone in the last 30 days."

#: src/features/recruitment/components/ProfileProgressAvatar.tsx
msgid "No disponible por su estado"
msgstr "Not available in this status"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "No encontramos la tabla en el PDF: hace falta una fila con los títulos de las columnas. Si es un escaneo, usa Excel o CSV."
msgstr "We couldn't find the table in the PDF: it needs a row with the column titles. If it's a scan, use Excel or CSV."

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/components/ReportCharts.tsx
#: src/features/messaging/components/ReportParts.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "No entregados"
msgstr "Not delivered"

#. placeholder {0}: preview.usMarketing
#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "No enviar a los {0} números de EE. UU. (no les llegaría y Meta lo cuenta como fallo)."
msgstr "Don't send to the {0} US numbers (it wouldn't reach them and Meta counts it as a failure)."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "No está guardada porque se creó antes. Si la necesitas, ponle una nueva con «Poner contraseña»."
msgstr "It isn't saved because it was created earlier. If you need it, set a new one with “Set password”."

#: src/features/conversion/api/conversionApi.ts
msgid "No existe, y el contacto principal no tiene correo: agrégaselo para poder crearlo"
msgstr "It doesn't exist, and the main contact has no email: add one so it can be created"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "No firmó"
msgstr "Didn't sign"

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "No hay consolidados con esos filtros."
msgstr "No consolidations match those filters."

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "No hay deducciones de ese tipo esta semana."
msgstr "No deductions of that type this week."

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "No hay facturas con esos filtros."
msgstr "No invoices match those filters."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "No hay hoteles debajo de los títulos."
msgstr "There are no hotels below the titles."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "No hay hoteles libres: todos tienen ciclo abierto"
msgstr "No hotels are free: they all have an open cycle"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "No hay más personas a quien dárselo."
msgstr "There's nobody else to grant it to."

#: src/features/observability/components/TabParts.tsx
msgid "No hay nada que contar."
msgstr "There's nothing to count."

#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "No hay otra Líder en tu equipo a la cual moverla. Cuando des de alta a una Líder y te reporte, aparecerá aquí."
msgstr "There's no other Group Leader on your team to move them to. Once you create a Group Leader who reports to you, they'll show up here."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "No hay plantillas aprobadas. Sincronízalas desde Meta en la sección Plantillas."
msgstr "There are no approved templates. Sync them from Meta in the Templates section."

#: src/features/schedule/pages/SchedulePage.tsx
msgid "No hay requisiciones autorizadas para esta semana. Cuando un Manager autorice una, sus posiciones aparecerán aquí."
msgstr "There are no authorized requisitions for this week. When a Manager authorizes one, its positions will show up here."

#: src/features/dashboard/components/RecruitmentDashboard.tsx
msgid "No hay requisiciones autorizadas por ahora."
msgstr "No authorized requisitions right now."

#: src/features/timesheet/components/TimesheetViewControls.tsx
#: src/features/timesheet/components/WeekSlider.tsx
msgid "No hay semanas anteriores con datos"
msgstr "No earlier weeks with data"

#: src/features/timesheet/components/TimesheetViewControls.tsx
msgid "No hay semanas más recientes con datos"
msgstr "No later weeks with data"

#: src/features/recruitment/pages/SelfPickPage.tsx
msgid "No hay slots libres con estos filtros. La Bolsa se llena cuando un hotel crea una requisición; prueba a quitar un filtro."
msgstr "No free slots with these filters. The Self-Pick pool fills up when a hotel creates a requisition; try dropping a filter."

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "No hay vetos con estos filtros. Prueba con otro origen o con el historial completo."
msgstr "No bans with these filters. Try another source or the full history."

#: src/features/admin/components/UserFormDialog.tsx
msgid "No hay zonas en el catálogo todavía."
msgstr "There are no zones in the catalog yet."

#: src/shared/constants/contactAttempt.ts
msgid "No interesado"
msgstr "Not interested"

#: src/features/worker/pages/NotificationsPage.tsx
msgid "No leído"
msgstr "Unread"

#: src/features/audits/pages/AuditsPage.tsx
msgid "No mueve ningún semáforo. Inspecciona cuando quieras antes del corte semanal — el sistema te avisa conforme se acerca."
msgstr "It doesn't move any status light. Inspect whenever you like before the weekly cutoff — the system reminds you as it gets closer."

#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "No paga horas extra"
msgstr "Doesn't pay overtime"

#: src/features/worker/components/TaxDeadlineBanner.tsx
msgid "No pasó la revisión."
msgstr "It didn't pass review."

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "No pudimos conectar con Oranje. Revisa tu conexión e inténtalo en un momento."
msgstr "We couldn't reach Oranje. Check your connection and try again in a moment."

#: src/features/observability/components/PeopleView.tsx
msgid "No registró nada en el periodo."
msgstr "Didn't log anything in the period."

#: src/features/timesheet/components/WorkerWeekSummary.tsx
msgid "No registró ni una marca esta semana: no hay timesheet que enviar ni aprobar."
msgstr "Didn't log a single punch this week: there's no timesheet to send or approve."

#: src/features/observability/lib/cohorts.ts
#: src/shared/constants/workerStatus.ts
msgid "No regresó"
msgstr "Didn't return"

#: src/features/team/pages/HotelTeamPage.tsx
msgid "No reportan a ningún Manager de Área de tu hotel."
msgstr "They don't report to any Area Manager at your hotel."

#: src/features/recruitment/components/SelfPickPositionCard.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/shared/constants/catalogs.ts
msgid "No requerido"
msgstr "Not required"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "No salió"
msgstr "Didn't send"

#: src/shared/constants/workerEnums.ts
msgid "No sé"
msgstr "Don't know"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "No se archiva: si algo del sistema lo está usando, la propia base lo protege y te lo dice."
msgstr "It isn't archived: if something in the system is using it, the database itself protects it and tells you."

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "No se cerró nada esta vez."
msgstr "Nothing was closed this time."

#: src/features/contracts/components/MultiplierTable.tsx
msgid "No se descuenta"
msgstr "Not deducted"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "No se encontró al colaborador: puede que el enlace sea viejo o que ya no esté en el Pool."
msgstr "We couldn't find the collaborator: the link may be old, or they may no longer be in the Pool."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "No se encontró esta posición: puede que ya se haya cubierto o eliminado."
msgstr "We couldn't find this position: it may already be covered or deleted."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "No se encontró la requisición: puede que se haya eliminado o que el enlace sea viejo."
msgstr "The requisition wasn't found: it may have been deleted or the link may be old."

#. placeholder {0}: result.withoutPhone
#. placeholder {1}: result.invalidPhone + result.rejected
#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "No se enviaron {skipped}: {0} sin teléfono y {1} con teléfono inválido."
msgstr "{skipped} were not sent: {0} without a phone and {1} with an invalid phone."

#: src/features/worker/pages/PunchPage.tsx
msgid "No se guardó"
msgstr "Not saved"

#: src/features/worker/components/MobileShell.tsx
#: src/layouts/Sidebar.tsx
msgid "No se guardó tu idioma: al volver a entrar puede regresar a español."
msgstr "Your language wasn't saved: it may switch back to Spanish next time you sign in."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "No se importaron"
msgstr "Not imported"

#: src/features/admin/components/UserFormDialog.tsx
msgid "No se podrá cambiar después del alta: es el correo con el que la persona entra."
msgstr "It can't be changed after intake: it's the email they sign in with."

#: src/shared/constants/workerStatus.ts
msgid "No se presentó a trabajar por su cuenta."
msgstr "Did not show up to work, on their own."

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "No se pudieron cargar las campañas."
msgstr "Campaigns could not be loaded."

#: src/features/admin/components/HotelUsersSection.tsx
msgid "No se pudieron cargar las cuentas de los hoteles. Reintenta en unos segundos."
msgstr "We couldn't load the hotel accounts. Try again in a few seconds."

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "No se pudieron cargar las deducciones. Reintenta en unos segundos."
msgstr "Couldn't load the deductions. Try again in a few seconds."

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "No se pudieron cargar las etiquetas."
msgstr "Couldn't load the tags."

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "No se pudieron cargar las facturas. Reintenta en unos segundos."
msgstr "Invoices could not be loaded. Try again in a few seconds."

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "No se pudieron cargar las funciones adicionales."
msgstr "Couldn't load the additional roles."

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "No se pudieron cargar las plantillas."
msgstr "Templates could not be loaded."

#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "No se pudieron cargar las propuestas. Reintenta en unos segundos."
msgstr "We couldn't load the proposals. Try again in a few seconds."

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "No se pudieron cargar las semanas sin aprobar. Reintenta en unos segundos."
msgstr "Could not load the weeks awaiting approval. Try again in a few seconds."

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "No se pudieron cargar los accesos especiales."
msgstr "Special access couldn't be loaded."

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "No se pudieron cargar los ajustes del correo."
msgstr "The email settings couldn't be loaded."

#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "No se pudieron cargar los ajustes pendientes. Reintenta en unos segundos."
msgstr "Couldn't load the pending adjustments. Try again in a few seconds."

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
msgid "No se pudieron cargar los ajustes. Reintenta en unos segundos."
msgstr "The adjustments could not be loaded. Try again in a few seconds."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "No se pudieron cargar los catálogos. Reintenta en unos segundos."
msgstr "We couldn't load the catalogs. Try again in a few seconds."

#: src/features/messaging/components/MessagingWorkersList.tsx
msgid "No se pudieron cargar los colaboradores."
msgstr "Collaborators could not be loaded."

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "No se pudieron cargar los consolidados. Reintenta en unos segundos."
msgstr "Consolidations could not be loaded. Try again in a few seconds."

#: src/features/messaging/components/MessagingContactsList.tsx
msgid "No se pudieron cargar los contactos."
msgstr "Contacts could not be loaded."

#: src/features/contracts/pages/ContractListPage.tsx
msgid "No se pudieron cargar los contratos. Reintenta en unos segundos."
msgstr "The contracts could not be loaded. Try again in a few seconds."

#: src/features/onboarding/components/HotelGlobeCard.tsx
msgid "No se pudieron cargar los hoteles del mapa. Recarga la página para reintentar."
msgstr "We couldn't load the hotels on the map. Reload the page to try again."

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "No se pudieron cargar los hoteles. Reintenta en unos segundos."
msgstr "The hotels couldn't be loaded. Try again in a few seconds."

#: src/features/observability/components/TabParts.tsx
msgid "No se pudieron cargar los indicadores."
msgstr "The indicators couldn't be loaded."

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "No se pudieron cargar los límites de pago."
msgstr "The payment limits could not be loaded."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "No se pudieron cargar los reactivos. Reintenta en unos segundos."
msgstr "We couldn't load the checklist items. Try again in a few seconds."

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "No se pudieron cargar los reportes."
msgstr "Couldn't load the reports."

#: src/features/admin/pages/UsersPage.tsx
msgid "No se pudieron cargar los usuarios. Reintenta en unos segundos."
msgstr "We couldn't load the users. Try again in a few seconds."

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "No se pudieron guardar los límites. Inténtalo de nuevo."
msgstr "The limits could not be saved. Try again."

#: src/features/worker/pages/Phase3Page.tsx
msgid "No se pudieron guardar tus datos. Inténtalo de nuevo."
msgstr "Your info couldn't be saved. Try again."

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "No se pudieron sincronizar las plantillas."
msgstr "Templates could not be synced."

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "No se pudieron sincronizar los colaboradores."
msgstr "Workers could not be synced."

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "No se pudo abrir DocuSign. Inténtalo de nuevo."
msgstr "Couldn't open DocuSign. Try again."

#: src/features/onboarding/components/CreateProposalPromptDialog.tsx
msgid "No se pudo abrir el borrador. Ciérralo e inténtalo de nuevo desde la ficha del prospecto."
msgstr "Couldn't open the draft. Close this and try again from the prospect's profile."

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "No se pudo abrir el borrador. Reintenta en unos segundos."
msgstr "The draft couldn't be opened. Try again in a few seconds."

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "No se pudo abrir el documento firmado."
msgstr "Couldn't open the signed document."

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "No se pudo abrir esta factura. Puede que ya no exista."
msgstr "This invoice could not be opened. It may no longer exist."

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "No se pudo abrir este consolidado. Puede que ya no exista."
msgstr "This consolidation could not be opened. It may no longer exist."

#: src/features/worker/components/CameraCapture.tsx
#: src/features/worker/components/QrScanner.tsx
msgid "No se pudo abrir la cámara. Cierra otras apps que la usen e inténtalo de nuevo."
msgstr "The camera couldn't be opened. Close other apps using it and try again."

#: src/app/RouteErrorPage.tsx
msgid "No se pudo abrir la versión nueva de Oranje. Vuelve a cargar la página; si sigue igual, cierra la pestaña y ábrela de nuevo."
msgstr "We couldn't open the new version of Oranje. Reload the page; if it still fails, close the tab and open it again."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "No se pudo abrir la versión. Inténtalo de nuevo."
msgstr "Couldn't open the version. Try again."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "No se pudo aceptar la retención. Inténtalo de nuevo."
msgstr "Couldn't accept the retention. Try again."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "No se pudo actualizar. Inténtalo de nuevo."
msgstr "It couldn't be updated. Try again."

#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "No se pudo actualizar. Reintenta en unos segundos."
msgstr "Couldn't update. Try again in a few seconds."

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "No se pudo agregar el turno. Inténtalo de nuevo."
msgstr "The shift couldn't be added. Try again."

#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "No se pudo agregar la deducción. Reintenta."
msgstr "Couldn't add the deduction. Try again."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "No se pudo aprobar la conversión. Inténtalo de nuevo."
msgstr "Couldn't approve the conversion. Try again."

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "No se pudo aprobar la factura. Reintenta."
msgstr "The invoice could not be approved. Try again."

#: src/features/admin/components/PendingHotelUsers.tsx
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "No se pudo aprobar. Inténtalo de nuevo."
msgstr "Could not approve. Try again."

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "No se pudo archivar el ciclo. Inténtalo de nuevo."
msgstr "We couldn't archive the cycle. Try again."

#: src/features/reports/pages/ReportsPage.tsx
msgid "No se pudo armar el reporte. Reintenta en unos segundos."
msgstr "We couldn't build the report. Try again in a few seconds."

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "No se pudo armar este reporte. Reintenta en unos segundos."
msgstr "This report couldn't be built. Try again in a few seconds."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "No se pudo asignar al colaborador. Inténtalo de nuevo."
msgstr "We couldn't assign the collaborator. Try again."

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "No se pudo autorizar el pago. Reintenta."
msgstr "The payment could not be authorized. Try again."

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "No se pudo borrar el archivo. Inténtalo de nuevo."
msgstr "We couldn't delete the file. Try again."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "No se pudo borrar el documento. Inténtalo de nuevo."
msgstr "We couldn't delete the document. Try again."

#: src/features/accounting/pages/PendingApprovalsPage.tsx
#: src/features/observability/pages/ObservabilityPage.tsx
msgid "No se pudo calcular la aprobación oportuna. Reintenta en unos segundos."
msgstr "Could not calculate timely approval. Try again in a few seconds."

#: src/layouts/RoleSwitcher.tsx
msgid "No se pudo cambiar de función. Inténtalo de nuevo."
msgstr "Couldn't switch roles. Try again."

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "No se pudo cambiar el acceso. Inténtalo de nuevo."
msgstr "The access couldn't be changed. Try again."

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "No se pudo cambiar el ajuste. Inténtalo de nuevo."
msgstr "The setting couldn't be changed. Try again."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "No se pudo cambiar el estado del contrato. Inténtalo de nuevo."
msgstr "The contract's status could not be changed. Try again."

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "No se pudo cambiar el estado. Inténtalo de nuevo."
msgstr "We couldn't change the status. Try again."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "No se pudo cambiar el estado. Revisa el motivo e inténtalo de nuevo."
msgstr "We couldn't change the status. Check the reason and try again."

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
#: src/features/worker/components/ChangePasswordForm.tsx
msgid "No se pudo cambiar la contraseña. Inténtalo de nuevo."
msgstr "The password could not be changed. Try again."

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "No se pudo cambiar la semana. Inténtalo de nuevo."
msgstr "The week couldn't be changed. Try again."

#: src/features/worker/pages/HomePage.tsx
msgid "No se pudo cambiar tu disponibilidad. Inténtalo de nuevo."
msgstr "Your availability couldn't be changed. Try again."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "No se pudo cambiar. Inténtalo de nuevo."
msgstr "Couldn't change it. Try again."

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "No se pudo cancelar el envío. Inténtalo de nuevo."
msgstr "Couldn't cancel the request. Try again."

#: src/features/clients/pages/ClientPortfolioPage.tsx
msgid "No se pudo cargar Clientes Activos. Reintenta en unos segundos."
msgstr "We couldn't load Active Clients. Try again in a few seconds."

#: src/features/dashboard/components/HotelDashboard.tsx
#: src/features/dashboard/components/RecruitmentDashboard.tsx
#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
#: src/features/dashboard/components/SalesDashboard.tsx
msgid "No se pudo cargar el dashboard. Reintenta en unos segundos."
msgstr "The dashboard couldn't be loaded. Try again in a few seconds."

#: src/features/messaging/components/TemplateDetailDialog.tsx
msgid "No se pudo cargar el detalle de la plantilla."
msgstr "Couldn't load the template details."

#: src/features/audits/components/AuditHistoryList.tsx
msgid "No se pudo cargar el historial de inspecciones. Inténtalo de nuevo."
msgstr "The inspection history couldn't be loaded. Try again."

#: src/features/messaging/components/MessagingOverviewPanel.tsx
msgid "No se pudo cargar el Panel de Mensajería."
msgstr "The Messaging overview could not be loaded."

#: src/features/onboarding/pages/PipelinePage.tsx
msgid "No se pudo cargar el Pipeline. Reintenta en unos segundos."
msgstr "We couldn't load the Pipeline. Try again in a few seconds."

#: src/features/audits/components/AuditWorkerList.tsx
msgid "No se pudo cargar el plantel del hotel. Inténtalo de nuevo."
msgstr "The hotel's staff couldn't be loaded. Try again."

#: src/features/recruitment/pages/PoolPage.tsx
msgid "No se pudo cargar el Pool de Colaboradores. Revisa tu conexión e inténtalo de nuevo."
msgstr "We couldn't load the Collaborator Pool. Check your connection and try again."

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "No se pudo cargar el QR. Inténtalo de nuevo."
msgstr "The QR couldn't be loaded. Try again."

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "No se pudo cargar el reporte."
msgstr "Couldn't load the report."

#: src/features/schedule/pages/SchedulePage.tsx
msgid "No se pudo cargar el Schedule. Revisa tu conexión e inténtalo de nuevo."
msgstr "The Schedule couldn't be loaded. Check your connection and try again."

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "No se pudo cargar el Tablero de Requisiciones. Revisa tu conexión e inténtalo de nuevo."
msgstr "The Requisition Board couldn't be loaded. Check your connection and try again."

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "No se pudo cargar el Timesheet. Reintenta en unos segundos."
msgstr "The Timesheet could not be loaded. Try again in a few seconds."

#: src/features/requisitions/components/RequisitionJournalDialog.tsx
msgid "No se pudo cargar la bitácora. Inténtalo de nuevo."
msgstr "The log couldn't be loaded. Try again."

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "No se pudo cargar la Blacklist. Revisa tu conexión e inténtalo de nuevo."
msgstr "We couldn't load the Blacklist. Check your connection and try again."

#: src/features/recruitment/pages/SelfPickHotelPage.tsx
#: src/features/recruitment/pages/SelfPickPage.tsx
msgid "No se pudo cargar la Bolsa de Self-Pick. Revisa tu conexión e inténtalo de nuevo."
msgstr "We couldn't load the Self-Pick pool. Check your connection and try again."

#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "No se pudo cargar la cola de Conversión. Reintenta en unos segundos."
msgstr "We couldn't load the Conversion queue. Try again in a few seconds."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "No se pudo cargar la conversión de este hotel. Recarga la página para reintentar."
msgstr "We couldn't load this hotel's conversion. Reload the page to try again."

#: src/features/admin/components/ColaboradorAccountsSection.tsx
msgid "No se pudo cargar la lista de colaboradores."
msgstr "We couldn't load the list of collaborators."

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "No se pudo cargar la lista de correos corporativos."
msgstr "We couldn't load the list of company emails."

#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "No se pudo cargar la lista."
msgstr "The list could not be loaded."

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "No se pudo cargar la propuesta de este hotel."
msgstr "This hotel's proposal couldn't be loaded."

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "No se pudo cargar la semana del Timesheet Global. Reintenta en unos segundos."
msgstr "The Global Timesheet week couldn't be loaded. Try again in a few seconds."

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "No se pudo cargar la semana del Timesheet. Reintenta en unos segundos."
msgstr "The Timesheet week couldn't be loaded. Try again in a few seconds."

#: src/features/team/pages/RecruitmentTeamPage.tsx
#: src/features/team/pages/TeamPage.tsx
msgid "No se pudo cargar Mi Equipo. Reintenta en unos segundos."
msgstr "We couldn't load My Team. Try again in a few seconds."

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "No se pudo cargar Mi Personal. Revisa tu conexión e inténtalo de nuevo."
msgstr "My Staff couldn't be loaded. Check your connection and try again."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "No se pudo cargar su acceso."
msgstr "Couldn't load their access."

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
#: src/features/team/pages/HotelTeamPage.tsx
msgid "No se pudo cargar tu equipo. Reintenta en unos segundos."
msgstr "Your team couldn't be loaded. Try again in a few seconds."

#: src/features/territory/pages/TerritoryPage.tsx
msgid "No se pudo cargar tu territorio. Reintenta."
msgstr "We couldn't load your territory. Try again."

#: src/features/worker/pages/PunchPage.tsx
msgid "No se pudo cargar tu turno."
msgstr "Your shift couldn't be loaded."

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "No se pudo cerrar la semana. Reintenta."
msgstr "Couldn't close the week. Try again."

#: src/features/messaging/components/ContactActions.tsx
#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "No se pudo completar la acción."
msgstr "The action could not be completed."

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "No se pudo completar la operación. Inténtalo de nuevo."
msgstr "We couldn't finish the operation. Try again."

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "No se pudo copiar. Anótalo a mano."
msgstr "It couldn't be copied. Write it down by hand."

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "No se pudo corregir el intento. Solo su autor puede hacerlo."
msgstr "We couldn't correct the attempt. Only the person who logged it can."

#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "No se pudo corregir la marca. Inténtalo de nuevo."
msgstr "Couldn't correct the punch. Try again."

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "No se pudo crear el acceso. Inténtalo de nuevo."
msgstr "Access could not be created. Try again."

#: src/features/contracts/components/NewContractDialog.tsx
msgid "No se pudo crear el contrato. Revisa los datos e inténtalo de nuevo."
msgstr "The contract could not be created. Check the details and try again."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "No se pudo crear la campaña."
msgstr "The campaign could not be created."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "No se pudo crear la cuenta del hotel. Inténtalo de nuevo."
msgstr "The hotel account could not be created. Try again."

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "No se pudo crear la cuenta. Inténtalo de nuevo."
msgstr "The account could not be created. Try again."

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "No se pudo crear la etiqueta."
msgstr "Couldn't create the tag."

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "No se pudo crear la lista."
msgstr "Couldn't create the list."

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "No se pudo dar el acceso. Inténtalo de nuevo."
msgstr "The access couldn't be granted. Try again."

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "No se pudo dar la función. Inténtalo de nuevo."
msgstr "Couldn't grant the role. Try again."

#: src/features/contracts/components/UnlockContractDialog.tsx
msgid "No se pudo desbloquear. Inténtalo de nuevo."
msgstr "Couldn't unlock. Try again."

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "No se pudo descargar el CSV."
msgstr "Couldn't download the CSV."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "No se pudo descartar el borrador. Inténtalo de nuevo."
msgstr "We couldn't discard the draft. Try again."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "No se pudo devolver a Café. Inténtalo de nuevo."
msgstr "Couldn't return to Brown. Try again."

#: src/features/recruitment/components/DeleteWorkerDialog.tsx
msgid "No se pudo eliminar al colaborador. Inténtalo de nuevo."
msgstr "We couldn't delete the collaborator. Try again."

#: src/features/onboarding/components/DeleteHotelAction.tsx
msgid "No se pudo eliminar el hotel. Reintenta."
msgstr "Couldn't delete the hotel. Try again."

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "No se pudo eliminar la etiqueta."
msgstr "Couldn't delete the tag."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "No se pudo eliminar la requisición. Inténtalo de nuevo."
msgstr "The requisition couldn't be deleted. Try again."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/admin/pages/CatalogsPage.tsx
msgid "No se pudo eliminar. Inténtalo de nuevo."
msgstr "We couldn't delete it. Try again."

#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "No se pudo enviar la campaña."
msgstr "Couldn't send the campaign."

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "No se pudo generar el PDF. Inténtalo de nuevo."
msgstr "Couldn't generate the PDF. Try again."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "No se pudo generar la vista previa — el enlace firmado venció. Cierra y vuelve a abrir el expediente."
msgstr "Couldn't generate the preview — the signed link expired. Close and reopen the profile."

#: src/mobile/nativeDownloads.ts
msgid "No se pudo guardar el archivo. Inténtalo de nuevo."
msgstr "The file couldn't be saved. Try again."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "No se pudo guardar el colaborador. Revisa los datos e inténtalo de nuevo."
msgstr "We couldn't save the collaborator. Check the details and try again."

#: src/features/messaging/components/ContactActions.tsx
msgid "No se pudo guardar el contacto."
msgstr "The contact could not be saved."

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "No se pudo guardar el contacto. Revisa los datos e inténtalo de nuevo."
msgstr "We couldn't save the contact. Check the details and try again."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "No se pudo guardar el nuevo orden: vuelve a intentarlo."
msgstr "We couldn't save the new order: try again."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "No se pudo guardar el prospecto. Revisa los datos e inténtalo de nuevo."
msgstr "We couldn't save the prospect. Check the details and try again."

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "No se pudo guardar el territorio. Inténtalo de nuevo."
msgstr "We couldn't save the territory. Try again."

#: src/features/worker/pages/Phase2Page.tsx
msgid "No se pudo guardar el transporte."
msgstr "Your transportation couldn't be saved."

#: src/features/admin/components/UserFormDialog.tsx
msgid "No se pudo guardar el usuario. Revisa los datos e inténtalo de nuevo."
msgstr "We couldn't save the user. Check the details and try again."

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "No se pudo guardar la corrección."
msgstr "Couldn't save the correction."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "No se pudo guardar la cuenta. Revisa los datos e inténtalo de nuevo."
msgstr "We couldn't save the account. Check the details and try again."

#: src/features/audits/components/AuditFormDialog.tsx
msgid "No se pudo guardar la inspección. Inténtalo de nuevo."
msgstr "The inspection couldn't be saved. Try again."

#: src/features/worker/pages/PunchPage.tsx
msgid "No se pudo guardar la marca. Inténtalo de nuevo."
msgstr "The punch couldn't be saved. Try again."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "No se pudo guardar la propuesta. Revisa las tarifas e inténtalo de nuevo."
msgstr "We couldn't save the proposal. Check the rates and try again."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "No se pudo guardar la requisición. Revisa las posiciones e inténtalo de nuevo."
msgstr "The requisition couldn't be saved. Check the positions and try again."

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "No se pudo guardar la revisión. Inténtalo de nuevo."
msgstr "The review couldn't be saved. Try again."

#: src/features/contracts/components/EditRateDialog.tsx
msgid "No se pudo guardar la tarifa. Inténtalo de nuevo."
msgstr "The rate could not be saved. Try again."

#: src/features/contracts/components/MultiplierTable.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "No se pudo guardar. Inténtalo de nuevo."
msgstr "Couldn't save. Try again."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "No se pudo guardar. Revisa el nombre e inténtalo de nuevo."
msgstr "We couldn't save it. Check the name and try again."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "No se pudo guardar. Revisa los campos e inténtalo de nuevo."
msgstr "We couldn't save it. Check the fields and try again."

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "No se pudo importar el archivo."
msgstr "The file could not be imported."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "No se pudo importar esta fila"
msgstr "This row couldn't be imported"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "No se pudo importar. Inténtalo de nuevo."
msgstr "The import failed. Try again."

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
#: src/features/timesheet/components/PendingAdjustmentsChip.tsx
msgid "No se pudo incluir. Inténtalo de nuevo."
msgstr "Could not include it. Try again."

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "No se pudo leer el archivo."
msgstr "The file could not be read."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "No se pudo leer el archivo. Revisa que no esté dañado ni protegido con contraseña."
msgstr "The file couldn't be read. Check that it isn't damaged or password-protected."

#: src/features/worker/pages/PunchPage.tsx
msgid "No se pudo leer tu ubicación. Sal a cielo abierto e inténtalo de nuevo."
msgstr "Your location couldn't be read. Step outside under open sky and try again."

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "No se pudo levantar el veto. Inténtalo de nuevo."
msgstr "We couldn't lift the ban. Try again."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/SlotList.tsx
msgid "No se pudo liberar el slot. Inténtalo de nuevo."
msgstr "We couldn't release the slot. Try again."

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "No se pudo mandar a firma. Inténtalo de nuevo."
msgstr "Couldn't send it for signature. Try again."

#: src/features/personnel/components/StandByDialog.tsx
msgid "No se pudo mandar a Stand-by. Inténtalo de nuevo."
msgstr "They couldn't be sent to Stand-by. Try again."

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "No se pudo mandar el correo — inténtalo de nuevo o mándalo tú aparte."
msgstr "The email couldn't be sent — try again or send it yourself separately."

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "No se pudo mandar el correo."
msgstr "The email couldn't be sent."

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "No se pudo mandar la plantilla a Meta."
msgstr "Couldn't submit the template to Meta."

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "No se pudo marcar como enviado. Reintenta en unos segundos."
msgstr "Couldn't mark it as sent. Try again in a few seconds."

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "No se pudo marcar como revisado. Reintenta."
msgstr "It could not be marked as reviewed. Try again."

#: src/features/timesheet/components/AttendanceView.tsx
msgid "No se pudo marcar el día. Reintenta."
msgstr "We couldn't mark the day. Try again."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "No se pudo mostrar. Inténtalo de nuevo."
msgstr "Couldn't show it. Try again."

#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "No se pudo mover. Reintenta en unos segundos."
msgstr "The move didn't go through. Try again in a few seconds."

#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "No se pudo programar la campaña."
msgstr "Couldn't schedule the campaign."

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "No se pudo quitar el acceso. Inténtalo de nuevo."
msgstr "The access couldn't be removed. Try again."

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "No se pudo quitar la corrección."
msgstr "Couldn't remove the correction."

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "No se pudo quitar la deducción. Reintenta."
msgstr "Couldn't remove the deduction. Try again."

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "No se pudo quitar la función. Inténtalo de nuevo."
msgstr "Couldn't remove the role. Try again."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "No se pudo quitar la retención. Inténtalo de nuevo."
msgstr "Couldn't remove the retention. Try again."

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "No se pudo recalcular la factura. Reintenta."
msgstr "The invoice couldn't be recalculated. Try again."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "No se pudo rechazar el documento. Inténtalo de nuevo."
msgstr "The document couldn't be rejected. Try again."

#: src/features/admin/components/PendingHotelUsers.tsx
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "No se pudo rechazar. Inténtalo de nuevo."
msgstr "Couldn't reject it. Try again."

#: src/features/admin/components/UserFormDialog.tsx
msgid "No se pudo reenviar la invitación. Inténtalo de nuevo."
msgstr "Couldn't resend the invitation. Try again."

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "No se pudo regenerar el QR. Inténtalo de nuevo."
msgstr "The QR couldn't be regenerated. Try again."

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "No se pudo registrar el cobro. Reintenta."
msgstr "The collection could not be recorded. Try again."

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "No se pudo registrar el envío. Reintenta."
msgstr "The sending could not be recorded. Try again."

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "No se pudo registrar el intento. Revisa los datos e inténtalo de nuevo."
msgstr "We couldn't log the attempt. Check the details and try again."

#: src/features/accounting/components/PayConsolidationButton.tsx
msgid "No se pudo registrar el pago. Reintenta."
msgstr "The payment could not be recorded. Try again."

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "No se pudo registrar el veto. Revisa que la persona no esté en Gris ni tenga ya un veto vigente, e inténtalo de nuevo."
msgstr "We couldn't register the ban. Check that the person isn't in Gray and doesn't already have an active ban, then try again."

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "No se pudo registrar la marca. Inténtalo de nuevo."
msgstr "The punch couldn't be recorded. Try again."

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "No se pudo renombrar el archivo. Inténtalo de nuevo."
msgstr "We couldn't rename the file. Try again."

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "No se pudo reportar al colaborador. Inténtalo de nuevo."
msgstr "The Collaborator couldn't be reported. Try again."

#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "No se pudo revisar la campaña antes de enviarla."
msgstr "Couldn't check the campaign before sending it."

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "No se pudo subir el archivo. Inténtalo de nuevo."
msgstr "We couldn't upload the file. Try again."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "No se pudo subir el documento. Inténtalo de nuevo."
msgstr "We couldn't upload the document. Try again."

#: src/features/admin/components/UserFormDialog.tsx
msgid "No se pudo subir la foto. Intenta con otra imagen."
msgstr "We couldn't upload the photo. Try another image."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "No se pudo subir la foto. Revisa tu conexión e inténtalo de nuevo."
msgstr "We couldn't upload the photo. Check your connection and try again."

#: src/features/worker/components/TaxDocumentUploader.tsx
msgid "No se pudo subir tu documento. Inténtalo de nuevo."
msgstr "Your document couldn't be uploaded. Try again."

#: src/features/worker/components/PhotoUploader.tsx
msgid "No se pudo subir tu foto. Inténtalo de nuevo."
msgstr "We couldn't upload your photo. Try again."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "No se pudo tomar la requisición. Inténtalo de nuevo."
msgstr "Couldn't take the requisition. Try again."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "No se pudo verificar el documento. Inténtalo de nuevo."
msgstr "Couldn't verify the document. Try again."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "No se puede activar sin tarifas: agrega al menos una."
msgstr "It cannot be activated without rates: add at least one."

#: src/features/audits/components/AuditFormDialog.tsx
msgid "No se puede calificar una inspección donde todo quedó en N/A."
msgstr "An inspection can't be scored when everything is N/A."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "No se puede leer la guardada. Ponle una nueva."
msgstr "The saved one can't be read. Set a new one."

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
msgid "No se pueden sincronizar, así que no les llegan las campañas. Corrige su teléfono en su expediente y vuelve a sincronizar."
msgstr "They can't be synced, so campaigns don't reach them. Fix their phone in their file and sync again."

#: src/features/timesheet/components/TimesheetDayCell.tsx
msgid "No se registró entrada ni salida. Puede ser que no tuviera turno ese día, o que el ponche no llegara a guardarse (por ejemplo, fuera de la geocerca). Revisa el Schedule para saber cuál de las dos fue."
msgstr "No clock-in or clock-out was recorded. Either there was no shift that day, or the punch never got saved (outside the geofence, for example). Check the Schedule to find out which."

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "No se sincronizan con Mensajería, así que ninguna campaña les llega. Corrige el teléfono en su expediente."
msgstr "They are not synced with Messaging, so no campaign reaches them. Fix the phone in their profile."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "No sirve (ilegible, incorrecto…): se le vuelve a pedir al colaborador."
msgstr "It doesn't work (illegible, incorrect…): the collaborator will be asked to upload it again."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "No tiene correo @oranjepeople.com."
msgstr "They don't have an @oranjepeople.com email."

#: src/features/contracts/components/ContractNextStep.tsx
msgid "No tiene fecha de fin: rige hasta que alguien lo marque expirado."
msgstr "It has no end date: it applies until someone marks it expired."

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "No tiene servidor de correo configurado, así que todo sale por Firebase. El interruptor de abajo no cambia nada hasta que se configure."
msgstr "It has no email server configured, so everything goes out through Firebase. The switch below changes nothing until one is set up."

#: src/features/worker/pages/Phase2Page.tsx
msgid "No tienes nada pendiente aquí. Esto es lo que quedó registrado; si algo cambió, corrígelo."
msgstr "You have nothing pending here. This is what we have on file — if something changed, update it."

#: src/features/worker/lib/noShiftMessage.ts
msgid "No tienes turno programado hoy. Si sí te tocaba, avísale a tu Supervisor para que revise el Schedule."
msgstr "You have no shift scheduled today. If you were supposed to, let your Supervisor know so they check the Schedule."

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "no va con su otra función"
msgstr "conflicts with their other role"

#: src/features/worker/components/useFaceGuide.ts
msgid "No vemos tu cara: mira a la cámara"
msgstr "We can't see your face: look at the camera"

#: src/features/observability/lib/recruitmentKpis.ts
msgid "No-show del día 1"
msgstr "Day 1 no-show"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "No, dejarlo"
msgstr "No, keep it"

#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/components/TemplateFormDialog.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
#: src/features/onboarding/components/PlacesAutofillSummary.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/recruitment/components/PoolTable.tsx
#: src/features/worker/pages/Phase3Page.tsx
msgid "Nombre"
msgstr "Name"

#: src/features/messaging/components/ContactActions.tsx
#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Nombre *"
msgstr "First name *"

#: src/features/clients/types/client.types.ts
msgid "nombre A–Z"
msgstr "name A–Z"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/contracts/components/SignAndSendDialog.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Nombre completo"
msgstr "Full name"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Nombre completo del contacto"
msgstr "Contact's full name"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Nombre de la industria, p. ej. Retail…"
msgstr "Industry name, e.g. Retail…"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Nombre de la modalidad, p. ej. Tiempo completo…"
msgstr "Hiring modality name, e.g. Full-time…"

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Nombre de la persona…"
msgstr "Person's name…"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Nombre de la posición, p. ej. Steward…"
msgstr "Position name, e.g. Steward…"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Nombre de la propiedad"
msgstr "Property name"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Nombre de la zona, p. ej. Riviera Maya…"
msgstr "Zone name, e.g. Riviera Maya…"

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Nombre del archivo"
msgstr "File name"

#: src/features/team/pages/TeamPage.tsx
msgid "Nombre del BD, p. ej. Rocío Lima…"
msgstr "BD's name, e.g. Rocío Lima…"

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Nombre del colaborador"
msgstr "Worker name"

#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "Nombre del colaborador, p. ej. Ana Rivera…"
msgstr "Collaborator's name, e.g. Ana Rivera…"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Nombre del concepto, p. ej. Uber…"
msgstr "Concept name, e.g. Uber…"

#: src/features/messaging/components/CreateCampaignDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Nombre del contacto"
msgstr "Contact name"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Nombre del contacto de emergencia"
msgstr "Emergency contact name"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Nombre del estado, p. ej. Descanso…"
msgstr "Status name, e.g. Rest…"

#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/shared/lib/contractClauses.ts
msgid "Nombre del hotel"
msgstr "Hotel name"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Nombre del hotel en el documento"
msgstr "Hotel name in the document"

#: src/features/clients/components/ClientFilters.tsx
#: src/features/conversion/pages/ConversionQueuePage.tsx
#: src/features/onboarding/pages/ProposalListPage.tsx
#: src/features/territory/pages/TerritoryPage.tsx
msgid "Nombre del hotel, p. ej. Puerto Real…"
msgstr "Hotel name, e.g. Puerto Real…"

#: src/features/contracts/components/MissingContractsNotice.tsx
#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Nombre del hotel…"
msgstr "Hotel name…"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Nombre del motivo, p. ej. Se mudó…"
msgstr "Reason name, e.g. Moved away…"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Nombre del nivel, p. ej. Conversacional…"
msgstr "Level name, e.g. Conversational…"

#: src/shared/lib/contractClauses.ts
msgid "Nombre del proveedor"
msgstr "Provider name"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Nombre en la firma de Oranje"
msgstr "Name on Oranje's signature"

#: src/features/admin/pages/UsersPage.tsx
msgid "Nombre o correo, p. ej. Ana López…"
msgstr "Name or email, e.g. Ana López…"

#: src/features/admin/components/ColaboradorAccountsSection.tsx
msgid "Nombre o correo, p. ej. Ana Rivera…"
msgstr "Name or email, e.g. Ana Rivera…"

#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Nombre o teléfono…"
msgstr "Name or phone…"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Nombre o zona, p. ej. Puerto Real…"
msgstr "Name or zone, e.g. Puerto Real…"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Nombre o zona…"
msgstr "Name or zone…"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Nombre y puesto de quien envía"
msgstr "Name and title of the sender"

#: src/features/admin/components/HotelUsersSection.tsx
msgid "Nombre, correo u hotel, p. ej. Xcaret…"
msgstr "Name, email or hotel, e.g. Xcaret…"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Nombre, p. ej. Alejandra Cohuo…"
msgstr "Name, e.g. Alejandra Cohuo…"

#: src/features/team/pages/HotelTeamPage.tsx
msgid "Nombre, p. ej. Alma Torres…"
msgstr "Name, e.g. Alma Torres…"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Nombre, p. ej. Rubén Sandoval"
msgstr "Name, e.g. Rubén Sandoval"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "nombre@hotel.mx"
msgstr "name@hotel.mx"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "nombre@oranjepeople.com"
msgstr "name@oranjepeople.com"

#: src/shared/constants/requisitionStatus.ts
msgid "Normal"
msgstr "Normal"

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Nota"
msgstr "Note"

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
#: src/features/personnel/components/ReportWorkerDialog.tsx
#: src/features/personnel/components/StandByDialog.tsx
msgid "Nota (opcional)"
msgstr "Note (optional)"

#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Nota <0>(opcional)</0>"
msgstr "Note <0>(optional)</0>"

#: src/features/team/pages/TeamPage.tsx
msgid "Nota al BD"
msgstr "Note to the BD"

#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Nota de la deducción"
msgstr "Deduction note"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Nota de revisión"
msgstr "Review note"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Nota de revisión <0>(obligatoria)</0>"
msgstr "Review note <0>(required)</0>"

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "Nota del cierre"
msgstr "Closing note"

#: src/shared/components/SendDocumentModal.tsx
msgid "Nota para el hotel"
msgstr "Note for the hotel"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Notas"
msgstr "Notes"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "notas de crédito"
msgstr "credit notes"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Notas médicas"
msgstr "Medical notes"

#: src/layouts/Header.tsx
msgid "Notificaciones"
msgstr "Notifications"

#. placeholder {0}: String(unread)
#: src/layouts/Header.tsx
msgid "Notificaciones: {0} sin leer"
msgstr "Notifications: {0} unread"

#: src/layouts/Header.tsx
msgid "Notificaciones: nada nuevo"
msgstr "Notifications: nothing new"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Nuestras plantillas, remitente @oranjepeople.com."
msgstr "Our templates, sent from @oranjepeople.com."

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Nuestro equipo de reclutamiento ya está buscando a {total, plural, one {la persona que pediste} other {las # personas que pediste}}."
msgstr "Our recruiting team is already looking for {total, plural, one {the person you requested} other {the # people you requested}}."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Nueva campaña"
msgstr "New campaign"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Nueva cuenta del hotel"
msgstr "New hotel account"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Nueva etiqueta"
msgstr "New tag"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Nueva plantilla"
msgstr "New template"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Nueva requisición"
msgstr "New requisition"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Nueva versión (v{nextVersion})"
msgstr "New version (v{nextVersion})"

#: src/features/clients/components/ClientSpotlightCard.tsx
#: src/features/recruitment/components/PoolCardBoard.tsx
msgid "Nuevo"
msgstr "New"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Nuevo colaborador"
msgstr "New collaborator"

#: src/features/messaging/components/ContactActions.tsx
msgid "Nuevo contacto"
msgstr "New contact"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Nuevo contrato"
msgstr "New contract"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Nuevo estado"
msgstr "New status"

#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Nuevo prospecto"
msgstr "New prospect"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Nuevo usuario"
msgstr "New user"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Nuevos"
msgstr "New"

#: src/features/contracts/components/ContractTable.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/requisitions/components/RequisitionTable.tsx
msgid "Número"
msgstr "Number"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "o"
msgstr "or"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "o acepta la retención del 16% y no lo pidas"
msgstr "or accept the 16% retention and don't ask for it"

#: src/features/messaging/components/tours.ts
msgid "O agrégalos uno por uno"
msgstr "Or add them one by one"

#: src/shared/constants/workerEnums.ts
msgid "O+"
msgstr "O+"

#: src/shared/constants/workerEnums.ts
msgid "O−"
msgstr "O−"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "obligatoria"
msgstr "required"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "obligatorio"
msgstr "required"

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Observaciones generales <0>(opcional)</0>"
msgstr "General remarks <0>(optional)</0>"

#: src/shared/constants/timesheetStatus.ts
msgid "Observado"
msgstr "Flagged"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "observados"
msgstr "flagged"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Ocho caracteres: seis letras y dos números. Si el correo la rechaza por débil, se pone una de 16."
msgstr "Eight characters: six letters and two numbers. If the email rejects it as weak, a 16-character one is set."

#: src/features/auth/pages/LoginPage.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Ocultar contraseña"
msgstr "Hide password"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "ocupado"
msgstr "taken"

#: src/features/requisitions/components/SlotList.tsx
msgid "Ocupado"
msgstr "Taken"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "OFF"
msgstr "OFF"

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Ojo: el {activeContractNumber} sigue vigente para este hotel — solo puede haber uno activo, así que al activar este hay que expirar aquel."
msgstr "Heads up: {activeContractNumber} is still in force for this hotel — only one can be active, so activating this one means expiring that one."

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Omitidos"
msgstr "Skipped"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
#: src/features/worker/pages/Phase2Page.tsx
msgid "opcional"
msgstr "optional"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Opcional — solo si el hotel pertenece a una cadena o lo administra otra empresa"
msgstr "Optional — only if the hotel belongs to a chain or is managed by another company"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Opcional, y las dos pueden ir juntas: cada una la aprueba el Manager de QA por separado antes de que pese en el pago."
msgstr "Optional, and both can go together: each one is approved by the QA Manager separately before it counts toward pay."

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Opcional: en una visita en frío puedes no encontrar a nadie"
msgstr "Optional: on a cold visit you may not find anyone"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Opcional: lo completa el colaborador desde su app, pero si ya lo tienes, captúralo aquí y podrás validarlo sin esperar."
msgstr "Optional: the collaborator completes it from their app, but if you already have it, enter it here and you can validate them without waiting."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Opcional: puedes agregarla después desde el Pool"
msgstr "Optional: you can add it later from the Pool"

#: src/shared/constants/roles.ts
msgid "Operador de QA"
msgstr "QA Operator"

#: src/features/contracts/components/ContractSignatureCard.tsx
#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
msgid "Oranje"
msgstr "Oranje"

#: src/features/requisitions/components/SlotList.tsx
msgid "Oranje está buscando a alguien"
msgstr "Oranje is finding someone"

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Oranje la está cubriendo"
msgstr "Oranje is filling it"

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "Oranje ya lo cubrió y el colaborador pidió que se le descontara: el monto se resta de lo que recibe esta semana, como una deducción más."
msgstr "Oranje already covered it and the collaborator asked to have it deducted: the amount is subtracted from what they receive this week, as one more deduction."

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Oranje ya recibió tu requisición"
msgstr "Oranje received your requisition"

#: src/features/clients/components/ClientFilters.tsx
msgid "Ordenar"
msgstr "Sort"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Origen"
msgstr "Source"

#: src/features/accounting/components/AddDeductionDialog.tsx
#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Otra deducción"
msgstr "Other deduction"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Otra persona acaba de asignar a {nombreElegido}. Elige a alguien más."
msgstr "Someone else just assigned {nombreElegido}. Pick another collaborator."

#. placeholder {0}: IS_DEV_UI ? ' (RR-15)' : ''
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Otra Reclutadora tomó este slot antes{0}: el tablero ya se actualizó, revisa el siguiente libre."
msgstr "Another Recruiter took this slot first{0}: the board is already updated, check the next free one."

#: src/features/observability/lib/cohorts.ts
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/shared/constants/workerEnums.ts
msgid "Otro"
msgstr "Other"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Otro clic lo borra definitivamente"
msgstr "One more click deletes it for good"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "otro estado"
msgstr "another status"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "otro rol"
msgstr "another role"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Otros documentos"
msgstr "Other documents"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Overtime"
msgstr "Overtime"

#: src/features/contracts/components/ContractTable.tsx
msgid "Overtime · Festivo"
msgstr "Overtime · Holiday"

#. placeholder {0}: overtime.pay.toFixed(2)
#. placeholder {1}: overtime.bill.toFixed(2)
#. placeholder {2}: holiday.pay.toFixed(2)
#. placeholder {3}: holiday.bill.toFixed(2)
#: src/features/contracts/components/ContractChecklist.tsx
msgid "Overtime {0}× / {1}× · Festivo {2}× / {3}× (pago / factura). El de factura nunca va por debajo del de pago."
msgstr "Overtime {0}× / {1}× · Holiday {2}× / {3}× (pay / bill). The bill one never goes below the pay one."

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Overtime y día festivo según el contrato (mínimo 1.00×)"
msgstr "Overtime and holiday as set by the contract (minimum 1.00×)"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Overtime y festivo no comen el margen"
msgstr "Overtime and holiday do not eat the margin"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "P. ej. «Abandonó el turno sin aviso en dos ocasiones.»"
msgstr "E.g. “Walked off shift without notice twice.”"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "P. ej. «Acuerdo con el hotel; reincorporación autorizada por el Manager de Reclutamiento.»"
msgstr "E.g. “Agreement with the hotel; return authorized by the Recruitment Manager.”"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "P. ej. Steward"
msgstr "E.g. Steward"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "P. ej. Uniforme completo, limpio y planchado"
msgstr "E.g. Uniform complete, clean and pressed"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "P. ej. Uniformidad"
msgstr "E.g. Uniformity"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Pacífico — Los Ángeles, Las Vegas"
msgstr "Pacific — Los Angeles, Las Vegas"

#: src/shared/constants/workerEnums.ts
msgid "Padre"
msgstr "Father"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Paga las horas aprobadas de este hotel esta semana"
msgstr "Pays this hotel's approved hours for the week"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Paga las horas ya aprobadas de {hotelName} esta semana."
msgstr "Pays {hotelName}'s already-approved hours for the week."

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Paga lo que se aprobó después del corte del miércoles."
msgstr "Pays what was approved after Wednesday’s cut."

#: src/features/accounting/types/settlement.constants.ts
msgid "Pagada"
msgstr "Paid"

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "Pagada la registra Contabilidad"
msgstr "Accounting records it as paid"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Pagada. Estado terminal."
msgstr "Paid. Final status."

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/types/settlement.constants.ts
#: src/features/observability/lib/inspectionKpis.ts
msgid "Pagado"
msgstr "Paid"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Pagado. Estado terminal."
msgstr "Paid. Final status."

#: src/features/accounting/components/PayConsolidationButton.tsx
msgid "Pagar"
msgstr "Pay"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Pagar seleccionados"
msgstr "Pay selected"

#. placeholder {0}: data.meta.page
#. placeholder {0}: data.pagination.page
#. placeholder {1}: data.meta.totalPages
#. placeholder {1}: data.pagination.totalPages
#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/components/ContactImportsDialog.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Página {0} de {1}"
msgstr "Page {0} of {1}"

#: src/features/messaging/components/Pager.tsx
#: src/shared/components/CardPagination.tsx
msgid "Página {page} de {totalPages}"
msgstr "Page {page} of {totalPages}"

#: src/features/messaging/components/Pager.tsx
msgid "Página anterior"
msgstr "Previous page"

#: src/features/messaging/components/Pager.tsx
msgid "Página siguiente"
msgstr "Next page"

#: src/features/messaging/components/Pager.tsx
#: src/shared/components/CardPagination.tsx
msgid "Paginación"
msgstr "Pagination"

#. placeholder {0}: ONBOARDING_STATUS_LABEL[status]
#. placeholder {0}: department.name
#. placeholder {0}: items[0]?.category ?? ''
#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/onboarding/components/PipelineColumn.tsx
msgid "Páginas de {0}"
msgstr "{0} pages"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Páginas de correos corporativos"
msgstr "Corporate email pages"

#: src/features/admin/components/ColaboradorAccountsSection.tsx
msgid "Páginas de cuentas de colaboradores"
msgstr "Worker account pages"

#: src/features/admin/components/HotelUsersSection.tsx
msgid "Páginas de cuentas de hotel"
msgstr "Hotel account pages"

#: src/features/admin/components/PendingHotelUsers.tsx
msgid "Páginas de cuentas por aprobar"
msgstr "Pending account pages"

#: src/features/clients/pages/ClientPortfolioPage.tsx
msgid "Páginas de hoteles"
msgstr "Hotel pages"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Páginas de los últimos correos"
msgstr "Recent email pages"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Páginas de personas con acceso"
msgstr "Pages of people with access"

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Páginas de personas con funciones adicionales"
msgstr "Pages of people with additional roles"

#: src/features/admin/pages/UsersPage.tsx
msgid "Páginas de usuarios"
msgstr "User pages"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Páginas del catálogo"
msgstr "Catalog pages"

#. placeholder {0}: String(index + 1)
#: src/features/contracts/components/NewContractDialog.tsx
msgid "Pago {0}"
msgstr "Pay {0}"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Pago autorizado"
msgstr "Payment authorized"

#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Pago de horas extra"
msgstr "Overtime pay"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Pago del día"
msgstr "Day's pay"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Pago estimado"
msgstr "Estimated pay"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Pago por hora"
msgstr "Pay per hour"

#: src/features/accounting/components/PayConsolidationButton.tsx
msgid "Pago registrado"
msgstr "Payment recorded"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Pago y facturación de {hotelName} esta semana, listos para bajar — el mismo cuadro de \"Lo que el hotel nos paga\" en un archivo."
msgstr "{hotelName}'s pay and billing for the week, ready to download — the same “What the hotel pays us” table in a file."

#: src/features/messaging/components/ContactActions.tsx
#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
#: src/shared/components/PhoneInput.tsx
msgid "País"
msgstr "Country"

#: src/shared/components/PhoneInput.tsx
msgid "País o lada: México, +52…"
msgstr "Country or code: Mexico, +52…"

#: src/features/messaging/pages/MessagingPage.tsx
msgid "Panel"
msgstr "Overview"

#: src/shared/components/SendDocumentModal.tsx
msgid "Para"
msgstr "To"

#. placeholder {0}: row.workerName
#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Para {0} — la marca quedará señalada como manual, con tu motivo."
msgstr "For {0} — the punch will be flagged as manual, with your reason."

#. placeholder {0}: typeLabel ? i18n._(typeLabel) : target.punch.type
#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "Para {workerName} — {0}. Queda registrado quién corrigió y por qué."
msgstr "For {workerName} — {0}. Who corrected it and why is kept on record."

#: src/features/messaging/pages/MessagingPage.tsx
msgid "Para agrupar contactos"
msgstr "To group contacts"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Para asignar:"
msgstr "To assign:"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Para completar"
msgstr "To complete"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Para completar en su ficha"
msgstr "To complete on their page"

#. placeholder {0}: missingData.join(', ')
#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Para completar: {0}."
msgstr "To complete: {0}."

#: src/features/worker/pages/PermissionsPage.tsx
msgid "Para confirmar que estás dentro del hotel al ponchar."
msgstr "To confirm you're inside the hotel when you punch in."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Para continuar:"
msgstr "To continue:"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Para convertir a Naranja primero debe existir el Usuario del Hotel: créalo desde aquí mismo."
msgstr "To convert to Orange, the Hotel User must exist first: create it right here."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Para convertir a Naranja primero debe existir el Usuario del Hotel: créalo desde Conversión."
msgstr "To convert to Orange the Hotel User must exist first: create it from Conversion."

#. placeholder {0}: missing.join(' · ')
#: src/features/contracts/components/NewContractDialog.tsx
msgid "Para crear: {0}."
msgstr "To create it: {0}."

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Para encontrar una en segundos"
msgstr "To find one in seconds"

#: src/features/worker/pages/PermissionsPage.tsx
msgid "Para la foto de Entrada y Salida — cuando el hotel usa selfie y no QR."
msgstr "For the Clock in / Clock out photo — when the hotel uses selfie instead of QR."

#. placeholder {0}: REQUISITION_STATUS_LABEL[detail.status]
#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Para llenar un slot, la requisición tiene que estar autorizada y en proceso. Ahora está en {0}."
msgstr "To fill a slot, the requisition has to be authorized and in progress. It's currently at {0}."

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Para pedir personal:"
msgstr "To request staff:"

#: src/features/recruitment/components/ProfileProgressAvatar.tsx
msgid "Para poder asignarlo falta capturar en la entrevista: {missingNames}"
msgstr "Before assigning, capture in the interview: {missingNames}"

#: src/features/worker/components/NativePunchGate.tsx
msgid "Para ponchar, la app necesita tu ubicación precisa, el GPS encendido y la cámara. Revisa qué falta y actívalo."
msgstr "To punch, the app needs your precise location, GPS turned on, and the camera. Check what's missing and turn it on."

#: src/features/onboarding/components/DeleteHotelAction.tsx
msgid "Para un hotel dado de alta por error o de prueba. Solo si nunca salió del Pipeline."
msgstr "For a hotel added by mistake or as a test. Only if it never left the Pipeline."

#: src/features/messaging/components/tours.ts
msgid "Para ver solo a los de una etiqueta, por ejemplo los de una importación."
msgstr "To see only those with one tag, for example those from an import."

#: src/features/requisitions/utils/coverage.ts
msgid "parcial"
msgstr "partial"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Parciales"
msgstr "Partial"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/pages/Phase3Page.tsx
msgid "Parentesco"
msgstr "Relationship"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Parentesco…"
msgstr "Relationship…"

#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "Pasa a reportar a"
msgstr "Will report to"

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "Pasa a Rojo: es una incidencia, no una pausa. Inspección la revisa."
msgstr "Goes to Red: it's an incident, not a pause. Inspection reviews it."

#: src/features/personnel/components/StandByDialog.tsx
msgid "Pasa a Rosa: queda en pausa, sin turnos nuevos, hasta que el Hotel lo reactive."
msgstr "They move to Pink: paused, with no new shifts, until the Hotel reactivates them."

#. placeholder {0}: money(consolidation.netAmount)
#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Pasa del neto de {0}: el pago quedaría en negativo."
msgstr "It exceeds the {0} net: the payment would go negative."

#: src/features/worker/components/AccessDeadlineBanner.tsx
msgid "Pasaron los 30 días para cambiar la contraseña temporal que te dieron. Elige la tuya aquí y tu acceso vuelve al instante — tus datos y tu historial no se pierden."
msgstr "The 30 days to change the temporary password you were given have passed. Pick your own here and your access comes back instantly — your details and history are not lost."

#. placeholder {0}: index + 1
#. placeholder {1}: steps.length
#: src/features/messaging/components/Tour.tsx
msgid "Paso {0} de {1}"
msgstr "Step {0} of {1}"

#: src/features/worker/pages/Phase2Page.tsx
msgid "Paso {step} de {LAST_STEP}"
msgstr "Step {step} of {LAST_STEP}"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Paso 2 de 2"
msgstr "Step 2 of 2"

#: src/features/worker/components/AccessDeadlineBanner.tsx
msgid "Pasó el día para completar tu expediente después de que Reclutamiento te validó. Llénalo aquí y tu acceso vuelve al instante — tus datos y tu historial no se pierden."
msgstr "The day to complete your file after Recruitment validated you has passed. Fill it out here and your access comes back instantly — your data and history aren't lost."

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Pasos de tu requisición"
msgstr "Your requisition's steps"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "pausa temporal (Rosa)"
msgstr "temporary pause (Pink)"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Pausa temporal (Rosa); lo compartes con el Manager de Área"
msgstr "Temporary pause (Pink); you share it with the Area Manager"

#: src/features/personnel/components/StandByDialog.tsx
msgid "Pausa, no baja"
msgstr "A pause, not a removal"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Pausada"
msgstr "Paused"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Pausado (Stand-by)"
msgstr "Paused (Stand-by)"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Pausar"
msgstr "Pause"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "pausarlo o reactivarlo es del BDC."
msgstr "pausing or reactivating it is the BDC's."

#. placeholder {0}: formatMoney(version.payRate)
#. placeholder {1}: formatMoney(version.billRate)
#: src/features/onboarding/lib/summarizeRates.ts
msgid "pay {0} · bill {1}"
msgstr "pay {0} · bill {1}"

#: src/features/onboarding/components/ProposalRateFields.tsx
msgid "Pay rate"
msgstr "Pay rate"

#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Pay rate por hora"
msgstr "Pay rate per hour"

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "Pedido por"
msgstr "Requested by"

#. placeholder {0}: row.requestedBy.fullName
#. placeholder {1}: formatDateTime(row.requestedAt)
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "Pedido por {0} · {1}"
msgstr "Requested by {0} · {1}"

#: src/features/contracts/components/ContractChecklist.tsx
#: src/features/recruitment/components/PoolTable.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Pendiente"
msgstr "Pending"

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "Pendiente → Aprobada → Emitida"
msgstr "Pending → Approved → Issued"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "pendiente de aprobación"
msgstr "pending approval"

#: src/features/accounting/types/settlement.constants.ts
msgid "Pendiente de aprobación"
msgstr "Pending approval"

#: src/features/accounting/pages/AccountingPendingPages.tsx
msgid "Pendiente de definir"
msgstr "Still to be defined"

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "pendiente de horas contractuales"
msgstr "waiting for contract hours"

#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Pendiente de verificar"
msgstr "Pending verification"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "pendientes"
msgstr "pending"

#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Pendientes"
msgstr "Pending"

#: src/features/audits/components/EnvironmentAuditDialog.tsx
msgid "Percepción de Ambiente y Recursos"
msgstr "Environment & Resources Perception"

#: src/features/observability/lib/salesKpis.ts
msgid "Pérdida"
msgstr "Loss"

#: src/features/worker/components/useFaceGuide.ts
msgid "Perfecto, toma la foto"
msgstr "Perfect, take the photo"

#: src/features/recruitment/components/PoolTable.tsx
#: src/features/worker/components/MobileShell.tsx
msgid "Perfil"
msgstr "Profile"

#: src/features/recruitment/components/PoolCardBoard.tsx
msgid "perfil completo"
msgstr "complete profile"

#: src/features/recruitment/components/PoolCardBoard.tsx
msgid "perfil incompleto"
msgstr "incomplete profile"

#: src/features/recruitment/components/ProfilePendingLabel.tsx
msgid "Perfil incompleto"
msgstr "Incomplete profile"

#: src/features/recruitment/components/ProfilePendingLabel.tsx
msgid "Perfil incompleto · se le venció, ya no entra a su app"
msgstr "Incomplete profile · deadline passed, they can no longer open their app"

#: src/features/recruitment/components/ProfilePendingLabel.tsx
msgid "Perfil incompleto · tiene hasta el {date}"
msgstr "Incomplete profile · they have until {date}"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Perfil laboral y salud"
msgstr "Work profile and health"

#: src/features/accounting/pages/InvoicesPage.tsx
#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/observability/components/TabParts.tsx
#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "Periodo"
msgstr "Period"

#: src/shared/components/DateRangeField.tsx
msgid "Periodo {label}"
msgstr "Period {label}"

#: src/features/worker/components/MobileShell.tsx
#: src/features/worker/pages/PermissionsPage.tsx
msgid "Permisos"
msgstr "Permissions"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
#: src/features/observability/components/PeopleView.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Persona"
msgstr "Person"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Persona a quien dar el acceso"
msgstr "Person to grant access to"

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Persona a quien dar la función"
msgstr "Person to grant the role to"

#: src/features/admin/pages/UsersPage.tsx
msgid "Personal de hoteles"
msgstr "Hotel staff"

#: src/features/admin/pages/UsersPage.tsx
msgid "Personal Oranje"
msgstr "Oranje staff"

#: src/features/observability/components/CohortsView.tsx
#: src/features/requisitions/components/RequisitionSummaryStrip.tsx
msgid "Personas"
msgstr "People"

#: src/features/observability/lib/recruitmentKpis.ts
msgid "Personas asignadas que no ponchan su primer día, con el primer día en el periodo."
msgstr "Assigned people who don't punch on their first day, with the first day in the period."

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Personas con acceso"
msgstr "People with access"

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Personas con funciones adicionales"
msgstr "People with additional roles"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Personas en tu equipo"
msgstr "People on your team"

#: src/features/observability/lib/workerKpis.ts
msgid "Personas que poncharon entrada hoy y todavía no su salida."
msgstr "People who punched in today and haven't punched out yet."

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "personas que respondieron"
msgstr "people who replied"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Peso"
msgstr "Weight"

#. placeholder {0}: item.weight
#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Peso {0}"
msgstr "Weight {0}"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Peso en el promedio ponderado del score"
msgstr "Weight in the score's weighted average"

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "Pide al menos 1 persona"
msgstr "Request at least 1 person"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Pide personal desde aquí"
msgstr "Request staff from here"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Pide personal para tu hotel"
msgstr "Request staff for your hotel"

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Pídele al Administrador que lo cree desde Correos corporativos."
msgstr "Ask the Administrator to create it from Corporate emails."

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Pidió que llamáramos la próxima semana"
msgstr "Asked us to call back next week"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Pie (opcional)"
msgstr "Footer (optional)"

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
msgid "Pin ajustado a mano"
msgstr "Pin adjusted by hand"

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
msgid "Pin en el punto exacto de Google"
msgstr "Pin on Google's exact spot"

#: src/features/onboarding/pages/PipelinePage.tsx
#: src/features/onboarding/pages/ProspectDetailPage.tsx
#: src/features/reports/pages/ReportsPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Pipeline"
msgstr "Pipeline"

#: src/features/dashboard/components/StatusFunnel.tsx
msgid "Pipeline por estado"
msgstr "Pipeline by status"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Plantilla"
msgstr "Template"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Plantilla *"
msgstr "Template *"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Plantilla en español"
msgstr "Template in Spanish"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Plantilla en inglés"
msgstr "Template in English"

#: src/features/messaging/components/MessagingOverviewPanel.tsx
#: src/features/messaging/components/MessagingTemplatesList.tsx
#: src/features/messaging/pages/MessagingPage.tsx
msgid "Plantillas"
msgstr "Templates"

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Plazo para aprobar las horas (miércoles)"
msgstr "Deadline to approve hours (Wednesday)"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "pon desde cuándo rige"
msgstr "set when it starts applying"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Pon la fecha de fin: la asignación es temporal."
msgstr "Set the end date: the assignment is temporary."

#: src/features/worker/components/MobileShell.tsx
#: src/features/worker/pages/HomePage.tsx
msgid "Ponchar"
msgstr "Clock in"

#. placeholder {0}: i18n._(PUNCH_LABEL[next]).toLowerCase()
#: src/features/worker/pages/PunchPage.tsx
msgid "Ponchar {0}"
msgstr "Punch: {0}"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "Ponche"
msgstr "Punch"

#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Ponches a tiempo"
msgstr "Punches on time"

#: src/features/observability/lib/workerKpis.ts
msgid "Ponches capturados a mano en lugar de con el teléfono."
msgstr "Punches captured by hand instead of with the phone."

#: src/features/timesheet/components/TimesheetDayCell.tsx
#: src/shared/constants/timesheetStatus.ts
msgid "Ponches completos"
msgstr "Punches complete"

#: src/features/observability/lib/workerKpis.ts
msgid "Ponches fuera de geocerca"
msgstr "Punches outside the geofence"

#: src/features/timesheet/components/TimesheetDayCell.tsx
#: src/shared/constants/timesheetStatus.ts
msgid "Ponches incompletos"
msgstr "Punches incomplete"

#: src/features/observability/lib/workerKpis.ts
msgid "Ponches manuales"
msgstr "Manual punches"

#: src/features/observability/lib/workerKpis.ts
msgid "Ponches registrados fuera del radio del hotel."
msgstr "Punches recorded outside the hotel's radius."

#: src/shared/constants/workerStatus.ts
msgid "Ponchó en la propiedad al tercer día: ya tiene su uniforme."
msgstr "Punched in at the property on day three: already has their uniform."

#: src/features/observability/components/CohortSection.tsx
msgid "Ponchó esta semana o la pasada, después de su semana de ingreso."
msgstr "Punched this week or last, after their joining week."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Poner contraseña"
msgstr "Set password"

#: src/features/messaging/components/tours.ts
msgid "Ponle nombre y color. Luego asígnala a contactos o al importar un Excel."
msgstr "Give it a name and color. Then assign it to contacts or when importing an Excel file."

#: src/features/recruitment/pages/PoolPage.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Pool de Colaboradores"
msgstr "Collaborator Pool"

#: src/features/dashboard/components/RecruitmentDashboard.tsx
#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Pool por estado"
msgstr "Pool by status"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Por ahora la retención del 16% aplica a todos los colaboradores, suban o verifiquen o no su SSN/ITIN — es temporal, mientras se conecta ese proceso."
msgstr "For now the 16% withholding applies to every collaborator, whether or not they upload or verify their SSN/ITIN — it's temporary, until that process is wired up."

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Por ahora, los reportes de Mensajería solo los ve Reclutamiento."
msgstr "For now, only Recruitment can see Messaging reports."

#: src/features/messaging/pages/MessagingPage.tsx
msgid "Por ahora, Mensajería es solo de Reclutamiento."
msgstr "For now, Messaging is only for Recruitment."

#: src/features/recruitment/types/blacklist.types.ts
msgid "Por ausencias"
msgstr "For absences"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Por categoría de plantilla"
msgstr "By template category"

#: src/features/recruitment/types/blacklist.types.ts
msgid "Por disputa"
msgstr "For a dispute"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Por dónde buscaste al hotel"
msgstr "How you reached out to the hotel"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Por dónde sale el correo"
msgstr "Where email goes out from"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Por dónde salen los correos que manda el sistema, y qué ha pasado con ellos."
msgstr "Where the system's email goes out from, and what has happened to it."

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Por el respaldo"
msgstr "Through the backup"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Por el servidor de Oranje"
msgstr "Through the Oranje server"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Por etiquetas"
msgstr "By tags"

#: src/features/messaging/components/tours.ts
msgid "Por nombre, teléfono o email: son los contactos de la plataforma de mensajería."
msgstr "By name, phone or email: these are the messaging platform's contacts."

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Por país"
msgstr "By country"

#: src/features/observability/components/CohortSection.tsx
#: src/features/observability/components/TabParts.tsx
msgid "Por persona"
msgstr "Per person"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Por persona · asignaciones y altas de los últimos 30 días"
msgstr "By person · assignments and new collaborators in the last 30 days"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Por qué esta tarifa…"
msgstr "Why this rate…"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Por qué este gasto…"
msgstr "Why this expense…"

#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "Por qué la hora registrada estaba mal"
msgstr "Why the recorded time was wrong"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Por qué no existe el ponche: rechazo de ubicación, teléfono sin batería…"
msgstr "Why there's no punch: location rejected, phone out of battery…"

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Por qué no llegaron"
msgstr "Why they didn't arrive"

#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "Por qué no procede…"
msgstr "Why it doesn't apply…"

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Por qué se corrige — p. ej. «El contrato traía la tarifa vieja.»"
msgstr "Why it's being corrected — e.g. «The contract had the old rate.»"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/SlotList.tsx
msgid "Por qué se libera este slot…"
msgstr "Why this slot is being released…"

#: src/features/reports/pages/ReportsPage.tsx
msgid "por qué se van los ciclos, y que son reactivables"
msgstr "why cycles leave, and that they can be reactivated"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Por si algo pasa"
msgstr "In case something happens"

#: src/features/onboarding/components/HotelGlobeCard.tsx
msgid "Por todo el territorio"
msgstr "Across the whole territory"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Por validar"
msgstr "Pending validation"

#. placeholder {0}: String(member.pendingValidation)
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Por validar · {0}"
msgstr "Pending validation · {0}"

#: src/features/messaging/components/ReportCharts.tsx
msgid "Porcentaje acumulado de destinatarios con el mensaje entregado y leído desde el inicio del envío. Usa las flechas para recorrer; «Ver tabla» tiene los valores."
msgstr "Cumulative percentage of recipients with the message delivered and read since sending started. Use the arrow keys to move through; \"View table\" has the values."

#. placeholder {0}: data.thresholds.green
#. placeholder {1}: data.thresholds.yellow
#. placeholder {2}: data.weeks
#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Porcentaje de ponches de cada semana cerrada que el Manager de Área aprobó antes del cierre. Verde desde {0}%, amarillo desde {1}%, rojo por debajo. Últimas {2} semanas."
msgstr "Share of punches from each closed week that the Area Manager approved before the cutoff. Green from {0}%, yellow from {1}%, red below. Last {2} weeks."

#: src/features/requisitions/components/RequisitionTable.tsx
msgid "Pos."
msgstr "Pos."

#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/clients/components/ClientSpotlightCard.tsx
msgid "posición"
msgstr "position"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/pages/InvoiceDetailPage.tsx
#: src/features/contracts/components/EditRateDialog.tsx
#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/components/RateTable.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/components/PoolTable.tsx
#: src/features/recruitment/components/SelfPickFilterBar.tsx
#: src/features/recruitment/lib/profileFields.ts
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Posición"
msgstr "Position"

#. placeholder {0}: String(index + 1)
#. placeholder {0}: index + 1
#: src/features/contracts/components/NewContractDialog.tsx
msgid "Posición {0}"
msgstr "Position {0}"

#. placeholder {0}: row.lineNumber
#. placeholder {1}: row.positionName
#: src/features/recruitment/components/SelfPickPositionCard.tsx
msgid "Posición {0} · {1}"
msgstr "Position {0} · {1}"

#: src/features/requisitions/components/SlotList.tsx
msgid "Posición {index} · {name}"
msgstr "Position {index} · {name}"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Posición {ordinal}"
msgstr "Position {ordinal}"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Posición y modalidad"
msgstr "Position and hiring modality"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Posición, modalidad, inglés y experiencia se deciden aquí: son decisiones de Oranje, no del colaborador."
msgstr "Position, hiring modality, English and experience are decided here: they're Oranje's calls, not the collaborator's."

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Posición…"
msgstr "Position…"

#: src/features/clients/components/ClientSpotlightCard.tsx
msgid "posiciones"
msgstr "positions"

#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/contracts/components/ContractTable.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/requisitions/components/RequisitionSummaryStrip.tsx
msgid "Posiciones"
msgstr "Positions"

#: src/features/observability/lib/recruitmentKpis.ts
msgid "Posiciones con urgencia roja y lugares vacíos, en requisiciones que se están llenando."
msgstr "Positions with red urgency and empty spots, in requisitions being filled."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Posiciones solicitadas"
msgstr "Requested positions"

#: src/features/observability/lib/people.ts
#: src/features/observability/lib/recruitmentKpis.ts
msgid "Posiciones urgentes sin cubrir"
msgstr "Urgent positions still uncovered"

#: src/shared/constants/workerStatus.ts
msgid "Pre-asignación"
msgstr "Pre-assignment"

#: src/features/accounting/pages/AccountingPendingPages.tsx
#: src/layouts/Sidebar.tsx
msgid "Pre-Payroll"
msgstr "Pre-Payroll"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Prendido"
msgstr "On"

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Preparando el documento…"
msgstr "Preparing the document…"

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "Preparando el QR…"
msgstr "Preparing the QR…"

#: src/features/worker/components/useFaceGuide.ts
msgid "Preparando la cámara…"
msgstr "Getting the camera ready…"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/audits/components/AuditHistoryList.tsx
#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Presentación Personal"
msgstr "Personal Presentation"

#: src/features/audits/pages/AuditsPage.tsx
msgid "Presentación Personal por colaborador y Percepción de Ambiente y Recursos de tu hotel — misma mecánica, categorías distintas."
msgstr "Personal Presentation per collaborator and Environment & Resources Perception for your hotel — same mechanics, different categories."

#: src/features/audits/pages/AuditsPage.tsx
msgid "Presentación Personal por colaborador y Percepción de Ambiente y Recursos del hotel — un registro semanal que no toca ningún semáforo."
msgstr "Personal Presentation per collaborator and Environment & Resources Perception for the hotel — a weekly record that doesn't touch any status light."

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Previsualizar"
msgstr "Preview"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Primer contacto"
msgstr "First contact"

#: src/shared/constants/workerStatus.ts
msgid "Primer o segundo día en el hotel. El Inspector confirma su llegada el día 1."
msgstr "First or second day at the hotel. The Inspector confirms their arrival on day 1."

#: src/features/onboarding/components/ContractStepCard.tsx
msgid "Primero envía una propuesta al hotel"
msgstr "Send the hotel a proposal first"

#: src/features/messaging/components/CampaignsTour.tsx
msgid "Primero, sincroniza"
msgstr "First, sync"

#: src/features/onboarding/components/HotelContactList.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Principal"
msgstr "Main"

#. placeholder {0}: roleLabelOf(item.primaryRole.code).title
#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Principal: {0}"
msgstr "Main: {0}"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Problemas"
msgstr "Problems"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
msgid "Programada"
msgstr "Scheduled"

#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Programar"
msgstr "Schedule"

#. placeholder {0}: campaign.name
#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "Programar «{0}»"
msgstr "Schedule “{0}”"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
#: src/features/reports/pages/ReportsPage.tsx
msgid "Programar envío recurrente"
msgstr "Schedule recurring delivery"

#: src/features/messaging/components/MessagingOverviewPanel.tsx
msgid "Progreso"
msgstr "Progress"

#: src/features/clients/pages/ClientPortfolioPage.tsx
msgid "promedio como cliente"
msgstr "average as a client"

#: src/features/observability/lib/hotelKpis.ts
msgid "Promedio de horas para aprobar una semana, de todo el histórico."
msgstr "Average hours to approve a week, across the entire history."

#: src/features/observability/lib/salesKpis.ts
msgid "Promedio de la apertura del ciclo a su cierre, de todo el histórico."
msgstr "Average from the cycle's opening to its closing, across the entire history."

#: src/features/observability/lib/recruitmentKpis.ts
msgid "Promedio en Autorizada más promedio en En proceso, de todo el histórico."
msgstr "Average in Authorized plus average in In Progress, across the entire history."

#: src/features/observability/lib/hotelKpis.ts
msgid "Promedio que un colaborador pasa en Stand-by, de todo el histórico."
msgstr "Average time a collaborator spends in Stand-by, across the entire history."

#: src/shared/constants/workerEnums.ts
msgid "Propio"
msgstr "Own"

#: src/features/territory/components/TerritoryMapLegend.tsx
msgid "Propuesta"
msgstr "Proposal"

#. placeholder {0}: workspace.hotelName
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Propuesta · {0}"
msgstr "Proposal · {0}"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Propuesta del hotel"
msgstr "Hotel's proposal"

#: src/features/conversion/api/conversionApi.ts
#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
msgid "Propuesta enviada"
msgstr "Proposal sent"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Propuesta enviada al hotel"
msgstr "Proposal sent to the hotel"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Propuesta marcada como enviada"
msgstr "Proposal marked as sent"

#. placeholder {0}: contract.proposal.version
#. placeholder {0}: selected.version
#. placeholder {0}: version.version
#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
#: src/features/onboarding/components/ProposalVersionHistory.tsx
#: src/features/onboarding/components/ProposalVersionList.tsx
#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Propuesta v{0}"
msgstr "Proposal v{0}"

#. placeholder {0}: String(sentProposal.version)
#. placeholder {0}: selected.version
#. placeholder {1}: formatDayMonth(sentProposal.sentAt as string)
#. placeholder {1}: workspace.hotelName
#: src/features/conversion/api/conversionApi.ts
#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Propuesta v{0} · {1}"
msgstr "Proposal v{0} · {1}"

#. placeholder {0}: prospect.latestProposalVersion
#: src/features/onboarding/utils/resolveActivityLabel.ts
msgid "Propuesta v{0} enviada"
msgstr "Proposal v{0} sent"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
#: src/features/onboarding/pages/ProposalListPage.tsx
#: src/features/onboarding/pages/ProposalVersionPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Propuestas"
msgstr "Proposals"

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Propuesto con la inicial y el apellido; cámbialo si ya existe."
msgstr "Suggested from the initial and last name; change it if it already exists."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Prospecto actualizado"
msgstr "Prospect updated"

#. placeholder {0}: form.hotelName
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Prospecto creado — {0}"
msgstr "Prospect created — {0}"

#: src/features/dashboard/components/StatusFunnel.tsx
msgid "Prospectos"
msgstr "Prospects"

#: src/features/dashboard/components/ActivityCards.tsx
#: src/features/observability/lib/people.ts
#: src/features/team/pages/TeamPage.tsx
msgid "Prospectos abiertos"
msgstr "Open prospects"

#: src/features/observability/lib/salesKpis.ts
msgid "Prospectos abiertos con {STALE_DAYS} días o más sin un intento de contacto."
msgstr "Open prospects with {STALE_DAYS} days or more without a contact attempt."

#: src/features/team/pages/TeamPage.tsx
msgid "Prospectos abiertos del equipo"
msgstr "The team's open prospects"

#: src/features/observability/lib/salesKpis.ts
msgid "Prospectos estancados"
msgstr "Stalled prospects"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "protegido (Gris)"
msgstr "protected (Gray)"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Protegido (Gris)"
msgstr "Protected (Gray)"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Próximamente"
msgstr "Coming soon"

#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "Prueba con otra parte del nombre, o quita la búsqueda."
msgstr "Try another part of the name, or clear the search."

#: src/shared/constants/workerEnums.ts
msgid "Público"
msgstr "Public"

#: src/features/recruitment/pages/SelfPickHotelPage.tsx
msgid "Puede que otra Reclutadora ya los haya llenado. Vuelve a la Bolsa para ver los de todos los hoteles."
msgstr "Another Recruiter may have filled them already. Go back to the pool to see open slots at every hotel."

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
msgid "Puede que ya no tenga requisiciones o que no estén en tu zona. Vuelve al tablero para ver las de todos los hoteles."
msgstr "It may have no requisitions left, or they may be outside your zone. Go back to the board to see every hotel's requisitions."

#: src/shared/components/LanguagePrompt.tsx
msgid "Puedes cambiarlo después desde tu perfil · You can change this later"
msgstr "Puedes cambiarlo después desde tu perfil · You can change this later"

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "Puedes dejar al BD sin territorio: queda visible así en Mi Equipo hasta el siguiente reparto."
msgstr "You can leave the BD with no territory: it shows that way in My Team until the next handout."

#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/onboarding/components/ProposalRateFields.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Puesto"
msgstr "Job title"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Puesto «{jobTitleText}» no es un tipo de usuario del sistema: elígelo después"
msgstr "Job title “{jobTitleText}” isn't one of the system's user types: choose it later"

#: src/features/onboarding/components/JobTitleSelect.tsx
msgid "Puesto actual"
msgstr "Current job title"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Puesto del contacto"
msgstr "Contact's job title"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Puesto por puesto"
msgstr "Position by position"

#: src/features/contracts/components/ActivateContractDialog.tsx
#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Puestos cotizados"
msgstr "Positions quoted"

#: src/features/observability/lib/workerKpis.ts
#: src/features/personnel/components/WorkerPerformanceRadar.tsx
msgid "Puntualidad"
msgstr "Punctuality"

#. placeholder {0}: formatDate(access.changedByWorkerAt)
#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Puso la suya el {0}. Esa no se guarda: si la olvida, ponle una nueva."
msgstr "They set their own on {0}. That one isn't saved: if they forget it, set a new one."

#. placeholder {0}: data.hotelName
#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "QR de ponche de {0}"
msgstr "Punch QR for {0}"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "QR del hotel"
msgstr "Hotel QR"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "QR regenerado: versión {version}. Descarga la hoja nueva."
msgstr "QR regenerated: version {version}. Download the new sheet."

#: src/features/reports/pages/ReportsPage.tsx
msgid "qué canal sí logra contacto"
msgstr "which channel actually gets through"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Qué estás viendo"
msgstr "What you're looking at"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Que la genere el sistema"
msgstr "Let the system create it"

#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Qué necesita"
msgstr "What they need"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Qué pasa al aprobar"
msgstr "What happens when you approve"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Qué pasa después del alta"
msgstr "What happens after intake"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Qué pasó con este intento"
msgstr "What happened on this attempt"

#: src/features/observability/components/CohortSection.tsx
msgid "Qué pasó con quienes ya no trabajan"
msgstr "What happened to those who no longer work"

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "Qué pasó y cuándo…"
msgstr "What happened and when…"

#: src/features/observability/components/CohortSection.tsx
msgid "Qué pasó y motivo"
msgstr "What happened and why"

#: src/features/observability/components/CohortSection.tsx
msgid "Qué semanas ver"
msgstr "Which weeks to view"

#. placeholder {0}: index + 1
#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Qué va en la variable {0}"
msgstr "What goes in variable {0}"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Qué viste y cómo se resuelve — p. ej. «Salió por el acceso de servicio; el GPS tomó la calle.»"
msgstr "What you saw and how it's resolved — e.g. \"Left through the service entrance; the GPS picked up the street.\""

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "queda como gasto de Oranje, sin tocar su pago"
msgstr "stays as Oranje's expense, without touching their pay"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Queda lista para pago y factura, y deja de poder corregirse desde aquí. Si algo cambia después de aprobarla, contacta a Oranje."
msgstr "It's ready for payment and invoicing, and can no longer be corrected from here. If something changes after approving it, contact Oranje."

#: src/features/contracts/components/UnlockContractDialog.tsx
msgid "Queda registrado en el journal, con este motivo."
msgstr "This gets logged in the journal, with this reason."

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Queda señalada como manual"
msgstr "It's flagged as manual"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Quedan días con anomalía sin resolver: revísalos antes de enviar la semana."
msgstr "There are still days with unresolved anomalies: review them before sending the week."

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Quedan días sin marca ni estado: marca Descanso, OFF… en cada uno antes de enviar la semana."
msgstr "There are still days without a mark or a status: mark Rest, OFF… on each one before sending the week."

#: src/features/contracts/components/ContractNextStep.tsx
#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Quién"
msgstr "Who"

#: src/features/reports/pages/ReportsPage.tsx
msgid "quién convierte y en cuánto tiempo"
msgstr "who converts and how long it takes"

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Quién firma por el hotel"
msgstr "Who signs for the hotel"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Quién la está trabajando"
msgstr "Who is working on it"

#: src/features/requisitions/components/SlotList.tsx
msgid "Quien lo cubrió ya terminó"
msgstr "Whoever covered it has finished"

#: src/features/observability/components/CohortSection.tsx
msgid "Quién lo originó"
msgstr "Who originated it"

#: src/features/observability/components/CohortSection.tsx
msgid "Quién originó la salida"
msgstr "Who originated the exit"

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Quién trabaja el turno"
msgstr "Who works the shift"

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Quien trabaja en dos hoteles la misma semana tiene dos consolidados — cada uno con su propio cheque."
msgstr "Someone who works at two hotels the same week has two consolidations — each with its own check."

#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "Quienes la recibirían hoy: sin dados de baja, inactivos ni lista negra."
msgstr "Who would receive it today: no opt-outs, inactive or blacklisted contacts."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Quintana Roo — Cancún (sin horario de verano)"
msgstr "Quintana Roo — Cancún (no daylight saving)"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Quita el filtro para reordenar"
msgstr "Clear the filter to reorder"

#: src/features/accounting/components/PayOverrideDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Quitando…"
msgstr "Removing…"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Quitar"
msgstr "Remove"

#. placeholder {0}: roleLabelOf(extra.code).title
#. placeholder {1}: item.fullName
#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Quitar {0} a {1}"
msgstr "Remove {0} from {1}"

#. placeholder {0}: contactName(contact)
#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Quitar a {0}"
msgstr "Remove {0}"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Quitar acceso"
msgstr "Remove access"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Quitar botón"
msgstr "Remove button"

#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "Quitar búsqueda"
msgstr "Clear search"

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Quitar corrección"
msgstr "Remove correction"

#. placeholder {0}: String(index + 1)
#: src/features/onboarding/components/ProposalRateFields.tsx
msgid "Quitar el renglón {0}"
msgstr "Remove line {0}"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Quitar esta posición del contrato"
msgstr "Remove this position from the contract"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Quitar esta posición del pedido"
msgstr "Remove this position from the request"

#: src/shared/components/FilterReset.tsx
msgid "Quitar filtros"
msgstr "Clear filters"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Quitar la deducción de {label}"
msgstr "Remove the {label} deduction"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Quitar la marca"
msgstr "Remove the mark"

#. placeholder {0}: String(index + 1)
#: src/features/contracts/components/NewContractDialog.tsx
msgid "Quitar posición {0}"
msgstr "Remove position {0}"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Quitar posición {ordinal}"
msgstr "Remove position {ordinal}"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Quitar selección"
msgstr "Clear selection"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Quitar, volver a pedirlo"
msgstr "Remove, ask for it again"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Radio de geocerca"
msgstr "Geofence radius"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Razón social de Oranje"
msgstr "Oranje's legal name"

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "Reactiva hacia Azul claro: {reactivatedLabel}."
msgstr "Reactivates to Light blue: {reactivatedLabel}."

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Reactivar"
msgstr "Reactivate"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "reactivarlo es del BD o del BDC."
msgstr "reactivating it is the BD's or the BDC's."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "reactivarlo es del BDC."
msgstr "reactivating it is the BDC's."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Reactivo actualizado"
msgstr "Checklist item updated"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Reactivos de Inspección"
msgstr "Inspection Checklist Items"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Reactivos de Inspección es distinto"
msgstr "Inspection Checklist Items works differently"

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "Reales"
msgstr "Actual"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Reanudar"
msgstr "Resume"

#: src/features/observability/lib/people.ts
msgid "Reasignadas"
msgstr "Reassigned"

#: src/features/observability/lib/people.ts
msgid "Reasignó la requisición"
msgstr "Reassigned the requisition"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Recalculando…"
msgstr "Recalculating…"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Recalcular"
msgstr "Recalculate"

#: src/shared/components/ReloadButton.tsx
msgid "Recargar"
msgstr "Reload"

#: src/features/onboarding/components/HotelLocationMap.tsx
msgid "Recentrar"
msgstr "Recenter"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Rechazada"
msgstr "Rejected"

#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "Rechazando…"
msgstr "Rejecting…"

#: src/features/admin/components/PendingHotelUsers.tsx
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Rechazar"
msgstr "Reject"

#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "Rechazar ajuste"
msgstr "Reject adjustment"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Rechazaste firmar: el envío quedó cancelado."
msgstr "You declined to sign: the request was canceled."

#: src/features/territory/components/TerritoryMapLegend.tsx
msgid "Rechazo"
msgstr "Rejection"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Rechazó firmar"
msgstr "Declined to sign"

#: src/shared/constants/onboardingStatus.ts
msgid "Rechazo o no interés"
msgstr "Rejection or no interest"

#: src/shared/constants/roles.ts
msgid "Reclutadora"
msgstr "Recruiter"

#: src/features/requisitions/components/RequisitionJournalDialog.tsx
msgid "Reclutadora salió"
msgstr "Recruiter left"

#: src/features/requisitions/components/RequisitionJournalDialog.tsx
msgid "Reclutadora se unió"
msgstr "Recruiter joined"

#: src/features/observability/lib/cohorts.ts
#: src/features/observability/pages/ObservabilityPage.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
#: src/features/recruitment/pages/PoolPage.tsx
msgid "Reclutamiento"
msgstr "Recruitment"

#: src/features/conversion/api/conversionApi.ts
msgid "Reclutamiento e Inspección toman la operación"
msgstr "Recruitment and Inspection take over the operation"

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
msgid "Reclutamiento pide, el Manager de QA aprueba"
msgstr "Recruitment requests, the QA Manager approves"

#. placeholder {0}: formatDate(profile.dueAt)
#. placeholder {1}: profile.day ?? 1
#: src/features/worker/components/AccessDeadlineBanner.tsx
msgid "Reclutamiento ya te validó con tu expediente a medias. Tienes hasta el <0>{0}</0> (día {1} de 1); después tu acceso se bloquea hasta que lo completes."
msgstr "Recruitment already validated you with your incomplete file. You have until <0>{0}</0> (day {1} of 1); after that your access locks until you complete it."

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Recupera tu contraseña"
msgstr "Reset your password"

#: src/shared/components/SettlementEffectBadge.tsx
msgid "Reembolso: se le suma"
msgstr "Reimbursement: added to their pay"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Reemplazar"
msgstr "Replace"

#: src/features/admin/components/UserFormDialog.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Reemplazar foto"
msgstr "Replace photo"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Reenviar a Meta"
msgstr "Resubmit to Meta"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Reenviar contrato por correo"
msgstr "Resend contract by email"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Reenviar invitación"
msgstr "Resend invitation"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Reenviar por correo"
msgstr "Resend by email"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "Regenerando…"
msgstr "Regenerating…"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "Regenerar QR"
msgstr "Regenerate QR"

#: src/features/timesheet/components/ManualPunchDialog.tsx
#: src/features/worker/pages/PunchPage.tsx
msgid "Registrando…"
msgstr "Recording…"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Registrar cobro"
msgstr "Record collection"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Registrar el intento"
msgstr "Log the attempt"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Registrar envío al hotel"
msgstr "Record sending to hotel"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Registrar intento"
msgstr "Log attempt"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Registrar intento de contacto"
msgstr "Log contact attempt"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Registrar la marca"
msgstr "Record the punch"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Registrar marca"
msgstr "Record punch"

#: src/features/accounting/components/PayConsolidationButton.tsx
msgid "Registrar pago"
msgstr "Record payment"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Registras la hora real del hecho, no la de ahora: esa es la que cuenta horas para la nómina."
msgstr "You record the actual time it happened, not the current time: that's what counts hours for payroll."

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Registró"
msgstr "Logged by"

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "Registro de entrada y salida"
msgstr "Clock in and clock out"

#: src/features/observability/components/CohortSection.tsx
msgid "Regresaron el lunes"
msgstr "Came back Monday"

#: src/features/observability/components/CohortsView.tsx
msgid "Regresaron la semana siguiente"
msgstr "Came back the following week"

#: src/features/timesheet/components/AttendanceView.tsx
#: src/features/timesheet/components/CorrectPunchDialog.tsx
#: src/features/timesheet/components/ManualPunchDialog.tsx
#: src/features/timesheet/components/ReviewDayDialog.tsx
#: src/features/worker/api/punchApi.ts
msgid "Regreso de lunch"
msgstr "Back from lunch"

#: src/features/onboarding/components/ViewProposalDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Reintentar"
msgstr "Retry"

#: src/shared/constants/onboardingStatus.ts
msgid "Renegociación / desbloqueo"
msgstr "Renegotiation / unblock"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Renglón completo"
msgstr "Line complete"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Renombrar"
msgstr "Rename"

#. placeholder {0}: doc.displayName
#. placeholder {0}: i18n._(editor.noun)
#: src/features/admin/pages/CatalogsPage.tsx
#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Renombrar {0}"
msgstr "Rename {0}"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Renovar contrato"
msgstr "Renew contract"

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "Repartir el territorio"
msgstr "Hand out territory"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Repetido en el archivo"
msgstr "Repeated in the file"

#. placeholder {0}: String(seen.get(nameKey(hotelName)))
#: src/features/onboarding/import/mapImportRows.ts
msgid "Repetido en el archivo (fila {0})"
msgstr "Repeated in the file (row {0})"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/worker/components/ChangePasswordForm.tsx
msgid "Repítela"
msgstr "Repeat it"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/HotelUsersSection.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/admin/pages/UsersPage.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Reporta a"
msgstr "Reports to"

#. placeholder {0}: member.reportsTo.fullName
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "reporta a {0}"
msgstr "reports to {0}"

#: src/features/observability/lib/inspectionKpis.ts
#: src/shared/constants/workerStatus.ts
msgid "Reportado"
msgstr "Reported"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Reportado (Rojo)"
msgstr "Reported (Red)"

#: src/features/observability/lib/cohorts.ts
msgid "Reportado por el hotel"
msgstr "Reported by the hotel"

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "Reportando…"
msgstr "Reporting…"

#: src/features/personnel/components/ReportWorkerDialog.tsx
#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Reportar"
msgstr "Report"

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "Reportar a {workerName}"
msgstr "Report {workerName}"

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "Reportar es más serio que Stand-by"
msgstr "Reporting is more serious than Stand-by"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/reports/pages/ReportsPage.tsx
msgid "Reporte"
msgstr "Report"

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/MessagingPage.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
#: src/features/reports/pages/ReportsPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Reportes"
msgstr "Reports"

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Reportes de Reclutamiento"
msgstr "Recruitment reports"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Reprogramar"
msgstr "Reschedule"

#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "Requisición"
msgstr "Requisition"

#. placeholder {0}: board.requisitionState.name
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Requisición · {0}"
msgstr "Requisition · {0}"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Requisición {requisitionNumber} eliminada"
msgstr "Requisition {requisitionNumber} deleted"

#: src/features/requisitions/components/RequisitionJournalDialog.tsx
msgid "Requisición autorizada"
msgstr "Requisition authorized"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/requisitions/components/RequisitionJournalDialog.tsx
msgid "Requisición creada"
msgstr "Requisition created"

#: src/features/requisitions/components/RequisitionJournalDialog.tsx
msgid "Requisición eliminada"
msgstr "Requisition deleted"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
#: src/features/requisitions/pages/RequisitionDetailPage.tsx
#: src/layouts/GlobalSearch.tsx
#: src/layouts/Sidebar.tsx
msgid "Requisiciones"
msgstr "Requisitions"

#: src/features/observability/lib/people.ts
msgid "Requisiciones a su cargo"
msgstr "Requisitions in their charge"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Requisiciones abiertas"
msgstr "Open requisitions"

#: src/features/observability/lib/people.ts
msgid "Requisiciones abiertas en su zona"
msgstr "Open requisitions in their zone"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Requisiciones autorizadas, en proceso o cubiertas parcialmente"
msgstr "Requisitions authorized, in progress or partially covered"

#: src/features/observability/lib/hotelKpis.ts
msgid "Requisiciones creadas en el periodo que hoy están eliminadas. No incluye las modificadas."
msgstr "Requisitions created in the period that are deleted today. Doesn't include the modified ones."

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Requisiciones críticas"
msgstr "Critical requisitions"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Requisiciones cubiertas"
msgstr "Covered requisitions"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Requisiciones del hotel"
msgstr "Hotel requisitions"

#: src/features/observability/lib/hotelKpis.ts
msgid "Requisiciones eliminadas"
msgstr "Deleted requisitions"

#: src/features/dashboard/components/RecruitmentDashboard.tsx
msgid "Requisiciones en cola"
msgstr "Requisitions in queue"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Requisiciones por estado y lugares cubiertos; sin las eliminadas"
msgstr "Requisitions by status and slots filled; deleted ones excluded"

#: src/features/observability/lib/people.ts
msgid "Requisiciones que creó"
msgstr "Requisitions they created"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Requisiciones que está llenando"
msgstr "Requisitions they're filling"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Requisiciones que están llenando"
msgstr "Requisitions being filled"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Requisitos para habilitar la conversión"
msgstr "What's needed to unlock the conversion"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Resolver y marcar revisado"
msgstr "Resolve and mark as reviewed"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Respaldo"
msgstr "Backup"

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "Responsable"
msgstr "Responsible"

#. placeholder {0}: item.label
#: src/features/audits/components/AuditFormDialog.tsx
msgid "Respuesta para {0}"
msgstr "Answer for {0}"

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Respuestas"
msgstr "Replies"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/components/ReportCharts.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
#: src/features/onboarding/components/RegisterAttemptDialog.tsx
#: src/features/reports/pages/ReportsPage.tsx
msgid "Resultado"
msgstr "Outcome"

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Resultado de los mensajes"
msgstr "Message outcomes"

#: src/layouts/GlobalSearch.tsx
msgid "Resultados"
msgstr "Results"

#: src/features/messaging/pages/MessagingPage.tsx
msgid "Resumen de la operación"
msgstr "Summary of the operation"

#: src/features/accounting/types/settlement.constants.ts
msgid "Retención del 16%"
msgstr "16% withholding"

#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Retención del 16% aceptada"
msgstr "16% retention accepted"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Retención del 16% aceptada: ya no se pide el SSN/ITIN"
msgstr "16% retention accepted: the SSN/ITIN is no longer requested"

#: src/features/observability/components/CohortsView.tsx
msgid "Retención por cohorte"
msgstr "Retention by cohort"

#. placeholder {0}: fields.join(', ')
#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Revisa estos campos: {0}."
msgstr "Check these fields: {0}."

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/types/settlement.constants.ts
#: src/shared/constants/timesheetStatus.ts
msgid "Revisado"
msgstr "Reviewed"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "revisados"
msgstr "reviewed"

#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "Revisando a quién le llegaría…"
msgstr "Checking who it would reach…"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Revisando con las reglas de Meta…"
msgstr "Checking against Meta's rules…"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Revisando el archivo…"
msgstr "Checking the file…"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Revisando…"
msgstr "Checking…"

#: src/features/timesheet/components/AttendanceView.tsx
#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "Revisar"
msgstr "Review"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Revisar el día"
msgstr "Review the day"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Revisar no es aprobar"
msgstr "Reviewing isn't approving"

#: src/features/worker/components/NativePunchGate.tsx
msgid "Revisar permisos"
msgstr "Check permissions"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Revisas antes de importar"
msgstr "You review before importing"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Revisión"
msgstr "Review"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Revisión del día"
msgstr "Day review"

#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "Rige desde"
msgstr "In force from"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Ritmo de entrega y lectura"
msgstr "Delivery and read pace"

#: src/shared/components/ApprovalTimelinessPanel.tsx
#: src/shared/constants/onboardingStatus.ts
msgid "Rojo"
msgstr "Red"

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "Rojo · anomalía"
msgstr "Red · anomaly"

#: src/features/dashboard/components/PipelineFlowCard.tsx
msgid "Rojo, Café y Negro pueden reactivarse: vuelven a Azul claro."
msgstr "Red, Brown and Black can be reactivated: they go back to Light blue."

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/HotelUsersSection.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/admin/pages/UsersPage.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Rol"
msgstr "Role"

#: src/shared/constants/onboardingStatus.ts
msgid "Rosa"
msgstr "Pink"

#: src/features/conversion/components/ApproveConversionDialog.tsx
#: src/features/team/pages/TeamPage.tsx
msgid "Rosa → Naranja"
msgstr "Pink → Orange"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "Rosa → Naranja, por semana"
msgstr "Pink → Orange, per week"

#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/pages/PipelinePage.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
#: src/features/recruitment/pages/PoolPage.tsx
#: src/features/recruitment/pages/SelfPickHotelPage.tsx
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Ruta"
msgstr "Breadcrumb"

#: src/features/schedule/components/ScheduleMiniCalendar.tsx
msgid "S"
msgstr "S"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "Sáb"
msgstr "Sat"

#. placeholder {0}: formatDateTime(campaign.scheduledAt)
#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Sale {0}"
msgstr "Goes out {0}"

#: src/features/observability/tabs/RecruitmentTab.tsx
msgid "Sale de la bitácora de las requisiciones (quién las tomó, soltó o reasignó) y del historial de cada candidato nuevo (quién lo dio de alta). A quién asignó cada reclutador no se ve: eso se registra en otra bitácora que el Manager de QA no lee. Quien no movió ninguna requisición ni dio de alta a nadie no aparece."
msgstr "Comes from the requisitions log (who took, released, or reassigned them) and from each new candidate's history (who registered them). Who each recruiter assigned isn't visible: that's recorded in another log the QA Manager doesn't read. Anyone who didn't move a requisition or register anyone doesn't appear."

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Sale del Pool mientras el veto viva; el historial completo queda y solo el Administrador lo levanta."
msgstr "They leave the Pool while the ban is active; the full history stays and only the Administrator can lift it."

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Sale siempre, con o sin pendientes."
msgstr "Always sent, with or without pending items."

#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "Sale sola a esa hora, con los contactos que cumplan el filtro en ese momento."
msgstr "It goes out on its own at that time, to the contacts that match the filter then."

#: src/features/schedule/components/AddShiftDialog.tsx
#: src/features/timesheet/components/AttendanceView.tsx
#: src/features/timesheet/components/CorrectPunchDialog.tsx
#: src/features/timesheet/components/ManualPunchDialog.tsx
#: src/features/timesheet/components/ReviewDayDialog.tsx
#: src/features/worker/api/punchApi.ts
#: src/features/worker/pages/PunchPage.tsx
msgid "Salida"
msgstr "Clock out"

#: src/features/timesheet/components/AttendanceView.tsx
#: src/features/timesheet/components/CorrectPunchDialog.tsx
#: src/features/timesheet/components/ManualPunchDialog.tsx
#: src/features/timesheet/components/ReviewDayDialog.tsx
#: src/features/worker/api/punchApi.ts
msgid "Salida a lunch"
msgstr "Out to lunch"

#: src/features/worker/components/MobileShell.tsx
msgid "Saliendo…"
msgstr "Signing out…"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Salió"
msgstr "Sent"

#. placeholder {0}: formatDateTime(campaign.startedAt)
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Salió {0}"
msgstr "Sent {0}"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Salir de la requisición"
msgstr "Leave the requisition"

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "Salir por una rama pide siempre el motivo, que queda en el historial del prospecto. Cerrar el ciclo (archivarlo) es un acto aparte: libera al hotel para un ciclo nuevo."
msgstr "Leaving through a branch always asks for the reason, which stays in the prospect's history. Closing the cycle (archiving it) is a separate act: it frees the hotel for a new cycle."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Saliste sin firmar. Cuando quieras, «Firmar ahora» te regresa al documento."
msgstr "You left without signing. Whenever you want, “Sign now” takes you back to the document."

#: src/features/messaging/components/Tour.tsx
#: src/shared/components/OnboardingIntro.tsx
msgid "Saltar"
msgstr "Skip"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Salud"
msgstr "Health"

#: src/layouts/Sidebar.tsx
msgid "Schedule"
msgstr "Schedule"

#: src/features/schedule/pages/SchedulePage.tsx
msgid "Schedule del hotel"
msgstr "Hotel Schedule"

#. placeholder {0}: label.trim()
#. placeholder {0}: name.trim()
#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Se agregó «{0}»"
msgstr "“{0}” added"

#: src/features/onboarding/components/ConfirmSendProposalDialog.tsx
msgid "Se arma el PDF y se manda por correo al contacto del hotel."
msgstr "The PDF is put together and sent by email to the hotel's contact."

#: src/shared/constants/onboardingStatus.ts
msgid "Se arma y se envía aquí, dentro de Verde. No se sale hacia otro estado sin haberla mandado."
msgstr "It's put together and sent right here, inside Green. You can't leave Green for another status without having sent it."

#: src/features/messaging/components/ContactActions.tsx
msgid "Se borra de la plataforma de mensajería junto con su historial de mensajes. No se puede deshacer."
msgstr "It is removed from the messaging platform along with its message history. This cannot be undone."

#: src/features/onboarding/components/DeleteHotelAction.tsx
msgid "Se borran el hotel, sus contactos, sus ciclos en el Pipeline y los intentos de contacto. No se puede deshacer; en el historial queda quién lo eliminó."
msgstr "The hotel, its contacts, its Pipeline cycles and its contact attempts are deleted. This can't be undone; the history keeps who deleted it."

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Se canceló el envío. El contrato se puede editar y mandar otra vez."
msgstr "The request was canceled. The contract can be edited and sent again."

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Se capturan en el consolidado"
msgstr "Entered on the consolidation"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Se capturan una sola vez, aquí: cuando el hotel firme su contrato, lo hereda de aquí y no se vuelve a preguntar."
msgstr "Captured only once, here: when the hotel signs its contract, it inherits it from here and it's never asked again."

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Se conserva como historial y no admite cambios."
msgstr "It is kept as history and admits no changes."

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Se conserva como historial: las semanas que rigió se calcularon con él."
msgstr "It is kept as history: the weeks it governed were calculated with it."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Se cotiza por puesto"
msgstr "Quoted per job title"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Se crea como borrador. Ajusta las tarifas por posición y actívalo cuando esté listo."
msgstr "It is created as a draft. Adjust the rates per position and activate it when it is ready."

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Se crea si no existe. Con ella los encuentras en Etiquetas y les mandas una campaña."
msgstr "Created if it doesn't exist. Use it to find them in Tags and send them a campaign."

#. placeholder {0}: campaign.name
#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Se creó «{0}», pero nadie cumple con esos destinatarios: revisa a quién va antes de enviarla."
msgstr "“{0}” was created, but nobody matches those recipients: check who it goes to before sending it."

#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Se descuenta del pago de esta semana. Se puede quitar mientras el consolidado siga en Borrador."
msgstr "It's taken out of this week's pay. It can be removed while the consolidation is still a Draft."

#. placeholder {0}: mealDeductionAmount.toFixed(2)
#: src/features/contracts/components/MultiplierTable.tsx
msgid "Se descuenta, {0} USD por día laborado"
msgstr "Deducted, {0} USD per day worked"

#. placeholder {0}: money(removing.amount)
#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Se devuelven <0>{0}</0> al neto de esta semana. Queda en el historial quién la quitó."
msgstr "<0>{0}</0> goes back to this week's net pay. The history keeps who removed it."

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Se dio de baja"
msgstr "Opted out"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Se elabora y se envía con el hotel en Verde — y de ahí no se avanza sin propuesta enviada."
msgstr "It's written and sent with the hotel in Green — and there's no moving on from there without a proposal sent."

#. placeholder {0}: item.label
#. placeholder {0}: pending.item.name
#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Se eliminó «{0}»"
msgstr "“{0}” deleted"

#: src/features/clients/components/ClientSpotlightCard.tsx
msgid "Se factura {billRange} por hora"
msgstr "Billed at {billRange} per hour"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Se genera automáticamente a partir de los campos — no se edita aquí."
msgstr "It's generated automatically from the fields — it's not edited here."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Se genera automáticamente a partir de los campos de arriba — no se edita aquí."
msgstr "Generated automatically from the fields above — not edited here."

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Se genera solo al correr el pago de la semana (miércoles o la emergencia del jueves) — nunca se crea uno a mano aquí."
msgstr "It's only generated by running the week's payment (Wednesday or Thursday's emergency run) — one is never created by hand here."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Se guarda como borrador: enviarla es otro paso, desde el listado."
msgstr "It is saved as a draft: sending it is a separate step, from the list."

#. placeholder {0}: check.name
#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Se guardará como {0}"
msgstr "It will be saved as {0}"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Se importan, con un aviso:"
msgstr "Imported, with a warning:"

#: src/features/contracts/components/EditRateDialog.tsx
#: src/features/contracts/components/MultiplierTable.tsx
#: src/features/contracts/components/RateTable.tsx
msgid "Se le factura al hotel"
msgstr "Billed to the hotel"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Se le paga a esta posición"
msgstr "Paid for this position"

#: src/features/contracts/components/EditRateDialog.tsx
#: src/features/contracts/components/MultiplierTable.tsx
#: src/features/contracts/components/RateTable.tsx
msgid "Se le paga al colaborador"
msgstr "Paid to the Collaborator"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Se le reembolsa: se suma a lo que Contabilidad le paga en su próxima nómina."
msgstr "They're reimbursed: it's added to what Accounting pays them in their next payroll."

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "se le resta al colaborador"
msgstr "it's subtracted from the collaborator"

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "se le suma al colaborador"
msgstr "it's added to the collaborator"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "se llena ahora"
msgstr "fills now"

#: src/features/messaging/components/tours.ts
msgid "Se manda a Meta para revisión. Solo las aprobadas se pueden usar en campañas."
msgstr "It's sent to Meta for review. Only approved ones can be used in campaigns."

#: src/shared/components/SendDocumentModal.tsx
msgid "Se manda desde notificaciones@oranjepeople.com — las respuestas del hotel llegan a tu correo."
msgstr "It's sent from notificaciones@oranjepeople.com — the hotel's replies arrive in your email."

#. placeholder {0}: campaign.templateName ?? '—'
#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "Se manda por WhatsApp con la plantilla {0}. Una vez enviado, el mensaje no se puede retirar."
msgstr "It's sent on WhatsApp with the template {0}. Once sent, the message can't be withdrawn."

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Se manda y se aprueba en un solo paso: el hotel ya no podrá editar estos días. Si algo cambia después, contacta a Oranje."
msgstr "It's sent and approved in one step: the hotel won't be able to edit these days anymore. If something changes afterward, contact Oranje."

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Se muestra una sola vez: cPanel no la vuelve a enseñar. Cópiala antes de cerrar."
msgstr "It's shown only once: cPanel won't show it again. Copy it before you close."

#: src/features/conversion/api/conversionApi.ts
msgid "Se negocia en Rosa — el sistema aún no lo registra (pendiente de modelar)"
msgstr "Negotiated in Pink — the system doesn't record it yet (still to be modeled)"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Se parte en 40 h regulares y lo que exceda, por requisición. Sin contrato ni tarifa interna que resolver, no se inventa un número — queda en «—»."
msgstr "It splits into 40 regular hours and whatever's beyond that, per requisition. Without a contract or internal rate to resolve, it doesn't invent a number — it shows «—»."

#: src/shared/components/SendDocumentModal.tsx
msgid "Se propone el correo del contacto principal del hotel — puedes cambiarlo."
msgstr "The hotel's main contact's email is suggested — you can change it."

#: src/features/recruitment/components/PoolRoster.tsx
msgid "Se puso disponible por su cuenta: no cambia la asignación de arriba."
msgstr "They marked themselves available on their own — it doesn't change the assignment above."

#. placeholder {0}: grant.fullName
#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Se quitó «{title}» a {0}"
msgstr "“{title}” was removed from {0}"

#. placeholder {0}: money(netAmount)
#: src/features/accounting/components/PayConsolidationButton.tsx
msgid "Se registran <0>{0}</0> como pagados a {workerName}. No se puede deshacer ni editar desde aquí: si algo cambia después, el ajuste va en otra semana."
msgstr "<0>{0}</0> is recorded as paid to {workerName}. This can't be undone or edited from here: if something changes later, the adjustment goes in another week."

#. placeholder {0}: status.workers
#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Se registran o actualizan {0} colaboradores como contactos en la plataforma, con sus etiquetas de hotel y estado. Los de la lista negra quedan inactivos."
msgstr "{0} workers are added or updated as contacts on the platform, with their hotel and status tags. Blacklisted workers are set to inactive."

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Se registran o actualizan los colaboradores como contactos en la plataforma, con sus etiquetas de hotel y estado. Los de la lista negra quedan inactivos."
msgstr "Workers are added or updated as contacts on the platform, with their hotel and status tags. Blacklisted workers are set to inactive."

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Se registran o actualizan solo los colaboradores que cumplan el filtro, con sus etiquetas de hotel y estado. A los demás contactos no les pasa nada."
msgstr "Only the workers that match the filter are registered or updated, with their hotel and status tags. Other contacts aren't touched."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Se vuelve a pedir el SSN/ITIN"
msgstr "The SSN/ITIN is requested again"

#: src/features/worker/components/MobileShell.tsx
msgid "Secciones"
msgstr "Sections"

#: src/shared/constants/onboardingStatus.ts
msgid "Seguimiento"
msgstr "Follow-up"

#: src/features/observability/lib/inspectionKpis.ts
msgid "Seguimiento médico"
msgstr "Medical follow-up"

#. placeholder {0}: draft.version
#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Seguir borrador v{0}"
msgstr "Continue draft v{0}"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Según el día de envío; cada columna muestra cómo terminaron esos mensajes."
msgstr "By sending day; each column shows how those messages ended up."

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Según el país del contacto."
msgstr "By the contact's country."

#: src/shared/constants/catalogs.ts
msgid "Según solicitud"
msgstr "On request"

#. placeholder {0}: entry.date
#: src/features/timesheet/components/TimesheetDayCell.tsx
msgid "Seleccionar {0}"
msgstr "Select {0}"

#: src/layouts/Sidebar.tsx
msgid "Self-Pick"
msgstr "Self-Pick"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Selfie"
msgstr "Selfie"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Selfie es lo normal. QR es para los hoteles que no permiten tomar fotos: Oranje genera un código que el hotel imprime en el acceso."
msgstr "Selfie is the norm. QR is for hotels that don't allow photos: Oranje generates a code the hotel prints at the entrance."

#: src/features/observability/components/CohortsView.tsx
msgid "Sem {k}"
msgstr "Wk {k}"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Semáforo"
msgstr "Status Light"

#: src/features/dashboard/components/RecruitmentDashboard.tsx
msgid "Semáforo del Colaborador · hoy"
msgstr "Collaborator status light · today"

#. placeholder {0}: String(data.poolPendingValidation)
#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Semáforo del Colaborador · hoy · {0} por validar"
msgstr "Collaborator status light · today · {0} pending validation"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Semáforo del motivo"
msgstr "The reason's Status Light"

#: src/features/accounting/pages/ConsolidationsPage.tsx
#: src/features/accounting/pages/PendingApprovalsPage.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "Semana"
msgstr "Week"

#. placeholder {0}: formatWeekRange( selectedWeek, new Date(new Date(`${selectedWeek}T00:00:00Z`).getTime() + 6 * 86_400_000) .toISOString() .slice(0, 10), )
#. placeholder {0}: formatWeekRange(selectedWeek, rows[0]?.weekEnd ?? selectedWeek)
#. placeholder {0}: formatWeekRange(selectedWeek, weekEnd)
#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/accounting/pages/AccountingTimesheetPage.tsx
#: src/features/accounting/pages/ConsolidationsPage.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Semana {0}"
msgstr "Week {0}"

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Semana {rangeLabel}"
msgstr "Week {rangeLabel}"

#: src/features/timesheet/components/TimesheetViewControls.tsx
msgid "Semana anterior"
msgstr "Previous week"

#: src/features/timesheet/components/AttendanceView.tsx
#: src/features/timesheet/components/WeekActionBar.tsx
#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Semana aprobada"
msgstr "Week approved"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Semana cerrada"
msgstr "Week closed"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Semana cerrada — estos valores no cambian aunque ajustes el lonche del hotel."
msgstr "Week closed — these values don't change even if you adjust the hotel's lunch setting."

#: src/features/observability/components/CohortSection.tsx
msgid "Semana de ingreso"
msgstr "Joining week"

#. placeholder {0}: formatWeekRange(selectedWeek, addDaysIso(selectedWeek, 6))
#. placeholder {0}: weekRangeOf(selected)
#: src/features/observability/components/CohortSection.tsx
#: src/features/timesheet/components/AttendanceView.tsx
msgid "Semana del {0}"
msgstr "Week of {0}"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Semana enviada a revisión"
msgstr "Week sent for review"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Semana enviada y aprobada"
msgstr "Week submitted and approved"

#: src/features/observability/components/CohortsView.tsx
msgid "Semana pasada"
msgstr "Last week"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Semana pendiente de aprobar"
msgstr "Week pending approval"

#: src/features/timesheet/components/TimesheetViewControls.tsx
msgid "Semana siguiente"
msgstr "Next week"

#: src/features/schedule/pages/SchedulePage.tsx
msgid "Semana: <0>{coverage}% cubierto</0> · {holes, plural, one {# hueco} other {# huecos}} — se asignan desde la Bolsa de la Reclutadora"
msgstr "Week: <0>{coverage}% covered</0> · {holes, plural, one {# gap} other {# gaps}} — assigned from the Recruiter's Pool"

#: src/features/observability/components/CohortsView.tsx
msgid "Semanal"
msgstr "Weekly"

#: src/features/observability/components/CohortTimeline.tsx
msgid "Semanas de ingreso"
msgstr "Joining weeks"

#: src/features/observability/lib/hotelKpis.ts
msgid "Semanas de timesheet que el hotel recibió y todavía no aprueba."
msgstr "Timesheet weeks the hotel received and hasn't approved yet."

#: src/features/timesheet/components/BulkApproveButton.tsx
msgid "Semanas sin anomalías pendientes, listas para aprobar"
msgstr "Weeks with no anomalies left, ready to approve"

#: src/features/accounting/pages/PendingApprovalsPage.tsx
#: src/features/observability/lib/hotelKpis.ts
#: src/layouts/Sidebar.tsx
msgid "Semanas sin aprobar"
msgstr "Weeks awaiting approval"

#: src/features/observability/components/CohortSection.tsx
msgid "Semanas trabajadas"
msgstr "Weeks worked"

#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Servicios ofrecidos"
msgstr "Services offered"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Servidor de Oranje"
msgstr "Oranje server"

#: src/features/recruitment/components/PoolTable.tsx
msgid "sí"
msgstr "yes"

#. placeholder {0}: contract.hotelName
#: src/features/contracts/components/ContractNextStep.tsx
msgid "Si {0} necesita contrato, crea uno nuevo desde «Agregar contrato»."
msgstr "If {0} needs a contract, create a new one from «Add contract»."

#. placeholder {0}: contract.hotelName
#: src/features/contracts/components/ContractNextStep.tsx
msgid "Si {0} sigue siendo cliente, lo que sigue es crear un contrato nuevo."
msgstr "If {0} is still a client, what comes next is creating a new contract."

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Si <0>{resetSentTo}</0> está registrado en Oranje, el enlace ya va en camino. Revisa también la carpeta de spam."
msgstr "If <0>{resetSentTo}</0> is registered with Oranje, the link is on its way. Check your spam folder too."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Si aparece, el nombre, la dirección, el teléfono, el pin del mapa y la foto llegan solos. Si no está en Google, escribe el nombre abajo y en el siguiente paso marcas el punto en el mapa."
msgstr "If it shows up, the name, address, phone, map pin and photo come in on their own. If it's not on Google, type the name below and mark the spot on the map in the next step."

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Si cambian las tarifas, se corrigen aquí mismo — primero hay que desbloquearlo. Las semanas ya pagadas no se recalculan: cada una usó la tarifa que regía ese día."
msgstr "If rates change, correct them right here — unlock it first. Weeks already paid aren't recalculated: each one used the rate in effect that day."

#: src/features/onboarding/components/DeleteHotelAction.tsx
msgid "Si el hotel ya tiene propuestas, contratos, requisiciones o es cliente, no se elimina: archiva su ciclo."
msgstr "If the hotel already has proposals, contracts, requisitions or is a client, it can't be deleted: archive its cycle instead."

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Si el servidor de Oranje falla, el sistema se pasa a Firebase él solo. Cambia esto a mano solo cuando el correo parezca salir bien pero no llegue."
msgstr "If the Oranje server fails, the system switches to Firebase on its own. Change this by hand only when email seems to go out fine but doesn't arrive."

#: src/features/worker/pages/Phase2Page.tsx
msgid "Si tu Reclutadora no te la tomó en la entrevista, súbela tú. Se guarda al elegirla. No hace falta para que te validen."
msgstr "If your Recruiter didn't take it during the interview, upload it yourself. It saves as soon as you pick it. It's not needed for you to be validated."

#: src/shared/components/MascotaPeek.tsx
msgid "Si tu sesión caduca, al volver a entrar retomas en la misma pantalla."
msgstr "If your session expires, you pick up on the same screen when you sign back in."

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Si ya se lo hiciste llegar al hotel por fuera"
msgstr "If you already got it to the hotel another way"

#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "Sí, activar contrato"
msgstr "Yes, activate contract"

#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "Sí, actualizar"
msgstr "Yes, update"

#: src/features/timesheet/components/BulkApproveButton.tsx
msgid "Sí, aprobarlas"
msgstr "Yes, approve them"

#: src/features/onboarding/components/ContactAttemptLog.tsx
#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Sí, borrar"
msgstr "Yes, delete"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Sí, cancelar borrador"
msgstr "Yes, cancel draft"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Sí, cancelar envío"
msgstr "Yes, cancel request"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Sí, cerrar"
msgstr "Yes, close"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Sí, continuar"
msgstr "Yes, continue"

#: src/features/conversion/components/ApproveConversionDialog.tsx
msgid "Sí, convertir en cliente"
msgstr "Yes, convert to client"

#: src/features/onboarding/components/CreateProposalPromptDialog.tsx
msgid "Sí, crear propuesta"
msgstr "Yes, create proposal"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Sí, dar de baja"
msgstr "Yes, deactivate"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Sí, descartar borrador"
msgstr "Yes, discard draft"

#: src/features/contracts/components/clauses/ClausesEditWarningDialog.tsx
msgid "Sí, editar"
msgstr "Yes, edit"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/recruitment/components/DeleteWorkerDialog.tsx
msgid "Sí, eliminar"
msgstr "Yes, delete"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Sí, eliminar buzón"
msgstr "Yes, delete mailbox"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Sí, eliminar contacto"
msgstr "Yes, delete contact"

#: src/features/onboarding/components/DeleteHotelAction.tsx
msgid "Sí, eliminar hotel"
msgstr "Yes, delete hotel"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Sí, eliminar requisición"
msgstr "Yes, delete requisition"

#: src/features/onboarding/components/ConfirmSendProposalDialog.tsx
msgid "Sí, enviar propuesta"
msgstr "Yes, send proposal"

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "Sí, inclúyelo"
msgstr "Yes, include it"

#: src/shared/components/ReleaseAssignmentWarningDialog.tsx
msgid "Sí, liberar"
msgstr "Yes, release"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/SlotList.tsx
msgid "Sí, liberar slot"
msgstr "Yes, release slot"

#: src/features/onboarding/components/ConfirmSendProposalDialog.tsx
msgid "Sí, marcar como enviada"
msgstr "Yes, mark as sent"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Sí, marcar como enviado"
msgstr "Yes, mark as sent"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Sí, marcar expirado"
msgstr "Yes, mark expired"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/admin/components/RoleGrantsSection.tsx
#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Sí, quitar"
msgstr "Yes, remove"

#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "Sí, rechazar"
msgstr "Yes, reject"

#: src/features/accounting/components/PayConsolidationButton.tsx
msgid "Sí, registrar pago"
msgstr "Yes, record payment"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Sí, volver a correr"
msgstr "Yes, run it again"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Sí: está en Gris y protegido"
msgstr "Yes: they're in Gray and protected"

#: src/features/clients/components/ClientFilters.tsx
msgid "siempre"
msgstr "always"

#: src/features/worker/pages/PermissionsPage.tsx
msgid "Sigue bloqueado. Actívalo desde los Ajustes de tu teléfono."
msgstr "Still blocked. Turn it on from your phone's Settings."

#: src/features/onboarding/components/ContractStepCard.tsx
msgid "Sigue el contrato"
msgstr "Next comes the contract"

#: src/features/onboarding/components/ProspectPhotoCard.tsx
msgid "Sigue el contrato →"
msgstr "Next comes the contract →"

#. placeholder {0}: values.hotelName
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Sigue siendo {0}. Arrastra el mapa para dejar el pin en la entrada por donde llegan los colaboradores: mover el pin no cambia el hotel, solo dónde se poncha."
msgstr "It's still {0}. Drag the map to drop the pin at the entrance the collaborators use: moving the pin doesn't change the hotel, only where they clock in."

#: src/features/observability/lib/cohorts.ts
msgid "Sigue trabajando"
msgstr "Still working"

#: src/features/observability/components/CohortsView.tsx
msgid "Siguen a las 12 semanas"
msgstr "Still around at 12 weeks"

#: src/features/observability/components/CohortsView.tsx
msgid "Siguen a las 4 semanas"
msgstr "Still around at 4 weeks"

#: src/features/observability/components/CohortSection.tsx
msgid "Siguen trabajando"
msgstr "Still working"

#: src/features/worker/pages/Phase2Page.tsx
msgid "Sigues en Blanco hasta que la Reclutadora valide el alta"
msgstr "You stay in White until the Recruiter validates your sign-up"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/components/ContactImportsDialog.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/components/Pager.tsx
#: src/features/messaging/components/Tour.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
#: src/shared/components/CardPagination.tsx
#: src/shared/components/GuidedTour.tsx
msgid "Siguiente"
msgstr "Next"

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Siguiente paso: activar el contrato"
msgstr "Next step: activate the contract"

#: src/shared/components/SoundSwitch.tsx
msgid "Silencio"
msgstr "Muted"

#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Sin acceso a la app"
msgstr "No app access"

#: src/features/onboarding/pages/PipelinePage.tsx
#: src/features/team/pages/TeamPage.tsx
msgid "Sin actividad 7+ días"
msgstr "No activity for 7+ days"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Sin actividad en 7 días o más"
msgstr "No activity in 7 days or more"

#: src/features/observability/components/PeopleView.tsx
msgid "Sin actividad en el periodo"
msgstr "No activity in the period"

#: src/features/dashboard/components/StaleProspectList.tsx
msgid "Sin actividad reciente"
msgstr "No recent activity"

#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "Sin ajustes pendientes: nada que aprobar por ahora."
msgstr "No pending adjustments: nothing to approve for now."

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
msgid "Sin ajustes por incluir: no hay nada aprobado pendiente de decisión."
msgstr "No adjustments to include: nothing approved is pending a decision."

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Sin altas ni asignaciones todavía"
msgstr "No new collaborators or assignments yet"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Sin aprobación no se paga"
msgstr "No approval, no pay"

#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Sin asignación"
msgstr "Not assigned"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Sin asignación en esta requisición: no hay contra qué capturar marcas"
msgstr "No assignment on this requisition: there's nothing to record punches against"

#: src/features/observability/lib/cohorts.ts
msgid "Sin asignación: terminó o lo liberaron"
msgstr "No assignment: it ended or they were released"

#: src/features/requisitions/components/SlotList.tsx
msgid "Sin asignar"
msgstr "Unassigned"

#: src/features/worker/pages/NotificationsPage.tsx
#: src/layouts/Header.tsx
msgid "Sin avisos por ahora."
msgstr "No notices for now."

#: src/features/timesheet/components/PayPreviewBadge.tsx
msgid "Sin bill rate"
msgstr "No bill rate"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Sin campañas"
msgstr "No campaigns"

#: src/features/onboarding/components/HotelGlobeCard.tsx
msgid "Sin ciclo abierto"
msgstr "No open cycle"

#: src/features/team/pages/TeamPage.tsx
msgid "Sin ciclos abiertos ahora mismo: todo lo suyo está convertido o cerrado."
msgstr "No open cycles right now: everything of theirs is converted or closed."

#: src/features/messaging/components/MessagingWorkersList.tsx
msgid "Sin colaboradores"
msgstr "No collaborators"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Sin conceptos en el catálogo: pídele al Administrador que agregue uno en Catálogos."
msgstr "No concepts in the catalog yet: ask the Administrator to add one in Catalogs."

#: src/features/worker/pages/PunchPage.tsx
msgid "Sin conexión: la marca no se puede guardar todavía. Vuelve a intentarlo cuando tengas señal."
msgstr "No connection: the punch can't be saved yet. Try again when you have signal."

#: src/features/messaging/components/ReportCharts.tsx
msgid "Sin confirmar o en cola"
msgstr "Unconfirmed or queued"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Sin contacto identificado"
msgstr "No contact identified"

#: src/features/conversion/api/conversionApi.ts
msgid "Sin contacto registrado — agrégalo en la ficha del prospecto"
msgstr "No contact on record — add one in the prospect's record"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Sin contacto: agrégalo después en la ficha"
msgstr "No contact: add it later on the prospect's page"

#: src/features/messaging/components/MessagingContactsList.tsx
msgid "Sin contactos"
msgstr "No contacts"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Sin contraseñas de por medio"
msgstr "No passwords involved"

#: src/features/clients/components/ClientCardGrid.tsx
#: src/features/clients/components/ClientMapCard.tsx
#: src/features/clients/components/ClientSpotlightCard.tsx
msgid "sin contrato"
msgstr "no contract"

#: src/features/onboarding/components/HotelContactList.tsx
msgid "Sin correo"
msgstr "No email"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Sin crear"
msgstr "Not created"

#: src/features/requisitions/utils/coverage.ts
#: src/features/schedule/pages/SchedulePage.tsx
msgid "sin cubrir"
msgstr "uncovered"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Sin cuenta todavía"
msgstr "No account yet"

#: src/features/observability/lib/cohorts.ts
#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
msgid "Sin dato"
msgstr "No data"

#: src/features/observability/components/KpiCard.tsx
msgid "Sin datos"
msgstr "No data"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Sin deducciones esta semana."
msgstr "No deductions this week."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Sin definir aún…"
msgstr "Not set yet…"

#: src/features/team/pages/HotelTeamPage.tsx
msgid "Sin departamento asignado"
msgstr "No department assigned"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Sin departamento, esta cuenta ve y pide personal de TODOS los departamentos del hotel — la jerarquía simple de un hotel chico, con un solo Supervisor."
msgstr "With no department, this account sees and requests staff for EVERY department in the hotel — the simple hierarchy of a small hotel with a single Supervisor."

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
msgid "Sin dirección todavía"
msgstr "No address yet"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Sin documentos adicionales."
msgstr "No additional documents."

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Sin encabezado"
msgstr "No header"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Sin entrada registrada"
msgstr "No clock-in recorded"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "sin enviar a revisión"
msgstr "not sent for review"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Sin envíos en el periodo"
msgstr "No sends in the period"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Sin estos datos no hay Fase 1"
msgstr "Without these details there's no Phase 1"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Sin etiquetas"
msgstr "No tags"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Sin etiquetas: para mandarles una campaña, elígelos en Contactos específicos."
msgstr "No tags: to send them a campaign, pick them under Specific contacts."

#: src/features/requisitions/components/RequisitionJournalDialog.tsx
msgid "Sin eventos registrados todavía."
msgstr "No events recorded yet."

#: src/shared/constants/workerEnums.ts
msgid "Sin experiencia"
msgstr "No experience"

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Sin filtro se sincronizan todos."
msgstr "With no filter, everyone is synced."

#: src/features/accounting/components/AccountingTimesheetGrid.tsx
#: src/features/timesheet/components/TimesheetGrid.tsx
msgid "Sin folio"
msgstr "No number"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Sin foto todavía. Al elegir el hotel en el buscador, la foto llega sola y se guarda con el prospecto."
msgstr "No photo yet. When you pick the hotel in the search box, the photo comes in on its own and is saved with the prospect."

#: src/features/observability/components/KpiCard.tsx
msgid "Sin fuente"
msgstr "No source"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "sin guardar"
msgstr "unsaved"

#: src/features/accounting/components/AccountingTimesheetGrid.tsx
msgid "Sin hoja esta semana"
msgstr "No sheet this week"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Sin industria"
msgstr "No industry"

#: src/features/recruitment/components/PoolCardBoard.tsx
msgid "Sin inglés registrado"
msgstr "No English level on record"

#: src/features/audits/components/AuditWorkerList.tsx
#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Sin inspeccionar"
msgstr "Not inspected"

#: src/features/dashboard/components/StaleProspectList.tsx
msgid "Sin intento de contacto en 7 días o más"
msgstr "No contact attempt in 7 days or more"

#: src/features/onboarding/utils/resolveActivityLabel.ts
msgid "Sin intentos"
msgstr "No attempts"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Sin intentos registrados todavía. Se llenan desde la bitácora de cada prospecto."
msgstr "No attempts logged yet. They're filled in from each prospect's log."

#: src/features/onboarding/components/ContactAttemptLog.tsx
msgid "Sin intentos registrados. Usa «Registrar intento» para anotar el primero."
msgstr "No attempts logged. Use “Log attempt” to record the first one."

#. placeholder {0}: IS_DEV_UI ? ' (D-27)' : ''
#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Sin ITIN: aplica retención del 16%{0}"
msgstr "No ITIN: 16% withholding applies{0}"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "Sin jornadas este día"
msgstr "No workdays this day"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Sin líneas."
msgstr "No lines."

#. placeholder {0}: campaign.audience.excludedCountries.join(', ')
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Sin los países: {0}"
msgstr "Without countries: {0}"

#: src/features/accounting/pages/PendingApprovalsPage.tsx
#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Sin Manager de Área"
msgstr "No Area Manager"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Sin marcas"
msgstr "No clock marks"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Sin marcas · marcar"
msgstr "No marks · mark"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Sin marcas esta semana."
msgstr "No clock marks this week."

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Sin marcas hoy"
msgstr "No punches today"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Sin marcas registradas todavía."
msgstr "No punches recorded yet."

#: src/features/observability/components/KpiCard.tsx
msgid "Sin meta"
msgstr "No target"

#: src/features/recruitment/components/PoolCardBoard.tsx
msgid "Sin modalidad definida"
msgstr "No hiring modality set"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "sin motivo"
msgstr "no reason"

#: src/features/reports/api/reportsApi.ts
msgid "Sin motivo registrado"
msgstr "No reason on record"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Sin motivos: quien cierre o rechace en este semáforo no tendrá de dónde elegir."
msgstr "No reasons: whoever closes or rejects on this Status Light will have nothing to choose from."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Sin notas registradas."
msgstr "No notes on file."

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Sin país"
msgstr "No country"

#: src/features/worker/components/QrScanner.tsx
msgid "Sin permiso de cámara no se puede leer el QR. Permítelo para este sitio y vuelve a intentar."
msgstr "Without camera permission the QR can't be read. Allow it for this site and try again."

#: src/features/worker/pages/PunchPage.tsx
msgid "Sin permiso de ubicación no se puede ponchar: actívalo en Permisos, en el menú de tu cuenta."
msgstr "Without location permission you can't punch in: turn it on in Permissions, from your account menu."

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Sin plantilla"
msgstr "No template"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Sin plantillas"
msgstr "No templates"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Sin ponche hoy"
msgstr "No punch today"

#: src/features/timesheet/components/TimesheetDayCell.tsx
msgid "Sin ponches"
msgstr "No punches"

#: src/shared/constants/timesheetStatus.ts
msgid "Sin ponches ese día"
msgstr "No punches that day"

#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Sin posición"
msgstr "No position"

#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Sin posición asignada"
msgstr "No position assigned"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "sin posiciones contratadas"
msgstr "no contracted positions"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Sin posiciones para este departamento"
msgstr "No positions for this department"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Sin posiciones: mientras no tenga, nadie puede pedir personal de este departamento."
msgstr "No positions: until it has some, no one can request staff for this department."

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Sin problemas"
msgstr "No problems"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Sin propuesta"
msgstr "No proposal"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "sin propuesta de origen"
msgstr "no originating proposal"

#: src/features/conversion/api/conversionApi.ts
msgid "Sin propuesta enviada — se elabora y envía en Verde"
msgstr "No proposal sent — it's written and sent in Green"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Sin propuesta que mostrar todavía."
msgstr "No proposal to show yet."

#: src/features/dashboard/components/StatusFunnel.tsx
msgid "Sin prospectos abiertos en el periodo."
msgstr "No open prospects in this period."

#: src/features/onboarding/components/PipelineColumn.tsx
msgid "Sin prospectos en este estado"
msgstr "No prospects in this status"

#: src/features/timesheet/components/TimesheetGrid.tsx
msgid "Sin registro este día"
msgstr "No record this day"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "sin requisición"
msgstr "without a requisition"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Sin requisitos pendientes."
msgstr "Nothing left to meet."

#: src/shared/constants/timesheetStatus.ts
msgid "Sin revisar"
msgstr "Not reviewed"

#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "sin salida"
msgstr "no clock-out"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Sin salida registrada"
msgstr "No clock-out recorded"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Sin salidas registradas todavía. Ningún ciclo se ha ido a Rojo, Café o Negro."
msgstr "No exits on record yet. No cycle has gone to Red, Brown or Black."

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Sin salir"
msgstr "Never sent"

#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Sin semanas cerradas en el periodo."
msgstr "No closed weeks in the period."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Sin subir todavía"
msgstr "Not uploaded yet"

#: src/features/clients/components/ClientCardGrid.tsx
msgid "Sin tarifas"
msgstr "No rates"

#: src/features/contracts/components/ContractPdfButton.tsx
#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Sin tarifas no se puede enviar el contrato."
msgstr "A contract with no rates can't be sent."

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Sin tarifas no se puede enviar ni activar: este contrato no trae ninguna posición cotizada."
msgstr "Without rates it can't be sent or activated: this contract has no quoted positions."

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
#: src/features/messaging/components/SyncWorkersButton.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Sin teléfono"
msgstr "No phone"

#: src/features/team/pages/TeamPage.tsx
msgid "sin territorio asignado todavía"
msgstr "no territory assigned yet"

#: src/shared/constants/timesheetStatus.ts
msgid "Sin Timesheet"
msgstr "No Timesheet"

#: src/features/timesheet/components/TimesheetGrid.tsx
msgid "Sin timesheet esta semana"
msgstr "No timesheet this week"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Sin Timesheet esta semana — no registró ni una marca"
msgstr "No Timesheet this week — didn't log a single punch"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Sin Timesheets esta semana."
msgstr "No Timesheets this week."

#: src/features/worker/lib/noShiftMessage.ts
msgid "Sin turnos por ahora"
msgstr "No shifts for now"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Sin ubicación: marca el pin en la ficha del prospecto"
msgstr "No location: set the pin on the prospect's page"

#: src/features/recruitment/components/SelfPickHotelCardList.tsx
msgid "Sin urgentes"
msgstr "None urgent"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Sin verificación pendiente"
msgstr "Nothing left to check"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Sin versión abierta"
msgstr "No open version"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Sin versión abierta · la última ya se envió"
msgstr "No open version · the last one was already sent"

#: src/features/contracts/utils/validity.ts
msgid "sin vigencia"
msgstr "no validity dates"

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "Sin zonas elegidas el BD queda sin territorio asignado."
msgstr "With no zones picked, the BD is left with no territory."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Sin zonas elegidas el Inspector no ve ningún hotel para levantar requisiciones ni inspeccionar."
msgstr "With no zones picked, the Inspector sees no hotel to open requisitions or inspections for."

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "Sin zonas también es válido"
msgstr "No zones is valid too"

#: src/features/messaging/components/tours.ts
msgid "Sincroniza para ver las plantillas que Meta ya aprobó o rechazó."
msgstr "Sync to see the templates Meta has approved or rejected."

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Sincronización"
msgstr "Sync"

#: src/features/messaging/components/TemplateDetailDialog.tsx
msgid "Sincronizada"
msgstr "Synced"

#. placeholder {0}: formatDateTime(template.syncedAt)
#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Sincronizada {0}"
msgstr "Synced {0}"

#: src/features/messaging/components/MessagingTemplatesList.tsx
#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Sincronizando…"
msgstr "Syncing…"

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Sincronizar"
msgstr "Sync"

#. placeholder {0}: chosenIds.length
#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Sincronizar a {0}"
msgstr "Sync {0}"

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Sincronizar colaboradores"
msgstr "Sync workers"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Sincronizar desde Meta"
msgstr "Sync from Meta"

#: src/features/requisitions/components/RequisitionJournalDialog.tsx
#: src/shared/constants/roles.ts
msgid "Sistema"
msgstr "System"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/SlotList.tsx
msgid "Slot liberado"
msgstr "Slot released"

#: src/features/requisitions/components/RequisitionSummaryStrip.tsx
msgid "Slots"
msgstr "Slots"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Slots del renglón"
msgstr "Slots on this line"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "sobre 40 h por requisición"
msgstr "over 40h per requisition"

#: src/features/team/pages/TeamPage.tsx
msgid "Solicitar reporte"
msgstr "Request report"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Solo a quien tenga todas las etiquetas elegidas."
msgstr "Only those with all the selected tags."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Solo aparece quien está en Verde fuerte: expediente completo, validado por Reclutamiento y sin otra asignación activa."
msgstr "Only people in Strong green show up: complete file, validated by Recruitment and with no other active assignment."

#: src/features/team/pages/TeamPage.tsx
msgid "solo ciclos abiertos"
msgstr "open cycles only"

#: src/features/dashboard/components/StatusFunnel.tsx
msgid "Solo ciclos abiertos"
msgstr "Open cycles only"

#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "Solo corriges las horas de tu departamento."
msgstr "You can only correct hours in your own department."

#: src/features/worker/pages/PunchPage.tsx
msgid "Solo dentro del hotel"
msgstr "Only inside the hotel"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "Solo el Administrador levanta"
msgstr "Only the Administrator lifts it"

#: src/shared/constants/workerStatus.ts
msgid "solo el Administrador levanta un veto, desde Blacklist."
msgstr "only the Administrator lifts a ban, from Blacklist."

#. placeholder {0}: IS_DEV_UI ? ' (blacklist:lift)' : ''
#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "Solo el Administrador puede levantar un veto{0}: pídeselo."
msgstr "Only the Administrator can lift a ban{0}: ask them."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Solo el BD dueño del ciclo o el BDC abren y envían versiones. Desde tu rol puedes consultarla, no editarla."
msgstr "Only the BD who owns the cycle or the BDC open and send versions. Your role can read it, not edit it."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Solo el BD dueño del ciclo o el BDC pueden elaborar la propuesta."
msgstr "Only the BD who owns the cycle or the BDC can draft the proposal."

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "Solo el BD, el BDC o el hotel pueden regenerar su QR."
msgstr "Only the BD, the BDC or the hotel can regenerate its QR."

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "solo el BDC"
msgstr "only the BDC"

#: src/features/conversion/api/conversionApi.ts
msgid "solo el BDC aprueba esta transición"
msgstr "only the BDC approves this transition"

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "Solo el BDC o el Administrador pueden asignar territorio."
msgstr "Only the BDC or the Administrator can assign territory."

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Solo el contrato define lo que se paga y se factura"
msgstr "Only the contract defines what is paid and what is billed"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Solo el Manager de Área o el Manager General pueden aprobar la semana."
msgstr "Only the Area Manager or the General Manager can approve the week."

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Solo el nombre es obligatorio. Puesto, teléfono y correo se registran con lo que se tenga y se completan después."
msgstr "Only the name is required. Job title, phone and email go in with whatever you have and get completed later."

#: src/features/observability/components/CohortSection.tsx
msgid "Solo esta semana"
msgstr "Only this week"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Solo lectura: las horas se capturan y revisan en cada hotel. Aquí ves el semáforo de la semana de todos — filtra por Hotel para quedarte en uno solo."
msgstr "Read-only: hours are captured and reviewed at each hotel. Here you see everyone's week status light — filter by Hotel to narrow to one."

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Solo lectura. Las horas se revisan en cada hotel; aquí solo se consultan."
msgstr "Read only. Hours are reviewed at each hotel; here they are only consulted."

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Solo letras, números, punto y guión"
msgstr "Only letters, numbers, dot and hyphen"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Solo lo aprobado paga"
msgstr "Only what's approved gets paid"

#: src/features/observability/tabs/InspectionTab.tsx
msgid "Solo lo que dicen las requisiciones: las de su zona y las que creó. Sus inspecciones, accidentes y visitas no se ven: el Manager de QA no tiene permiso para leerlos. Un inspector sin requisiciones asignadas no aparece."
msgstr "Only what the requisitions say: those in their zone and the ones they created. Their inspections, accidents, and visits aren't visible: the QA Manager doesn't have permission to read them. An inspector with no assigned requisitions doesn't appear."

#: src/features/observability/tabs/InspectionTab.tsx
msgid "Solo los consolidados de nómina por estado. Los KPIs de Contabilidad (consolidados a tiempo, días a invoice, cobro, fuga de horas) necesitan que el Manager de QA pueda leer nómina y facturación."
msgstr "Only payroll consolidations by status. Accounting's KPIs (consolidations on time, days to invoice, collection, hour leakage) need the QA Manager to be able to read payroll and billing."

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Solo los hoteles en Verde (o Café, para renegociar) pueden abrir propuesta — y de Verde no se avanza sin enviarla."
msgstr "Only hotels in Green (or Brown, to renegotiate) can open a proposal — and there's no moving on from Green without sending it."

#: src/features/observability/components/CohortSection.tsx
msgid "Solo para las dos semanas más recientes."
msgstr "Only for the two most recent weeks."

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Solo planeas turnos de tu departamento."
msgstr "You only plan shifts for your department."

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Solo puede haber un principal por hotel."
msgstr "There can only be one main contact per hotel."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Solo puedes crear requisiciones de tu hotel"
msgstr "You can only create requisitions for your hotel"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Solo puedes crear requisiciones de tu hotel."
msgstr "You can only create requisitions for your hotel."

#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "Solo puedes moverla con una Líder de tu equipo o contigo."
msgstr "You can only move them to a Group Leader on your team or to yourself."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Solo puedes pedir posiciones de tu departamento"
msgstr "You can only request positions from your department"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Solo puedes pedir posiciones de tu departamento. Las de otro departamento las crea su Manager de Área o el Manager General."
msgstr "You can only request positions from your department. Those for another department are created by its Area Manager or the General Manager."

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Solo roles internos (nunca Administrador, Sistema, Colaborador ni roles del hotel) y solo a personal interno."
msgstr "Internal roles only (never Administrator, System, Collaborator or hotel roles), and only to internal staff."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Solo roles internos de Oranje — las cuentas de los hoteles van en «Personal de hoteles»."
msgstr "Oranje's internal roles only — hotel accounts go in “Hotel staff”."

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Solo se aprueba una semana enviada a aprobación."
msgstr "Only a week sent for approval can be approved."

#: src/features/contracts/components/UnlockContractDialog.tsx
msgid "Solo se desbloquea un contrato enviado o vigente."
msgstr "Only a sent or active contract can be unlocked."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Solo se ofrecen los superiores del rol elegido: el BD apunta a su BDC, la Reclutadora a su Líder o al Manager de Reclutamiento."
msgstr "Only superiors of the chosen role are offered: the BD points to their BDC, the Recruiter to their Lead or the Recruitment Manager."

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Solo se puede dar a un BD o un BDC: quien ya tiene el Pipeline y puede dar de alta hoteles."
msgstr "It can only be granted to a BD or a BDC: someone who already has the Pipeline and can add hotels."

#: src/features/worker/pages/HomePage.tsx
msgid "Solo se usa al ponchar, para saber que estás dentro del hotel. Al continuar, tu teléfono te va a pedir permiso de ubicación."
msgstr "It's only used when you punch in, to know you're inside the hotel. When you continue, your phone will ask for location permission."

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Solo su autor corrige"
msgstr "Only the author can correct it"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Solo tiene sentido dentro de Hospitality."
msgstr "Only makes sense within Hospitality."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Solo un borrador se cancela."
msgstr "Only a draft gets cancelled."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Solo un contrato vigente se puede marcar expirado."
msgstr "Only a contract in force can be marked expired."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Solo verá los hoteles de estas zonas — nunca todos."
msgstr "They'll only see the hotels in these zones — never all of them."

#: src/features/observability/lib/people.ts
msgid "Soltadas"
msgstr "Released"

#. placeholder {0}: formatWeekRange(target, addDaysIso(target, 6))
#: src/features/timesheet/components/WeekSlider.tsx
msgid "Soltar en: {0}"
msgstr "Drop on: {0}"

#: src/features/observability/lib/people.ts
msgid "Soltó la requisición"
msgstr "Released the requisition"

#: src/shared/components/SoundSwitch.tsx
msgid "Sonido"
msgstr "Sound"

#: src/features/worker/components/MobileShell.tsx
#: src/shared/components/SoundSwitch.tsx
msgid "Sonido apagado"
msgstr "Sound off"

#: src/features/worker/components/MobileShell.tsx
#: src/shared/components/SoundSwitch.tsx
msgid "Sonido encendido"
msgstr "Sound on"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/pages/Phase2Page.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "SSN / ITIN"
msgstr "SSN / ITIN"

#: src/features/worker/components/TaxDocumentUploader.tsx
msgid "SSN o ITIN subido"
msgstr "SSN or ITIN uploaded"

#: src/features/recruitment/lib/profileFields.ts
msgid "SSN/ITIN"
msgstr "SSN/ITIN"

#: src/features/worker/components/TaxDeadlineBanner.tsx
msgid "SSN/ITIN recibido"
msgstr "SSN/ITIN received"

#: src/shared/constants/workerStatus.ts
msgid "Stand-by"
msgstr "Stand-by"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Su conversión ya se aprobó: no hay nada que convertir."
msgstr "Their conversion is already approved: there's nothing to convert."

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Su correo"
msgstr "Their email"

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Su cuenta de Oranje y su correo corporativo, con contraseñas para entregar en mano."
msgstr "Their Oranje account and corporate email, with passwords to hand over in person."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Su cuenta todavía no está lista. Inténtalo en unos minutos."
msgstr "Their account isn't ready yet. Try again in a few minutes."

#: src/features/messaging/components/tours.ts
msgid "Su estado y cuántos mensajes van enviados. Para enviarlas o ver más, entra a Campañas."
msgstr "Their status and how many messages have been sent. To send them or see more, go to Campaigns."

#. placeholder {0}: missingProfileFields.join(', ')
#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Su expediente está a medias: falta {0}."
msgstr "Their file is half done: {0} missing."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Su folio, en qué estado está y cuántos lugares llevas cubiertos de los que pediste."
msgstr "Its number, which status it's in, and how many of the slots you asked for are covered."

#: src/features/admin/components/PendingHotelUsers.tsx
msgid "Su hotel los propuso. Al aprobar, la cuenta se activa y les llega la invitación; hasta entonces no pueden entrar."
msgstr "Their hotel proposed them. On approval the account is activated and their invitation goes out; until then they cannot sign in."

#: src/features/observability/components/CohortSection.tsx
msgid "Su lunes todavía no llega."
msgstr "Their Monday hasn't arrived yet."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Su propio peso por reactivo y arrastre para reordenar — por eso vive separado, con una línea divisoria antes de su pestaña."
msgstr "Its own weight per item and drag to reorder — that's why it lives apart, with a divider before its tab."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Su rol define su app"
msgstr "Their role defines their app"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Su rol ya no da de alta hoteles: el acceso no cuenta."
msgstr "Their role no longer adds hotels: the access doesn't count."

#: src/features/personnel/components/WorkerPerformanceRadar.tsx
msgid "Su semana aún no da para medir"
msgstr "Their week isn't enough to measure yet"

#: src/features/messaging/components/CampaignsTour.tsx
msgid "Sube a tus colaboradores a la plataforma de mensajería. Las campañas solo les llegan a sus contactos."
msgstr "Upload your workers to the messaging platform. Campaigns only reach its contacts."

#: src/features/messaging/components/tours.ts
msgid "Sube un archivo con nombre y teléfono, previsualízalo y luego impórtalo. Ponles una etiqueta para mandarles una campaña."
msgstr "Upload a file with name and phone, preview it and then import it. Tag them to send them a campaign."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Sube un archivo nuevo en lugar de este — queda pendiente de verificar otra vez."
msgstr "Upload a new file in place of this one — it goes back to pending verification."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Sube un archivo nuevo en lugar de este."
msgstr "Upload a new file in place of this one."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Sube un Excel (.xlsx), un CSV o TXT, o un PDF con una tabla. Cada fila se vuelve un hotel con su ciclo en Gris, igual que «Nuevo prospecto»."
msgstr "Upload an Excel (.xlsx), a CSV or TXT, or a PDF with a table. Each row becomes a hotel with its cycle in Gray, just like “New prospect”."

#: src/features/admin/components/UserFormDialog.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/components/PhotoUploader.tsx
#: src/features/worker/components/TaxDocumentUploader.tsx
#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Subiendo…"
msgstr "Uploading…"

#: src/shared/constants/workerStatus.ts
msgid "Subió sus datos en la app y está pendiente de que Reclutamiento valide su expediente."
msgstr "Uploaded their info in the app and is waiting for Recruiting to validate their file."

#. placeholder {0}: documentTypeLabel(type)
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Subir {0}"
msgstr "Upload {0}"

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Subir archivo"
msgstr "Upload file"

#: src/features/worker/components/TaxDeadlineBanner.tsx
msgid "Subir de nuevo"
msgstr "Upload again"

#: src/features/admin/components/UserFormDialog.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Subir foto"
msgstr "Upload photo"

#: src/features/worker/components/PhotoUploader.tsx
msgid "Subir mi foto"
msgstr "Upload my photo"

#: src/features/worker/components/TaxDocumentUploader.tsx
msgid "Subir mi SSN o ITIN"
msgstr "Upload my SSN or ITIN"

#: src/features/worker/components/TaxDocumentUploader.tsx
msgid "Subir otro archivo"
msgstr "Upload another file"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Subtotal"
msgstr "Subtotal"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "suma de los días con marcas"
msgstr "sum of the days with clock marks"

#: src/features/admin/types/admin.types.ts
#: src/shared/constants/roles.ts
msgid "Supervisor"
msgstr "Supervisor"

#. placeholder {0}: manager.fullName
#: src/features/team/pages/HotelTeamPage.tsx
msgid "Supervisores de {0}"
msgstr "{0}'s supervisors"

#: src/features/team/pages/HotelTeamPage.tsx
msgid "Supervisores sin Manager de Área"
msgstr "Supervisors without an Area Manager"

#. placeholder {0}: tag.contactCount
#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Sus {0} contactos se quedan en la plataforma; solo pierden la etiqueta. Un borrador de campaña que la use se quedaría sin esos destinatarios."
msgstr "Its {0} contacts stay on the platform; they only lose the tag. A campaign draft using it would lose those recipients."

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Sus altas"
msgstr "Collaborators they created"

#: src/features/team/pages/TeamPage.tsx
msgid "Sus ciclos abiertos"
msgstr "Their open cycles"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Sus datos"
msgstr "Their info"

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Tablero de Requisiciones"
msgstr "Requisition Board"

#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Tarde"
msgstr "Late"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Tarifa"
msgstr "Rate"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Tarifa acordada"
msgstr "Agreed rate"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Tarifa acordada, en dólares"
msgstr "Agreed rate, in dollars"

#: src/features/contracts/components/EditRateDialog.tsx
msgid "Tarifa de facturación"
msgstr "Bill rate"

#: src/features/contracts/components/EditRateDialog.tsx
msgid "Tarifa de pago"
msgstr "Pay rate"

#: src/features/contracts/components/EditRateDialog.tsx
msgid "Tarifa guardada"
msgstr "Rate saved"

#: src/features/accounting/components/AccountingTimesheetGrid.tsx
msgid "Tarifa interna"
msgstr "Internal rate"

#: src/features/accounting/components/AccountingTimesheetGrid.tsx
msgid "Tarifa interna del colaborador — no es la del contrato de este hotel"
msgstr "The collaborator's internal rate — not this hotel's contract rate"

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Tarifa por hora"
msgstr "Hourly rate"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Tarifa y reparto de horas se pueden corregir aquí; el monto se recalcula solo. La corrida real del miércoles usa tu corrección, no lo calculado."
msgstr "Rate and hour split can be corrected here; the amount recalculates on its own. Wednesday's real run uses your correction, not the calculated value."

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Tarifa/h"
msgstr "Rate/h"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Tarifas"
msgstr "Rates"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Tarifas globales, por ahora"
msgstr "Global rates, for now"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/components/RateTable.tsx
msgid "Tarifas por posición"
msgstr "Rates per position"

#: src/features/observability/lib/inspectionKpis.ts
msgid "Tarjetas de accidente abiertas"
msgstr "Open accident cards"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Tasa"
msgstr "Rate"

#: src/features/dashboard/components/ActivityCards.tsx
#: src/features/team/pages/TeamPage.tsx
msgid "Tasa de conversión"
msgstr "Conversion rate"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Te dice que esa semana ya está lista para el Consolidado — no es un botón, es el estado que dejó el Manager al aprobarla."
msgstr "Tells you that week is already ready for the Consolidation — it's not a button, it's the state the Manager left when approving it."

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Te mandamos un enlace al correo para crear una nueva."
msgstr "We'll email you a link to create a new one."

#: src/features/team/pages/TeamPage.tsx
msgid "te reportan directo"
msgstr "report directly to you"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Te reportan directo"
msgstr "Report directly to you"

#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/pages/Phase3Page.tsx
#: src/features/worker/pages/ProfilePage.tsx
#: src/shared/components/PhoneInput.tsx
msgid "Teléfono"
msgstr "Phone"

#. placeholder {0}: punch.deviceTime
#. placeholder {1}: punch.serverTime
#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "teléfono {0} · <0>servidor {1}</0>"
msgstr "phone {0} · <0>server {1}</0>"

#: src/features/messaging/components/ContactActions.tsx
msgid "Teléfono *"
msgstr "Phone *"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Teléfono con código de país"
msgstr "Phone with country code"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Teléfono copiado: márcalo desde tu celular"
msgstr "Phone number copied: dial it from your phone"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Teléfono de emergencia"
msgstr "Emergency phone"

#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Teléfono de quien envía"
msgstr "Sender's phone"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Teléfono del contacto"
msgstr "Contact's phone"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Teléfono del contacto de emergencia"
msgstr "Emergency contact phone"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Teléfono del contacto no válido: no se guarda"
msgstr "Invalid contact phone: not saved"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Teléfono del hotel no válido: no se guarda"
msgstr "Invalid hotel phone: not saved"

#: src/features/onboarding/components/HotelDataCard.tsx
msgid "Teléfono general"
msgstr "Main phone"

#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Teléfono inválido"
msgstr "Invalid phone"

#. placeholder {0}: worker.phone
#: src/features/messaging/components/ExcludedWorkersDialog.tsx
msgid "Teléfono inválido: {0}"
msgstr "Invalid phone: {0}"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Teléfono y zona"
msgstr "Phone and zone"

#: src/features/personnel/components/StandByDialog.tsx
msgid "Temporada baja"
msgstr "Low season"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/recruitment/types/selfPick.types.ts
#: src/shared/constants/catalogs.ts
msgid "Temporal"
msgstr "Temporary"

#. placeholder {0}: weekdayName((values.weekStartDay + 6) % 7)
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Termina el {0}."
msgstr "Ends on {0}."

#: src/features/requisitions/components/SlotList.tsx
msgid "Terminado"
msgstr "Ended"

#: src/features/worker/pages/Phase2Page.tsx
msgid "Terminar"
msgstr "Finish"

#. placeholder {0}: formatInstantDayMonth(slot.endedAt)
#: src/features/requisitions/components/SlotList.tsx
msgid "Terminó el {0}"
msgstr "Ended on {0}"

#: src/features/observability/lib/cohorts.ts
msgid "Terminó su asignación"
msgstr "Their assignment ended"

#. placeholder {0}: member.fullName
#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "Territorio asignado a {0}"
msgstr "Territory assigned to {0}"

#: src/features/territory/pages/TerritoryPage.tsx
msgid "Territorio de {ownerName}"
msgstr "{ownerName}'s territory"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Texto"
msgstr "Text"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Texto de la propuesta"
msgstr "Proposal text"

#. placeholder {0}: index + 1
#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Texto de la variable {0}"
msgstr "Text for variable {0}"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Texto del botón"
msgstr "Button text"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Texto del encabezado"
msgstr "Header text"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Texto del reactivo"
msgstr "Checklist item text"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Texto del reactivo, p. ej. Uniforme…"
msgstr "Checklist item text, e.g. Uniform…"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Texto fijo"
msgstr "Fixed text"

#: src/shared/constants/catalogs.ts
msgid "Tiempo completo"
msgstr "Full-time"

#: src/features/observability/lib/hotelKpis.ts
msgid "Tiempo en Stand-by"
msgstr "Time in Stand-by"

#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "Tiempo extra"
msgstr "Overtime"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Tiempo hasta entregar"
msgstr "Time to deliver"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Tiempo hasta leer"
msgstr "Time to read"

#: src/features/observability/lib/hotelKpis.ts
msgid "Tiempo para aprobar el timesheet"
msgstr "Time to approve the timesheet"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Tiempo por color del semáforo"
msgstr "Time per Status Light color"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "Tiempo promedio"
msgstr "Average time"

#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Tiempo y medio"
msgstr "Time and a half"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Tiene al menos una posición cotizada"
msgstr "It has at least one position quoted"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Tiene colaboradores asignados: libera las asignaciones antes de eliminarla."
msgstr "It has collaborators assigned: release the assignments before deleting it."

#. placeholder {0}: String(MAX_IMPORT_ROWS)
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Tiene más de {0} hoteles: divídelo en varios archivos."
msgstr "It has more than {0} hotels: split it into several files."

#: src/features/recruitment/components/DeleteWorkerDialog.tsx
msgid "Tiene una asignación activa en un hotel: primero hay que terminarla o reasignarla."
msgstr "They have an active assignment at a hotel: end it or reassign it first."

#: src/features/observability/lib/recruitmentKpis.ts
msgid "Time-to-fill"
msgstr "Time-to-fill"

#: src/features/onboarding/components/StatusTimeline.tsx
#: src/features/territory/components/HotelMapCard.tsx
msgid "Timeline del semáforo"
msgstr "Status Light timeline"

#: src/features/timesheet/pages/TimesheetPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Timesheet"
msgstr "Timesheet"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Timesheet · Todos los hoteles"
msgstr "Timesheet · All hotels"

#: src/layouts/Sidebar.tsx
msgid "Timesheet de todos los hoteles"
msgstr "Timesheet · All hotels"

#: src/layouts/Sidebar.tsx
msgid "Timesheet Global"
msgstr "Global Timesheet"

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "Timesheet Global · Cumplimiento"
msgstr "Global Timesheet · Compliance"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Timesheets sin aprobar"
msgstr "Unapproved Timesheets"

#: src/features/accounting/components/AddDeductionDialog.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Tipo"
msgstr "Type"

#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Tipo de deducción"
msgstr "Deduction type"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Tipo de intento"
msgstr "Attempt type"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Tipo de marca"
msgstr "Punch type"

#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/lib/profileFields.ts
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/pages/Phase3Page.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Tipo de sangre"
msgstr "Blood type"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Tipo y resultado salen de listas cerradas — así los reportes pueden agrupar sin adivinar."
msgstr "Type and outcome come from closed lists — that way reports can group without guessing."

#: src/features/worker/pages/NotificationsPage.tsx
msgid "Tocar un aviso lo marca como leído; los leídos se limpian a los 30 días"
msgstr "Tapping a notice marks it as read; read notices clear after 30 days"

#: src/features/clients/components/ClientFilters.tsx
#: src/features/contracts/components/ContractFilters.tsx
#: src/features/dashboard/api/dashboardApi.ts
#: src/features/onboarding/pages/PipelinePage.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/components/SelfPickFilterBar.tsx
msgid "todas"
msgstr "all"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
#: src/features/territory/components/TerritoryZoneChips.tsx
#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "Todas"
msgstr "All"

#: src/features/messaging/components/MessagingContactsList.tsx
msgid "Todas las etiquetas"
msgstr "All tags"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Todas las semanas, de un vistazo"
msgstr "Every week, at a glance"

#: src/features/admin/components/ColaboradorAccountsSection.tsx
msgid "Todavía nadie tiene correo corporativo asignado."
msgstr "No one has a company email yet."

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
#: src/features/contracts/components/ActivateContractDialog.tsx
#: src/features/contracts/components/clauses/ClausesEditWarningDialog.tsx
#: src/features/conversion/components/ApproveConversionDialog.tsx
msgid "Todavía no"
msgstr "Not yet"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Todavía no eliges a nadie: márcalos en la lista de abajo."
msgstr "You haven't chosen anyone yet: check them in the list below."

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Todavía no ha entrado por primera vez."
msgstr "They haven't signed in for the first time yet."

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Todavía no ha salido ningún correo desde este ambiente."
msgstr "No email has gone out from this environment yet."

#: src/features/observability/tabs/InspectionTab.tsx
msgid "Todavía no hay actividad por persona en Contabilidad: quién consolidó, validó o pagó vive en nómina y facturación, que el Manager de QA no tiene permiso para leer."
msgstr "There's no per-person activity in Accounting yet: who consolidated, validated, or paid lives in payroll and billing, which the QA Manager doesn't have permission to read."

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Todavía no hay archivos en el vault de este hotel. Sube el primero para empezar."
msgstr "This hotel's vault doesn't have any files yet. Upload the first one to get started."

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Todavía no hay campañas en la plataforma."
msgstr "There are no campaigns on the platform yet."

#: src/features/messaging/components/MessagingOverviewPanel.tsx
msgid "Todavía no hay campañas."
msgstr "No campaigns yet."

#: src/features/messaging/components/MessagingWorkersList.tsx
msgid "Todavía no hay colaboradores que puedas ver."
msgstr "There are no collaborators you can see yet."

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Todavía no hay consolidados. Se generan al cerrar la semana con las horas ya aprobadas."
msgstr "There are no consolidations yet. They are generated when the week closes, with the hours already approved."

#: src/features/messaging/components/MessagingContactsList.tsx
msgid "Todavía no hay contactos en la plataforma de mensajería."
msgstr "There are no contacts on the messaging platform yet."

#: src/features/onboarding/components/HotelContactList.tsx
msgid "Todavía no hay contactos."
msgstr "No contacts yet."

#: src/features/onboarding/components/HotelContactList.tsx
msgid "Todavía no hay contactos. Usa «Editar» para agregar el primero."
msgstr "No contacts yet. Use “Edit” to add the first one."

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Todavía no hay contratos. El contrato de un hotel nace en su propia ficha del Pipeline, cuando ya vio la propuesta."
msgstr "There are no contracts yet. A hotel's contract starts on its own Pipeline record, once it has seen the proposal."

#: src/features/admin/components/HotelUsersSection.tsx
msgid "Todavía no hay cuentas de hotel activas. Agrega la primera con el botón de arriba."
msgstr "No active hotel accounts yet. Add the first one with the button above."

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Todavía no hay deducciones. Se capturan en el detalle de cada consolidado mientras está en Borrador."
msgstr "No deductions yet. They are entered on each consolidation while it is a Draft."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Todavía no hay departamentos. Agrega el primero con el botón de arriba; las posiciones se cuelgan de cada uno."
msgstr "No departments yet. Add the first one with the button above; positions hang off each one."

#: src/features/messaging/components/ContactActions.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Todavía no hay etiquetas en la plataforma de mensajería."
msgstr "There are no tags on the messaging platform yet."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Todavía no hay etiquetas en la plataforma."
msgstr "There are no tags on the platform yet."

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "Todavía no hay facturas. Se generan por hotel y semana con las horas autorizadas."
msgstr "There are no invoices yet. They are generated per hotel and week, with the authorized hours."

#: src/features/team/pages/HotelTeamPage.tsx
msgid "Todavía no hay gerentes ni supervisores en tu hotel"
msgstr "There are no managers or supervisors at your hotel yet"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Todavía no hay hoteles dados de alta: los crea Ventas en el Pipeline."
msgstr "No hotels on file yet: Sales creates them in the Pipeline."

#: src/features/observability/components/CohortsView.tsx
msgid "Todavía no hay ingresos que medir."
msgstr "There are no joins to measure yet."

#: src/features/audits/components/AuditHistoryList.tsx
msgid "Todavía no hay inspecciones"
msgstr "No inspections yet"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Todavía no hay motivos. Agrega el primero desde el semáforo al que pertenece."
msgstr "No reasons yet. Add the first one from the Status Light it belongs to."

#: src/features/admin/pages/UsersPage.tsx
msgid "Todavía no hay personal activo. Agrega al primer usuario con el botón de arriba."
msgstr "No active staff yet. Add the first user with the button above."

#: src/features/observability/components/CohortsView.tsx
msgid "Todavía no hay ponches para este hotel."
msgstr "There are no punches for this hotel yet."

#: src/features/onboarding/components/ProposalVersionList.tsx
msgid "Todavía no hay propuesta para este hotel. Empieza con «Abrir propuesta»."
msgstr "No proposal for this hotel yet. Start with “Open proposal”."

#: src/features/onboarding/components/ProposalVersionList.tsx
msgid "Todavía no hay propuesta: se arma con el hotel en Verde."
msgstr "No proposal yet: it's built while the hotel is in Green."

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Todavía no hay reactivos para esta inspección. Pídele al Administrador que los agregue en Catálogos."
msgstr "There are no checklist items for this inspection yet. Ask the Administrator to add them in Catalogs."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Todavía no hay reactivos. Agrega el primero con el botón de arriba."
msgstr "No checklist items yet. Add the first one with the button above."

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Todavía no hay requisiciones autorizadas en ningún hotel."
msgstr "No hotel has authorized requisitions yet."

#: src/features/accounting/components/AccountingTimesheetGrid.tsx
msgid "Todavía no hay timesheets."
msgstr "There aren't any timesheets yet."

#: src/features/onboarding/components/ProposalVersionHistory.tsx
msgid "Todavía no hay versiones de la propuesta."
msgstr "No proposal versions yet."

#: src/features/messaging/components/ContactImportsDialog.tsx
msgid "Todavía no se ha importado ningún archivo."
msgstr "No file has been imported yet."

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Todavía no se puede crear: el hotel está en {statusLabel}. La propuesta se abre cuando llega a Verde (o regresa en Café)."
msgstr "It can't be created yet: the hotel is in {statusLabel}. The proposal opens when it reaches Green (or comes back in Brown)."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Todavía no se puede:"
msgstr "Not available yet:"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Todavía no tiene acceso."
msgstr "They don't have access yet."

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Todavía no tiene Reclutadoras en su grupo."
msgstr "No Recruiters in their group yet."

#: src/features/team/pages/HotelTeamPage.tsx
msgid "Todavía no tiene Supervisores a cargo."
msgstr "No Supervisors in charge yet."

#: src/features/audits/pages/AuditsPage.tsx
msgid "Todavía no tienes ningún hotel cliente en tus zonas asignadas — pídele al Coordinador que revise tu zona."
msgstr "You don't have any client hotels in your assigned zones yet — ask your Coordinator to check your zone."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Todavía no toca convertir"
msgstr "It's not time to convert yet"

#: src/features/timesheet/components/WorkerWeekSummary.tsx
msgid "Todavía se puede corregir y capturar marcas. El Supervisor la envía cuando esté lista."
msgstr "It can still be corrected and punches can still be recorded. The Supervisor sends it when it's ready."

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Todavía sin construir"
msgstr "Not built yet"

#: src/features/accounting/pages/AccountingPendingPages.tsx
msgid "Todavía sin datos conectados"
msgstr "No data connected yet"

#: src/features/admin/components/HotelUsersSection.tsx
msgid "Todo el hotel"
msgstr "The whole hotel"

#: src/shared/components/DateRangeField.tsx
msgid "Todo el periodo"
msgstr "Whole period"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Todo tu equipo tuvo actividad en la última semana."
msgstr "Everyone on your team was active in the last week."

#: src/features/admin/components/HotelUsersSection.tsx
#: src/features/admin/pages/UsersPage.tsx
#: src/features/clients/components/ClientFilters.tsx
#: src/features/contracts/components/ContractFilters.tsx
#: src/features/onboarding/pages/PipelinePage.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "todos"
msgstr "all"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
#: src/features/accounting/pages/ConsolidationsPage.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
#: src/features/accounting/pages/InvoicesPage.tsx
#: src/features/observability/components/CohortSection.tsx
msgid "Todos"
msgstr "All"

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Todos los colaboradores tienen un teléfono válido."
msgstr "All workers have a valid phone."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Todos los contactos"
msgstr "All contacts"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Todos los contactos de la plataforma de mensajería, no solo los de Oranje: los importados, los creados a mano y los de otras áreas."
msgstr "Every contact on the messaging platform, not only Oranje's: imported ones, ones created by hand and those from other areas."

#: src/features/observability/components/CohortSection.tsx
msgid "Todos los de esta cohorte siguen trabajando: no hay salidas que desglosar."
msgstr "Everyone in this cohort is still working: there are no exits to break down."

#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "Todos los días de este grupo pertenecen a esta requisición"
msgstr "Every day in this group belongs to this requisition"

#: src/features/messaging/components/MessagingFilters.tsx
#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "Todos los estados"
msgstr "All statuses"

#: src/features/clients/pages/ClientPortfolioPage.tsx
#: src/features/messaging/components/MessagingFilters.tsx
#: src/features/observability/components/CohortsView.tsx
#: src/features/timesheet/components/TimesheetToolbar.tsx
#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Todos los hoteles"
msgstr "All hotels"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Todos los mensajes de las campañas del periodo."
msgstr "All messages from the period's campaigns."

#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Todos los motivos"
msgstr "All reasons"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Todos los resultados"
msgstr "All results"

#: src/features/observability/lib/people.ts
msgid "Tomadas"
msgstr "Taken"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Tomadas por tu equipo"
msgstr "Taken by your team"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Tomadas por tu equipo y sin cubrir del todo"
msgstr "Taken by your team and not fully covered"

#: src/features/dashboard/components/RecruitmentDashboard.tsx
msgid "Tomadas por una Reclutadora"
msgstr "Taken by a Recruiter"

#: src/features/worker/components/CameraCapture.tsx
msgid "Tomar foto"
msgstr "Take photo"

#: src/features/observability/lib/people.ts
msgid "Tomó la requisición"
msgstr "Took the requisition"

#: src/features/accounting/pages/DeductionsPage.tsx
#: src/features/accounting/pages/InvoiceDetailPage.tsx
#: src/features/accounting/pages/InvoicesPage.tsx
#: src/features/messaging/components/ReportCharts.tsx
msgid "Total"
msgstr "Total"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Total de la semana"
msgstr "Week total"

#. placeholder {0}: report.teamTotals.open
#. placeholder {1}: report.teamTotals.converted
#. placeholder {2}: formatPercent(report.teamTotals.rate)
#. placeholder {3}: report.teamTotals.averageDays !== null ? ` · ${String(report.teamTotals.averageDays)} d` : ''
#: src/features/reports/pages/ReportsPage.tsx
msgid "Total del equipo: {0} abiertos · {1} convertidos · {2}{3}"
msgstr "Team total: {0} open · {1} converted · {2}{3}"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Total: {positionCount, plural, one {# posición} other {# posiciones}} · {totalSlots, plural, one {# slot} other {# slots}}"
msgstr "Total: {positionCount, plural, one {# position} other {# positions}} · {totalSlots, plural, one {# slot} other {# slots}}"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Trabajadas esta semana"
msgstr "Worked this week"

#: src/features/timesheet/components/TimesheetDayCell.tsx
#: src/shared/constants/timesheetStatus.ts
msgid "Trabajando ahora"
msgstr "Working now"

#: src/layouts/RoleSwitcher.tsx
msgid "Trabajar como"
msgstr "Work as"

#: src/features/observability/components/CohortsView.tsx
msgid "Trabajaron en su semana 12 · ~90 días"
msgstr "Worked in their week 12 · ~90 days"

#: src/features/observability/components/CohortsView.tsx
msgid "Trabajaron en su semana 4 · ~30 días"
msgstr "Worked in their week 4 · ~30 days"

#: src/features/observability/components/CohortSection.tsx
msgid "Trabajaron la semana siguiente"
msgstr "Worked the following week"

#: src/features/accounting/components/ConsolidationPayStatus.tsx
msgid "Trabajó en más de un hotel esta semana: cada Consolidado se paga por separado, desde su propia ficha."
msgstr "Worked at more than one hotel this week: each Consolidation is paid separately, from its own record."

#: src/features/messaging/components/tours.ts
msgid "Trae las de Meta"
msgstr "Bring them from Meta"

#: src/shared/components/ReloadButton.tsx
msgid "Traer lo más reciente"
msgstr "Get the latest"

#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/lib/profileFields.ts
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/pages/Phase2Page.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Transporte"
msgstr "Transportation"

#: src/features/worker/pages/Phase2Page.tsx
msgid "Transporte guardado"
msgstr "Transportation saved"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Transporte y salud"
msgstr "Transport and health"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Transporte y tipo de sangre"
msgstr "Transport and blood type"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Transporte, emergencia y salud — opcional"
msgstr "Transport, emergency and health — optional"

#: src/features/observability/lib/cohorts.ts
msgid "Tres faltas: Blacklist automático"
msgstr "Three absences: automatic Blacklist"

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Tres reglas que el sistema hace cumplir siempre: un colaborador en <0>Gris</0> (accidentado) no se puede vetar; solo hay un veto vigente a la vez y el historial nunca se borra; y al levantarlo la persona vuelve a <1>Blanco</1>, reingresando por la validación de la Reclutadora."
msgstr "Three rules the system always enforces: a collaborator in <0>Gray</0> (injured at work) can't be banned; there's only one active ban at a time and the history is never deleted; and when it's lifted the person goes back to <1>White</1>, re-entering through the Recruiter's validation."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "tú"
msgstr "you"

#: src/features/worker/components/MobileShell.tsx
msgid "Tu acceso terminó"
msgstr "Your access has ended"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "Tu actividad"
msgstr "Your activity"

#: src/features/worker/pages/HomePage.tsx
msgid "tu contacto de emergencia"
msgstr "your emergency contact"

#. placeholder {0}: profile.legacyAccess.corporateEmail
#: src/features/worker/pages/PunchPage.tsx
msgid "Tu correo para entrar cambia a <0>{0}</0>: úsalo la próxima vez."
msgstr "Your sign-in email changes to <0>{0}</0>: use it next time."

#: src/features/worker/components/TaxDocumentUploader.tsx
msgid "Tu cuenta aún no tiene permiso para subir archivos: Oranje lo está habilitando."
msgstr "Your account can't upload files yet: Oranje is enabling it."

#: src/features/worker/pages/PunchPage.tsx
msgid "Tu cuenta aún no tiene permiso para subir la foto: Oranje lo está habilitando."
msgstr "Your account can't upload the photo yet: Oranje is enabling it."

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Tu cuenta no está activa en Oranje. Pide al Administrador que la active."
msgstr "Your Oranje account isn't active. Ask the Administrator to activate it."

#: src/features/worker/pages/PunchPage.tsx
msgid "Tu cuenta no está ligada a un colaborador: avisa a Reclutamiento."
msgstr "Your account isn't linked to a collaborator: let Recruitment know."

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Tu cuenta no tiene permiso para subir archivos a este vault."
msgstr "Your account doesn't have permission to upload files to this vault."

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
msgid "Tú decides si entra a la nómina"
msgstr "You decide if it enters payroll"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Tu equipo"
msgstr "Your team"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "Tu equipo avanza contigo"
msgstr "Your team moves forward with you"

#: src/features/worker/pages/ProfilePage.tsx
msgid "Tu estado hoy"
msgstr "Your status today"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Tu expediente quedó completo. La Reclutadora lo validará"
msgstr "Your file is complete. Your Recruiter will validate it"

#: src/features/worker/components/MobileShell.tsx
msgid "Tu expediente ya no está activo en Oranje, así que aquí no hay nada que mostrarte. Si crees que es un error, habla con tu Reclutadora."
msgstr "Your file is no longer active at Oranje, so there's nothing to show you here. If you think this is a mistake, talk to your Recruiter."

#: src/features/worker/pages/Phase2Page.tsx
msgid "Tu foto"
msgstr "Your photo"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Tu gente y su color"
msgstr "Your people and their color"

#: src/features/audits/components/AuditHotelCard.tsx
msgid "Tu hotel"
msgstr "Your hotel"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Tu hotel todavía no tiene un contrato activo con Oranje: pídele a tu ejecutivo de Oranje que lo active."
msgstr "Your hotel doesn't have an active contract with Oranje yet: ask your Oranje representative to activate it."

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Tu hotel usa selfie o el QR del acceso. Si usa QR, desde aquí imprimes la hoja que se pega en la entrada, y puedes regenerarla si se filtró."
msgstr "Your hotel uses a selfie or the entrance QR. If it uses QR, you print the sheet for the entrance from here — and you can regenerate it if it leaks."

#: src/features/worker/pages/PunchPage.tsx
msgid "Tu marca quedó registrada"
msgstr "Your punch was recorded"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Tu plantel de un vistazo"
msgstr "Your staff at a glance"

#. placeholder {0}: profile.position.name
#. placeholder {1}: profile.hiringModality?.name ?? '—'
#. placeholder {2}: profile.englishLevel?.name ?? '—'
#: src/features/worker/pages/Phase2Page.tsx
msgid "Tu posición ({0}), modalidad ({1}) y nivel de inglés ({2}) los definió Oranje en tu entrevista. Si algo no cuadra, coméntalo con tu Reclutadora."
msgstr "Your position ({0}), hiring modality ({1}) and English level ({2}) were set by Oranje at your interview. If something doesn't add up, talk to your Recruiter."

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Tu requisición está cubierta"
msgstr "Your requisition is filled"

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Tu requisición se cerró"
msgstr "Your requisition was closed"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Tú resuelves anomalías y dejas la nota; aprobar las horas es del Manager de Área o del General."
msgstr "You resolve anomalies and leave the note; approving hours is up to the Area Manager or the General Manager."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Tu rol no puede crear requisiciones: las crean el Supervisor, el Manager de Área, el Manager General del hotel o el Inspector de su zona."
msgstr "Your role can't create requisitions: they're created by the Supervisor, the Area Manager, the General Manager, or the Inspector of the zone."

#: src/features/messaging/components/MessagingWorkersList.tsx
msgid "Tu rol no puede ver el listado de colaboradores"
msgstr "Your role cannot see the collaborator list"

#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Tu rol no puede ver esta lista"
msgstr "Your role cannot see this list"

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Tu rol no tiene acceso al Tablero de Requisiciones. Lo ven el hotel que las pide y Reclutamiento."
msgstr "Your role doesn't have access to the Requisitions Board. It's seen by the hotel requesting them and Recruitment."

#: src/features/team/pages/TeamPage.tsx
msgid "Tu rol no tiene BDs a cargo, así que aquí no hay nada que mostrar."
msgstr "Your role has no BDs under it, so there's nothing to show here."

#: src/features/team/pages/HotelTeamPage.tsx
msgid "Tu rol no tiene gerentes ni supervisores a cargo, así que aquí no hay nada que mostrar."
msgstr "Your role has no managers or supervisors under it, so there's nothing to show here."

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Tu rol no tiene Líderes ni Reclutadoras a cargo, así que aquí no hay nada que mostrar."
msgstr "Your role has no Group Leaders or Recruiters under it, so there's nothing to show here."

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Tu rol todavía no tiene acceso a las horas de todos los hoteles."
msgstr "Your role does not have access to the hours of all hotels yet."

#: src/features/worker/pages/ProfilePage.tsx
msgid "Tu semáforo"
msgstr "Your status light"

#: src/features/worker/pages/HomePage.tsx
msgid "Tu semáforo no permite encender Amarillo desde aquí."
msgstr "Your status light doesn't allow turning on Yellow from here."

#: src/features/worker/pages/HomePage.tsx
msgid "Tu semáforo, en palabras"
msgstr "Your status light, in words"

#: src/features/worker/lib/noShiftMessage.ts
msgid "Tu situación está en revisión y no hay turnos que ponchar. Customer Service te puede orientar."
msgstr "Your situation is under review and there are no shifts to clock. Customer Service can guide you."

#: src/features/worker/pages/HomePage.tsx
msgid "tu SSN o ITIN"
msgstr "your SSN or ITIN"

#. placeholder {0}: deadline.isDocumentVerified ? t`verificado` : t`cargado, en verificación`
#: src/features/worker/components/TaxDeadlineBanner.tsx
msgid "Tu SSN/ITIN está {0}."
msgstr "Your SSN/ITIN is {0}."

#: src/features/worker/components/TaxDeadlineBanner.tsx
msgid "Tu SSN/ITIN fue rechazado"
msgstr "Your SSN/ITIN was rejected"

#: src/features/worker/pages/PunchPage.tsx
msgid "Tu teléfono manda la ubicación y el sistema verifica que estés en el hotel. Si estás fuera, pídele al Supervisor un ponche manual."
msgstr "Your phone sends your location and the system checks that you're at the hotel. If you're outside, ask the Supervisor for a manual punch."

#: src/features/worker/pages/HomePage.tsx
msgid "tu tipo de sangre"
msgstr "your blood type"

#: src/features/worker/pages/Phase2Page.tsx
msgid "Tu transporte quedó guardado."
msgstr "Your transportation was saved."

#: src/features/worker/pages/Phase2Page.tsx
msgid "Tu transporte y tu SSN o ITIN"
msgstr "Your transportation and your SSN or ITIN"

#: src/mobile/AppLoginPage.tsx
msgid "Tu turno o la operación de tu hotel, en tu celular."
msgstr "Your shift or your hotel's operation, on your phone."

#: src/features/auth/pages/LoginPage.tsx
msgid "Tu turno, tu ponche y tus datos, en tu celular."
msgstr "Your shift, your punches and your details, on your phone."

#: src/features/audits/pages/AuditsPage.tsx
msgid "Tu usuario no tiene un hotel asignado todavía. Sin hotel no hay a quién inspeccionar — pídele al Administrador que revise tu alta."
msgstr "Your account doesn't have a hotel assigned yet. Without a hotel there's no one to inspection — ask the Administrator to check your account setup."

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Turno agregado"
msgstr "Shift added"

#: src/features/schedule/pages/SchedulePage.tsx
#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "Turno elegido"
msgstr "Selected shift"

#: src/features/worker/pages/NotificationsPage.tsx
msgid "Tus avisos llegarán aquí en cuanto el servicio de notificaciones esté activo."
msgstr "Your notices will show up here as soon as the notification service is active."

#: src/features/worker/pages/ProfilePage.tsx
msgid "Tus datos"
msgstr "Your info"

#: src/features/team/pages/HotelTeamPage.tsx
msgid "Tus gerentes y supervisores"
msgstr "Your managers and supervisors"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Tus Líderes y Reclutadoras, y cómo va el trabajo de cada una"
msgstr "Your Group Leaders and Recruiters, and how each one's work is going"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Tus requisiciones recientes"
msgstr "Your recent requisitions"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Tus tres números"
msgstr "Your three numbers"

#: src/shared/constants/workerStatus.ts
msgid "Tuvo un accidente laboral y está en incapacidad médica. No se le puede vetar mientras esté aquí."
msgstr "Had a workplace accident and is on medical leave. Cannot be blacklisted while here."

#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/onboarding/components/PlacesAutofillSummary.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/worker/pages/PermissionsPage.tsx
msgid "Ubicación"
msgstr "Location"

#: src/features/observability/components/PeopleView.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Última actividad"
msgstr "Last activity"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Última actividad hoy"
msgstr "Last activity today"

#. placeholder {0}: lastSent.version
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Última enviada · v{0}"
msgstr "Last sent · v{0}"

#: src/features/observability/components/CohortSection.tsx
msgid "Última semana"
msgstr "Last week"

#. placeholder {0}: formatDateTime(data.updatedAt)
#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Última vez que se cambió: {0}"
msgstr "Last changed: {0}"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "Últimas 8 semanas"
msgstr "Last 8 weeks"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Últimos 30 días"
msgstr "Last 30 days"

#. placeholder {0}: String(member.workersCreatedLast30Days)
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Últimos 30 días · {0}"
msgstr "Last 30 days · {0}"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Últimos 7 días"
msgstr "Last 7 days"

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/observability/lib/period.ts
msgid "Últimos 90 días"
msgstr "Last 90 days"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Últimos correos"
msgstr "Recent emails"

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Un consolidado es de un colaborador, un hotel y una semana: quien trabajó en dos hoteles aparece dos veces. El filtro por hotel llega después."
msgstr "A consolidation belongs to one collaborator, one hotel and one week: someone who worked at two hotels appears twice. The hotel filter comes later."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Un dato no es válido"
msgstr "A value isn't valid"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Un dato no es válido ({fields})"
msgstr "A value isn't valid ({fields})"

#: src/features/timesheet/components/DayStatusTour.tsx
msgid "Un día sin marcas no se puede enviar a aprobar hasta que elijas qué fue: Descanso, OFF… Tócalo aquí para marcarlo."
msgstr "A day without marks can't be sent for approval until you choose what it was: Rest, OFF… Tap here to mark it."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Un documento por tipo — súbelo, verifícalo o reemplázalo"
msgstr "One document per type — upload it, verify it or replace it"

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "Un hotel en Naranja es cliente activo: primero pásalo a Negro y luego archiva."
msgstr "A hotel in Orange is an active client: move it to Black first, then archive."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Un hotel puede pedir personal cuando llega a Naranja, es decir, cuando ya es cliente activo."
msgstr "A hotel can request staff once it reaches Orange, that is, once it's an active client."

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Un hotel puede tener los contactos que haga falta"
msgstr "A hotel can have as many contacts as it needs"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Un hotel solo puede tener un contrato vigente a la vez: es lo que respalda cada asignación y cada factura."
msgstr "A hotel can only have one contract in force at a time: it is what backs every assignment and every invoice."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Un hotel, un ciclo"
msgstr "One hotel, one cycle"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Un intento puede corregirse o borrarse, pero únicamente por quien lo registró."
msgstr "An attempt can be corrected or deleted, but only by whoever logged it."

#: src/features/timesheet/components/WorkerWeekSummary.tsx
msgid "Un Manager ya la aprobó. Sigue el pago y la factura del hotel."
msgstr "A Manager already approved it. Next come the payment and the hotel's invoice."

#: src/shared/components/SendDocumentModal.tsx
msgid "Un mensaje breve antes del documento (opcional)…"
msgstr "A short message before the document (optional)…"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
#: src/features/worker/pages/HomePage.tsx
msgid "Un momento…"
msgstr "One moment…"

#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Un monto mayor que 0, con hasta 2 decimales (p. ej. 15.00)."
msgstr "An amount greater than 0, with up to 2 decimals (e.g. 15.00)."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Un motivo pertenece a un semáforo: elige a cuál."
msgstr "A reason belongs to a Status Light: pick which one."

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Un número mayor a 0."
msgstr "A number greater than 0."

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Un número válido, 0 o más."
msgstr "A valid number, 0 or more."

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Un pay rate y un bill rate para todo el hotel. Cotizar por posición llegará más adelante."
msgstr "One pay rate and one bill rate for the whole hotel. Quoting per position comes later."

#: src/features/audits/pages/AuditsPage.tsx
msgid "Un registro sin consecuencia"
msgstr "A record with no consequences"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Un renglón por puesto con su pay y su bill: es el mismo cuadro que el hotel firma en el contrato."
msgstr "One line per job title with its pay and its bill: it's the same table the hotel signs in the contract."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Un slot por cada persona pedida en la posición"
msgstr "One slot for each person requested on the position"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Un solo clic: manda la semana y la deja aprobada"
msgstr "One click: submits the week and leaves it approved"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Un solo veto vigente"
msgstr "One active ban at a time"

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Un solo veto vigente por colaborador; el historial nunca se borra"
msgstr "One active ban per collaborator; the history is never deleted"

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Un turno no puede pasar de 16 horas."
msgstr "A shift can't be longer than 16 hours."

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Un veto vigente solo lo levanta el Administrador. Al levantarlo, el colaborador vuelve a Blanco y pasa otra vez por la validación de la Reclutadora antes de ser asignable."
msgstr "Only the Administrator lifts an active ban. Once lifted, the collaborator goes back to White and passes through the Recruiter's validation again before they can be assigned."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Una asignación temporal necesita fecha de fin: mientras dure, el colaborador está en Café y al vencer vuelve a su estado anterior."
msgstr "A temporary assignment needs an end date: while it lasts, the collaborator is in Brown, and when it expires they go back to their previous status."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Una de las posiciones no está en el contrato vigente del hotel: agrégala ahí primero."
msgstr "One of the positions isn't in the hotel's active contract: add it there first."

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
msgid "Una eventual puede llevar un ajuste de tarifa o un gasto con concepto (Uber…). El Manager de QA los revisa, pero eso todavía no les hace nada a tus números."
msgstr "A temporary assignment can carry a rate adjustment or an expense with a concept (Uber…). The QA Manager reviews them, but that still does not do anything to your numbers."

#: src/features/worker/components/TaxDocumentUploader.tsx
msgid "Una foto clara o un PDF. Oranje lo revisa y te avisa cuando quede verificado."
msgstr "A clear photo or a PDF. Oranje reviews it and lets you know when it's verified."

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Una persona en accidente laboral no puede vetarse: primero se resuelve su caso, luego se decide."
msgstr "Someone with a workplace accident can't be banned: their case is resolved first, then it's decided."

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Una persona puede trabajar con más de un rol. Elige con cuál desde el pie del menú y nunca se suman: con cada función ve y hace solo lo de esa función. Las parejas que rompen una doble firma no se pueden dar."
msgstr "A person can work with more than one role. They choose which one from the bottom of the menu, and roles never add up: in each role they see and do only what that role allows. Pairs that would break a double signature can't be granted."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Una posición pertenece a una industria: elige a cuál."
msgstr "A position belongs to one industry: choose which."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Una requisición en este estado no se elimina: las cubiertas se conservan como historia."
msgstr "A requisition in this state can't be deleted: covered ones are kept as history."

#: src/features/observability/components/CohortTimeline.tsx
msgid "Una semana antes"
msgstr "One week earlier"

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "Una semana cerrada sin aprobar no entra al Consolidado ni a la factura del hotel — queda en espera hasta que el Manager de Área la apruebe."
msgstr "A closed week that isn't approved doesn't enter the Consolidation or the hotel's invoice — it stays pending until the Area Manager approves it."

#: src/features/observability/components/CohortTimeline.tsx
msgid "Una semana después"
msgstr "One week later"

#: src/features/contracts/components/RateTable.tsx
msgid "Una tarifa por posición del catálogo"
msgstr "One rate per position in the catalog"

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Una vez revisado el consolidado, sus deducciones quedan firmes. Un error se corrige en Borrador."
msgstr "Once the consolidation is reviewed, its deductions are final. A mistake is fixed while it is a Draft."

#: src/features/accounting/types/settlement.constants.ts
msgid "Uniforme"
msgstr "Uniform"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "uniforme, comida y retención"
msgstr "uniform, meals and withholding"

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Uniforme, comida y retención del 16% no entran solos con la corrida de pago: se agregan en el consolidado de cada colaborador mientras está en Borrador."
msgstr "Uniform, meals and 16% withholding don't come in on their own with the payment run: they are added on each collaborator's consolidation while it is a Draft."

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Uniforme, comida y retención del 16% que se descuentan del pago del colaborador."
msgstr "Uniform, meals and the 16% withholding that are deducted from the collaborator's pay."

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Uniforme, comida y retención no entran solos con la corrida de pago: captúralos antes de marcarlo como revisado."
msgstr "Uniform, meals and withholding don't come in on their own with the payment run: enter them before marking it as reviewed."

#: src/features/audits/components/PersonalPresentationAuditDialog.tsx
msgid "Uniformidad, higiene, seguridad y actitud del colaborador, reactivo por reactivo."
msgstr "The collaborator's uniform, hygiene, safety and attitude, item by item."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Unirme a la requisición"
msgstr "Join the requisition"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Uno de los puestos ya no está en el catálogo. Recarga la página y vuelve a elegirlo."
msgstr "One of the job titles is no longer in the catalog. Reload the page and pick it again."

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Uno de los reactivos ya no es parte de esta inspección. Recarga e inténtalo de nuevo."
msgstr "One of the checklist items is no longer part of this inspection. Reload and try again."

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Uno de los reactivos ya no existe. Recarga e inténtalo de nuevo."
msgstr "One of the checklist items no longer exists. Reload and try again."

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Uno por colaborador, hotel y semana"
msgstr "One per collaborator, hotel and week"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Uno vigente ahora mismo"
msgstr "One active right now"

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Uno vigente por hotel"
msgstr "One in force per hotel"

#: src/features/requisitions/components/RequisitionTable.tsx
msgid "Urgencia"
msgstr "Urgency"

#: src/shared/components/UrgencyChip.tsx
msgid "Urgencia: {label}. Toca para ver el tiempo"
msgstr "Urgency: {label}. Tap to see the timing"

#: src/shared/constants/requisitionStatus.ts
msgid "Urgente"
msgstr "Urgent"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Urgentes"
msgstr "Urgent"

#: src/features/messaging/components/WorkersSyncNotice.tsx
msgid "Usa «Sincronizar colaboradores» antes de crear una campaña: si no, no les llegaría."
msgstr "Use “Sync workers” before creating a campaign, or it will not reach them."

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Usa «Sincronizar desde Meta» para traer las plantillas aprobadas."
msgstr "Use «Sync from Meta» to bring in the approved templates."

#. placeholder {0}: String(max)
#: src/features/onboarding/types/prospectForm.schema.ts
msgid "Usa como máximo {0} caracteres"
msgstr "Use at most {0} characters"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Usa la plantilla (en español o inglés) o tus propios títulos en español, inglés o portugués. Obligatorias: Nombre del hotel, Zona, Inicio de semana, Paga horas extra y el contacto (nombre, teléfono y correo)."
msgstr "Use the template (in Spanish or English) or your own titles in Spanish, English or Portuguese. Required: Hotel name, Zone, Week start, Pays overtime and the contact (name, phone and email)."

#: src/features/onboarding/components/ConfirmSendProposalDialog.tsx
msgid "Úsalo cuando ya se entregó por otro medio — impresa, en mano, por otro correo."
msgstr "Use it when it was already delivered another way — printed, in person, by another email."

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Úsalo si ya se lo hiciste llegar al hotel por fuera. Igual que la propuesta, al enviarlo queda bloqueado: si hay que corregir algo, el BDC lo desbloquea."
msgstr "Use this if you already got it to the hotel another way. Just like the proposal, sending it locks it: if something needs fixing, the BDC unlocks it."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Usuario (su correo)"
msgstr "Username (their email)"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Usuario activado"
msgstr "User activated"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Usuario actualizado"
msgstr "User updated"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Usuario copiado"
msgstr "Username copied"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Usuario creado"
msgstr "User created"

#. placeholder {0}: values.email
#: src/features/admin/components/UserFormDialog.tsx
msgid "Usuario creado — invitación enviada a {0}"
msgstr "User created — invitation sent to {0}"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Usuario dado de baja"
msgstr "User deactivated"

#: src/features/conversion/api/conversionApi.ts
msgid "Usuario del Hotel creado"
msgstr "Hotel User created"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Usuario del sistema"
msgstr "System user"

#: src/layouts/Sidebar.tsx
msgid "Usuarios"
msgstr "Users"

#: src/features/admin/pages/UsersPage.tsx
msgid "Usuarios del sistema"
msgstr "System users"

#: src/features/admin/pages/UsersPage.tsx
msgid "Usuarios del sistema es del Administrador"
msgstr "System users is the Administrator's"

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/components/MessagingTemplatesList.tsx
#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Utilidad"
msgstr "Utility"

#: src/features/schedule/components/ScheduleMiniCalendar.tsx
msgid "V"
msgstr "F"

#. placeholder {0}: candidate.latestVersion
#. placeholder {1}: candidate.latestSentAt ? t`Enviada ${formatDate(candidate.latestSentAt)}` : t`Borrador sin enviar`
#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "v{0} · {1}"
msgstr "v{0} · {1}"

#. placeholder {0}: last.version
#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "v{0} enviada"
msgstr "v{0} sent"

#: src/features/accounting/pages/AccountingPendingPages.tsx
#: src/features/personnel/components/StandByDialog.tsx
#: src/layouts/Sidebar.tsx
msgid "Vacaciones"
msgstr "Vacation"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Vacantes y promociones. Meta no la entrega a números de EE. UU."
msgstr "Openings and promotions. Meta doesn't deliver it to US numbers."

#: src/features/observability/lib/inspectionKpis.ts
msgid "Validado"
msgstr "Validated"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Validar lo hace entrar al Pool"
msgstr "Validating gets them into the Pool"

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Validarlo de todas formas"
msgstr "Validate anyway"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Válidas"
msgstr "Valid"

#: src/shared/constants/onboardingStatus.ts
msgid "Vamos a crear la propuesta"
msgstr "We're about to create the proposal"

#. placeholder {0}: status.workers
#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Van los {0} colaboradores. Para elegir solo a algunos, busca por nombre o usa Hotel y Estado."
msgstr "All {0} workers go. To choose only some, search by name or use Hotel and Status."

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Van todos los colaboradores. Para elegir solo a algunos, busca por nombre o usa Hotel y Estado."
msgstr "All workers go. To choose only some, search by name or use Hotel and Status."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Variables"
msgstr "Variables"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Varias Reclutadoras pueden trabajar la misma requisición a la vez."
msgstr "Several Recruiters can work the same requisition at once."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Varios hoteles de una vez"
msgstr "Several hotels at once"

#: src/features/contracts/components/clauses/ClausesEditWarningDialog.tsx
msgid "Vas a editar el machote"
msgstr "You're about to edit the template"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Vas a marcar:"
msgstr "You're about to punch:"

#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/pages/ProposalVersionPage.tsx
#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Vault de documentos"
msgstr "Document vault"

#: src/features/messaging/components/tours.ts
msgid "Ve quiénes la tienen"
msgstr "See who has it"

#. placeholder {0}: formatDate(contract.validTo)
#: src/features/contracts/components/ContractNextStep.tsx
msgid "Vence el {0}. Para renovar, crea un contrato nuevo antes de esa fecha y marca este como expirado."
msgstr "It expires on {0}. To renew, create a new contract before that date and mark this one as expired."

#. placeholder {0}: String(row.daysRemaining)
#: src/features/contracts/utils/validity.ts
msgid "vence en {0} días"
msgstr "expires in {0} days"

#: src/features/contracts/utils/validity.ts
msgid "vence en 1 día"
msgstr "expires in 1 day"

#: src/features/contracts/utils/validity.ts
msgid "vencido"
msgstr "expired"

#: src/features/contracts/components/ContractFilters.tsx
msgid "Vencimiento"
msgstr "Expiry"

#: src/features/observability/pages/ObservabilityPage.tsx
#: src/features/reports/pages/ReportsPage.tsx
msgid "Ventas"
msgstr "Sales"

#: src/features/messaging/components/SyncWorkersButton.tsx
#: src/shared/components/ListItemViewHint.tsx
msgid "Ver"
msgstr "View"

#. placeholder {0}: doc.displayName
#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Ver {0}"
msgstr "View {0}"

#: src/features/messaging/components/ReportParts.tsx
msgid "Ver a quiénes"
msgstr "See who"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Ver bitácora"
msgstr "View log"

#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "Ver Clientes Activos"
msgstr "See Active Clients"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Ver contactos"
msgstr "View contacts"

#: src/features/onboarding/components/ContractStepCard.tsx
msgid "Ver contrato"
msgstr "See contract"

#: src/features/onboarding/components/ProspectPhotoCard.tsx
msgid "Ver contrato →"
msgstr "See contract →"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Ver detalle"
msgstr "View details"

#. placeholder {0}: version.version
#: src/features/onboarding/components/ProposalVersionHistory.tsx
msgid "Ver el detalle de la Propuesta v{0}, enviada"
msgstr "View details of Proposal v{0}, sent"

#. placeholder {0}: slot.assigneeName
#: src/features/requisitions/components/SlotList.tsx
msgid "Ver el perfil de {0}"
msgstr "View {0}'s profile"

#: src/features/audits/pages/AuditsPage.tsx
#: src/features/dashboard/components/HotelDashboard.tsx
#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Ver el recorrido"
msgstr "Take the tour"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Ver en Clientes Activos"
msgstr "See in Active Clients"

#: src/features/messaging/components/ReportCharts.tsx
msgid "Ver gráfica"
msgstr "View chart"

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Ver lista de contratos"
msgstr "View contract list"

#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "Ver lista de propuestas"
msgstr "View proposal list"

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Ver los contratos"
msgstr "See the contracts"

#: src/features/dashboard/components/ActivityCards.tsx
#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Ver Mi Equipo"
msgstr "View My Team"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Ver PDF"
msgstr "View PDF"

#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/PoolRoster.tsx
msgid "Ver perfil"
msgstr "View profile"

#: src/features/onboarding/components/ProposalVersionList.tsx
#: src/features/onboarding/components/ViewProposalDialog.tsx
#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "Ver propuesta"
msgstr "See proposal"

#: src/features/onboarding/components/ProspectPhotoCard.tsx
msgid "Ver propuesta enviada →"
msgstr "View sent proposal →"

#: src/features/onboarding/components/ProposalVersionList.tsx
msgid "Ver propuestas"
msgstr "See proposals"

#: src/features/recruitment/pages/PoolPage.tsx
msgid "Ver quién tiene un documento (SSN/ITIN) pendiente de verificar"
msgstr "See who has a document (SSN/ITIN) pending verification"

#: src/features/messaging/components/Tour.tsx
msgid "Ver recorrido"
msgstr "Show tour"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Ver reporte"
msgstr "View report"

#: src/features/timesheet/components/ReviewDayDialog.tsx
#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "Ver revisión"
msgstr "View review"

#: src/features/recruitment/components/SelfPickHotelCardList.tsx
msgid "Ver slots"
msgstr "See slots"

#: src/features/messaging/components/ReportCharts.tsx
msgid "Ver tabla"
msgstr "View table"

#: src/features/recruitment/pages/SelfPickPage.tsx
msgid "Ver toda la Bolsa"
msgstr "See the whole queue"

#: src/features/requisitions/components/HotelRequisitionCardList.tsx
msgid "Ver todas"
msgstr "See all"

#: src/shared/components/DateRangeField.tsx
msgid "Ver todo el periodo"
msgstr "View the whole period"

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
msgid "Ver todos ({total})"
msgstr "See all ({total})"

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
msgid "Ver todos y corregirlos"
msgstr "See all and fix them"

#: src/shared/components/ApprovalTimelinessPanel.tsx
#: src/shared/constants/onboardingStatus.ts
msgid "Verde"
msgstr "Green"

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "Verde · cumplimiento"
msgstr "Green · compliance"

#: src/features/dashboard/components/RecruitmentDashboard.tsx
msgid "Verde fuerte, sin veto vigente"
msgstr "Strong green, no active veto"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Verde no se abandona sin enviar la Propuesta Personalizada: abre la propuesta, envíala y vuelve a intentar."
msgstr "There's no leaving Green without sending the Custom Proposal: open the proposal, send it and try again."

#: src/features/worker/components/TaxDeadlineBanner.tsx
msgid "verificado"
msgstr "verified"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/pages/Phase2Page.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Verificado"
msgstr "Verified"

#. placeholder {0}: previewDoc.verifiedBy?.fullName ?? '—'
#. placeholder {1}: previewDoc.verifiedAt === null ? '—' : formatDate(previewDoc.verifiedAt)
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Verificado por {0} · {1}"
msgstr "Verified by {0} · {1}"

#: src/features/worker/pages/PunchPage.tsx
msgid "Verificando…"
msgstr "Verifying…"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Verificar documento"
msgstr "Verify document"

#. placeholder {0}: draft.version
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Versión {0} · borrador sin enviar"
msgstr "Version {0} · unsent draft"

#. placeholder {0}: String(punchQr.version)
#. placeholder {1}: formatDateTime(punchQr.generatedAt)
#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "Versión {0} · generado el {1}"
msgstr "Version {0} · generated on {1}"

#. placeholder {0}: data.version
#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "Versión {0} · generado el {generatedOn}. Si el hotel regenera su QR, esta hoja deja de servir."
msgstr "Version {0} · generated on {generatedOn}. If the hotel regenerates its QR, this sheet stops working."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Versión nueva abierta"
msgstr "New version opened"

#: src/features/onboarding/components/ProposalVersionList.tsx
#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Versiones de la propuesta"
msgstr "Proposal versions"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Ves cada fila: lista, para completar o con error. Eliges cuáles entran: una o todas. Lo que falte (el pin, el contacto) se completa después en la ficha del prospecto."
msgstr "You see each row: ready, to complete or with errors. You choose which go in: one or all. Whatever's missing (the pin, the contact) is completed later on the prospect's page."

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Vetando…"
msgstr "Banning…"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Vetar colaborador"
msgstr "Ban collaborator"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "Veto levantado — vuelve a Blanco"
msgstr "Ban lifted — back to White"

#. placeholder {0}: worker.fullName
#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Veto registrado — {0}"
msgstr "Ban registered — {0}"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Vetos anteriores"
msgstr "Previous bans"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "Vie"
msgstr "Fri"

#. placeholder {0}: filters.hotelName
#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Viendo {0} · solo lectura"
msgstr "Viewing {0} · read-only"

#: src/features/recruitment/pages/SelfPickPage.tsx
msgid "Viendo solo esta requisición, cubierto incluido."
msgstr "Showing only this requisition, covered positions included."

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Viendo todos los hoteles · solo lectura"
msgstr "Viewing all hotels · read-only"

#. placeholder {0}: formatWeekRange(visibleWeek, addDaysIso(visibleWeek, 6))
#: src/features/timesheet/components/WeekSlider.tsx
msgid "Viendo: {0}"
msgstr "Viewing: {0}"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Viene del día anterior"
msgstr "Comes from the previous day"

#: src/features/contracts/components/ContractTable.tsx
#: src/features/contracts/components/NewContractDialog.tsx
msgid "Vigencia"
msgstr "Validity"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Vigencia actualizada"
msgstr "Validity updated"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Vigencia y semana de nómina"
msgstr "Validity and payroll week"

#: src/features/contracts/components/ValidityCell.tsx
msgid "Vigencia: {note}"
msgstr "Validity: {note}"

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Vigente"
msgstr "Active"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Vigente desde"
msgstr "In force from"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Vigente desde el inicio, sin fecha de fin: aplica hasta que se expire a mano."
msgstr "In force from the start, with no end date: it applies until it is expired by hand."

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Vigente hasta"
msgstr "In force until"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Vigente hasta (opcional)"
msgstr "In force until (optional)"

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "vigentes"
msgstr "active"

#: src/features/requisitions/api/requisitionsApi.ts
msgid "Visible en la Bolsa · Self-Pick"
msgstr "Visible in the pool · Self-Pick"

#: src/features/observability/lib/people.ts
#: src/shared/constants/contactAttempt.ts
msgid "Visita en frío"
msgstr "Cold visit"

#: src/features/observability/lib/people.ts
#: src/features/observability/lib/salesKpis.ts
msgid "Visitas en frío"
msgstr "Cold visits"

#: src/features/observability/lib/salesKpis.ts
msgid "Visitas en frío registradas en el periodo, de todos los BD."
msgstr "Cold visits logged in the period, across all BDs."

#: src/features/observability/components/TabParts.tsx
#: src/features/timesheet/components/TimesheetViewControls.tsx
msgid "Vista"
msgstr "View"

#: src/features/onboarding/components/ContractPreviewDialog.tsx
msgid "Vista previa del contrato"
msgstr "Contract preview"

#. placeholder {0}: version.version
#: src/features/onboarding/components/ContractPreviewButton.tsx
msgid "Vista previa del contrato de la Propuesta v{0}"
msgstr "Contract preview for Proposal v{0}"

#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Vista previa del documento"
msgstr "Document preview"

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
msgid "Vista rápida"
msgstr "Quick view"

#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/SyncWorkersButton.tsx
#: src/layouts/AppShell.tsx
#: src/mobile/layouts.tsx
msgid "Volver"
msgstr "Back"

#: src/shared/components/LoadError.tsx
msgid "Volver a cargar"
msgstr "Reload"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Volver a Contratos"
msgstr "Back to Contracts"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Volver a Conversión"
msgstr "Back to Conversion"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Volver a correrla solo agrega lo que {hotelName} aprobó después de la última vez — no duplica nada de lo que ya está cerrado."
msgstr "Running it again only adds what {hotelName} approved since last time — it never duplicates anything already closed."

#: src/features/recruitment/pages/SelfPickHotelPage.tsx
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Volver a la Bolsa"
msgstr "Back to the Self-Pick pool"

#: src/shared/components/BackToListButton.tsx
msgid "Volver a la lista"
msgstr "Back to the list"

#: src/layouts/AppShell.tsx
msgid "Volver a la página anterior"
msgstr "Go back to the previous page"

#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Volver a Propuestas"
msgstr "Back to Proposals"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Volver al Pipeline"
msgstr "Back to the Pipeline"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Volver al Pool de Colaboradores"
msgstr "Back to the Collaborator Pool"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Volver al Tablero de Requisiciones"
msgstr "Back to the Requisition Board"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "Vuelve a Blanco, no al Pool"
msgstr "Back to White, not to the Pool"

#: src/shared/constants/workerStatus.ts
msgid "vuelve solo al vencer los días asignados; Reclutamiento puede cancelarlo liberando la asignación."
msgstr "returns on its own when the assigned days end; Recruiting can cancel it by releasing the assignment."

#: src/shared/constants/workerStatus.ts
msgid "vuelve solo cuando el colaborador poncha de nuevo; a la tercera falta el sistema lo manda a Blacklist."
msgstr "it clears on its own when the collaborator punches again; on the third no-show the system sends them to Blacklist."

#: src/features/schedule/components/ScheduleMiniCalendar.tsx
msgid "X"
msgstr "W"

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "y"
msgstr "and"

#: src/features/worker/pages/HomePage.tsx
msgid "Y tu ubicación, para confirmar dónde estás"
msgstr "And your location, to confirm where you are"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "ya aprobada"
msgstr "already approved"

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Ya cubrimos {covered} de {total, plural, one {# lugar} other {# lugares}}. Abajo ves quién llega a cada uno."
msgstr "We've filled {covered} of {total, plural, one {# spot} other {# spots}}. Below you can see who is coming to each one."

#: src/features/admin/components/userListParts.tsx
msgid "Ya entró"
msgstr "Signed in"

#: src/features/admin/components/HotelUsersSection.tsx
#: src/features/admin/pages/UsersPage.tsx
msgid "Ya entró al sistema"
msgstr "Already signed in"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Ya entró por primera vez: no hace falta reenviar la invitación."
msgstr "They already signed in for the first time: no need to resend the invitation."

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Ya es cliente con contrato vigente: la propuesta no se reabre. Si cambian las tarifas, se edita el contrato."
msgstr "It's already a client with an active contract: the proposal doesn't reopen. If the rates change, edit the contract."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Ya está autorizada: Reclutamiento la ve desde ahora y empieza a cubrirla."
msgstr "It's already authorized: Recruitment can see it now and starts filling it."

#: src/features/worker/pages/Phase2Page.tsx
msgid "Ya está todo"
msgstr "You're all set"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Ya está verificado: no se puede borrar, deja rastro de quién lo revisó."
msgstr "Already verified: it can't be deleted, it keeps a record of who reviewed it."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Ya estabas trabajando esta requisición."
msgstr "You were already working on this requisition."

#: src/features/worker/pages/HomePage.tsx
msgid "Ya estás disponible"
msgstr "You're now available"

#: src/features/timesheet/components/WeekSlider.tsx
msgid "Ya estás en la semana más reciente"
msgstr "You're already on the latest week"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Ya existe en Oranje"
msgstr "Already exists in Oranje"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Ya existe en Oranje: para abrirle un ciclo usa «Hotel ya registrado»"
msgstr "Already exists in Oranje: to open a cycle for it use “Hotel already registered”"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Ya existe un hotel con ese nombre: elige «Hotel ya registrado» o cambia el nombre."
msgstr "A hotel with that name already exists: pick “Hotel already registered” or change the name."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Ya existe un reactivo con ese texto en esta inspección."
msgstr "A checklist item with that text already exists in this inspection."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Ya existe un usuario con ese correo."
msgstr "A user with that email already exists."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Ya existe una fila con ese nombre en este catálogo."
msgstr "A row with that name already exists in this catalog."

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Ya existen"
msgstr "Already exist"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Ya hay un veto vigente para esta persona: levántalo antes de registrar otro."
msgstr "This person already has an active ban: lift it before registering another."

#. placeholder {0}: formatHours(overtime.hours)
#. placeholder {1}: overtime.multiplier
#: src/features/timesheet/components/AttendanceView.tsx
msgid "Ya incluye {0} de extra, pagadas a {1}×"
msgstr "Already includes {0} of overtime, paid at {1}×"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "Ya la anoté"
msgstr "I wrote it down"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Ya le llegó el correo de DocuSign: esperando su firma"
msgstr "DocuSign's email already reached them: waiting for their signature"

#: src/features/worker/pages/PermissionsPage.tsx
msgid "Ya lo cambié: comprobar de nuevo"
msgstr "I already changed it: check again"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "ya marcaron hoy"
msgstr "already clocked in today"

#: src/shared/components/UrgencyChip.tsx
msgid "Ya no aplica"
msgstr "No longer applies"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Ya no está guardada. Si la necesitas, ponle una nueva."
msgstr "It's no longer saved. If you need it, set a new one."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Ya no estabas trabajando esta requisición."
msgstr "You were no longer working on this requisition."

#: src/features/messaging/components/ContactActions.tsx
msgid "Ya no recibirá mensajes de ninguna campaña. Es la baja que pide la ley: no se deshace desde aquí."
msgstr "They will no longer receive messages from any campaign. This is the legally required opt-out: it cannot be undone from here."

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Ya no se va a cubrir. Si todavía necesitas personal, crea una requisición nueva."
msgstr "It won't be filled anymore. If you still need staff, create a new requisition."

#: src/features/observability/components/CohortSection.tsx
msgid "Ya no trabajan"
msgstr "No longer work"

#: src/features/contracts/components/MissingContractsNotice.tsx
msgid "Ya pasaron Amarillo y todavía no tienen contrato, ni en Borrador"
msgstr "Already past Yellow and still no contract, not even a Draft"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Ya puede entrar con la contraseña que definiste. Compártesela por un canal seguro — no viaja por correo."
msgstr "They can sign in now with the password you set. Share it through a secure channel — it doesn't travel by email."

#: src/features/onboarding/components/ContractUnlockedDialog.tsx
msgid "Ya puedes armar el contrato"
msgstr "You can now put together the contract"

#: src/features/admin/components/PendingHotelUsers.tsx
msgid "Ya se aprobó: un rechazo no deshace una aprobación."
msgstr "It's already approved: a rejection doesn't undo an approval."

#. placeholder {0}: rows.length
#. placeholder {1}: formatMoney(totalNet)
#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Ya se cerraron {0} hojas esta semana, por {1} neto."
msgstr "{0} sheets already closed this week, for {1} net."

#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "Ya se le envió al hotel y está bloqueado: desbloquéalo primero."
msgstr "It was already sent to the hotel and is locked: unlock it first."

#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "Ya son clientes: su ficha completa vive en Clientes Activos"
msgstr "They're clients already: their full record lives in Active Clients"

#: src/features/requisitions/components/SlotList.tsx
msgid "Ya terminó"
msgstr "Already ended"

#: src/features/recruitment/components/ProfileProgressAvatar.tsx
msgid "Ya tiene todo lo de la entrevista. Para asignarlo, cámbialo a {readyLabel}."
msgstr "Everything from the interview is captured. To assign them, switch them to {readyLabel}."

#: src/features/recruitment/components/PoolRoster.tsx
msgid "Ya tiene una asignación fija: pasa a Día 1-2 en cuanto ponche por primera vez."
msgstr "Already has a fixed assignment: moves to Day 1-2 as soon as they punch in for the first time."

#: src/features/onboarding/pages/PipelinePage.tsx
msgid "yo"
msgstr "me"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "zona"
msgstr "zone"

#: src/features/clients/components/ClientFilters.tsx
#: src/features/contracts/components/ContractFilters.tsx
#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/onboarding/pages/PipelinePage.tsx
#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/components/PoolTable.tsx
#: src/features/recruitment/components/SelfPickFilterBar.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Zona"
msgstr "Zone"

#. placeholder {0}: client.zoneName
#. placeholder {1}: client.timezone
#: src/features/clients/components/ClientSpotlightCard.tsx
msgid "Zona {0} · {1}"
msgstr "Zone {0} · {1}"

#. placeholder {0}: client.zoneName
#. placeholder {1}: formatDate(client.activatedAt)
#: src/features/clients/components/ClientCardGrid.tsx
msgid "Zona {0} · cliente desde {1}"
msgstr "Zone {0} · client since {1}"

#. placeholder {0}: hotel.zoneName
#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Zona {0} · el Inspector se congela al guardar"
msgstr "Zone {0} · the Inspector is locked in on save"

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
msgid "Zona comercial"
msgstr "Commercial zone"

#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/onboarding/components/PlacesAutofillSummary.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Zona horaria"
msgstr "Time zone"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Zona horaria no reconocida: «{timeZoneText}»"
msgstr "Time zone not recognized: “{timeZoneText}”"

#. placeholder {0}: zoneOptions.find((zone) => zone.value === filters.zone)?.label ?? filters.zone
#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Zona: {0}"
msgstr "Zone: {0}"

#: src/features/recruitment/components/SelfPickFilterBar.tsx
msgid "Zona: próximamente"
msgstr "Zone: coming soon"

#: src/features/admin/components/UserFormDialog.tsx
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Zonas"
msgstr "Zones"

#. placeholder {0}: formatList(member.zoneNames)
#: src/features/team/pages/TeamPage.tsx
msgid "Zonas {0}"
msgstr "Zones {0}"

#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "Zoom · ancho de columna"
msgstr "Zoom · column width"
